'use strict';

var pokemonCardLibrary = require('@markfazzio/pokemon-card-library');
var React = require('react');
var classNames = require('classnames');
var jsxRuntime = require('react/jsx-runtime');
var ReactDOM = require('react-dom');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const TINY_ICON_SIZE = 12;
const SMALL_ICON_SIZE = 16;
const DEFAULT_ICON_SIZE = 24;
const DEFAULT_SHADOW_SIZE = 0.2;
const DEFAULT_CARD_TEMPLATE = pokemonCardLibrary.CARD_TEMPLATES.BASE;
const DEFAULT_CARD_ENERGY_TYPE = pokemonCardLibrary.ENERGY_TYPES.COLORLESS;
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_TRAINER_HEADING = 'Trainer';
const DEFAULT_ENERGY_HEADING = 'Energy';
const DEFAULT_HOLO_STRENGTH = 0.5;
const DEFAULT_HOLO_BLEND_MODE = pokemonCardLibrary.BLEND_MODES.NORMAL;
const DEFAULT_HOLO_SHEET_TYPE = pokemonCardLibrary.CARD_HOLO_SHEETS.STARS;
const DEFAULT_REVERSE_HOLO_SHEET_TYPE = pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS;
const MOVES_MAX = 3;
const RETREAT_COST_MAX = 4;
const HP_MAX = 999;
const HP_MIN = 0;
const STAGE_MAX = 2;
const STAGE_MIN = 0;
const DEFAULT_ENERGY_ICON_SIZE = 30;
const DEFAULT_ENERGY_ICON_SIZE_SMALL = 24;
const DEFAULT_ENERGY_ICON_SIZE_TINY = 16;
const DEFAULT_FIRST_EDITION_ICON_SIZE = 28;
const ENERGY_COST_MAX = 5;
const WEIGHT_MAX = 9999;
const LEVEL_MAX = 99;
const NAME_MAX_LENGTH = 30;
const NAME_MAX_LENGTH_TRAINER = 40;
const CARD_SIZES = {
    SMALL: 'small',
    LARGE: 'large',
};
const COMPONENT_VARIANTS = [
    'primary',
    'secondary',
    'info',
    'dark',
    'light',
    'danger',
    'warning',
    'success',
    'white',
    'outline-light',
    'outline-dark',
];
const ENERGY_SIZES = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
const ENERGY_SYMBOL_CODES = [
    'WA',
    'PS',
    'FG',
    'LG',
    'GR',
    'CO',
    'FR',
    'DK',
    'MT',
    'RA',
];
const FRAME_SIZES = {
    SMALL: 'small',
};
const MASTHEAD_TYPES = {
    ENERGY: 'energy',
    TRAINER: 'trainer',
    ILLUSTRATOR: 'illustrator',
};
const CARD_FRAME_STYLES = {
    LIGHT: 'light',
    DARK: 'dark',
};
const NEO_SWOOSH_BG = 'https://poketcgshop.s3.amazonaws.com/card-body-bgs/swoosh-bg.jpg';
const ALLOWED_IMAGE_UPLOAD_TYPES = '.png,.gif,.jpg,.jpeg';
const DEFAULT_CARD_ORDER = [
    'C',
    'C',
    'C',
    'C',
    'C',
    'E',
    'E',
    'R',
    'U',
    'U',
    'U',
];
const BOOSTER_BOX_ORIENTATIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'front',
    'back',
];
const WOTC_HOLO_ODDS = 0.33;
const WOTC_SHINING_ODDS = 0.05;
const WOTC_CRYSTAL_ODDS = 0.05;
const ADDITIONAL_CARD_CREATOR_SETS = [
    pokemonCardLibrary.CARD_SETS_JPN.T_PROMOTIONAL_CARDS,
    pokemonCardLibrary.CARD_SETS_JPN.VENDING,
    pokemonCardLibrary.CARD_SETS_JPN.GB_PROMO,
    {
        label: 'McDonalds Promo',
        value: 'mcdonalds',
    },
    {
        label: 'Snap Promo',
        value: 'snap',
    },
    {
        label: 'E3 Promo',
        value: 'e3',
    },
];

const DEFAULT_CARD_SET_STATE = {
    copyright: '',
    firstEdition: false,
    id: 'custom-set',
    language: DEFAULT_LANGUAGE,
    reverseHoloSheetType: '',
    setSymbol: '',
    setTotal: null,
    shadowless: false,
};
const DEFAULT_CARD_STATE = {
    babyDescription: '',
    backgroundColor: '#000000',
    backgroundImageBlendMode: '',
    backgroundImageOpacity: null,
    backgroundImagePositionX: null,
    backgroundImagePositionY: null,
    backgroundImageUrl: '',
    cardTemplate: '',
    cardTemplateSubtype: '',
    creatureImageBlendMode: '',
    description: '',
    dotMatrixVariant: '',
    energyResistance: '',
    energyRetreatCost: null,
    energyType: pokemonCardLibrary.ENERGY_TYPES.COLORLESS,
    energyWeakness: '',
    eReaderId: '',
    evolutionBoxBackgroundImageSize: 70,
    evolutionBoxBackgroundVariant: '',
    evolutionBoxImageUrl: '',
    evolvesFrom: '',
    evolvesTo: '',
    frameMode: '',
    hasStatsBarShadow: false,
    hitPoints: null,
    holo: false,
    holoBlendMode: '',
    holoSheetType: pokemonCardLibrary.CARD_HOLO_SHEETS.STARS,
    holoStrength: 0.7,
    illustrator: '',
    isDoubleEnergyType: false,
    isFullReverseHolo: false,
    language: DEFAULT_LANGUAGE,
    lengthFeet: null,
    lengthInches: null,
    moves: [],
    name: '',
    nameCondenseLevel: 0,
    pokemonImagePositionX: 50,
    pokemonImagePositionY: 50,
    pokemonImageRotation: null,
    pokemonImageShadowColor: '#000000',
    pokemonImageShadowOffsetX: null,
    pokemonImageShadowOffsetY: null,
    pokemonImageShadowSize: null,
    pokemonImageSize: 50,
    pokemonImageUrl: '',
    pokemonLevel: null,
    pokemonNumber: null,
    pokemonType: '',
    rarity: '',
    reverseHoloSheetType: pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS,
    setNumber: null,
    setSymbol: '',
    specialTemplateType: '',
    stage: 0,
    stamp: '',
    subtitle: '',
    trainerImageUrl: '',
    trainerRule: '',
    unownLetter: '',
    weight: null,
};

function resolveUrl(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) {
        return url;
    }
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) {
        return window.location.protocol + url;
    }
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) {
        return url;
    }
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) {
        base.href = baseUrl;
    }
    a.href = url;
    return a.href;
}
const uuid$3 = (() => {
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = () => 
    // eslint-disable-next-line no-bitwise
    `0000${((Math.random() * 36 ** 4) << 0).toString(36)}`.slice(-4);
    return () => {
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function toArray$4(arrayLike) {
    const arr = [];
    for (let i = 0, l = arrayLike.length; i < l; i++) {
        arr.push(arrayLike[i]);
    }
    return arr;
}
let styleProps = null;
function getStyleProperties(options = {}) {
    if (styleProps) {
        return styleProps;
    }
    if (options.includeStyleProperties) {
        styleProps = options.includeStyleProperties;
        return styleProps;
    }
    styleProps = toArray$4(window.getComputedStyle(document.documentElement));
    return styleProps;
}
function px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function getNodeWidth(node) {
    const leftBorder = px(node, 'border-left-width');
    const rightBorder = px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function getNodeHeight(node) {
    const topBorder = px(node, 'border-top-width');
    const bottomBorder = px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function getImageSize(targetNode, options = {}) {
    const width = options.width || getNodeWidth(targetNode);
    const height = options.height || getNodeHeight(targetNode);
    return { width, height };
}
function getPixelRatio() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = process;
    }
    catch (e) {
        // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env
        ? FINAL_PROCESS.env.devicePixelRatio
        : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) {
            ratio = 1;
        }
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const canvasDimensionLimit = 16384;
function checkCanvasDimensions(canvas) {
    if (canvas.width > canvasDimensionLimit ||
        canvas.height > canvasDimensionLimit) {
        if (canvas.width > canvasDimensionLimit &&
            canvas.height > canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= canvasDimensionLimit / canvas.width;
                canvas.width = canvasDimensionLimit;
            }
            else {
                canvas.width *= canvasDimensionLimit / canvas.height;
                canvas.height = canvasDimensionLimit;
            }
        }
        else if (canvas.width > canvasDimensionLimit) {
            canvas.height *= canvasDimensionLimit / canvas.width;
            canvas.width = canvasDimensionLimit;
        }
        else {
            canvas.width *= canvasDimensionLimit / canvas.height;
            canvas.height = canvasDimensionLimit;
        }
    }
}
function createImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            img.decode().then(() => {
                requestAnimationFrame(() => resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function svgToDataURL(svg) {
    return Promise.resolve()
        .then(() => new XMLSerializer().serializeToString(svg))
        .then(encodeURIComponent)
        .then((html) => `data:image/svg+xml;charset=utf-8,${html}`);
}
async function nodeToDataURL(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return svgToDataURL(svg);
}
const isInstanceOfElement = (node, instance) => {
    if (node instanceof instance)
        return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null)
        return false;
    return (nodePrototype.constructor.name === instance.name ||
        isInstanceOfElement(nodePrototype, instance));
};

function formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function formatCSSProperties(style, options) {
    return getStyleProperties(options)
        .map((name) => {
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    })
        .join(' ');
}
function getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText
        ? formatCSSText(style)
        : formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') {
        return;
    }
    const className = uuid$3();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    }
    catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild(getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function clonePseudoElements(nativeNode, clonedNode, options) {
    clonePseudoElement(nativeNode, clonedNode, ':before', options);
    clonePseudoElement(nativeNode, clonedNode, ':after', options);
}

const WOFF = 'application/font-woff';
const JPEG = 'image/jpeg';
const mimes = {
    woff: WOFF,
    woff2: WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: JPEG,
    jpeg: JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp',
};
function getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function getMimeType(url) {
    const extension = getExtension(url).toLowerCase();
    return mimes[extension] || '';
}

function getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
function makeDataUrl(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function fetchAsDataURL(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) {
        throw new Error(`Resource "${res.url}" not found`);
    }
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = () => {
            try {
                resolve(process({ res, result: reader.result }));
            }
            catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const cache = {};
function getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) {
        key = url;
    }
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) {
        key = key.replace(/.*\//, '');
    }
    return contentType ? `[${contentType}]${key}` : key;
}
async function resourceToDataURL(resourceUrl, contentType, options) {
    const cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if (cache[cacheKey] != null) {
        return cache[cacheKey];
    }
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) {
        // eslint-disable-next-line no-param-reassign
        resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    }
    let dataURL;
    try {
        const content = await fetchAsDataURL(resourceUrl, options.fetchRequestInit, ({ res, result }) => {
            if (!contentType) {
                // eslint-disable-next-line no-param-reassign
                contentType = res.headers.get('Content-Type') || '';
            }
            return getContentFromDataUrl(result);
        });
        dataURL = makeDataUrl(content, contentType);
    }
    catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) {
            msg = typeof error === 'string' ? error : error.message;
        }
        if (msg) {
            console.warn(msg);
        }
    }
    cache[cacheKey] = dataURL;
    return dataURL;
}

async function cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') {
        return canvas.cloneNode(false);
    }
    return createImage(dataURL);
}
async function cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return createImage(dataURL);
    }
    const poster = video.poster;
    const contentType = getMimeType(poster);
    const dataURL = await resourceToDataURL(poster, contentType, options);
    return createImage(dataURL);
}
async function cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) {
            return (await cloneNode(iframe.contentDocument.body, options, true));
        }
    }
    catch (_b) {
        // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function cloneSingleNode(node, options) {
    if (isInstanceOfElement(node, HTMLCanvasElement)) {
        return cloneCanvasElement(node);
    }
    if (isInstanceOfElement(node, HTMLVideoElement)) {
        return cloneVideoElement(node, options);
    }
    if (isInstanceOfElement(node, HTMLIFrameElement)) {
        return cloneIFrameElement(node, options);
    }
    return node.cloneNode(isSVGElement(node));
}
const isSlotElement = (node) => node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const isSVGElement = (node) => node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if (isSVGElement(clonedNode)) {
        return clonedNode;
    }
    let children = [];
    if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
        children = toArray$4(nativeNode.assignedNodes());
    }
    else if (isInstanceOfElement(nativeNode, HTMLIFrameElement) &&
        ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        children = toArray$4(nativeNode.contentDocument.body.childNodes);
    }
    else {
        children = toArray$4(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    }
    if (children.length === 0 ||
        isInstanceOfElement(nativeNode, HTMLVideoElement)) {
        return clonedNode;
    }
    await children.reduce((deferred, child) => deferred
        .then(() => cloneNode(child, options))
        .then((clonedChild) => {
        if (clonedChild) {
            clonedNode.appendChild(clonedChild);
        }
    }), Promise.resolve());
    return clonedNode;
}
function cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) {
        return;
    }
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    }
    else {
        getStyleProperties(options).forEach((name) => {
            let value = sourceStyle.getPropertyValue(name);
            if (name === 'font-size' && value.endsWith('px')) {
                const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
                value = `${reducedFont}px`;
            }
            if (isInstanceOfElement(nativeNode, HTMLIFrameElement) &&
                name === 'display' &&
                value === 'inline') {
                value = 'block';
            }
            if (name === 'd' && clonedNode.getAttribute('d')) {
                value = `path(${clonedNode.getAttribute('d')})`;
            }
            targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
        });
    }
}
function cloneInputValue(nativeNode, clonedNode) {
    if (isInstanceOfElement(nativeNode, HTMLTextAreaElement)) {
        clonedNode.innerHTML = nativeNode.value;
    }
    if (isInstanceOfElement(nativeNode, HTMLInputElement)) {
        clonedNode.setAttribute('value', nativeNode.value);
    }
}
function cloneSelectValue(nativeNode, clonedNode) {
    if (isInstanceOfElement(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child) => nativeNode.value === child.getAttribute('value'));
        if (selectedOption) {
            selectedOption.setAttribute('selected', '');
        }
    }
}
function decorate(nativeNode, clonedNode, options) {
    if (isInstanceOfElement(clonedNode, Element)) {
        cloneCSSStyle(nativeNode, clonedNode, options);
        clonePseudoElements(nativeNode, clonedNode, options);
        cloneInputValue(nativeNode, clonedNode);
        cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) {
        return clone;
    }
    const processedDefs = {};
    for (let i = 0; i < uses.length; i++) {
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) {
                // eslint-disable-next-line no-await-in-loop
                processedDefs[id] = (await cloneNode(definition, options, true));
            }
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for (let i = 0; i < nodes.length; i++) {
            defs.appendChild(nodes[i]);
        }
        clone.appendChild(svg);
    }
    return clone;
}
async function cloneNode(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) {
        return null;
    }
    return Promise.resolve(node)
        .then((clonedNode) => cloneSingleNode(clonedNode, options))
        .then((clonedNode) => cloneChildren(node, clonedNode, options))
        .then((clonedNode) => decorate(node, clonedNode, options))
        .then((clonedNode) => ensureSVGSymbols(clonedNode, options));
}

const URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function parseURLs(cssText) {
    const urls = [];
    cssText.replace(URL_REGEX, (raw, quotation, url) => {
        urls.push(url);
        return raw;
    });
    return urls.filter((url) => !isDataUrl(url));
}
async function embed(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
        const contentType = getMimeType(resourceURL);
        let dataURL;
        if (getContentFromUrl) ;
        else {
            dataURL = await resourceToDataURL(resolvedURL, contentType, options);
        }
        return cssText.replace(toRegex(resourceURL), `$1${dataURL}$3`);
    }
    catch (error) {
        // pass
    }
    return cssText;
}
function filterPreferredFontFormat(str, { preferredFontFormat }) {
    return !preferredFontFormat
        ? str
        : str.replace(FONT_SRC_REGEX, (match) => {
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const [src, , format] = URL_WITH_FORMAT_REGEX.exec(match) || [];
                if (!format) {
                    return '';
                }
                if (format === preferredFontFormat) {
                    return `src: ${src};`;
                }
            }
        });
}
function shouldEmbed(url) {
    return url.search(URL_REGEX) !== -1;
}
async function embedResources(cssText, baseUrl, options) {
    if (!shouldEmbed(cssText)) {
        return cssText;
    }
    const filteredCSSText = filterPreferredFontFormat(cssText, options);
    const urls = parseURLs(filteredCSSText);
    return urls.reduce((deferred, url) => deferred.then((css) => embed(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}

async function embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await embedResources(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function embedBackground(clonedNode, options) {
    (await embedProp('background', clonedNode, options)) ||
        (await embedProp('background-image', clonedNode, options));
    (await embedProp('mask', clonedNode, options)) ||
        (await embedProp('-webkit-mask', clonedNode, options)) ||
        (await embedProp('mask-image', clonedNode, options)) ||
        (await embedProp('-webkit-mask-image', clonedNode, options));
}
async function embedImageNode(clonedNode, options) {
    const isImageElement = isInstanceOfElement(clonedNode, HTMLImageElement);
    if (!(isImageElement && !isDataUrl(clonedNode.src)) &&
        !(isInstanceOfElement(clonedNode, SVGImageElement) &&
            !isDataUrl(clonedNode.href.baseVal))) {
        return;
    }
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await resourceToDataURL(url, getMimeType(url), options);
    await new Promise((resolve, reject) => {
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler
            ? (...attributes) => {
                try {
                    resolve(options.onImageErrorHandler(...attributes));
                }
                catch (error) {
                    reject(error);
                }
            }
            : reject;
        const image = clonedNode;
        if (image.decode) {
            image.decode = resolve;
        }
        if (image.loading === 'lazy') {
            image.loading = 'eager';
        }
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        }
        else {
            clonedNode.href.baseVal = dataURL;
        }
    });
}
async function embedChildren(clonedNode, options) {
    const children = toArray$4(clonedNode.childNodes);
    const deferreds = children.map((child) => embedImages(child, options));
    await Promise.all(deferreds).then(() => clonedNode);
}
async function embedImages(clonedNode, options) {
    if (isInstanceOfElement(clonedNode, Element)) {
        await embedBackground(clonedNode, options);
        await embedImageNode(clonedNode, options);
        await embedChildren(clonedNode, options);
    }
}

function applyStyle(node, options) {
    const { style } = node;
    if (options.backgroundColor) {
        style.backgroundColor = options.backgroundColor;
    }
    if (options.width) {
        style.width = `${options.width}px`;
    }
    if (options.height) {
        style.height = `${options.height}px`;
    }
    const manual = options.style;
    if (manual != null) {
        Object.keys(manual).forEach((key) => {
            style[key] = manual[key];
        });
    }
    return node;
}

const cssFetchCache = {};
async function fetchCSS(url) {
    let cache = cssFetchCache[url];
    if (cache != null) {
        return cache;
    }
    const res = await fetch(url);
    const cssText = await res.text();
    cache = { url, cssText };
    cssFetchCache[url] = cache;
    return cache;
}
async function embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc) => {
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) {
            url = new URL(url, data.url).href;
        }
        return fetchAsDataURL(url, options.fetchRequestInit, ({ result }) => {
            cssText = cssText.replace(loc, `url(${result})`);
            return [loc, result];
        });
    });
    return Promise.all(loadFonts).then(() => cssText);
}
function parseCSS(source) {
    if (source == null) {
        return [];
    }
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) {
            break;
        }
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]' +
        '*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})';
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) {
                break;
            }
            else {
                importRegex.lastIndex = unifiedRegex.lastIndex;
            }
        }
        else {
            unifiedRegex.lastIndex = importRegex.lastIndex;
        }
        result.push(matches[0]);
    }
    return result;
}
async function getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet) => {
        if ('cssRules' in sheet) {
            try {
                toArray$4(sheet.cssRules || []).forEach((item, index) => {
                    if (item.type === CSSRule.IMPORT_RULE) {
                        let importIndex = index + 1;
                        const url = item.href;
                        const deferred = fetchCSS(url)
                            .then((metadata) => embedFonts(metadata, options))
                            .then((cssText) => parseCSS(cssText).forEach((rule) => {
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import')
                                    ? (importIndex += 1)
                                    : sheet.cssRules.length);
                            }
                            catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule,
                                    error,
                                });
                            }
                        }))
                            .catch((e) => {
                            console.error('Error loading remote css', e.toString());
                        });
                        deferreds.push(deferred);
                    }
                });
            }
            catch (e) {
                const inline = styleSheets.find((a) => a.href == null) || document.styleSheets[0];
                if (sheet.href != null) {
                    deferreds.push(fetchCSS(sheet.href)
                        .then((metadata) => embedFonts(metadata, options))
                        .then((cssText) => parseCSS(cssText).forEach((rule) => {
                        inline.insertRule(rule, inline.cssRules.length);
                    }))
                        .catch((err) => {
                        console.error('Error loading remote stylesheet', err);
                    }));
                }
                console.error('Error inlining remote css file', e);
            }
        }
    });
    return Promise.all(deferreds).then(() => {
        // Second loop parses rules
        styleSheets.forEach((sheet) => {
            if ('cssRules' in sheet) {
                try {
                    toArray$4(sheet.cssRules || []).forEach((item) => {
                        ret.push(item);
                    });
                }
                catch (e) {
                    console.error(`Error while reading CSS rules from ${sheet.href}`, e);
                }
            }
        });
        return ret;
    });
}
function getWebFontRules(cssRules) {
    return cssRules
        .filter((rule) => rule.type === CSSRule.FONT_FACE_RULE)
        .filter((rule) => shouldEmbed(rule.style.getPropertyValue('src')));
}
async function parseWebFontRules(node, options) {
    if (node.ownerDocument == null) {
        throw new Error('Provided element is not within a Document');
    }
    const styleSheets = toArray$4(node.ownerDocument.styleSheets);
    const cssRules = await getCSSRules(styleSheets, options);
    return getWebFontRules(cssRules);
}
function normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font) => {
            fonts.add(normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child) => {
            if (child instanceof HTMLElement) {
                traverse(child);
            }
        });
    }
    traverse(node);
    return fonts;
}
async function getWebFontCSS(node, options) {
    const rules = await parseWebFontRules(node, options);
    const usedFonts = getUsedFonts(node);
    const cssTexts = await Promise.all(rules
        .filter((rule) => usedFonts.has(normalizeFontFamily(rule.style.fontFamily)))
        .map((rule) => {
        const baseUrl = rule.parentStyleSheet
            ? rule.parentStyleSheet.href
            : null;
        return embedResources(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function embedWebFonts(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null
        ? options.fontEmbedCSS
        : options.skipFonts
            ? null
            : await getWebFontCSS(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) {
            clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        }
        else {
            clonedNode.appendChild(styleNode);
        }
    }
}

async function toSvg(node, options = {}) {
    const { width, height } = getImageSize(node, options);
    const clonedNode = (await cloneNode(node, options, true));
    await embedWebFonts(clonedNode, options);
    await embedImages(clonedNode, options);
    applyStyle(clonedNode, options);
    const datauri = await nodeToDataURL(clonedNode, width, height);
    return datauri;
}
async function toCanvas(node, options = {}) {
    const { width, height } = getImageSize(node, options);
    const svg = await toSvg(node, options);
    const img = await createImage(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || getPixelRatio();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) {
        checkCanvasDimensions(canvas);
    }
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function toPng(node, options = {}) {
    const canvas = await toCanvas(node, options);
    return canvas.toDataURL();
}
async function toJpeg(node, options = {}) {
    const canvas = await toCanvas(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}

const buildImage = async (id, options = { type: 'png' }) => {
    const { type } = options;
    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    const htmlToImageStyle = {};
    if (id === 'card-surface-back') {
        htmlToImageStyle['transform'] = 'none';
    }
    if (type === 'jpeg') {
        htmlToImageStyle['borderRadius'] = 0;
    }
    const htmlToImageParams = {
        cacheBust: true,
        canvasWidth: 750,
        canvasHeight: 1050,
        skipAutoScale: true,
        includeQueryParams: true,
        pixelRatio: isFirefox ? 1 : 3,
        style: htmlToImageStyle,
    };
    const layerElementToSave = document.getElementById(id);
    let dataUrl = '';
    let i = 0;
    let maxAttempts = 0;
    if (isFirefox) {
        maxAttempts = 5;
    }
    else {
        maxAttempts = 1;
    }
    let cycle = [];
    let repeat = true;
    while (repeat && i < maxAttempts) {
        console.log(type);
        if (type === 'jpeg') {
            dataUrl = await toJpeg(layerElementToSave, htmlToImageParams);
        }
        else if (type === 'svg') {
            dataUrl = await toSvg(layerElementToSave, htmlToImageParams);
        }
        else {
            dataUrl = await toPng(layerElementToSave, htmlToImageParams);
        }
        i += 1;
        cycle[i] = dataUrl.length;
        if (dataUrl.length > cycle[i - 1])
            repeat = false;
    }
    return dataUrl;
};
const saveImage = (blob, fileName) => {
    if (!window)
        return;
    const elem = window.document.createElement('a');
    elem.href = blob;
    elem.download = fileName;
    elem.setAttribute('style', 'display:none;');
    (document.body || document.documentElement).appendChild(elem);
    if (typeof elem.click === 'function') {
        elem.click();
    }
    else {
        elem.target = '_blank';
        elem.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        }));
    }
    URL.revokeObjectURL(elem.href);
    elem.remove();
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutPropertiesLoose$a(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var browser = invariant;

var invariant$1 = /*@__PURE__*/getDefaultExportFromCjs(browser);

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (String )(input); }

function useUncontrolledProp$1(propValue, defaultValue, handler) {
  var wasPropRef = React.useRef(propValue !== undefined);

  var _useState = React.useState(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, React.useCallback(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}
function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = _objectWithoutPropertiesLoose$a(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp$1(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return _extends({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/React__namespace.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;
function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = React.useContext(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = React.useContext(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = React.useContext(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = React.useContext(ThemeContext);
  return dir === 'rtl';
}

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle$2(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}

var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}

function style$1(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle$2(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

var propTypes$3 = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$1.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$1.exports = requireReactIs_production_min$1();
	} else {
	  reactIs$1.exports = requireReactIs_development$1();
	}
	return reactIs$1.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$1;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$1;
	hasRequiredHas = 1;
	has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$3.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$3.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$3.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$a(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$5() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

function isEscKey(e) {
  return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
  const parts = React__namespace.version.split('.');
  return {
    major: +parts[0],
    minor: +parts[1],
    patch: +parts[2]
  };
}
function getChildRef(element) {
  if (!element || typeof element === 'function') {
    return null;
  }
  const {
    major
  } = getReactVersion();
  const childRef = major >= 19 ? element.props.ref : element.ref;
  return childRef;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}

function parseDuration$1(node) {
  var str = style$1(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = listen(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration$1(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = listen(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

function parseDuration(node, property) {
  const str = style$1(node, property) || '';
  const mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
  const duration = parseDuration(element, 'transitionDuration');
  const delay = parseDuration(element, 'transitionDelay');
  const remove = transitionEnd(element, e => {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }
    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args);
      // @ts-ignore
      f.apply(this, args);
    };
  }, null);
}

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}

const toFnRef$1 = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function mergeRefs$1(refA, refB) {
  const a = toFnRef$1(refA);
  const b = toFnRef$1(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs$1(refA, refB) {
  return React.useMemo(() => mergeRefs$1(refA, refB), [refA, refB]);
}

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return ReactDOM.findDOMNode(componentOrElement);
  }
  return componentOrElement != null ? componentOrElement : null;
}

// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/React.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  addEndListener,
  children,
  childRef,
  ...props
}, ref) => {
  const nodeRef = React.useRef(null);
  const mergedRef = useMergedRefs$1(nodeRef, childRef);
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const handleEnter = React.useCallback(normalize(onEnter), [onEnter]);
  const handleEntering = React.useCallback(normalize(onEntering), [onEntering]);
  const handleEntered = React.useCallback(normalize(onEntered), [onEntered]);
  const handleExit = React.useCallback(normalize(onExit), [onExit]);
  const handleExiting = React.useCallback(normalize(onExiting), [onExiting]);
  const handleExited = React.useCallback(normalize(onExited), [onExited]);
  const handleAddEndListener = React.useCallback(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return /*#__PURE__*/jsxRuntime.jsx(Transition, {
    ref: ref,
    ...props,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, {
      ...innerProps,
      ref: attachRef
    }) : /*#__PURE__*/React.cloneElement(children, {
      ref: attachRef
    })
  });
});

const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};
function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value +
  // @ts-ignore
  parseInt(style$1(elem, margins[0]), 10) +
  // @ts-ignore
  parseInt(style$1(elem, margins[1]), 10);
}
const collapseStyles = {
  [EXITED]: 'collapse',
  [EXITING]: 'collapsing',
  [ENTERING]: 'collapsing',
  [ENTERED]: 'collapse show'
};
const Collapse = /*#__PURE__*/React.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  in: inProp = false,
  timeout = 300,
  mountOnEnter = false,
  unmountOnExit = false,
  appear = false,
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;

  /* -- Expanding -- */
  const handleEnter = React.useMemo(() => createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = React.useMemo(() => createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = React.useMemo(() => createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);

  /* -- Collapsing -- */
  const handleExit = React.useMemo(() => createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    triggerBrowserReflow(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = React.useMemo(() => createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/jsxRuntime.jsx(TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    ...props,
    "aria-expanded": props.role ? inProp : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: getChildRef(children),
    in: inProp,
    timeout: timeout,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    appear: appear,
    children: (state, innerProps) => /*#__PURE__*/React.cloneElement(children, {
      ...innerProps,
      className: classNames(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
});

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context$4 = /*#__PURE__*/React__namespace.createContext({});
context$4.displayName = 'AccordionContext';

/**
 * This component accepts all of [`Collapse`'s props](/docs/utilities/transitions#collapse-1).
 */
const AccordionCollapse = /*#__PURE__*/React__namespace.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = React.useContext(context$4);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/jsxRuntime.jsx(Collapse, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classNames(className, bsPrefix),
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      children: React__namespace.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';

const context$3 = /*#__PURE__*/React__namespace.createContext({
  eventKey: ''
});
context$3.displayName = 'AccordionItemContext';

const AccordionBody = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = React.useContext(context$3);
  return /*#__PURE__*/jsxRuntime.jsx(AccordionCollapse, {
    eventKey: eventKey,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      ref: ref,
      ...props,
      className: classNames(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';

function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = React.useContext(context$4);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;
    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }
    onSelect == null || onSelect(eventKeyPassed, e);
    onClick == null || onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = React.useContext(context$3);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = React.useContext(context$4);
  if (Component === 'button') {
    props.type = 'button';
  }
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : eventKey === activeEventKey,
    className: classNames(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';

const AccordionHeader = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  'aria-controls': ariaControls,
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-header');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    ...props,
    className: classNames(className, bsPrefix),
    children: /*#__PURE__*/jsxRuntime.jsx(AccordionButton, {
      onClick: onClick,
      "aria-controls": ariaControls,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';

const AccordionItem = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-item');
  const contextValue = React.useMemo(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/jsxRuntime.jsx(context$3.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      ref: ref,
      ...props,
      className: classNames(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';

const Accordion = /*#__PURE__*/React__namespace.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = useUncontrolled(props, {
    activeKey: 'onSelect'
  });
  const prefix = useBootstrapPrefix(bsPrefix, 'accordion');
  const contextValue = React.useMemo(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/jsxRuntime.jsx(context$4.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      ref: ref,
      ...controlledProps,
      className: classNames(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
var Accordion$1 = Object.assign(Accordion, {
  Button: AccordionButton,
  Collapse: AccordionCollapse,
  Item: AccordionItem,
  Header: AccordionHeader,
  Body: AccordionBody
});

const RPCAccordionComponent = (props) => {
    const { activeKey, alwaysOpen = true, className, children, defaultActiveKey, disabled, fluid, flush, } = props;
    const accordionClassNames = classNames({
        'rpc-accordion': true,
        'accordion--fluid': fluid,
        [`${className}`]: className,
    });
    return (React.createElement(Accordion$1, { activeKey: activeKey, alwaysOpen: alwaysOpen, className: accordionClassNames, defaultActiveKey: !disabled ? defaultActiveKey : undefined, flush: flush },
        disabled ? React.createElement("div", { className: "accordion-disabled" }) : undefined,
        children));
};
const RPCAccordion = React.memo(RPCAccordionComponent);

const IconPlusCircleComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, style, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, style: style, viewBox: "0 0 512 512" },
        React.createElement("path", { fill: fill, d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" })));
};
const IconPlusCircle = React.memo(IconPlusCircleComponent);

const IconMinusCircleComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 32 32" },
        React.createElement("path", { fill: fill, fillRule: "evenodd", d: "M22 17H10a1.001 1.001 0 0 1 0-2h12a1.001 1.001 0 0 1 0 2ZM16 0C7.163 0 0 7.16 0 16s7.163 16 16 16 16-7.16 16-16S24.837 0 16 0Z" })));
};
const IconMinusCircle = React.memo(IconMinusCircleComponent);

const RPCAccordionItemComponent = (props) => {
    const { children, className, bodyBgVariant, bodyTextVariant, headerBgVariant, headerTextVariant, eventKey, header, id, subheader, } = props;
    const accordionItemClassNames = classNames({
        [`bg-${headerBgVariant || 'light'}`]: true,
        [`${className}`]: className,
    });
    const accordionItemHeaderClassNames = classNames({
        [`text-${headerTextVariant || 'dark'}`]: headerTextVariant,
    });
    const accordionItemBodyClassNames = classNames({
        [`bg-${bodyBgVariant || 'light'}`]: true,
        [`text-${bodyTextVariant || 'dark'}`]: true,
    });
    return (React.createElement(Accordion$1.Item, { eventKey: eventKey, className: accordionItemClassNames, id: id },
        React.createElement(Accordion$1.Header, null,
            React.createElement("div", { className: "d-flex align-items-center w-100" },
                React.createElement("div", null,
                    React.createElement("div", { className: accordionItemHeaderClassNames }, header),
                    subheader ? (React.createElement("div", { className: "accordion-item__subheader my-1" }, subheader)) : undefined),
                React.createElement("div", { className: "ms-auto" },
                    React.createElement("span", { className: "expand-icon" },
                        React.createElement(IconPlusCircle, { width: 24, height: 24 })),
                    React.createElement("span", { className: "collapse-icon" },
                        React.createElement(IconMinusCircle, { width: 24, height: 24 }))))),
        React.createElement(Accordion$1.Body, { className: accordionItemBodyClassNames }, children)));
};
const RPCAccordionItem = React.memo(RPCAccordionItemComponent);

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef$1(value) {
  const ref = React.useRef(value);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback$1(fn) {
  const ref = useCommittedRef$1(fn);
  return React.useCallback(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

var divWithClassName = (className => /*#__PURE__*/React__namespace.forwardRef((p, ref) => /*#__PURE__*/jsxRuntime.jsx("div", {
  ...p,
  ref: ref,
  className: classNames(p.className, className)
})));

const DivStyledAsH4$1 = divWithClassName('h4');
DivStyledAsH4$1.displayName = 'DivStyledAsH4';
const AlertHeading = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH4$1,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'alert-heading');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
AlertHeading.displayName = 'AlertHeading';

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef$1() {
  return React.useState(null);
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef(value) {
  const ref = React.useRef(value);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  const ref = useCommittedRef(fn);
  return React.useCallback(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener(eventTarget, event, listener, capture = false) {
  const handler = useEventCallback(listener);
  React.useEffect(() => {
    const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return () => target.removeEventListener(event, handler, capture);
  }, [eventTarget]);
}

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted$1() {
  const mounted = React.useRef(true);
  const isMounted = React.useRef(() => mounted.current);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const isReactNative$1 = typeof global !== 'undefined' &&
// @ts-ignore
global.navigator &&
// @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM$2 = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
var useIsomorphicEffect$1 = isDOM$2 || isReactNative$1 ? React.useLayoutEffect : React.useEffect;

const _excluded$k = ["as", "disabled"];
function _objectWithoutPropertiesLoose$9(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function isTrivialHref$1(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref$1(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button$1 = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose$9(_ref, _excluded$k);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button$1.displayName = 'Button';

const _excluded$j = ["onKeyDown"];
function _objectWithoutPropertiesLoose$8(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      onKeyDown
    } = _ref,
    props = _objectWithoutPropertiesLoose$8(_ref, _excluded$j);
  const [buttonProps] = useButtonProps(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = useEventCallback(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });
  if (isTrivialHref(props.href) || props.role === 'button') {
    return /*#__PURE__*/jsxRuntime.jsx("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }
  return /*#__PURE__*/jsxRuntime.jsx("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';

const AlertLink = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = Anchor,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'alert-link');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
AlertLink.displayName = 'AlertLink';

const fadeStyles$1 = {
  [ENTERING]: 'show',
  [ENTERED]: 'show'
};
const Fade = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  children,
  transitionClasses = {},
  onEnter,
  ...rest
}, ref) => {
  const props = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    ...rest
  };
  const handleEnter = React.useCallback((node, isAppearing) => {
    triggerBrowserReflow(node);
    onEnter == null || onEnter(node, isAppearing);
  }, [onEnter]);
  return /*#__PURE__*/jsxRuntime.jsx(TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    ...props,
    onEnter: handleEnter,
    childRef: getChildRef(children),
    children: (status, innerProps) => /*#__PURE__*/React__namespace.cloneElement(children, {
      ...innerProps,
      className: classNames('fade', className, children.props.className, fadeStyles$1[status], transitionClasses[status])
    })
  });
});
Fade.displayName = 'Fade';

const propTypes$2 = {
  /** An accessible label indicating the relevant information about the Close Button. */
  'aria-label': PropTypes.string,
  /** A callback fired after the Close Button is clicked. */
  onClick: PropTypes.func,
  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: PropTypes.oneOf(['white'])
};
const CloseButton = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  variant,
  'aria-label': ariaLabel = 'Close',
  ...props
}, ref) => /*#__PURE__*/jsxRuntime.jsx("button", {
  ref: ref,
  type: "button",
  className: classNames('btn-close', variant && `btn-close-${variant}`, className),
  "aria-label": ariaLabel,
  ...props
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes$2;

const Alert = /*#__PURE__*/React__namespace.forwardRef((uncontrolledProps, ref) => {
  const {
    bsPrefix,
    show = true,
    closeLabel = 'Close alert',
    closeVariant,
    className,
    children,
    variant = 'primary',
    onClose,
    dismissible,
    transition = Fade,
    ...props
  } = useUncontrolled(uncontrolledProps, {
    show: 'onClose'
  });
  const prefix = useBootstrapPrefix(bsPrefix, 'alert');
  const handleClose = useEventCallback$1(e => {
    if (onClose) {
      onClose(false, e);
    }
  });
  const Transition = transition === true ? Fade : transition;
  const alert = /*#__PURE__*/jsxRuntime.jsxs("div", {
    role: "alert",
    ...(!Transition ? props : undefined),
    ref: ref,
    className: classNames(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
    children: [dismissible && /*#__PURE__*/jsxRuntime.jsx(CloseButton, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  });
  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/jsxRuntime.jsx(Transition, {
    unmountOnExit: true,
    ...props,
    ref: undefined,
    in: show,
    children: alert
  });
});
Alert.displayName = 'Alert';
var Alert$1 = Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
});

const Badge = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  bg = 'primary',
  pill = false,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'badge');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    ...props,
    className: classNames(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';

const BreadcrumbItem = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    ...props,
    className: classNames(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/jsxRuntime.jsx(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';

const Breadcrumb = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/jsxRuntime.jsx("ol", {
      ...listProps,
      className: classNames(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
var Breadcrumb$1 = Object.assign(Breadcrumb, {
  Item: BreadcrumbItem
});

const Button = /*#__PURE__*/React__namespace.forwardRef(({
  as,
  bsPrefix,
  variant = 'primary',
  size,
  active = false,
  disabled = false,
  className,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = useButtonProps({
    tagName: as,
    disabled,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...buttonProps,
    ...props,
    ref: ref,
    disabled: disabled,
    className: classNames(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
  });
});
Button.displayName = 'Button';

const ButtonGroup = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  size,
  vertical = false,
  className,
  role = 'group',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...rest
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'btn-group');
  let baseClass = prefix;
  if (vertical) baseClass = `${prefix}-vertical`;
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...rest,
    ref: ref,
    role: role,
    className: classNames(className, baseClass, size && `${prefix}-${size}`)
  });
});
ButtonGroup.displayName = 'ButtonGroup';

const context$2 = /*#__PURE__*/React__namespace.createContext(null);
context$2.displayName = 'CardHeaderContext';

/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */
function useUpdateEffect(fn, deps) {
  const isFirst = React.useRef(true);
  React.useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    return fn();
  }, deps);
}

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = React.useRef(true);
  const isMounted = React.useRef(() => mounted.current);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef$1(value) {
  const valueRef = React.useRef(value);
  valueRef.current = value;
  return valueRef;
}

/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */
function useWillUnmount$1(fn) {
  const onUnmount = useUpdatedRef$1(fn);
  React.useEffect(() => () => onUnmount.current(), []);
}

/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */
const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  const delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(() => setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}

/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */
function useTimeout() {
  const isMounted = useMounted();

  // types are confused between node and web here IDK
  const handleRef = React.useRef();
  useWillUnmount$1(() => clearTimeout(handleRef.current));
  return React.useMemo(() => {
    const clear = () => clearTimeout(handleRef.current);
    function set(fn, delayMs = 0) {
      if (!isMounted()) return;
      clear();
      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }
    return {
      set,
      clear,
      handleRef
    };
  }, []);
}

const CarouselCaption = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'carousel-caption');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
CarouselCaption.displayName = 'CarouselCaption';

const CarouselItem = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  const finalClassName = classNames(className, useBootstrapPrefix(bsPrefix, 'carousel-item'));
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    ...props,
    className: finalClassName
  });
});
CarouselItem.displayName = 'CarouselItem';

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */
function map(children, func) {
  let index = 0;
  return React__namespace.Children.map(children, child => /*#__PURE__*/React__namespace.isValidElement(child) ? func(child, index++) : child);
}

/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */
function forEach(children, func) {
  let index = 0;
  React__namespace.Children.forEach(children, child => {
    if ( /*#__PURE__*/React__namespace.isValidElement(child)) func(child, index++);
  });
}

/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */
function hasChildOfType(children, type) {
  return React__namespace.Children.toArray(children).some(child => /*#__PURE__*/React__namespace.isValidElement(child) && child.type === type);
}

const SWIPE_THRESHOLD = 40;
function isVisible$1(element) {
  if (!element || !element.style || !element.parentNode || !element.parentNode.style) {
    return false;
  }
  const elementStyle = getComputedStyle(element);
  return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const Carousel = /*#__PURE__*/React__namespace.forwardRef(({
  defaultActiveIndex = 0,
  ...uncontrolledProps
}, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    bsPrefix,
    slide = true,
    fade = false,
    controls = true,
    indicators = true,
    indicatorLabels = [],
    activeIndex,
    onSelect,
    onSlide,
    onSlid,
    interval = 5000,
    keyboard = true,
    onKeyDown,
    pause = 'hover',
    onMouseOver,
    onMouseOut,
    wrap = true,
    touch = true,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    prevIcon = /*#__PURE__*/jsxRuntime.jsx("span", {
      "aria-hidden": "true",
      className: "carousel-control-prev-icon"
    }),
    prevLabel = 'Previous',
    nextIcon = /*#__PURE__*/jsxRuntime.jsx("span", {
      "aria-hidden": "true",
      className: "carousel-control-next-icon"
    }),
    nextLabel = 'Next',
    variant,
    className,
    children,
    ...props
  } = useUncontrolled({
    defaultActiveIndex,
    ...uncontrolledProps
  }, {
    activeIndex: 'onSelect'
  });
  const prefix = useBootstrapPrefix(bsPrefix, 'carousel');
  const isRTL = useIsRTL();
  const nextDirectionRef = React.useRef(null);
  const [direction, setDirection] = React.useState('next');
  const [paused, setPaused] = React.useState(false);
  const [isSliding, setIsSliding] = React.useState(false);
  const [renderedActiveIndex, setRenderedActiveIndex] = React.useState(activeIndex || 0);
  React.useEffect(() => {
    if (!isSliding && activeIndex !== renderedActiveIndex) {
      if (nextDirectionRef.current) {
        setDirection(nextDirectionRef.current);
      } else {
        setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
      }
      if (slide) {
        setIsSliding(true);
      }
      setRenderedActiveIndex(activeIndex || 0);
    }
  }, [activeIndex, isSliding, renderedActiveIndex, slide]);
  React.useEffect(() => {
    if (nextDirectionRef.current) {
      nextDirectionRef.current = null;
    }
  });
  let numChildren = 0;
  let activeChildInterval;

  // Iterate to grab all of the children's interval values
  // (and count them, too)
  forEach(children, (child, index) => {
    ++numChildren;
    if (index === activeIndex) {
      activeChildInterval = child.props.interval;
    }
  });
  const activeChildIntervalRef = useCommittedRef$1(activeChildInterval);
  const prev = React.useCallback(event => {
    if (isSliding) {
      return;
    }
    let nextActiveIndex = renderedActiveIndex - 1;
    if (nextActiveIndex < 0) {
      if (!wrap) {
        return;
      }
      nextActiveIndex = numChildren - 1;
    }
    nextDirectionRef.current = 'prev';
    onSelect == null || onSelect(nextActiveIndex, event);
  }, [isSliding, renderedActiveIndex, onSelect, wrap, numChildren]);

  // This is used in the setInterval, so it should not invalidate.
  const next = useEventCallback$1(event => {
    if (isSliding) {
      return;
    }
    let nextActiveIndex = renderedActiveIndex + 1;
    if (nextActiveIndex >= numChildren) {
      if (!wrap) {
        return;
      }
      nextActiveIndex = 0;
    }
    nextDirectionRef.current = 'next';
    onSelect == null || onSelect(nextActiveIndex, event);
  });
  const elementRef = React.useRef();
  React.useImperativeHandle(ref, () => ({
    element: elementRef.current,
    prev,
    next
  }));

  // This is used in the setInterval, so it should not invalidate.
  const nextWhenVisible = useEventCallback$1(() => {
    if (!document.hidden && isVisible$1(elementRef.current)) {
      if (isRTL) {
        prev();
      } else {
        next();
      }
    }
  });
  const slideDirection = direction === 'next' ? 'start' : 'end';
  useUpdateEffect(() => {
    if (slide) {
      // These callbacks will be handled by the <Transition> callbacks.
      return;
    }
    onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    onSlid == null || onSlid(renderedActiveIndex, slideDirection);
  }, [renderedActiveIndex]);
  const orderClassName = `${prefix}-item-${direction}`;
  const directionalClassName = `${prefix}-item-${slideDirection}`;
  const handleEnter = React.useCallback(node => {
    triggerBrowserReflow(node);
    onSlide == null || onSlide(renderedActiveIndex, slideDirection);
  }, [onSlide, renderedActiveIndex, slideDirection]);
  const handleEntered = React.useCallback(() => {
    setIsSliding(false);
    onSlid == null || onSlid(renderedActiveIndex, slideDirection);
  }, [onSlid, renderedActiveIndex, slideDirection]);
  const handleKeyDown = React.useCallback(event => {
    if (keyboard && !/input|textarea/i.test(event.target.tagName)) {
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          if (isRTL) {
            next(event);
          } else {
            prev(event);
          }
          return;
        case 'ArrowRight':
          event.preventDefault();
          if (isRTL) {
            prev(event);
          } else {
            next(event);
          }
          return;
      }
    }
    onKeyDown == null || onKeyDown(event);
  }, [keyboard, onKeyDown, prev, next, isRTL]);
  const handleMouseOver = React.useCallback(event => {
    if (pause === 'hover') {
      setPaused(true);
    }
    onMouseOver == null || onMouseOver(event);
  }, [pause, onMouseOver]);
  const handleMouseOut = React.useCallback(event => {
    setPaused(false);
    onMouseOut == null || onMouseOut(event);
  }, [onMouseOut]);
  const touchStartXRef = React.useRef(0);
  const touchDeltaXRef = React.useRef(0);
  const touchUnpauseTimeout = useTimeout();
  const handleTouchStart = React.useCallback(event => {
    touchStartXRef.current = event.touches[0].clientX;
    touchDeltaXRef.current = 0;
    if (pause === 'hover') {
      setPaused(true);
    }
    onTouchStart == null || onTouchStart(event);
  }, [pause, onTouchStart]);
  const handleTouchMove = React.useCallback(event => {
    if (event.touches && event.touches.length > 1) {
      touchDeltaXRef.current = 0;
    } else {
      touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
    }
    onTouchMove == null || onTouchMove(event);
  }, [onTouchMove]);
  const handleTouchEnd = React.useCallback(event => {
    if (touch) {
      const touchDeltaX = touchDeltaXRef.current;
      if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
        if (touchDeltaX > 0) {
          prev(event);
        } else {
          next(event);
        }
      }
    }
    if (pause === 'hover') {
      touchUnpauseTimeout.set(() => {
        setPaused(false);
      }, interval || undefined);
    }
    onTouchEnd == null || onTouchEnd(event);
  }, [touch, pause, prev, next, touchUnpauseTimeout, interval, onTouchEnd]);
  const shouldPlay = interval != null && !paused && !isSliding;
  const intervalHandleRef = React.useRef();
  React.useEffect(() => {
    var _ref, _activeChildIntervalR;
    if (!shouldPlay) {
      return undefined;
    }
    const nextFunc = isRTL ? prev : next;
    intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
    return () => {
      if (intervalHandleRef.current !== null) {
        clearInterval(intervalHandleRef.current);
      }
    };
  }, [shouldPlay, prev, next, activeChildIntervalRef, interval, nextWhenVisible, isRTL]);
  const indicatorOnClicks = React.useMemo(() => indicators && Array.from({
    length: numChildren
  }, (_, index) => event => {
    onSelect == null || onSelect(index, event);
  }), [indicators, numChildren, onSelect]);
  return /*#__PURE__*/jsxRuntime.jsxs(Component, {
    ref: elementRef,
    ...props,
    onKeyDown: handleKeyDown,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    className: classNames(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
    children: [indicators && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: `${prefix}-indicators`,
      children: map(children, (_, index) => /*#__PURE__*/jsxRuntime.jsx("button", {
        type: "button",
        "data-bs-target": "" // Bootstrap requires this in their css.
        ,
        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
        className: index === renderedActiveIndex ? 'active' : undefined,
        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
        "aria-current": index === renderedActiveIndex
      }, index))
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: `${prefix}-inner`,
      children: map(children, (child, index) => {
        const isActive = index === renderedActiveIndex;
        return slide ? /*#__PURE__*/jsxRuntime.jsx(TransitionWrapper, {
          in: isActive,
          onEnter: isActive ? handleEnter : undefined,
          onEntered: isActive ? handleEntered : undefined,
          addEndListener: transitionEndListener,
          children: (status, innerProps) => /*#__PURE__*/React__namespace.cloneElement(child, {
            ...innerProps,
            className: classNames(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
          })
        }) : ( /*#__PURE__*/React__namespace.cloneElement(child, {
          className: classNames(child.props.className, isActive && 'active')
        }));
      })
    }), controls && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [(wrap || activeIndex !== 0) && /*#__PURE__*/jsxRuntime.jsxs(Anchor, {
        className: `${prefix}-control-prev`,
        onClick: prev,
        children: [prevIcon, prevLabel && /*#__PURE__*/jsxRuntime.jsx("span", {
          className: "visually-hidden",
          children: prevLabel
        })]
      }), (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/jsxRuntime.jsxs(Anchor, {
        className: `${prefix}-control-next`,
        onClick: next,
        children: [nextIcon, nextLabel && /*#__PURE__*/jsxRuntime.jsx("span", {
          className: "visually-hidden",
          children: nextLabel
        })]
      })]
    })]
  });
});
Carousel.displayName = 'Carousel';
var Carousel$1 = Object.assign(Carousel, {
  Caption: CarouselCaption,
  Item: CarouselItem
});

function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  const breakpoints = useBootstrapBreakpoints();
  const minBreakpoint = useBootstrapMinBreakpoint();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classNames(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/React__namespace.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...colProps,
    ref: ref,
    className: classNames(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';

const Container = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    ...props,
    className: classNames(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';

var toArray$3 = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray$3(element.querySelectorAll(selector));
}

function useUncontrolledProp(propValue, defaultValue, handler) {
  const wasPropRef = React.useRef(propValue !== undefined);
  const [stateValue, setState] = React.useState(defaultValue);
  const isProp = propValue !== undefined;
  const wasProp = wasPropRef.current;
  wasPropRef.current = isProp;

  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */
  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }
  return [isProp ? propValue : stateValue, React.useCallback((...args) => {
    const [value, ...rest] = args;
    let returnValue = handler == null ? void 0 : handler(value, ...rest);
    setState(value);
    return returnValue;
  }, [handler])];
}

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */
function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are strictly equal to the last state value
  const [, dispatch] = React.useReducer(revision => revision + 1, 0);
  return dispatch;
}

const DropdownContext$1 = /*#__PURE__*/React__namespace.createContext(null);

var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */

function useSafeState$1(state) {
  const isMounted = useMounted$1();
  return [state[0], React.useCallback(nextState => {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$2(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains$2(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains$2(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

// For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment
const createPopper = popperGenerator({
  defaultModifiers: [hide$1, popperOffsets$1, computeStyles$1, eventListeners, offset$1, flip$1, preventOverflow$1, arrow$1]
});

const _excluded$i = ["enabled", "placement", "strategy", "modifiers"];
function _objectWithoutPropertiesLoose$7(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
const disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false,
  phase: 'afterWrite',
  fn: () => undefined
};

// until docjs supports type exports...

const ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: ({
    state
  }) => () => {
    const {
      reference,
      popper
    } = state.elements;
    if ('removeAttribute' in reference) {
      const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(id => id.trim() !== popper.id);
      if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
    }
  },
  fn: ({
    state
  }) => {
    var _popper$getAttribute;
    const {
      popper,
      reference
    } = state.elements;
    const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      const ids = reference.getAttribute('aria-describedby');
      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }
      reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
    }
  }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */
function usePopper(referenceElement, popperElement, _ref = {}) {
  let {
      enabled = true,
      placement = 'bottom',
      strategy = 'absolute',
      modifiers = EMPTY_MODIFIERS
    } = _ref,
    config = _objectWithoutPropertiesLoose$7(_ref, _excluded$i);
  const prevModifiers = React.useRef(modifiers);
  const popperInstanceRef = React.useRef();
  const update = React.useCallback(() => {
    var _popperInstanceRef$cu;
    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  const forceUpdate = React.useCallback(() => {
    var _popperInstanceRef$cu2;
    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);
  const [popperState, setState] = useSafeState$1(React.useState({
    placement,
    update,
    forceUpdate,
    attributes: {},
    styles: {
      popper: {},
      arrow: {}
    }
  }));
  const updateModifier = React.useMemo(() => ({
    name: 'updateStateModifier',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    fn: ({
      state
    }) => {
      const styles = {};
      const attributes = {};
      Object.keys(state.elements).forEach(element => {
        styles[element] = state.styles[element];
        attributes[element] = state.attributes[element];
      });
      setState({
        state,
        styles,
        attributes,
        update,
        forceUpdate,
        placement: state.placement
      });
    }
  }), [update, forceUpdate, setState]);
  const nextModifiers = React.useMemo(() => {
    if (!dequal(prevModifiers.current, modifiers)) {
      prevModifiers.current = modifiers;
    }
    return prevModifiers.current;
  }, [modifiers]);
  React.useEffect(() => {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement,
      strategy,
      modifiers: [...nextModifiers, updateModifier, disabledApplyStylesModifier]
    });
  }, [strategy, placement, updateModifier, enabled, nextModifiers]);
  React.useEffect(() => {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }
    popperInstanceRef.current = createPopper(referenceElement, popperElement, Object.assign({}, config, {
      placement,
      strategy,
      modifiers: [...nextModifiers, ariaDescribedByModifier, updateModifier]
    }));
    return () => {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(s => Object.assign({}, s, {
          attributes: {},
          styles: {
            popper: {}
          }
        }));
      }
    };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}

/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains$1(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$1 = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$1 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$1;

var warning$2 = /*@__PURE__*/getDefaultExportFromCjs(warning_1);

const noop$4 = () => {};
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = ref => ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
  click: 'mousedown',
  mouseup: 'mousedown',
  pointerup: 'pointerdown'
};

/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useClickOutside(ref, onClickOutside = noop$4, {
  disabled,
  clickTrigger = 'click'
} = {}) {
  const preventMouseClickOutsideRef = React.useRef(false);
  const waitingForTrigger = React.useRef(false);
  const handleMouseCapture = React.useCallback(e => {
    const currentTarget = getRefTarget(ref);
    warning$2(!!currentTarget, 'ClickOutside captured a close event but does not have a ref to compare it to. ' + 'useClickOutside(), should be passed a ref that resolves to a DOM node');
    preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains$1(currentTarget, e.target) || waitingForTrigger.current;
    waitingForTrigger.current = false;
  }, [ref]);
  const handleInitialMouse = useEventCallback(e => {
    const currentTarget = getRefTarget(ref);
    if (currentTarget && contains$1(currentTarget, e.target)) {
      waitingForTrigger.current = true;
    } else {
      // When clicking on scrollbars within current target, click events are not triggered, so this ref
      // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
      // to close the overlay.
      waitingForTrigger.current = false;
    }
  });
  const handleMouse = useEventCallback(e => {
    if (!preventMouseClickOutsideRef.current) {
      onClickOutside(e);
    }
  });
  React.useEffect(() => {
    var _ownerWindow$event, _ownerWindow$parent;
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));
    const ownerWindow = doc.defaultView || window;

    // Store the current event to avoid triggering handlers immediately
    // For things rendered in an iframe, the event might originate on the parent window
    // so we should fall back to that global event if the local one doesn't exist
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
    let removeInitialTriggerListener = null;
    if (InitialTriggerEvents[clickTrigger]) {
      removeInitialTriggerListener = listen(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
    }

    // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.
    const removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    const removeMouseListener = listen(doc, clickTrigger, e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleMouse(e);
    });
    let mobileSafariHackListeners = [];
    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(el => listen(el, 'mousemove', noop$4));
    }
    return () => {
      removeInitialTriggerListener == null ? void 0 : removeInitialTriggerListener();
      removeMouseCaptureListener();
      removeMouseListener();
      mobileSafariHackListeners.forEach(remove => remove());
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleInitialMouse, handleMouse]);
}

function toModifierMap(modifiers) {
  const result = {};
  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  }

  // eslint-disable-next-line no-unused-expressions
  modifiers == null ? void 0 : modifiers.forEach(m => {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map = {}) {
  if (Array.isArray(map)) return map;
  return Object.keys(map).map(k => {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig({
  enabled,
  enableEvents,
  placement,
  flip,
  offset,
  fixed,
  containerPadding,
  arrowElement,
  popperConfig = {}
}) {
  var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
  const modifiers = toModifierMap(popperConfig.modifiers);
  return Object.assign({}, popperConfig, {
    placement,
    enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(Object.assign({}, modifiers, {
      eventListeners: {
        enabled: enableEvents,
        options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
      },
      preventOverflow: Object.assign({}, modifiers.preventOverflow, {
        options: containerPadding ? Object.assign({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: Object.assign({
          offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: Object.assign({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: Object.assign({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

const _excluded$h = ["children", "usePopper"];
function _objectWithoutPropertiesLoose$6(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
const noop$3 = () => {};

/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */
function useDropdownMenu(options = {}) {
  const context = React.useContext(DropdownContext$1);
  const [arrowElement, attachArrowRef] = useCallbackRef$1();
  const hasShownRef = React.useRef(false);
  const {
    flip,
    offset,
    rootCloseEvent,
    fixed = false,
    placement: placementOverride,
    popperConfig = {},
    enableEventListeners = true,
    usePopper: shouldUsePopper = !!context
  } = options;
  const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
  if (show && !hasShownRef.current) {
    hasShownRef.current = true;
  }
  const handleClose = e => {
    context == null ? void 0 : context.toggle(false, e);
  };
  const {
    placement,
    setMenu,
    menuElement,
    toggleElement
  } = context || {};
  const popper = usePopper(toggleElement, menuElement, mergeOptionsWithPopperConfig({
    placement: placementOverride || placement || 'bottom-start',
    enabled: shouldUsePopper,
    enableEvents: enableEventListeners == null ? show : enableEventListeners,
    offset,
    flip,
    fixed,
    arrowElement,
    popperConfig
  }));
  const menuProps = Object.assign({
    ref: setMenu || noop$3,
    'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
  }, popper.attributes.popper, {
    style: popper.styles.popper
  });
  const metadata = {
    show,
    placement,
    hasShown: hasShownRef.current,
    toggle: context == null ? void 0 : context.toggle,
    popper: shouldUsePopper ? popper : null,
    arrowProps: shouldUsePopper ? Object.assign({
      ref: attachArrowRef
    }, popper.attributes.arrow, {
      style: popper.styles.arrow
    }) : {}
  };
  useClickOutside(menuElement, handleClose, {
    clickTrigger: rootCloseEvent,
    disabled: !show
  });
  return [menuProps, metadata];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */
function DropdownMenu$1(_ref) {
  let {
      children,
      usePopper: usePopperProp = true
    } = _ref,
    options = _objectWithoutPropertiesLoose$6(_ref, _excluded$h);
  const [props, meta] = useDropdownMenu(Object.assign({}, options, {
    usePopper: usePopperProp
  }));
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: children(props, meta)
  });
}
DropdownMenu$1.displayName = 'DropdownMenu';

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $b5e257d569688ac6$var$SSRContext = /*#__PURE__*/ (React).createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = /*#__PURE__*/ (React).createContext(false);
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (React.useContext)($b5e257d569688ac6$var$SSRContext);
    let ref = (React.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (React).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) // On the first render, and first call to useId, store the id and state in our weak map.
            $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (React.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = ctx === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === 'test' ? 'react-aria' : `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (React).useId();
    let [didSSR] = (React.useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
    let prefix = didSSR || process.env.NODE_ENV === 'test' ? 'react-aria' : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof (React)['useId'] === 'function' ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (React)['useSyncExternalStore'] === 'function') return (React)['useSyncExternalStore']($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (React.useContext)($b5e257d569688ac6$var$IsSSRContext);
}

const isRoleMenu = el => {
  var _el$getAttribute;
  return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const noop$2 = () => {};

/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */
function useDropdownToggle() {
  const id = $b5e257d569688ac6$export$619500959fc48b26();
  const {
    show = false,
    toggle = noop$2,
    setToggle,
    menuElement
  } = React.useContext(DropdownContext$1) || {};
  const handleClick = React.useCallback(e => {
    toggle(!show, e);
  }, [show, toggle]);
  const props = {
    id,
    ref: setToggle || noop$2,
    onClick: handleClick,
    'aria-expanded': !!show
  };

  // This is maybe better down in an effect, but
  // the component is going to update anyway when the menu element
  // is set so might return new props.
  if (menuElement && isRoleMenu(menuElement)) {
    props['aria-haspopup'] = true;
  }
  return [props, {
    show,
    toggle
  }];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */
function DropdownToggle$1({
  children
}) {
  const [props, meta] = useDropdownToggle();
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: children(props, meta)
  });
}
DropdownToggle$1.displayName = 'DropdownToggle';

const SelectableContext = /*#__PURE__*/React__namespace.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};

const NavContext = /*#__PURE__*/React__namespace.createContext(null);
NavContext.displayName = 'NavContext';

const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}

const _excluded$g = ["eventKey", "disabled", "onClick", "active", "as"];
function _objectWithoutPropertiesLoose$5(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */
function useDropdownItem({
  key,
  href,
  active,
  disabled,
  onClick
}) {
  const onSelectCtx = React.useContext(SelectableContext);
  const navContext = React.useContext(NavContext);
  const {
    activeKey
  } = navContext || {};
  const eventKey = makeEventKey(key, href);
  const isActive = active == null && key != null ? makeEventKey(activeKey) === eventKey : active;
  const handleClick = useEventCallback(event => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(event);
    if (onSelectCtx && !event.isPropagationStopped()) {
      onSelectCtx(eventKey, event);
    }
  });
  return [{
    onClick: handleClick,
    'aria-disabled': disabled || undefined,
    'aria-selected': isActive,
    [dataAttr('dropdown-item')]: ''
  }, {
    isActive
  }];
}
const DropdownItem$1 = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      eventKey,
      disabled,
      onClick,
      active,
      as: Component = Button$1
    } = _ref,
    props = _objectWithoutPropertiesLoose$5(_ref, _excluded$g);
  const [dropdownItemProps] = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled,
    onClick,
    active
  });
  return /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({}, props, {
    ref: ref
  }, dropdownItemProps));
});
DropdownItem$1.displayName = 'DropdownItem';

const Context$1 = /*#__PURE__*/React.createContext(canUseDOM ? window : undefined);
Context$1.Provider;

/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */
function useWindow() {
  return React.useContext(Context$1);
}

function useRefWithUpdate() {
  const forceUpdate = useForceUpdate();
  const ref = React.useRef(null);
  const attachRef = React.useCallback(element => {
    ref.current = element;
    // ensure that a menu set triggers an update for consumers
    forceUpdate();
  }, [forceUpdate]);
  return [ref, attachRef];
}

/**
 * @displayName Dropdown
 * @public
 */
function Dropdown$2({
  defaultShow,
  show: rawShow,
  onSelect,
  onToggle: rawOnToggle,
  itemSelector = `* [${dataAttr('dropdown-item')}]`,
  focusFirstItemOnShow,
  placement = 'bottom-start',
  children
}) {
  const window = useWindow();
  const [show, onToggle] = useUncontrolledProp(rawShow, defaultShow, rawOnToggle);

  // We use normal refs instead of useCallbackRef in order to populate the
  // the value as quickly as possible, otherwise the effect to focus the element
  // may run before the state value is set
  const [menuRef, setMenu] = useRefWithUpdate();
  const menuElement = menuRef.current;
  const [toggleRef, setToggle] = useRefWithUpdate();
  const toggleElement = toggleRef.current;
  const lastShow = usePrevious(show);
  const lastSourceEvent = React.useRef(null);
  const focusInDropdown = React.useRef(false);
  const onSelectCtx = React.useContext(SelectableContext);
  const toggle = React.useCallback((nextShow, event, source = event == null ? void 0 : event.type) => {
    onToggle(nextShow, {
      originalEvent: event,
      source
    });
  }, [onToggle]);
  const handleSelect = useEventCallback((key, event) => {
    onSelect == null ? void 0 : onSelect(key, event);
    toggle(false, event, 'select');
    if (!event.isPropagationStopped()) {
      onSelectCtx == null ? void 0 : onSelectCtx(key, event);
    }
  });
  const context = React.useMemo(() => ({
    toggle,
    placement,
    show,
    menuElement,
    toggleElement,
    setMenu,
    setToggle
  }), [toggle, placement, show, menuElement, toggleElement, setMenu, setToggle]);
  if (menuElement && lastShow && !show) {
    focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
  }
  const focusToggle = useEventCallback(() => {
    if (toggleElement && toggleElement.focus) {
      toggleElement.focus();
    }
  });
  const maybeFocusFirst = useEventCallback(() => {
    const type = lastSourceEvent.current;
    let focusType = focusFirstItemOnShow;
    if (focusType == null) {
      focusType = menuRef.current && isRoleMenu(menuRef.current) ? 'keyboard' : false;
    }
    if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) {
      return;
    }
    const first = qsa(menuRef.current, itemSelector)[0];
    if (first && first.focus) first.focus();
  });
  React.useEffect(() => {
    if (show) maybeFocusFirst();else if (focusInDropdown.current) {
      focusInDropdown.current = false;
      focusToggle();
    }
    // only `show` should be changing
  }, [show, focusInDropdown, focusToggle, maybeFocusFirst]);
  React.useEffect(() => {
    lastSourceEvent.current = null;
  });
  const getNextFocusedChild = (current, offset) => {
    if (!menuRef.current) return null;
    const items = qsa(menuRef.current, itemSelector);
    let index = items.indexOf(current) + offset;
    index = Math.max(0, Math.min(index, items.length));
    return items[index];
  };
  useEventListener(React.useCallback(() => window.document, [window]), 'keydown', event => {
    var _menuRef$current, _toggleRef$current;
    const {
      key
    } = event;
    const target = event.target;
    const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
    const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);

    // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
    // in inscrutability
    const isInput = /input|textarea/i.test(target.tagName);
    if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) {
      return;
    }
    if (!fromMenu && !fromToggle) {
      return;
    }
    if (key === 'Tab' && (!menuRef.current || !show)) {
      return;
    }
    lastSourceEvent.current = event.type;
    const meta = {
      originalEvent: event,
      source: event.type
    };
    switch (key) {
      case 'ArrowUp':
        {
          const next = getNextFocusedChild(target, -1);
          if (next && next.focus) next.focus();
          event.preventDefault();
          return;
        }
      case 'ArrowDown':
        event.preventDefault();
        if (!show) {
          onToggle(true, meta);
        } else {
          const next = getNextFocusedChild(target, 1);
          if (next && next.focus) next.focus();
        }
        return;
      case 'Tab':
        // on keydown the target is the element being tabbed FROM, we need that
        // to know if this event is relevant to this dropdown (e.g. in this menu).
        // On `keyup` the target is the element being tagged TO which we use to check
        // if focus has left the menu
        addEventListener(target.ownerDocument, 'keyup', e => {
          var _menuRef$current2;
          if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) {
            onToggle(false, meta);
          }
        }, {
          once: true
        });
        break;
      case 'Escape':
        if (key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }
        onToggle(false, meta);
        break;
    }
  });
  return /*#__PURE__*/jsxRuntime.jsx(SelectableContext.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/jsxRuntime.jsx(DropdownContext$1.Provider, {
      value: context,
      children: children
    })
  });
}
Dropdown$2.displayName = 'Dropdown';
Dropdown$2.Menu = DropdownMenu$1;
Dropdown$2.Toggle = DropdownToggle$1;
Dropdown$2.Item = DropdownItem$1;

const DropdownContext = /*#__PURE__*/React__namespace.createContext({});
DropdownContext.displayName = 'DropdownContext';

const DropdownDivider = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'hr',
  role = 'separator',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'dropdown-divider');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    role: role,
    ...props
  });
});
DropdownDivider.displayName = 'DropdownDivider';

const DropdownHeader = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  role = 'heading',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'dropdown-header');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    role: role,
    ...props
  });
});
DropdownHeader.displayName = 'DropdownHeader';

const DropdownItem = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  eventKey,
  disabled = false,
  onClick,
  active,
  as: Component = Anchor,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'dropdown-item');
  const [dropdownItemProps, meta] = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled,
    onClick,
    active
  });
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ...dropdownItemProps,
    ref: ref,
    className: classNames(className, prefix, meta.isActive && 'active', disabled && 'disabled')
  });
});
DropdownItem.displayName = 'DropdownItem';

const DropdownItemText = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'span',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'dropdown-item-text');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
DropdownItemText.displayName = 'DropdownItemText';

const isReactNative = typeof global !== 'undefined' &&
// @ts-ignore
global.navigator &&
// @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM$1 = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
var useIsomorphicEffect = isDOM$1 || isReactNative ? React.useLayoutEffect : React.useEffect;

const context$1 = /*#__PURE__*/React__namespace.createContext(null);
context$1.displayName = 'InputGroupContext';

// TODO: check

const context = /*#__PURE__*/React__namespace.createContext(null);
context.displayName = 'NavbarContext';

function useWrappedRefWithWarning(ref, componentName) {
  // @ts-ignore
  if (!(process.env.NODE_ENV !== "production")) return ref;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const warningRef = React.useCallback(refValue => {
    !(refValue == null || !refValue.isReactComponent) ? process.env.NODE_ENV !== "production" ? invariant$1(false, `${componentName} injected a ref to a provided \`as\` component that resolved to a component instance instead of a DOM element. ` + 'Use `React.forwardRef` to provide the injected ref to the class component as a prop in order to pass it directly to a DOM element') : invariant$1(false) : void 0;
  }, [componentName]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMergedRefs$1(warningRef, ref);
}

function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
  const topStart = isRTL ? 'top-end' : 'top-start';
  const topEnd = isRTL ? 'top-start' : 'top-end';
  const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
  const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
  const leftStart = isRTL ? 'right-start' : 'left-start';
  const leftEnd = isRTL ? 'right-end' : 'left-end';
  const rightStart = isRTL ? 'left-start' : 'right-start';
  const rightEnd = isRTL ? 'left-end' : 'right-end';
  let placement = alignEnd ? bottomEnd : bottomStart;
  if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;else if (dropDirection === 'down-centered') placement = 'bottom';else if (dropDirection === 'up-centered') placement = 'top';
  return placement;
}
const DropdownMenu = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  align,
  rootCloseEvent,
  flip = true,
  show: showProps,
  renderOnMount,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  popperConfig,
  variant,
  ...props
}, ref) => {
  let alignEnd = false;
  const isNavbar = React.useContext(context);
  const prefix = useBootstrapPrefix(bsPrefix, 'dropdown-menu');
  const {
    align: contextAlign,
    drop,
    isRTL
  } = React.useContext(DropdownContext);
  align = align || contextAlign;
  const isInputGroup = React.useContext(context$1);
  const alignClasses = [];
  if (align) {
    if (typeof align === 'object') {
      const keys = Object.keys(align);
      process.env.NODE_ENV !== "production" ? warning$2(keys.length === 1, 'There should only be 1 breakpoint when passing an object to `align`') : void 0;
      if (keys.length) {
        const brkPoint = keys[0];
        const direction = align[brkPoint];

        // .dropdown-menu-end is required for responsively aligning
        // left in addition to align left classes.
        alignEnd = direction === 'start';
        alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
      }
    } else if (align === 'end') {
      alignEnd = true;
    }
  }
  const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
  const [menuProps, {
    hasShown,
    popper,
    show,
    toggle
  }] = useDropdownMenu({
    flip,
    rootCloseEvent,
    show: showProps,
    usePopper: !isNavbar && alignClasses.length === 0,
    offset: [0, 2],
    popperConfig,
    placement
  });
  menuProps.ref = useMergedRefs$1(useWrappedRefWithWarning(ref, 'DropdownMenu'), menuProps.ref);
  useIsomorphicEffect(() => {
    // Popper's initial position for the menu is incorrect when
    // renderOnMount=true. Need to call update() to correct it.
    if (show) popper == null || popper.update();
  }, [show]);
  if (!hasShown && !renderOnMount && !isInputGroup) return null;

  // For custom components provide additional, non-DOM, props;
  if (typeof Component !== 'string') {
    menuProps.show = show;
    menuProps.close = () => toggle == null ? void 0 : toggle(false);
    menuProps.align = align;
  }
  let style = props.style;
  if (popper != null && popper.placement) {
    // we don't need the default popper style,
    // menus are display: none when not shown.
    style = {
      ...props.style,
      ...menuProps.style
    };
    props['x-placement'] = popper.placement;
  }
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ...menuProps,
    style: style
    // Bootstrap css requires this data attrib to style responsive menus.
    ,
    ...((alignClasses.length || isNavbar) && {
      'data-bs-popper': 'static'
    }),
    className: classNames(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
  });
});
DropdownMenu.displayName = 'DropdownMenu';

const DropdownToggle = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  split,
  className,
  childBsPrefix,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = Button,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'dropdown-toggle');
  const dropdownContext = React.useContext(DropdownContext$1);
  if (childBsPrefix !== undefined) {
    props.bsPrefix = childBsPrefix;
  }
  const [toggleProps] = useDropdownToggle();
  toggleProps.ref = useMergedRefs$1(toggleProps.ref, useWrappedRefWithWarning(ref, 'DropdownToggle'));

  // This intentionally forwards size and variant (if set) to the
  // underlying component, to allow it to render size and style variants.
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    className: classNames(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
    ...toggleProps,
    ...props
  });
});
DropdownToggle.displayName = 'DropdownToggle';

const Dropdown = /*#__PURE__*/React__namespace.forwardRef((pProps, ref) => {
  const {
    bsPrefix,
    drop = 'down',
    show,
    className,
    align = 'start',
    onSelect,
    onToggle,
    focusFirstItemOnShow,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    navbar: _4,
    autoClose = true,
    ...props
  } = useUncontrolled(pProps, {
    show: 'onToggle'
  });
  const isInputGroup = React.useContext(context$1);
  const prefix = useBootstrapPrefix(bsPrefix, 'dropdown');
  const isRTL = useIsRTL();
  const isClosingPermitted = source => {
    // autoClose=false only permits close on button click
    if (autoClose === false) return source === 'click';

    // autoClose=inside doesn't permit close on rootClose
    if (autoClose === 'inside') return source !== 'rootClose';

    // autoClose=outside doesn't permit close on select
    if (autoClose === 'outside') return source !== 'select';
    return true;
  };
  const handleToggle = useEventCallback$1((nextShow, meta) => {
    var _meta$originalEvent;
    /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */
    const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
    if (isToggleButton && meta.source === 'mousedown') {
      return;
    }
    if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
    if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
  });
  const alignEnd = align === 'end';
  const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
  const contextValue = React.useMemo(() => ({
    align,
    drop,
    isRTL
  }), [align, drop, isRTL]);
  const directionClasses = {
    down: prefix,
    'down-centered': `${prefix}-center`,
    up: 'dropup',
    'up-centered': 'dropup-center dropup',
    end: 'dropend',
    start: 'dropstart'
  };
  return /*#__PURE__*/jsxRuntime.jsx(DropdownContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntime.jsx(Dropdown$2, {
      placement: placement,
      show: show,
      onSelect: onSelect,
      onToggle: handleToggle,
      focusFirstItemOnShow: focusFirstItemOnShow,
      itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
      children: isInputGroup ? props.children : /*#__PURE__*/jsxRuntime.jsx(Component, {
        ...props,
        ref: ref,
        className: classNames(className, show && 'show', directionClasses[drop])
      })
    })
  });
});
Dropdown.displayName = 'Dropdown';
var Dropdown$1 = Object.assign(Dropdown, {
  Toggle: DropdownToggle,
  Menu: DropdownMenu,
  Item: DropdownItem,
  ItemText: DropdownItemText,
  Divider: DropdownDivider,
  Header: DropdownHeader
});

({
  /**
   * @default 'img'
   */
  bsPrefix: PropTypes.string,
  /**
   * Sets image as fluid image.
   */
  fluid: PropTypes.bool,
  /**
   * Sets image shape as rounded.
   */
  rounded: PropTypes.bool,
  /**
   * Sets image shape as circle.
   */
  roundedCircle: PropTypes.bool,
  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: PropTypes.bool
});
const Image$1 = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  fluid = false,
  rounded = false,
  roundedCircle = false,
  thumbnail = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'img');
  return /*#__PURE__*/jsxRuntime.jsx("img", {
    // eslint-disable-line jsx-a11y/alt-text
    ref: ref,
    ...props,
    className: classNames(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
  });
});
Image$1.displayName = 'Image';

const propTypes$1 = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: PropTypes.string,
  /** Display feedback as a tooltip. */
  tooltip: PropTypes.bool,
  as: PropTypes.elementType
};
const Feedback = /*#__PURE__*/React__namespace.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  as: Component = 'div',
  className,
  type = 'valid',
  tooltip = false,
  ...props
}, ref) => /*#__PURE__*/jsxRuntime.jsx(Component, {
  ...props,
  ref: ref,
  className: classNames(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
}));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes$1;

// TODO

const FormContext = /*#__PURE__*/React__namespace.createContext({});

const FormCheckInput = /*#__PURE__*/React__namespace.forwardRef(({
  id,
  bsPrefix,
  className,
  type = 'checkbox',
  isValid = false,
  isInvalid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-input');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ref: ref,
    type: type,
    id: id || controlId,
    className: classNames(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  });
});
FormCheckInput.displayName = 'FormCheckInput';

const FormCheckLabel = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-label');
  return /*#__PURE__*/jsxRuntime.jsx("label", {
    ...props,
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classNames(className, bsPrefix)
  });
});
FormCheckLabel.displayName = 'FormCheckLabel';

const FormCheck = /*#__PURE__*/React__namespace.forwardRef(({
  id,
  bsPrefix,
  bsSwitchPrefix,
  inline = false,
  reverse = false,
  disabled = false,
  isValid = false,
  isInvalid = false,
  feedbackTooltip = false,
  feedback,
  feedbackType,
  className,
  style,
  title = '',
  type = 'checkbox',
  label,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as = 'input',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check');
  bsSwitchPrefix = useBootstrapPrefix(bsSwitchPrefix, 'form-switch');
  const {
    controlId
  } = React.useContext(FormContext);
  const innerFormContext = React.useMemo(() => ({
    controlId: id || controlId
  }), [controlId, id]);
  const hasLabel = !children && label != null && label !== false || hasChildOfType(children, FormCheckLabel);
  const input = /*#__PURE__*/jsxRuntime.jsx(FormCheckInput, {
    ...props,
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: as
  });
  return /*#__PURE__*/jsxRuntime.jsx(FormContext.Provider, {
    value: innerFormContext,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      style: style,
      className: classNames(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
      children: children || /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [input, hasLabel && /*#__PURE__*/jsxRuntime.jsx(FormCheckLabel, {
          title: title,
          children: label
        }), feedback && /*#__PURE__*/jsxRuntime.jsx(Feedback, {
          type: feedbackType,
          tooltip: feedbackTooltip,
          children: feedback
        })]
      })
    })
  });
});
FormCheck.displayName = 'FormCheck';
var FormCheck$1 = Object.assign(FormCheck, {
  Input: FormCheckInput,
  Label: FormCheckLabel
});

const FormControl = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  type,
  size,
  htmlSize,
  id,
  className,
  isValid = false,
  isInvalid = false,
  plaintext,
  readOnly,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-control');
  process.env.NODE_ENV !== "production" ? warning$2(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classNames(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
  });
});
FormControl.displayName = 'FormControl';
var FormControl$1 = Object.assign(FormControl, {
  Feedback
});

const FormFloating = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-floating');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
FormFloating.displayName = 'FormFloating';

const FormGroup = /*#__PURE__*/React__namespace.forwardRef(({
  controlId,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const context = React.useMemo(() => ({
    controlId
  }), [controlId]);
  return /*#__PURE__*/jsxRuntime.jsx(FormContext.Provider, {
    value: context,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      ...props,
      ref: ref
    })
  });
});
FormGroup.displayName = 'FormGroup';

const FormLabel = /*#__PURE__*/React__namespace.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'label',
  bsPrefix,
  column = false,
  visuallyHidden = false,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-label');
  let columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
  const classes = classNames(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
  process.env.NODE_ENV !== "production" ? warning$2(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/jsxRuntime.jsx(Col, {
    ref: ref,
    as: "label",
    className: classes,
    htmlFor: htmlFor,
    ...props
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    jsxRuntime.jsx(Component, {
      ref: ref,
      className: classes,
      htmlFor: htmlFor,
      ...props
    })
  );
});
FormLabel.displayName = 'FormLabel';

const FormRange = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-range');
  return /*#__PURE__*/jsxRuntime.jsx("input", {
    ...props,
    type: "range",
    ref: ref,
    className: classNames(className, bsPrefix),
    id: id || controlId
  });
});
FormRange.displayName = 'FormRange';

const FormSelect = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  size,
  htmlSize,
  className,
  isValid = false,
  isInvalid = false,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = React.useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-select');
  return /*#__PURE__*/jsxRuntime.jsx("select", {
    ...props,
    size: htmlSize,
    ref: ref,
    className: classNames(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
    id: id || controlId
  });
});
FormSelect.displayName = 'FormSelect';

const FormText = /*#__PURE__*/React__namespace.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  as: Component = 'small',
  muted,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-text');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ref: ref,
    className: classNames(className, bsPrefix, muted && 'text-muted')
  });
});
FormText.displayName = 'FormText';

const Switch = /*#__PURE__*/React__namespace.forwardRef((props, ref) => /*#__PURE__*/jsxRuntime.jsx(FormCheck$1, {
  ...props,
  ref: ref,
  type: "switch"
}));
Switch.displayName = 'Switch';
var Switch$1 = Object.assign(Switch, {
  Input: FormCheck$1.Input,
  Label: FormCheck$1.Label
});

const FloatingLabel = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  children,
  controlId,
  label,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-floating');
  return /*#__PURE__*/jsxRuntime.jsxs(FormGroup, {
    ref: ref,
    className: classNames(className, bsPrefix),
    controlId: controlId,
    ...props,
    children: [children, /*#__PURE__*/jsxRuntime.jsx("label", {
      htmlFor: controlId,
      children: label
    })]
  });
});
FloatingLabel.displayName = 'FloatingLabel';

const propTypes = {
  /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: PropTypes.any,
  /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */
  validated: PropTypes.bool,
  as: PropTypes.elementType
};
const Form = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  validated,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'form',
  ...props
}, ref) => /*#__PURE__*/jsxRuntime.jsx(Component, {
  ...props,
  ref: ref,
  className: classNames(className, validated && 'was-validated')
}));
Form.displayName = 'Form';
Form.propTypes = propTypes;
var Form$1 = Object.assign(Form, {
  Group: FormGroup,
  Control: FormControl$1,
  Floating: FormFloating,
  Check: FormCheck$1,
  Switch: Switch$1,
  Label: FormLabel,
  Text: FormText,
  Range: FormRange,
  Select: FormSelect,
  FloatingLabel
});

const InputGroupText = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'span',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'input-group-text');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
InputGroupText.displayName = 'InputGroupText';

const InputGroupCheckbox = props => /*#__PURE__*/jsxRuntime.jsx(InputGroupText, {
  children: /*#__PURE__*/jsxRuntime.jsx(FormCheckInput, {
    type: "checkbox",
    ...props
  })
});
const InputGroupRadio = props => /*#__PURE__*/jsxRuntime.jsx(InputGroupText, {
  children: /*#__PURE__*/jsxRuntime.jsx(FormCheckInput, {
    type: "radio",
    ...props
  })
});
const InputGroup = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  size,
  hasValidation,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'input-group');

  // Intentionally an empty object. Used in detecting if a dropdown
  // exists under an input group.
  const contextValue = React.useMemo(() => ({}), []);
  return /*#__PURE__*/jsxRuntime.jsx(context$1.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, {
      ref: ref,
      ...props,
      className: classNames(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
    })
  });
});
InputGroup.displayName = 'InputGroup';
var InputGroup$1 = Object.assign(InputGroup, {
  Text: InputGroupText,
  Radio: InputGroupRadio,
  Checkbox: InputGroupCheckbox
});

const toFnRef = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function mergeRefs(refA, refB) {
  const a = toFnRef(refA);
  const b = toFnRef(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs(refA, refB) {
  return React.useMemo(() => mergeRefs(refA, refB), [refA, refB]);
}

const TabContext = /*#__PURE__*/React__namespace.createContext(null);

const _excluded$f = ["as", "active", "eventKey"];
function _objectWithoutPropertiesLoose$4(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = React.useContext(SelectableContext);
  const navContext = React.useContext(NavContext);
  const tabContext = React.useContext(TabContext);
  let isActive = active;
  const props = {
    role
  };
  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null);

    // @ts-ignore
    props[dataAttr('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;

    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */
    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }
  if (props.role === 'tab') {
    props['aria-selected'] = isActive;
    if (!isActive) {
      props.tabIndex = -1;
    }
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }
  }
  props.onClick = useEventCallback(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);
    if (key == null) {
      return;
    }
    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem$1 = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      as: Component = Button$1,
      active,
      eventKey
    } = _ref,
    options = _objectWithoutPropertiesLoose$4(_ref, _excluded$f);
  const [props, meta] = useNavItem(Object.assign({
    key: makeEventKey(eventKey, options.href),
    active
  }, options));

  // @ts-ignore
  props[dataAttr('active')] = meta.isActive;
  return /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem$1.displayName = 'NavItem';

const _excluded$e = ["as", "onSelect", "activeKey", "role", "onKeyDown"];
function _objectWithoutPropertiesLoose$3(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop$1 = () => {};
const EVENT_KEY_ATTR = dataAttr('event-key');
const Nav$2 = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
      as: Component = 'div',
      onSelect,
      activeKey,
      role,
      onKeyDown
    } = _ref,
    props = _objectWithoutPropertiesLoose$3(_ref, _excluded$e);
  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = useForceUpdate();
  const needsRefocusRef = React.useRef(false);
  const parentOnSelect = React.useContext(SelectableContext);
  const tabContext = React.useContext(TabContext);
  let getControlledId, getControllerId;
  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey;
    // TODO: do we need to duplicate these?
    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }
  const listNode = React.useRef(null);
  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = qsa(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };
  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };
  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (!tabContext) {
      return;
    }
    let nextActiveChild;
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;
      default:
        return;
    }
    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[dataProp('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };
  React.useEffect(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }
    needsRefocusRef.current = false;
  });
  const mergedRef = useMergedRefs(ref, listNode);
  return /*#__PURE__*/jsxRuntime.jsx(SelectableContext.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/jsxRuntime.jsx(NavContext.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: makeEventKey(activeKey),
        getControlledId: getControlledId || noop$1,
        getControllerId: getControllerId || noop$1
      },
      children: /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav$2.displayName = 'Nav';
var BaseNav = Object.assign(Nav$2, {
  Item: NavItem$1
});

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef() {
  return React.useState(null);
}

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = ownerDocument();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef(value) {
  const valueRef = React.useRef(value);
  valueRef.current = value;
  return valueRef;
}

/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @deprecated Use `useMounted` and normal effects, this is not StrictMode safe
 * @category effects
 */
function useWillUnmount(fn) {
  const onUnmount = useUpdatedRef(fn);
  React.useEffect(() => () => onUnmount.current(), []);
}

/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth(ownerDocument = document) {
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

const OPEN_DATA_ATTRIBUTE = dataAttr('modal-open');

/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */
class ModalManager {
  constructor({
    ownerDocument,
    handleContainerOverflow = true,
    isRTL = false
  } = {}) {
    this.handleContainerOverflow = handleContainerOverflow;
    this.isRTL = isRTL;
    this.modals = [];
    this.ownerDocument = ownerDocument;
  }
  getScrollbarWidth() {
    return getBodyScrollbarWidth(this.ownerDocument);
  }
  getElement() {
    return (this.ownerDocument || document).body;
  }
  setModalAttributes(_modal) {
    // For overriding
  }
  removeModalAttributes(_modal) {
    // For overriding
  }
  setContainerStyle(containerState) {
    const style = {
      overflow: 'hidden'
    };

    // we are only interested in the actual `style` here
    // because we will override it
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const container = this.getElement();
    containerState.style = {
      overflow: container.style.overflow,
      [paddingProp]: container.style[paddingProp]
    };
    if (containerState.scrollBarWidth) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style[paddingProp] = `${parseInt(style$1(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
    }
    container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
    style$1(container, style);
  }
  reset() {
    [...this.modals].forEach(m => this.remove(m));
  }
  removeContainerStyle(containerState) {
    const container = this.getElement();
    container.removeAttribute(OPEN_DATA_ATTRIBUTE);
    Object.assign(container.style, containerState.style);
  }
  add(modal) {
    let modalIdx = this.modals.indexOf(modal);
    if (modalIdx !== -1) {
      return modalIdx;
    }
    modalIdx = this.modals.length;
    this.modals.push(modal);
    this.setModalAttributes(modal);
    if (modalIdx !== 0) {
      return modalIdx;
    }
    this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    };
    if (this.handleContainerOverflow) {
      this.setContainerStyle(this.state);
    }
    return modalIdx;
  }
  remove(modal) {
    const modalIdx = this.modals.indexOf(modal);
    if (modalIdx === -1) {
      return;
    }
    this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (!this.modals.length && this.handleContainerOverflow) {
      this.removeContainerStyle(this.state);
    }
    this.removeModalAttributes(modal);
  }
  isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  }
}

const resolveContainerRef = (ref, document) => {
  if (!canUseDOM) return null;
  if (ref == null) return (document || ownerDocument()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = useWindow();
  const [resolvedRef, setRef] = React.useState(() => resolveContainerRef(ref, window == null ? void 0 : window.document));
  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }
  React.useEffect(() => {
  }, [onResolved, resolvedRef]);
  React.useEffect(() => {
    const nextRef = resolveContainerRef(ref);
    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

function NoopTransition({
  children,
  in: inProp,
  onExited,
  mountOnEnter,
  unmountOnExit
}) {
  const ref = React.useRef(null);
  const hasEnteredRef = React.useRef(inProp);
  const handleExited = useEventCallback(onExited);
  React.useEffect(() => {
    if (inProp) hasEnteredRef.current = true;else {
      handleExited(ref.current);
    }
  }, [inProp, handleExited]);
  const combinedRef = useMergedRefs(ref, getChildRef(children));
  const child = /*#__PURE__*/React.cloneElement(children, {
    ref: combinedRef
  });
  if (inProp) return child;
  if (unmountOnExit) {
    return null;
  }
  if (!hasEnteredRef.current && mountOnEnter) {
    return null;
  }
  return child;
}

const _excluded$d = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children"];
function _objectWithoutPropertiesLoose$2(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/**
 * Normalizes RTG transition callbacks with nodeRef to better support
 * strict mode.
 *
 * @param props Transition props.
 * @returns Normalized transition props.
 */
function useRTGTransitionProps(_ref) {
  let {
      onEnter,
      onEntering,
      onEntered,
      onExit,
      onExiting,
      onExited,
      addEndListener,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose$2(_ref, _excluded$d);
  const nodeRef = React.useRef(null);
  const mergedRef = useMergedRefs(nodeRef, getChildRef(children));
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const handleEnter = React.useCallback(normalize(onEnter), [onEnter]);
  const handleEntering = React.useCallback(normalize(onEntering), [onEntering]);
  const handleEntered = React.useCallback(normalize(onEntered), [onEntered]);
  const handleExit = React.useCallback(normalize(onExit), [onExit]);
  const handleExiting = React.useCallback(normalize(onExiting), [onExiting]);
  const handleExited = React.useCallback(normalize(onExited), [onExited]);
  const handleAddEndListener = React.useCallback(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return Object.assign({}, props, {
    nodeRef
  }, onEnter && {
    onEnter: handleEnter
  }, onEntering && {
    onEntering: handleEntering
  }, onEntered && {
    onEntered: handleEntered
  }, onExit && {
    onExit: handleExit
  }, onExiting && {
    onExiting: handleExiting
  }, onExited && {
    onExited: handleExited
  }, addEndListener && {
    addEndListener: handleAddEndListener
  }, {
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, Object.assign({}, innerProps, {
      ref: mergedRef
    })) : /*#__PURE__*/React.cloneElement(children, {
      ref: mergedRef
    })
  });
}

const _excluded$c = ["component"];
function _objectWithoutPropertiesLoose$1(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/React__namespace.forwardRef((_ref, ref) => {
  let {
      component: Component
    } = _ref,
    props = _objectWithoutPropertiesLoose$1(_ref, _excluded$c);
  const transitionProps = useRTGTransitionProps(props);
  return /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({
    ref: ref
  }, transitionProps));
});

function useTransition({
  in: inProp,
  onTransition
}) {
  const ref = React.useRef(null);
  const isInitialRef = React.useRef(true);
  const handleTransition = useEventCallback(onTransition);
  useIsomorphicEffect$1(() => {
    if (!ref.current) {
      return undefined;
    }
    let stale = false;
    handleTransition({
      in: inProp,
      element: ref.current,
      initial: isInitialRef.current,
      isStale: () => stale
    });
    return () => {
      stale = true;
    };
  }, [inProp, handleTransition]);
  useIsomorphicEffect$1(() => {
    isInitialRef.current = false;
    // this is for strict mode
    return () => {
      isInitialRef.current = true;
    };
  }, []);
  return ref;
}
/**
 * Adapts an imperative transition function to a subset of the RTG `<Transition>` component API.
 *
 * ImperativeTransition does not support mounting options or `appear` at the moment, meaning
 * that it always acts like: `mountOnEnter={true} unmountOnExit={true} appear={true}`
 */
function ImperativeTransition({
  children,
  in: inProp,
  onExited,
  onEntered,
  transition
}) {
  const [exited, setExited] = React.useState(!inProp);

  // TODO: I think this needs to be in an effect
  if (inProp && exited) {
    setExited(false);
  }
  const ref = useTransition({
    in: !!inProp,
    onTransition: options => {
      const onFinish = () => {
        if (options.isStale()) return;
        if (options.in) {
          onEntered == null ? void 0 : onEntered(options.element, options.initial);
        } else {
          setExited(true);
          onExited == null ? void 0 : onExited(options.element);
        }
      };
      Promise.resolve(transition(options)).then(onFinish, error => {
        if (!options.in) setExited(true);
        throw error;
      });
    }
  });
  const combinedRef = useMergedRefs(ref, getChildRef(children));
  return exited && !inProp ? null : /*#__PURE__*/React.cloneElement(children, {
    ref: combinedRef
  });
}
function renderTransition(component, runTransition, props) {
  if (component) {
    return /*#__PURE__*/jsxRuntime.jsx(RTGTransition, Object.assign({}, props, {
      component: component
    }));
  }
  if (runTransition) {
    return /*#__PURE__*/jsxRuntime.jsx(ImperativeTransition, Object.assign({}, props, {
      transition: runTransition
    }));
  }
  return /*#__PURE__*/jsxRuntime.jsx(NoopTransition, Object.assign({}, props));
}

const _excluded$b = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "runTransition", "backdropTransition", "runBackdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
let manager;

/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/

function getManager(window) {
  if (!manager) manager = new ModalManager({
    ownerDocument: window == null ? void 0 : window.document
  });
  return manager;
}
function useModalManager(provided) {
  const window = useWindow();
  const modalManager = provided || getManager(window);
  const modal = React.useRef({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: () => modalManager.add(modal.current),
    remove: () => modalManager.remove(modal.current),
    isTopModal: () => modalManager.isTopModal(modal.current),
    setDialogRef: React.useCallback(ref => {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: React.useCallback(ref => {
      modal.current.backdrop = ref;
    }, [])
  });
}
const Modal$2 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      show = false,
      role = 'dialog',
      className,
      style,
      children,
      backdrop = true,
      keyboard = true,
      onBackdropClick,
      onEscapeKeyDown,
      transition,
      runTransition,
      backdropTransition,
      runBackdropTransition,
      autoFocus = true,
      enforceFocus = true,
      restoreFocus = true,
      restoreFocusOptions,
      renderDialog,
      renderBackdrop = props => /*#__PURE__*/jsxRuntime.jsx("div", Object.assign({}, props)),
      manager: providedManager,
      container: containerRef,
      onShow,
      onHide = () => {},
      onExit,
      onExited,
      onExiting,
      onEnter,
      onEntering,
      onEntered
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const ownerWindow = useWindow();
  const container = useWaitForDOMRef(containerRef);
  const modal = useModalManager(providedManager);
  const isMounted = useMounted$1();
  const prevShow = usePrevious(show);
  const [exited, setExited] = React.useState(!show);
  const lastFocusRef = React.useRef(null);
  React.useImperativeHandle(ref, () => modal, [modal]);
  if (canUseDOM && !prevShow && show) {
    lastFocusRef.current = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
  }

  // TODO: I think this needs to be in an effect
  if (show && exited) {
    setExited(false);
  }
  const handleShow = useEventCallback(() => {
    modal.add();
    removeKeydownListenerRef.current = listen(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = listen(document, 'focus',
    // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    () => setTimeout(handleEnforceFocus), true);
    if (onShow) {
      onShow();
    }

    // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.
    if (autoFocus) {
      var _modal$dialog$ownerDo, _modal$dialog;
      const currentActiveElement = activeElement((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
      if (modal.dialog && currentActiveElement && !contains$1(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  const handleHide = useEventCallback(() => {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();
    if (restoreFocus) {
      var _lastFocusRef$current;
      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  });

  // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120

  // Show logic when:
  //  - show is `true` _and_ `container` has resolved
  React.useEffect(() => {
    if (!show || !container) return;
    handleShow();
  }, [show, container, /* should never change: */handleShow]);

  // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;
  React.useEffect(() => {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  useWillUnmount(() => {
    handleHide();
  });

  // --------------------------------

  const handleEnforceFocus = useEventCallback(() => {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }
    const currentActiveElement = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
    if (modal.dialog && currentActiveElement && !contains$1(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  const handleBackdropClick = useEventCallback(e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    onBackdropClick == null ? void 0 : onBackdropClick(e);
    if (backdrop === true) {
      onHide();
    }
  });
  const handleDocumentKeyDown = useEventCallback(e => {
    if (keyboard && isEscKey(e) && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);
      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  const removeFocusListenerRef = React.useRef();
  const removeKeydownListenerRef = React.useRef();
  const handleHidden = (...args) => {
    setExited(true);
    onExited == null ? void 0 : onExited(...args);
  };
  if (!container) {
    return null;
  }
  const dialogProps = Object.assign({
    role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style,
    className,
    tabIndex: -1
  });
  let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/jsxRuntime.jsx("div", Object.assign({}, dialogProps, {
    children: /*#__PURE__*/React__namespace.cloneElement(children, {
      role: 'document'
    })
  }));
  dialog = renderTransition(transition, runTransition, {
    unmountOnExit: true,
    mountOnEnter: true,
    appear: true,
    in: !!show,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered,
    children: dialog
  });
  let backdropElement = null;
  if (backdrop) {
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });
    backdropElement = renderTransition(backdropTransition, runBackdropTransition, {
      in: !!show,
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      children: backdropElement
    });
  }
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [backdropElement, dialog]
    }), container)
  });
});
Modal$2.displayName = 'Modal';
var BaseModal = Object.assign(Modal$2, {
  Manager: ModalManager
});

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

const Selector$1 = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends ModalManager {
  adjustAndStore(prop, element, adjust) {
    const actual = element.style[prop];
    // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    // @ts-ignore
    element.dataset[prop] = actual;
    style$1(element, {
      [prop]: `${parseFloat(style$1(element, prop)) + adjust}px`
    });
  }
  restore(prop, element) {
    const value = element.dataset[prop];
    if (value !== undefined) {
      delete element.dataset[prop];
      style$1(element, {
        [prop]: value
      });
    }
  }
  setContainerStyle(containerState) {
    super.setContainerStyle(containerState);
    const container = this.getElement();
    addClass(container, 'modal-open');
    if (!containerState.scrollBarWidth) return;
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector$1.FIXED_CONTENT).forEach(el => this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
    qsa(container, Selector$1.STICKY_CONTENT).forEach(el => this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
    qsa(container, Selector$1.NAVBAR_TOGGLER).forEach(el => this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
  }
  removeContainerStyle(containerState) {
    super.removeContainerStyle(containerState);
    const container = this.getElement();
    removeClass(container, 'modal-open');
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector$1.FIXED_CONTENT).forEach(el => this.restore(paddingProp, el));
    qsa(container, Selector$1.STICKY_CONTENT).forEach(el => this.restore(marginProp, el));
    qsa(container, Selector$1.NAVBAR_TOGGLER).forEach(el => this.restore(marginProp, el));
  }
}
let sharedManager;
function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}

const ModalBody = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-body');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
ModalBody.displayName = 'ModalBody';

const ModalContext = /*#__PURE__*/React__namespace.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide() {}
});

const ModalDialog = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    ...props,
    ref: ref,
    className: classNames(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: classNames(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';

const ModalFooter = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-footer');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
ModalFooter.displayName = 'ModalFooter';

const AbstractModalHeader = /*#__PURE__*/React__namespace.forwardRef(({
  closeLabel = 'Close',
  closeVariant,
  closeButton = false,
  onHide,
  children,
  ...props
}, ref) => {
  const context = React.useContext(ModalContext);
  const handleClick = useEventCallback$1(() => {
    context == null || context.onHide();
    onHide == null || onHide();
  });
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    ref: ref,
    ...props,
    children: [children, closeButton && /*#__PURE__*/jsxRuntime.jsx(CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  });
});

const ModalHeader = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  closeLabel = 'Close',
  closeButton = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-header');
  return /*#__PURE__*/jsxRuntime.jsx(AbstractModalHeader, {
    ref: ref,
    ...props,
    className: classNames(className, bsPrefix),
    closeLabel: closeLabel,
    closeButton: closeButton
  });
});
ModalHeader.displayName = 'ModalHeader';

const DivStyledAsH4 = divWithClassName('h4');
const ModalTitle = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH4,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-title');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
ModalTitle.displayName = 'ModalTitle';

/* eslint-disable no-use-before-define, react/no-multi-comp */
function DialogTransition$1(props) {
  return /*#__PURE__*/jsxRuntime.jsx(Fade, {
    ...props,
    timeout: null
  });
}
function BackdropTransition$1(props) {
  return /*#__PURE__*/jsxRuntime.jsx(Fade, {
    ...props,
    timeout: null
  });
}

/* eslint-enable no-use-before-define */
const Modal = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog = ModalDialog,
  'data-bs-theme': dataBsTheme,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,
  /* BaseModal props */

  show = false,
  animation = true,
  backdrop = true,
  keyboard = true,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus = true,
  enforceFocus = true,
  restoreFocus = true,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = React.useState({});
  const [animateStaticModal, setAnimateStaticModal] = React.useState(false);
  const waitingForMouseUpRef = React.useRef(false);
  const ignoreBackdropClickRef = React.useRef(false);
  const removeStaticModalAnimationRef = React.useRef(null);
  const [modal, setModalRef] = useCallbackRef();
  const mergedRef = useMergedRefs$1(ref, setModalRef);
  const handleHide = useEventCallback$1(onHide);
  const isRTL = useIsRTL();
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const modalContext = React.useMemo(() => ({
    onHide: handleHide
  }), [handleHide]);
  function getModalManager() {
    if (propsManager) return propsManager;
    return getSharedManager({
      isRTL
    });
  }
  function updateDialogStyle(node) {
    if (!canUseDOM) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > ownerDocument(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }
  const handleWindowResize = useEventCallback$1(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  useWillUnmount$1(() => {
    removeEventListener(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
  });

  // We prevent the modal from closing during a drag by detecting where the
  // click originates from. If it starts in the modal and then ends outside
  // don't close.
  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };
  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }
    waitingForMouseUpRef.current = false;
  };
  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = transitionEnd(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };
  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    handleStaticModalAnimation();
  };
  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }
    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }
    onHide == null || onHide();
  };
  const handleEscapeKeyDown = e => {
    if (keyboard) {
      onEscapeKeyDown == null || onEscapeKeyDown(e);
    } else {
      // Call preventDefault to stop modal from closing in @restart/ui.
      e.preventDefault();
      if (backdrop === 'static') {
        // Play static modal animation.
        handleStaticModalAnimation();
      }
    }
  };
  const handleEnter = (node, isAppearing) => {
    if (node) {
      updateDialogStyle(node);
    }
    onEnter == null || onEnter(node, isAppearing);
  };
  const handleExit = node => {
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    onExit == null || onExit(node);
  };
  const handleEntering = (node, isAppearing) => {
    onEntering == null || onEntering(node, isAppearing);

    // FIXME: This should work even when animation is disabled.
    addEventListener(window, 'resize', handleWindowResize);
  };
  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes
    onExited == null || onExited(node);

    // FIXME: This should work even when animation is disabled.
    removeEventListener(window, 'resize', handleWindowResize);
  };
  const renderBackdrop = React.useCallback(backdropProps => /*#__PURE__*/jsxRuntime.jsx("div", {
    ...backdropProps,
    className: classNames(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = {
    ...style,
    ...modalStyle
  };

  // If `display` is not set to block, autoFocus inside the modal fails
  // https://github.com/react-bootstrap/react-bootstrap/issues/5102
  baseModalStyle.display = 'block';
  const renderDialog = dialogProps => /*#__PURE__*/jsxRuntime.jsx("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classNames(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "data-bs-theme": dataBsTheme,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children: /*#__PURE__*/jsxRuntime.jsx(Dialog, {
      ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });
  return /*#__PURE__*/jsxRuntime.jsx(ModalContext.Provider, {
    value: modalContext,
    children: /*#__PURE__*/jsxRuntime.jsx(BaseModal, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition$1 : undefined,
      backdropTransition: animation ? BackdropTransition$1 : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal.displayName = 'Modal';
var Modal$1 = Object.assign(Modal, {
  Body: ModalBody,
  Header: ModalHeader,
  Title: ModalTitle,
  Footer: ModalFooter,
  Dialog: ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
});

const NavItem = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-item');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
NavItem.displayName = 'NavItem';

const NavLink = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  as: Component = Anchor,
  active,
  eventKey,
  disabled = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-link');
  const [navItemProps, meta] = useNavItem({
    key: makeEventKey(eventKey, props.href),
    active,
    disabled,
    ...props
  });
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ...navItemProps,
    ref: ref,
    disabled: disabled,
    className: classNames(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';

const Nav = /*#__PURE__*/React__namespace.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill = false,
    justify = false,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = useUncontrolled(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = useBootstrapPrefix(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = React.useContext(context);
  const cardHeaderContext = React.useContext(context$2);
  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }
  return /*#__PURE__*/jsxRuntime.jsx(BaseNav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classNames(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav.displayName = 'Nav';
var Nav$1 = Object.assign(Nav, {
  Item: NavItem,
  Link: NavLink
});

const NavbarBrand = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  as,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-brand');
  const Component = as || (props.href ? 'a' : 'span');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ref: ref,
    className: classNames(className, bsPrefix)
  });
});
NavbarBrand.displayName = 'NavbarBrand';

const NavbarCollapse = /*#__PURE__*/React__namespace.forwardRef(({
  children,
  bsPrefix,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-collapse');
  const context$1 = React.useContext(context);
  return /*#__PURE__*/jsxRuntime.jsx(Collapse, {
    in: !!(context$1 && context$1.expanded),
    ...props,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      ref: ref,
      className: bsPrefix,
      children: children
    })
  });
});
NavbarCollapse.displayName = 'NavbarCollapse';

const NavbarToggle = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  children,
  label = 'Toggle navigation',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  onClick,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-toggler');
  const {
    onToggle,
    expanded
  } = React.useContext(context) || {};
  const handleClick = useEventCallback$1(e => {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });
  if (Component === 'button') {
    props.type = 'button';
  }
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ...props,
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: classNames(className, bsPrefix, !expanded && 'collapsed'),
    children: children || /*#__PURE__*/jsxRuntime.jsx("span", {
      className: `${bsPrefix}-icon`
    })
  });
});
NavbarToggle.displayName = 'NavbarToggle';

const matchersByWindow = new WeakMap();
const getMatcher = (query, targetWindow) => {
  if (!query || !targetWindow) return undefined;
  const matchers = matchersByWindow.get(targetWindow) || new Map();
  matchersByWindow.set(targetWindow, matchers);
  let mql = matchers.get(query);
  if (!mql) {
    mql = targetWindow.matchMedia(query);
    mql.refCount = 0;
    matchers.set(mql.media, mql);
  }
  return mql;
};
/**
 * Match a media query and get updates as the match changes. The media string is
 * passed directly to `window.matchMedia` and run as a Layout Effect, so initial
 * matches are returned before the browser has a chance to paint.
 *
 * ```tsx
 * function Page() {
 *   const isWide = useMediaQuery('min-width: 1000px')
 *
 *   return isWide ? "very wide" : 'not so wide'
 * }
 * ```
 *
 * Media query lists are also reused globally, hook calls for the same query
 * will only create a matcher once under the hood.
 *
 * @param query A media query
 * @param targetWindow The window to match against, uses the globally available one as a default.
 */
function useMediaQuery(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
  const mql = getMatcher(query, targetWindow);
  const [matches, setMatches] = React.useState(() => mql ? mql.matches : false);
  useIsomorphicEffect(() => {
    let mql = getMatcher(query, targetWindow);
    if (!mql) {
      return setMatches(false);
    }
    let matchers = matchersByWindow.get(targetWindow);
    const handleChange = () => {
      setMatches(mql.matches);
    };
    mql.refCount++;
    mql.addListener(handleChange);
    handleChange();
    return () => {
      mql.removeListener(handleChange);
      mql.refCount--;
      if (mql.refCount <= 0) {
        matchers == null ? void 0 : matchers.delete(mql.media);
      }
      mql = undefined;
    };
  }, [query]);
  return matches;
}

/**
 * Create a responsive hook we a set of breakpoint names and widths.
 * You can use any valid css units as well as a numbers (for pixels).
 *
 * **NOTE:** The object key order is important! it's assumed to be in order from smallest to largest
 *
 * ```ts
 * const useBreakpoint = createBreakpointHook({
 *  xs: 0,
 *  sm: 576,
 *  md: 768,
 *  lg: 992,
 *  xl: 1200,
 * })
 * ```
 *
 * **Watch out!** using string values will sometimes construct media queries using css `calc()` which
 * is NOT supported in media queries by all browsers at the moment. use numbers for
 * the widest range of browser support.
 *
 * @param breakpointValues A object hash of names to breakpoint dimensions
 */
function createBreakpointHook(breakpointValues) {
  const names = Object.keys(breakpointValues);
  function and(query, next) {
    if (query === next) {
      return next;
    }
    return query ? `${query} and ${next}` : next;
  }
  function getNext(breakpoint) {
    return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
  }
  function getMaxQuery(breakpoint) {
    const next = getNext(breakpoint);
    let value = breakpointValues[next];
    if (typeof value === 'number') value = `${value - 0.2}px`;else value = `calc(${value} - 0.2px)`;
    return `(max-width: ${value})`;
  }
  function getMinQuery(breakpoint) {
    let value = breakpointValues[breakpoint];
    if (typeof value === 'number') {
      value = `${value}px`;
    }
    return `(min-width: ${value})`;
  }

  /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */

  /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */

  function useBreakpoint(breakpointOrMap, direction, window) {
    let breakpointMap;
    if (typeof breakpointOrMap === 'object') {
      breakpointMap = breakpointOrMap;
      window = direction;
      direction = true;
    } else {
      direction = direction || true;
      breakpointMap = {
        [breakpointOrMap]: direction
      };
    }
    let query = React.useMemo(() => Object.entries(breakpointMap).reduce((query, [key, direction]) => {
      if (direction === 'up' || direction === true) {
        query = and(query, getMinQuery(key));
      }
      if (direction === 'down' || direction === true) {
        query = and(query, getMaxQuery(key));
      }
      return query;
    }, ''), [JSON.stringify(breakpointMap)]);
    return useMediaQuery(query, window);
  }
  return useBreakpoint;
}
const useBreakpoint = createBreakpointHook({
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
});

const OffcanvasBody = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas-body');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
OffcanvasBody.displayName = 'OffcanvasBody';

const transitionStyles = {
  [ENTERING]: 'show',
  [ENTERED]: 'show'
};
const OffcanvasToggling = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  children,
  in: inProp = false,
  mountOnEnter = false,
  unmountOnExit = false,
  appear = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas');
  return /*#__PURE__*/jsxRuntime.jsx(TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    in: inProp,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    appear: appear,
    ...props,
    childRef: getChildRef(children),
    children: (status, innerProps) => /*#__PURE__*/React__namespace.cloneElement(children, {
      ...innerProps,
      className: classNames(className, children.props.className, (status === ENTERING || status === EXITING) && `${bsPrefix}-toggling`, transitionStyles[status])
    })
  });
});
OffcanvasToggling.displayName = 'OffcanvasToggling';

const OffcanvasHeader = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  closeLabel = 'Close',
  closeButton = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas-header');
  return /*#__PURE__*/jsxRuntime.jsx(AbstractModalHeader, {
    ref: ref,
    ...props,
    className: classNames(className, bsPrefix),
    closeLabel: closeLabel,
    closeButton: closeButton
  });
});
OffcanvasHeader.displayName = 'OffcanvasHeader';

const DivStyledAsH5 = divWithClassName('h5');
const OffcanvasTitle = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH5,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas-title');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
OffcanvasTitle.displayName = 'OffcanvasTitle';

function DialogTransition(props) {
  return /*#__PURE__*/jsxRuntime.jsx(OffcanvasToggling, {
    ...props
  });
}
function BackdropTransition(props) {
  return /*#__PURE__*/jsxRuntime.jsx(Fade, {
    ...props
  });
}
const Offcanvas = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  children,
  'aria-labelledby': ariaLabelledby,
  placement = 'start',
  responsive,
  /* BaseModal props */

  show = false,
  backdrop = true,
  keyboard = true,
  scroll = false,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus = true,
  enforceFocus = true,
  restoreFocus = true,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  renderStaticNode = false,
  ...props
}, ref) => {
  const modalManager = React.useRef();
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas');
  const [showOffcanvas, setShowOffcanvas] = React.useState(false);
  const handleHide = useEventCallback$1(onHide);
  const hideResponsiveOffcanvas = useBreakpoint(responsive || 'xs', 'up');
  React.useEffect(() => {
    // Handles the case where screen is resized while the responsive
    // offcanvas is shown. If `responsive` not provided, just use `show`.
    setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
  }, [show, responsive, hideResponsiveOffcanvas]);
  const modalContext = React.useMemo(() => ({
    onHide: handleHide
  }), [handleHide]);
  function getModalManager() {
    if (propsManager) return propsManager;
    if (scroll) {
      // Have to use a different modal manager since the shared
      // one handles overflow.
      if (!modalManager.current) modalManager.current = new BootstrapModalManager({
        handleContainerOverflow: false
      });
      return modalManager.current;
    }
    return getSharedManager();
  }
  const handleEnter = (node, ...args) => {
    if (node) node.style.visibility = 'visible';
    onEnter == null || onEnter(node, ...args);
  };
  const handleExited = (node, ...args) => {
    if (node) node.style.visibility = '';
    onExited == null || onExited(...args);
  };
  const renderBackdrop = React.useCallback(backdropProps => /*#__PURE__*/jsxRuntime.jsx("div", {
    ...backdropProps,
    className: classNames(`${bsPrefix}-backdrop`, backdropClassName)
  }), [backdropClassName, bsPrefix]);
  const renderDialog = dialogProps => /*#__PURE__*/jsxRuntime.jsx("div", {
    ...dialogProps,
    ...props,
    className: classNames(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
    "aria-labelledby": ariaLabelledby,
    children: children
  });
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [!showOffcanvas && (responsive || renderStaticNode) && renderDialog({}), /*#__PURE__*/jsxRuntime.jsx(ModalContext.Provider, {
      value: modalContext,
      children: /*#__PURE__*/jsxRuntime.jsx(BaseModal, {
        show: showOffcanvas,
        ref: ref,
        backdrop: backdrop,
        container: container,
        keyboard: keyboard,
        autoFocus: autoFocus,
        enforceFocus: enforceFocus && !scroll,
        restoreFocus: restoreFocus,
        restoreFocusOptions: restoreFocusOptions,
        onEscapeKeyDown: onEscapeKeyDown,
        onShow: onShow,
        onHide: handleHide,
        onEnter: handleEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleExited,
        manager: getModalManager(),
        transition: DialogTransition,
        backdropTransition: BackdropTransition,
        renderBackdrop: renderBackdrop,
        renderDialog: renderDialog
      })
    })]
  });
});
Offcanvas.displayName = 'Offcanvas';
var Offcanvas$1 = Object.assign(Offcanvas, {
  Body: OffcanvasBody,
  Header: OffcanvasHeader,
  Title: OffcanvasTitle
});

const NavbarOffcanvas = /*#__PURE__*/React__namespace.forwardRef(({
  onHide,
  ...props
}, ref) => {
  const context$1 = React.useContext(context);
  const handleHide = useEventCallback$1(() => {
    context$1 == null || context$1.onToggle == null || context$1.onToggle();
    onHide == null || onHide();
  });
  return /*#__PURE__*/jsxRuntime.jsx(Offcanvas$1, {
    ref: ref,
    show: !!(context$1 != null && context$1.expanded),
    ...props,
    renderStaticNode: true,
    onHide: handleHide
  });
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';

const NavbarText = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'span',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-text');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
NavbarText.displayName = 'NavbarText';

const Navbar = /*#__PURE__*/React__namespace.forwardRef((props, ref) => {
  const {
    bsPrefix: initialBsPrefix,
    expand = true,
    variant = 'light',
    bg,
    fixed,
    sticky,
    className,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav',
    expanded,
    onToggle,
    onSelect,
    collapseOnSelect = false,
    ...controlledProps
  } = useUncontrolled(props, {
    expanded: 'onToggle'
  });
  const bsPrefix = useBootstrapPrefix(initialBsPrefix, 'navbar');
  const handleCollapse = React.useCallback((...args) => {
    onSelect == null || onSelect(...args);
    if (collapseOnSelect && expanded) {
      onToggle == null || onToggle(false);
    }
  }, [onSelect, collapseOnSelect, expanded, onToggle]);

  // will result in some false positives but that seems better
  // than false negatives. strict `undefined` check allows explicit
  // "nulling" of the role if the user really doesn't want one
  if (controlledProps.role === undefined && Component !== 'nav') {
    controlledProps.role = 'navigation';
  }
  let expandClass = `${bsPrefix}-expand`;
  if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
  const navbarContext = React.useMemo(() => ({
    onToggle: () => onToggle == null ? void 0 : onToggle(!expanded),
    bsPrefix,
    expanded: !!expanded,
    expand
  }), [bsPrefix, expanded, expand, onToggle]);
  return /*#__PURE__*/jsxRuntime.jsx(context.Provider, {
    value: navbarContext,
    children: /*#__PURE__*/jsxRuntime.jsx(SelectableContext.Provider, {
      value: handleCollapse,
      children: /*#__PURE__*/jsxRuntime.jsx(Component, {
        ref: ref,
        ...controlledProps,
        className: classNames(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
      })
    })
  });
});
Navbar.displayName = 'Navbar';
var Navbar$1 = Object.assign(Navbar, {
  Brand: NavbarBrand,
  Collapse: NavbarCollapse,
  Offcanvas: NavbarOffcanvas,
  Text: NavbarText,
  Toggle: NavbarToggle
});

const NavDropdown = /*#__PURE__*/React__namespace.forwardRef(({
  id,
  title,
  children,
  bsPrefix,
  className,
  rootCloseEvent,
  menuRole,
  disabled,
  active,
  renderMenuOnMount,
  menuVariant,
  ...props
}, ref) => {
  /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */
  const navItemPrefix = useBootstrapPrefix(undefined, 'nav-item');
  return /*#__PURE__*/jsxRuntime.jsxs(Dropdown$1, {
    ref: ref,
    ...props,
    className: classNames(className, navItemPrefix),
    children: [/*#__PURE__*/jsxRuntime.jsx(Dropdown$1.Toggle, {
      id: id,
      eventKey: null,
      active: active,
      disabled: disabled,
      childBsPrefix: bsPrefix,
      as: NavLink,
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx(Dropdown$1.Menu, {
      role: menuRole,
      renderOnMount: renderMenuOnMount,
      rootCloseEvent: rootCloseEvent,
      variant: menuVariant,
      children: children
    })]
  });
});
NavDropdown.displayName = 'NavDropdown';
var NavDropdown$1 = Object.assign(NavDropdown, {
  Item: Dropdown$1.Item,
  ItemText: Dropdown$1.ItemText,
  Divider: Dropdown$1.Divider,
  Header: Dropdown$1.Header
});

const noop = () => {};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, {
  disabled,
  clickTrigger
} = {}) {
  const onClose = onRootClose || noop;
  useClickOutside(ref, onClose, {
    disabled,
    clickTrigger
  });
  const handleKeyUp = useEventCallback(e => {
    if (isEscKey(e)) {
      onClose(e);
    }
  });
  React.useEffect(() => {
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));

    // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (doc.defaultView || window).event;
    const removeKeyupListener = listen(doc, 'keyup', e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleKeyUp(e);
    });
    return () => {
      removeKeyupListener();
    };
  }, [ref, disabled, handleKeyUp]);
}

/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
const Overlay$1 = /*#__PURE__*/React__namespace.forwardRef((props, outerRef) => {
  const {
    flip,
    offset,
    placement,
    containerPadding,
    popperConfig = {},
    transition: Transition,
    runTransition
  } = props;
  const [rootElement, attachRef] = useCallbackRef$1();
  const [arrowElement, attachArrowRef] = useCallbackRef$1();
  const mergedRef = useMergedRefs(attachRef, outerRef);
  const container = useWaitForDOMRef(props.container);
  const target = useWaitForDOMRef(props.target);
  const [exited, setExited] = React.useState(!props.show);
  const popper = usePopper(target, rootElement, mergeOptionsWithPopperConfig({
    placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip,
    offset,
    arrowElement,
    popperConfig
  }));

  // TODO: I think this needs to be in an effect
  if (props.show && exited) {
    setExited(false);
  }
  const handleHidden = (...args) => {
    setExited(true);
    if (props.onExited) {
      props.onExited(...args);
    }
  };

  // Don't un-render the overlay while it's transitioning out.
  const mountOverlay = props.show || !exited;
  useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });
  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }
  const {
    onExit,
    onExiting,
    onEnter,
    onEntering,
    onEntered
  } = props;
  let child = props.children(Object.assign({}, popper.attributes.popper, {
    style: popper.styles.popper,
    ref: mergedRef
  }), {
    popper,
    placement,
    show: !!props.show,
    arrowProps: Object.assign({}, popper.attributes.arrow, {
      style: popper.styles.arrow,
      ref: attachArrowRef
    })
  });
  child = renderTransition(Transition, runTransition, {
    in: !!props.show,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    children: child,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered
  });
  return container ? /*#__PURE__*/ReactDOM.createPortal(child, container) : null;
});
Overlay$1.displayName = 'Overlay';

const PopoverHeader = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-header');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
PopoverHeader.displayName = 'PopoverHeader';

const PopoverBody = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-body');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
PopoverBody.displayName = 'PopoverBody';

// Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;
  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }
  return bsDirection;
}

function getInitialPopperStyles(position = 'absolute') {
  return {
    position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
}

const Popover = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  body,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'popover');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    ref: ref,
    role: "tooltip",
    style: computedStyle,
    "x-placement": primaryPlacement,
    className: classNames(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "popover-arrow",
      ...arrowProps
    }), body ? /*#__PURE__*/jsxRuntime.jsx(PopoverBody, {
      children: children
    }) : children]
  });
});
var Popover$1 = Object.assign(Popover, {
  Header: PopoverHeader,
  Body: PopoverBody,
  // Default popover offset.
  // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
  POPPER_OFFSET: [0, 8]
});

const Tooltip = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    ref: ref,
    style: computedStyle,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classNames(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.displayName = 'Tooltip';
var Tooltip$1 = Object.assign(Tooltip, {
  // Default tooltip offset.
  // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
  TOOLTIP_OFFSET: [0, 6]
});

// This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover or tooltip.
function useOverlayOffset(customOffset) {
  const overlayRef = React.useRef(null);
  const popoverClass = useBootstrapPrefix(undefined, 'popover');
  const tooltipClass = useBootstrapPrefix(undefined, 'tooltip');
  const offset = React.useMemo(() => ({
    name: 'offset',
    options: {
      offset: () => {
        if (customOffset) {
          return customOffset;
        }
        if (overlayRef.current) {
          if (hasClass(overlayRef.current, popoverClass)) {
            return Popover$1.POPPER_OFFSET;
          }
          if (hasClass(overlayRef.current, tooltipClass)) {
            return Tooltip$1.TOOLTIP_OFFSET;
          }
        }
        return [0, 0];
      }
    }
  }), [customOffset, popoverClass, tooltipClass]);
  return [overlayRef, [offset]];
}

function wrapRefs(props, arrowProps) {
  const {
    ref
  } = props;
  const {
    ref: aRef
  } = arrowProps;
  props.ref = ref.__wrapped || (ref.__wrapped = r => ref(safeFindDOMNode(r)));
  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = r => aRef(safeFindDOMNode(r)));
}
const Overlay = /*#__PURE__*/React__namespace.forwardRef(({
  children: overlay,
  transition = Fade,
  popperConfig = {},
  rootClose = false,
  placement = 'top',
  show: outerShow = false,
  ...outerProps
}, outerRef) => {
  const popperRef = React.useRef({});
  const [firstRenderedState, setFirstRenderedState] = React.useState(null);
  const [ref, modifiers] = useOverlayOffset(outerProps.offset);
  const mergedRef = useMergedRefs$1(outerRef, ref);
  const actualTransition = transition === true ? Fade : transition || undefined;
  const handleFirstUpdate = useEventCallback$1(state => {
    setFirstRenderedState(state);
    popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
  });
  useIsomorphicEffect(() => {
    if (firstRenderedState && outerProps.target) {
      // Must wait for target element to resolve before updating popper.
      popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }
  }, [firstRenderedState, outerProps.target]);
  React.useEffect(() => {
    if (!outerShow) {
      setFirstRenderedState(null);
    }
  }, [outerShow]);
  return /*#__PURE__*/jsxRuntime.jsx(Overlay$1, {
    ...outerProps,
    ref: mergedRef,
    popperConfig: {
      ...popperConfig,
      modifiers: modifiers.concat(popperConfig.modifiers || []),
      onFirstUpdate: handleFirstUpdate
    },
    transition: actualTransition,
    rootClose: rootClose,
    placement: placement,
    show: outerShow,
    children: (overlayProps, {
      arrowProps,
      popper: popperObj,
      show
    }) => {
      var _popperObj$state;
      wrapRefs(overlayProps, arrowProps);
      // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
      const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
      const popper = Object.assign(popperRef.current, {
        state: popperObj == null ? void 0 : popperObj.state,
        scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
        placement: updatedPlacement,
        outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
        strategy: popperConfig.strategy
      });
      const hasDoneInitialMeasure = !!firstRenderedState;
      if (typeof overlay === 'function') return overlay({
        ...overlayProps,
        placement: updatedPlacement,
        show,
        ...(!transition && show && {
          className: 'show'
        }),
        popper,
        arrowProps,
        hasDoneInitialMeasure
      });
      return /*#__PURE__*/React__namespace.cloneElement(overlay, {
        ...overlayProps,
        placement: updatedPlacement,
        arrowProps,
        popper,
        hasDoneInitialMeasure,
        className: classNames(overlay.props.className, !transition && show && 'show'),
        style: {
          ...overlay.props.style,
          ...overlayProps.style
        }
      });
    }
  });
});
Overlay.displayName = 'Overlay';

function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
}

// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(
// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
  const [e] = args;
  const target = e.currentTarget;
  const related = e.relatedTarget || e.nativeEvent[relatedNative];
  if ((!related || related !== target) && !contains$1(target, related)) {
    handler(...args);
  }
}
PropTypes.oneOf(['click', 'hover', 'focus']);
const OverlayTrigger = ({
  trigger = ['hover', 'focus'],
  overlay,
  children,
  popperConfig = {},
  show: propsShow,
  defaultShow = false,
  onToggle,
  delay: propsDelay,
  placement,
  flip = placement && placement.indexOf('auto') !== -1,
  ...props
}) => {
  const triggerNodeRef = React.useRef(null);
  const mergedRef = useMergedRefs$1(triggerNodeRef, getChildRef(children));
  const timeout = useTimeout();
  const hoverStateRef = React.useRef('');
  const [show, setShow] = useUncontrolledProp$1(propsShow, defaultShow, onToggle);
  const delay = normalizeDelay(propsDelay);
  const {
    onFocus,
    onBlur,
    onClick
  } = typeof children !== 'function' ? React__namespace.Children.only(children).props : {};
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const handleShow = React.useCallback(() => {
    timeout.clear();
    hoverStateRef.current = 'show';
    if (!delay.show) {
      setShow(true);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  const handleHide = React.useCallback(() => {
    timeout.clear();
    hoverStateRef.current = 'hide';
    if (!delay.hide) {
      setShow(false);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  const handleFocus = React.useCallback((...args) => {
    handleShow();
    onFocus == null || onFocus(...args);
  }, [handleShow, onFocus]);
  const handleBlur = React.useCallback((...args) => {
    handleHide();
    onBlur == null || onBlur(...args);
  }, [handleHide, onBlur]);
  const handleClick = React.useCallback((...args) => {
    setShow(!show);
    onClick == null || onClick(...args);
  }, [onClick, setShow, show]);
  const handleMouseOver = React.useCallback((...args) => {
    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  const handleMouseOut = React.useCallback((...args) => {
    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  const triggers = trigger == null ? [] : [].concat(trigger);
  const triggerProps = {
    ref: attachRef
  };
  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }
  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }
  if (triggers.indexOf('hover') !== -1) {
    process.env.NODE_ENV !== "production" ? warning$2(triggers.length > 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/React.cloneElement(children, triggerProps), /*#__PURE__*/jsxRuntime.jsx(Overlay, {
      ...props,
      show: show,
      onHide: handleHide,
      flip: flip,
      placement: placement,
      popperConfig: popperConfig,
      target: triggerNodeRef.current,
      children: overlay
    })]
  });
};

const Table = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  striped,
  bordered,
  borderless,
  hover,
  size,
  variant,
  responsive,
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'table');
  const classes = classNames(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
  const table = /*#__PURE__*/jsxRuntime.jsx("table", {
    ...props,
    className: classes,
    ref: ref
  });
  if (responsive) {
    let responsiveClass = `${decoratedBsPrefix}-responsive`;
    if (typeof responsive === 'string') {
      responsiveClass = `${responsiveClass}-${responsive}`;
    }
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      className: responsiveClass,
      children: table
    });
  }
  return table;
});

const fadeStyles = {
  [ENTERING]: 'showing',
  [EXITING]: 'showing show'
};
const ToastFade = /*#__PURE__*/React__namespace.forwardRef((props, ref) => /*#__PURE__*/jsxRuntime.jsx(Fade, {
  ...props,
  ref: ref,
  transitionClasses: fadeStyles
}));
ToastFade.displayName = 'ToastFade';

const ToastContext = /*#__PURE__*/React__namespace.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {}
});

const ToastHeader = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  closeLabel = 'Close',
  closeVariant,
  closeButton = true,
  className,
  children,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'toast-header');
  const context = React.useContext(ToastContext);
  const handleClick = useEventCallback$1(e => {
    context == null || context.onClose == null || context.onClose(e);
  });
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    ref: ref,
    ...props,
    className: classNames(bsPrefix, className),
    children: [children, closeButton && /*#__PURE__*/jsxRuntime.jsx(CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick,
      "data-dismiss": "toast"
    })]
  });
});
ToastHeader.displayName = 'ToastHeader';

const ToastBody = /*#__PURE__*/React__namespace.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'toast-body');
  return /*#__PURE__*/jsxRuntime.jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
ToastBody.displayName = 'ToastBody';

const Toast = /*#__PURE__*/React__namespace.forwardRef(({
  bsPrefix,
  className,
  transition: Transition = ToastFade,
  show = true,
  animation = true,
  delay = 5000,
  autohide = false,
  onClose,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  bg,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'toast');

  // We use refs for these, because we don't want to restart the autohide
  // timer in case these values change.
  const delayRef = React.useRef(delay);
  const onCloseRef = React.useRef(onClose);
  React.useEffect(() => {
    delayRef.current = delay;
    onCloseRef.current = onClose;
  }, [delay, onClose]);
  const autohideTimeout = useTimeout();
  const autohideToast = !!(autohide && show);
  const autohideFunc = React.useCallback(() => {
    if (autohideToast) {
      onCloseRef.current == null || onCloseRef.current();
    }
  }, [autohideToast]);
  React.useEffect(() => {
    // Only reset timer if show or autohide changes.
    autohideTimeout.set(autohideFunc, delayRef.current);
  }, [autohideTimeout, autohideFunc]);
  const toastContext = React.useMemo(() => ({
    onClose
  }), [onClose]);
  const hasAnimation = !!(Transition && animation);
  const toast = /*#__PURE__*/jsxRuntime.jsx("div", {
    ...props,
    ref: ref,
    className: classNames(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  });
  return /*#__PURE__*/jsxRuntime.jsx(ToastContext.Provider, {
    value: toastContext,
    children: hasAnimation && Transition ? /*#__PURE__*/jsxRuntime.jsx(Transition, {
      in: show,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited,
      unmountOnExit: true,
      children: toast
    }) : toast
  });
});
Toast.displayName = 'Toast';
var Toast$1 = Object.assign(Toast, {
  Body: ToastBody,
  Header: ToastHeader
});

const isLightText = (variant) => {
    const textLightVariants = [
        'black',
        'success',
        'dark',
        'danger',
        'primary',
        'info',
        'outline-light',
    ];
    return textLightVariants.includes(variant);
};
const isPrimaryLabel = (variant) => {
    const primaryLabelVariants = ['light', 'white'];
    return primaryLabelVariants.includes(variant);
};

const AlertComponent = (props) => {
    const { className, children, closeVariant, dismissible, icon, isFixed, offsetTop, onClose, show, variant, } = props;
    const [isAlertShowing, setIsAlertShowing] = React.useState(show);
    const alertClassNames = classNames({
        'rpc-alert border-0 rounded-0': true,
        [`bg-${variant} bg-gradient`]: variant,
        [`text-light`]: variant && isLightText(variant),
        'rpc-alert--fixed mb-0 w-100 fixed-top': isFixed,
        [`${className}`]: className,
    });
    const alertStyles = offsetTop
        ? {
            top: `${offsetTop}px`,
        }
        : undefined;
    return (React.createElement(Alert$1, { className: alertClassNames, closeVariant: closeVariant || isLightText(variant) ? 'white' : undefined, dismissible: dismissible, onClose: () => {
            setIsAlertShowing(false);
        }, show: dismissible ? isAlertShowing : show, style: alertStyles, variant: variant },
        React.createElement("div", { className: "rpc-alert__content d-flex" },
            icon ? (React.createElement("div", { className: "rpc-alert__icon me-3 lh-0" }, icon)) : undefined,
            React.createElement("div", { className: "rpc-alert__message" }, children))));
};
const RPCAlert = React.memo(AlertComponent);

const BadgeComponent = (props) => {
    const { bg, children, className, pill, text } = props;
    return (React.createElement(Badge, { bg: bg, className: className, pill: pill, text: text }, children));
};
const RPCBadge = React.memo(BadgeComponent);

const RPCBreadcrumbsComponent = (props) => {
    const { activeItem, asButtons, items, variant = 'dark' } = props;
    const breadcrumbsClassNames = classNames({
        'rpc-breadcrumbs': true,
        [`bg-${variant} bg-gradient`]: variant,
    });
    return (React.createElement(Breadcrumb$1, { className: breadcrumbsClassNames }, items && items.length
        ? items.map((item, index) => (React.createElement(Breadcrumb$1.Item, { key: `breadcrumb-item-${index}-${item.title}`, active: item.active || (activeItem && activeItem === item.href), href: item.href, linkAs: asButtons ? 'button' : item.linkAs, linkProps: item.linkProps, target: item.target, onClick: item.onClick }, item.title)))
        : undefined));
};
const RPCBreadcrumbs = React.memo(RPCBreadcrumbsComponent);

const RPCTooltipComponent = (props) => {
    const { children, id, placement = 'right', tooltipPopper, show, transparent, } = props;
    const tooltipClassNames = classNames({
        transparent: transparent,
    });
    return (React.createElement(OverlayTrigger, { placement: placement, overlay: React.createElement(Tooltip$1, { id: id || `tooltip-${placement}`, show: show, className: tooltipClassNames }, children), rootClose: true },
        React.createElement("div", { className: "tooltip-popper" }, tooltipPopper)));
};
const RPCTooltip = React.memo(RPCTooltipComponent);

const RPCButtonComponent = (props) => {
    const { active, autoFocus, badgeLabel, badgeTextColor = 'dark', badgeVariant = 'warning', children, circular, className, disabled, fluid, hasTooltip, icon, iconPosition = 'left', label, onClick, size, style, title, tooltipContent, tooltipPlacement, type, variant, } = props;
    const buttonClassNames = classNames({
        'has-badge': badgeLabel,
        'has-icon': icon,
        [`icon--${iconPosition}`]: iconPosition,
        circular: circular,
        'w-100': fluid,
        'bg-gradient': variant !== 'link',
        [`${className}`]: className,
    });
    const renderButton = () => {
        return (React.createElement(Button, { active: active, autoFocus: autoFocus, className: buttonClassNames, disabled: disabled, onClick: onClick, size: size, style: style, title: title, type: type, variant: variant }, label || icon || badgeLabel ? (React.createElement(React.Fragment, null,
            icon && iconPosition === 'left' ? icon : undefined,
            label ? React.createElement("span", { className: "btn__label" }, label) : undefined,
            badgeLabel ? (React.createElement(RPCBadge, { bg: badgeVariant, text: badgeTextColor }, badgeLabel)) : undefined,
            icon && iconPosition === 'right' ? icon : undefined)) : (React.createElement(React.Fragment, null, children))));
    };
    return hasTooltip ? (React.createElement(RPCTooltip, { tooltipPopper: renderButton(), placement: tooltipPlacement }, tooltipContent)) : (renderButton());
};
const RPCButton = React.memo(RPCButtonComponent);

const ButtonGroupComponent = (props) => {
    const { activeIndex, onOptionSelect, options, size, variant, vertical } = props;
    return (React.createElement(ButtonGroup, { size: size, vertical: vertical }, options && options.length ? (React.createElement(React.Fragment, null, options.map((option, index) => (React.createElement(RPCButton, { active: activeIndex ? activeIndex === index : false, key: `rpc-btn-group-option-${index}-${option.value}`, label: option.label, onClick: () => {
            if (onOptionSelect)
                onOptionSelect(option);
        }, variant: (option.variant && option.variant.toString()) || variant }))))) : undefined));
};
const RPCButtonGroup = React.memo(ButtonGroupComponent);

const RPCCarouselComponent = (props) => {
    const { className, fade = true, fixed, fullscreen, indicators, interval, items, opacity, pause, variant, } = props;
    const carouselClassNames = classNames({
        'rpc-carousel': true,
        'rpc-carousel--fixed': fixed,
        'rpc-carousel--full': fullscreen,
        [`opacity-${opacity}`]: opacity,
        [`${className}`]: className,
    });
    return (React.createElement(Carousel$1, { className: carouselClassNames, controls: false, indicators: indicators, interval: interval, fade: fade, pause: pause, variant: variant }, items && items.length
        ? items.map((item, index) => (React.createElement(Carousel$1.Item, { key: `featured_carousel_slide_${index}`, style: {
                backgroundImage: `url("${item.imageUrl}")`,
            } }, item.caption ? (React.createElement(Carousel$1.Caption, { className: "d-flex align-items-center p-0" }, item.caption)) : undefined)))
        : undefined));
};
const RPCCarousel = React.memo(RPCCarouselComponent);

const ModalComponent = (props) => {
    const { backdrop, bodyVariant, children, centered = true, className, closeVariant, dismissible, footer, footerVariant, fullscreen, headerVariant, keyboard, onHide, onShow, scrollable, show, size = 'lg', title, variant, } = props;
    const modalClassNames = classNames({
        'rpc-modal': true,
        [`${className}`]: className,
    });
    const modalHeaderClassNames = classNames({
        [`bg-${headerVariant || variant}`]: headerVariant || variant,
        [`text-light`]: (headerVariant || variant) && isLightText(headerVariant || variant),
    });
    const modalBodyClassNames = classNames({
        [`bg-${bodyVariant || variant}`]: bodyVariant || variant,
        [`text-light`]: (bodyVariant || variant) && isLightText(bodyVariant || variant),
    });
    const modalFooterClassNames = classNames({
        [`bg-${footerVariant || variant}`]: footerVariant || variant,
        [`text-light`]: (footerVariant || variant) && isLightText(footerVariant || variant),
    });
    return (React.createElement(Modal$1, { backdrop: backdrop, centered: centered, className: modalClassNames, fullscreen: fullscreen, keyboard: keyboard, onHide: onHide, onShow: onShow, scrollable: scrollable, show: show, size: size },
        dismissible || title ? (React.createElement(Modal$1.Header, { className: modalHeaderClassNames, closeVariant: closeVariant || isLightText(headerVariant) ? 'white' : undefined, closeButton: dismissible }, title ? React.createElement(Modal$1.Title, null, title) : undefined)) : undefined,
        React.createElement(Modal$1.Body, { className: modalBodyClassNames }, children),
        footer ? (React.createElement(Modal$1.Footer, { className: modalFooterClassNames }, footer)) : undefined));
};
const RPCModal = React.memo(ModalComponent);

const RPCConfirmationModalComponent = (props) => {
    const { backdrop, cancelLabel = 'Cancel', children, confirmLabel = 'Confirm', confirmVariant = 'danger', headerVariant = 'danger', keyboard, onCancel, onConfirm, title = 'Are you sure?', show, } = props;
    return (React.createElement(RPCModal, { backdrop: backdrop, className: "confirmation-modal", headerVariant: headerVariant, footer: React.createElement("div", { className: "d-flex justify-content-center align-items-center w-100" },
            React.createElement(RPCButton, { className: "me-2 w-100", label: confirmLabel, onClick: onConfirm, variant: confirmVariant }),
            React.createElement(RPCButton, { className: "w-100", label: cancelLabel, onClick: onCancel })), keyboard: keyboard, size: "md", title: title, show: show, onHide: onCancel }, children));
};
const RPCConfirmationModal = React.memo(RPCConfirmationModalComponent);

const RPCOffCanvasComponent = (props) => {
    const { actionsChildren, backdrop, children, className, closeButton, fluidContent, fluidHeader, onHide, onShow, placement, scroll, show, title, variant, } = props;
    const offCanvasClassNames = classNames({
        [`offcanvas--${variant}`]: variant,
        [`${className}`]: className,
    });
    return (React.createElement(Offcanvas$1, { backdrop: backdrop, className: offCanvasClassNames, show: show, onHide: onHide, placement: placement, onShow: onShow, scroll: scroll },
        React.createElement(Offcanvas$1.Header, { closeButton: closeButton },
            React.createElement(Container, { fluid: fluidHeader }, title && React.createElement(Offcanvas$1.Title, { as: "h4" }, title))),
        React.createElement(Offcanvas$1.Body, null, !fluidContent ? React.createElement(Container, null, children) : React.createElement(React.Fragment, null, children)),
        actionsChildren && (React.createElement("div", { className: "offcanvas-actions" }, actionsChildren))));
};
const RPCOffCanvas = React.memo(RPCOffCanvasComponent);

const IconPokeBallComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 38 38", width: width, height: height },
        React.createElement("path", { fill: fill, d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Zm0,4A15,15,0,0,0,4,17.42h7.2a7.92,7.92,0,0,1,15.52,0H34A15,15,0,0,0,19,4ZM4,20.58a15,15,0,0,0,29.92,0h-7.2a7.92,7.92,0,0,1-15.52,0Zm15-6.33A4.75,4.75,0,1,0,23.75,19,4.75,4.75,0,0,0,19,14.25Zm0,2.37A2.38,2.38,0,1,1,16.62,19,2.39,2.39,0,0,1,19,16.62Z" })));
};
const IconPokeBall = React.memo(IconPokeBallComponent);

const RPCLoadingIndicatorComponent = (props) => {
    const { backdrop, className, label, fill = '#fff', full, icon } = props;
    const loadingIndicatorClassNames = classNames({
        'loading-indicator': true,
        'loading-indicator--full': full,
        'loading-indicator--backdrop': backdrop,
        [`${className}`]: className,
    });
    return (React.createElement("div", { className: loadingIndicatorClassNames },
        React.createElement("div", { className: "loading-indicator__content" },
            React.createElement("div", { className: "loading-indicator__icon d-flex align-items-center justify-content-center" }, icon || React.createElement(IconPokeBall, { fill: fill, width: 40, height: 40 })),
            label ? (React.createElement("div", { className: "loading-indicator__text d-flex align-items-center justify-content-center" }, label)) : undefined)));
};
const RPCLoadingIndicator = React.memo(RPCLoadingIndicatorComponent);

const RPCNavbarDropdownComponent = (props) => {
    const { activeItem, active, activeChild, badgeContent, drop, errorContent = 'Error loading menu.', icon, id, isError, isLoading, items, label, loadingLabel, onFirstLevelChildItemClick, onItemClick, onSecondLevelChildItemClick, openOnHover = true, show, variant, } = props;
    const [parentDropdownShowingId, setParentDropdownShowingId] = React.useState('');
    const [childDropdownShowingId, setChildDropdownShowingId] = React.useState('');
    const showParentDropdown = (menuId) => {
        setParentDropdownShowingId(menuId);
    };
    const hideParentDropdown = () => {
        setParentDropdownShowingId('');
    };
    const showChildDropdown = (itemId) => {
        setChildDropdownShowingId(itemId);
    };
    const hideChildDropdown = () => {
        setChildDropdownShowingId('');
    };
    const renderItemTitle = (dropIcon, dropLabel, dropBadgeContent) => {
        return (React.createElement(React.Fragment, null,
            dropIcon ? (React.createElement("span", { className: "nav-item__icon pe-2" }, dropIcon)) : undefined,
            React.createElement("span", { className: "nav-item__label pe-4" }, dropLabel),
            dropBadgeContent ? (React.createElement("span", { className: "nav-item__badge" },
                React.createElement(RPCBadge, { bg: "primary" }, dropBadgeContent))) : undefined));
    };
    return (React.createElement(NavDropdown$1, { active: active || parentDropdownShowingId === id, drop: drop, menuVariant: variant, onClick: (event) => {
            if (parentDropdownShowingId === id) {
                hideParentDropdown();
            }
            showParentDropdown(id);
            if (onItemClick)
                onItemClick(event);
        }, title: renderItemTitle(icon, label, badgeContent), id: id, show: openOnHover ? parentDropdownShowingId === id : show, onMouseEnter: openOnHover ? () => showParentDropdown(id) : undefined, onSelect: hideParentDropdown, onMouseLeave: openOnHover ? () => hideParentDropdown() : undefined }, isLoading ? (React.createElement(NavDropdown$1.Item, { className: "nav-item--is-loading p-4 justify-content-center" },
        React.createElement(RPCLoadingIndicator, { label: loadingLabel, fill: variant === 'dark' ? '#fff' : '#000' }))) : (React.createElement(React.Fragment, null, isError ? (React.createElement(React.Fragment, null, errorContent)) : (React.createElement(React.Fragment, null, items && items.length ? (React.createElement(React.Fragment, null, items.map((item, index) => (React.createElement(React.Fragment, { key: `item-${index}--${item.id}` }, item.children ? (React.createElement(NavDropdown$1, { className: "child-dropdown", active: activeChild === item.id ||
            childDropdownShowingId === item.id, title: renderItemTitle(item.icon, item.label, item.badgeContent), id: id, show: childDropdownShowingId === item.id, onClick: (event) => {
            if (onFirstLevelChildItemClick)
                onFirstLevelChildItemClick(event);
            showChildDropdown(item.id);
        }, onMouseEnter: openOnHover
            ? () => showChildDropdown(item.id)
            : undefined, onMouseLeave: openOnHover
            ? () => hideChildDropdown()
            : undefined, onSelect: hideChildDropdown, drop: "end", menuVariant: variant }, Array.isArray(item.children) &&
        item.children.length ? (item.children.map((childItem) => (React.createElement(NavDropdown$1.Item, { className: childItem.children
            ? 'has-children'
            : undefined, key: childItem.id, onClick: (event) => {
            if (onSecondLevelChildItemClick &&
                typeof onSecondLevelChildItemClick ===
                    'function')
                onSecondLevelChildItemClick(event);
            if (childItem &&
                childItem.onClick &&
                typeof childItem.onClick === 'function')
                childItem.onClick(event);
        }, active: activeItem === childItem.id }, childItem.children ? (React.createElement(React.Fragment, null, childItem.children)) : (React.createElement(React.Fragment, null, renderItemTitle(childItem.icon, childItem.label, childItem.badgeContent))))))) : (React.createElement(React.Fragment, null, item.children)))) : (React.createElement(NavDropdown$1.Item, { key: item.id, onClick: (event) => {
            if (onFirstLevelChildItemClick)
                onFirstLevelChildItemClick(event);
            item.onClick(event);
        }, active: activeItem === item.id },
        React.createElement(React.Fragment, null, renderItemTitle(item.icon, item.label, item.badgeContent))))))))) : undefined))))));
};
const RPCNavbarDropdown = React.memo(RPCNavbarDropdownComponent);

const RPCNavbarLinkComponent = (props) => {
    const { active, badgeContent, icon, label, onClick } = props;
    return (React.createElement(Nav$1.Link, { onClick: onClick, active: active, className: "nav-item" },
        React.createElement(React.Fragment, null,
            icon ? React.createElement("span", { className: "nav-item__icon pe-2" }, icon) : undefined,
            label,
            badgeContent ? (React.createElement("span", { className: "nav-item__badge" },
                React.createElement(RPCBadge, { bg: "primary" }, badgeContent))) : undefined)));
};
const RPCNavbarLink = React.memo(RPCNavbarLinkComponent);

const RPCNavbarComponent = (props) => {
    const { children, className, extraOptionsMobile, isMobileShowing, isSubNav, logo, navbarRightChildren, navbarRightItems, onHideMobileMenu, onLogoClick, offsetTop, openDropdownsOnHover = true, onToggleClick, searchComponent, slideInBgVariant, slideInTextVariant, toggleIcon, type = 'pills', variant = 'dark', } = props;
    const navbarClassNames = classNames({
        'rpc-navbar': true,
        'rpc-navbar--sub-nav': isSubNav,
        [`${className}`]: className,
    });
    const navbarNavClassNames = classNames({
        'me-auto': true,
        'rpc-navbar-nav': true,
    });
    const navbarNavRightClassNames = classNames({
        'rpc-navbar-nav': true,
        'rpc-navbar__right': true,
    });
    const navbarStyle = {
        top: offsetTop || undefined,
    };
    const navbarSlideInClassNames = classNames({
        'rpc-navbar__offcanvas': true,
        [`bg-${slideInBgVariant || 'light'}`]: true,
        [`text-${slideInTextVariant || 'dark'}`]: true,
    });
    const expand = 'lg';
    return (React.createElement(Navbar$1, { bg: variant, className: navbarClassNames, collapseOnSelect: true, "data-bs-theme": variant, expand: "xl", fixed: "top", style: navbarStyle },
        React.createElement("div", { className: "container-fluid" },
            logo ? (React.createElement(Nav$1.Link, { className: "logo-link", onClick: onLogoClick },
                React.createElement(Navbar$1.Brand, null, logo))) : undefined,
            extraOptionsMobile ? (React.createElement("div", { className: "mobile-options" }, extraOptionsMobile)) : undefined,
            React.createElement(Navbar$1.Toggle, { "aria-controls": `offcanvasNavbar-expand-${expand}`, onClick: onToggleClick }, toggleIcon || (React.createElement(IconPokeBall, { width: 24, height: 24, fill: variant && variant === 'dark' ? '#fff' : '#000' }))),
            React.createElement(Navbar$1.Offcanvas, { className: navbarSlideInClassNames, id: `offcanvasNavbar-expand-${expand}`, onHide: onHideMobileMenu, "aria-labelledby": `offcanvasNavbarLabel-expand-${expand}`, placement: "end", show: isMobileShowing },
                React.createElement(Offcanvas$1.Header, { closeButton: true }),
                React.createElement(Offcanvas$1.Body, null,
                    React.createElement(Nav$1, { className: navbarNavClassNames, variant: type },
                        React.createElement(React.Fragment, null, children)),
                    searchComponent ? (React.createElement("div", { className: "rpc-navbar__search d-flex align-items-center justify-content-center" }, searchComponent)) : undefined,
                    (navbarRightItems && navbarRightItems.length) ||
                        navbarRightChildren ? (React.createElement(Nav$1, { className: navbarNavRightClassNames, variant: type },
                        navbarRightItems && navbarRightItems.length
                            ? navbarRightItems.map((item, index) => (React.createElement(React.Fragment, { key: `item_${index}--${item.label}` }, item.type === 'dropdown' ? (React.createElement(RPCNavbarDropdown, { badgeContent: item.badgeContent, icon: item.icon, items: item.items, label: item.label, openOnHover: openDropdownsOnHover, variant: variant })) : (React.createElement(RPCNavbarLink, { badgeContent: item.badgeContent, icon: item.icon, label: item.label, onClick: item.onClick })))))
                            : undefined,
                        navbarRightChildren ? (React.createElement("div", { className: "d-flex align-items-center rpc-navbar__right__children" }, navbarRightChildren)) : undefined)) : undefined)))));
};
const RPCNavbar = React.memo(RPCNavbarComponent);

const RPCTableComponent = (props) => {
    const { bordered, borderless, children, className, hover, responsive, size, striped, variant, } = props;
    return (React.createElement(Table, { bordered: bordered, borderless: borderless, className: className, hover: hover, responsive: responsive, size: size, striped: striped, variant: variant }, children));
};
const RPCTable = React.memo(RPCTableComponent);

const RPCToastMessageComponent = (props) => {
    const { autohide = true, className, variant, delay = 3000, children, isFixedTop, onClose, show, } = props;
    const toastClassNames = classNames({
        'rpc-toast-message': true,
        'w-100 top-0 start-0 position-absolute': isFixedTop,
        [`bg-${variant}`]: variant,
        [`text-light`]: isLightText(variant),
        [`${className}`]: className,
    });
    return (React.createElement(Toast$1, { className: toastClassNames, bg: variant, onClose: onClose, show: show, delay: delay, autohide: autohide },
        React.createElement(Toast$1.Body, null, children)));
};
const RPCToastMessage = React.memo(RPCToastMessageComponent);

const CardBodyComponent = (props) => {
    const { children, className } = props;
    return React.createElement("div", { className: className }, children);
};
const CardBody = React.memo(CardBodyComponent);

const CardBodyImageComponent = (props) => {
    const { children } = props;
    return React.createElement("div", { className: "card-body-image" }, children);
};
const CardBodyImage = React.memo(CardBodyImageComponent);

const NeoRightSwooshComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 87.83 30.83" },
        React.createElement("defs", null,
            React.createElement("pattern", { id: "right-swoosh-image-fill", patternUnits: "userSpaceOnUse", width: "486", height: "354" },
                React.createElement("image", { href: NEO_SWOOSH_BG, x: "0", y: "-100", width: "486", height: "354" }))),
        React.createElement("path", { fill: "url(#right-swoosh-image-fill)", fillOpacity: 0.9, d: "M0 19.64c9.53-4.75 19.56-9.78 31-13.36C43.83 2.29 60.84-.21 72 0c5.33.12 16 .46 15.83 7.85a5.55 5.55 0 0 1-.83 2.71c-2.58 4.21-7.31 7.28-12.42 10.18a98.2 98.2 0 0 1-14.32 6.75c-7.07 2.66-10.43 3.34-11 3.34-.76 0 2.63-1.47 4-5.34C59.08 8.41 8.86 16.59 0 19.64Z", "data-name": "Layer 1" })));
};
const NeoRightSwoosh = React.memo(NeoRightSwooshComponent);

const NeoLeftSwooshComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 87.97 30.58" },
        React.createElement("pattern", { id: "left-swoosh-image-fill", patternUnits: "userSpaceOnUse", width: "486", height: "354" },
            React.createElement("image", { href: NEO_SWOOSH_BG, x: "0", y: "0", width: "486", height: "354" })),
        React.createElement("path", { fill: "url(#left-swoosh-image-fill)", fillOpacity: 0.8, d: "M88 11.79c-9.58 4.64-19.67 9.55-31.19 13-12.85 3.83-29.88 6.12-41 5.76-5.37-.17-16-.64-15.76-8a5.47 5.47 0 0 1 .85-2.71c2.63-4.18 7.4-7.19 12.55-10a99.09 99.09 0 0 1 14.4-6.57C34.91.64 38.28 0 38.87 0c.76 0-2.65 1.44-4 5.3-6.11 17.01 44.2 9.43 53.13 6.49Z", "data-name": "Layer 1" })));
};
const NeoLeftSwoosh = React.memo(NeoLeftSwooshComponent);

const WaterEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-b5fe8839-a238-4d44-abcb-ffbe7f292bff", viewBox: "0 0 76.86 76.86", width: width, height: height },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-bc4ad6df-6892-45c2-9ac1-bf67aeb1f690", cx: "16.94", cy: "16.55", r: "67.09", fx: "16.94", fy: "16.55", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#dde4ef" }),
                React.createElement("stop", { offset: ".2", stopColor: "#c1dde5" }),
                React.createElement("stop", { offset: ".4", stopColor: "#7db9e1" }),
                React.createElement("stop", { offset: ".61", stopColor: "#008ec3" }),
                React.createElement("stop", { offset: ".8", stopColor: "#0f6fb6" }),
                React.createElement("stop", { offset: "1", stopColor: "#1b4687" })),
            React.createElement("filter", { id: "uuid-2de4ed13-42cf-40c0-9933-c4630e2fe040", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-55909095-17d4-4eb6-8c73-367a55244c9f", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-55909095-17d4-4eb6-8c73-367a55244c9f", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-0ec170ca-c1f3-41a3-be0d-6ad39bec1e7d" },
            React.createElement("path", { fill: "url(#uuid-bc4ad6df-6892-45c2-9ac1-bf67aeb1f690)", d: "M76.86 38.43c0 21.22-17.2 38.43-38.43 38.43S0 59.65 0 38.43 17.2 0 38.43 0s38.43 17.21 38.43 38.43Z" }),
            React.createElement("path", { fill: "#fff", d: "M18.85 19.16c-2.63 2.63-4.99 4.54-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.98-2.55 1.22 1.22-.69 3.58-3.32 6.21Z", filter: "url(#uuid-2de4ed13-42cf-40c0-9933-c4630e2fe040)" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M56.19 14.37c-2.76 1.59-6.13 2.65-8.58 4.53-2.83 2.16-5.63 5.39-4.59 10.67 1.22 6.18 7.49 8.91 10.22 13.91 1.07 1.96 2.36 5.38 2.04 8.77-.5 5.24-5.92 8.72-10.71 9.67-15.45 3.07-29.43-6.47-28.54-21.55.23-4 2.13-8.11 4.56-11.02 6.96-8.36 21.52-13.27 35.6-14.98ZM26.52 53.19c.93 5.32 7.98 7.24 13.17 5.14-1.01-5.24-8.01-7.21-13.17-5.14Z" }))));
};
const WaterEnergy = React.memo(WaterEnergyComponent);

const FightingEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-0684b7ed-2226-4ec6-973c-58bbdd49705d", viewBox: "0 0 76.85 76.85", width: width, height: height },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-4b29cddb-e2ec-449a-8bc1-6d1e495cbe14", cx: "16.94", cy: "16.55", r: "67.09", fx: "16.94", fy: "16.55", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#f7e9d4" }),
                React.createElement("stop", { offset: ".2", stopColor: "#f9c863" }),
                React.createElement("stop", { offset: ".4", stopColor: "#e97824" }),
                React.createElement("stop", { offset: ".61", stopColor: "#d94826" }),
                React.createElement("stop", { offset: ".8", stopColor: "#b93226" }),
                React.createElement("stop", { offset: "1", stopColor: "#821618" })),
            React.createElement("filter", { id: "uuid-aad4c154-0672-4ce0-a427-6f500153a041", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-8b15045f-f032-4f76-a9cb-28142e5c93ca", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-8b15045f-f032-4f76-a9cb-28142e5c93ca", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-399c485a-749c-4fed-a134-73585e1ffd79" },
            React.createElement("path", { fill: "url(#uuid-4b29cddb-e2ec-449a-8bc1-6d1e495cbe14)", d: "M76.85 38.42c0 21.22-17.2 38.43-38.42 38.43S0 59.64 0 38.42 17.21 0 38.43 0s38.42 17.2 38.42 38.42Z" }),
            React.createElement("path", { fill: "#f7e9d4", d: "M18.85 19.15c-2.63 2.63-4.98 4.55-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.98-2.55 1.22 1.22-.69 3.58-3.32 6.2Z", filter: "url(#uuid-aad4c154-0672-4ce0-a427-6f500153a041)" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M36.74 18.15c1.6 2.05 1.05 5.85 1.05 9.48s.32 7.42-.7 9.84c-2.19.47-6.75.8-8.43-.35-.57-5.44-.57-13.19 0-18.62 1.54-1.1 6.05-.9 8.09-.35ZM48.33 18.5c.59 5.4.59 13.22 0 18.62-1.52 1.11-6.9 1.11-8.43 0-.81-5.4-.12-12.29-.36-18.27.72-.11.69-.95 1.41-1.05 2.43.26 6.03-.65 7.37.7ZM26.55 21.31c.57 4.52.57 11.31 0 15.82-1.68 1.15-6.24.82-8.43.35-1.08-4-1.18-12.19 0-16.17 1.55-1.2 6.83-.99 8.43 0ZM58.52 20.96c1.19 1.88.7 5.04.7 8.09 0 2.84.27 5.92-.34 8.08-1.53 1.11-6.91 1.11-8.44 0-.8-4.47-.12-10.42-.35-15.46.71-.1.69-.95 1.41-1.05 2.27.18 5.32-.42 7.02.35ZM19.88 39.93c5.03-.82 11.59-.12 17.21-.35 3.31.97 3.81 7.5.7 9.13-3.47-.43-5.78.31-7.03 2.11.48 3.4-.43 5.42-2.11 6.67-4.29-.15-9.8.9-11.24-2.11.64-5.33-1.8-13.73 2.46-15.46Z" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M48.69 63.82H28.65V59.6c2.63.4 3.13-1.32 4.22-2.46.28-1.61-.37-3.15 0-4.21.14-.39 1.84-2.01 2.11-2.11 1.2-.42 2.6.45 3.86 0 4.1-1.48 1.42-3.12 2.81-8.09.41-1.46 1.2-1.64 2.46-2.81h13.35c.55.86 1.26 1.56 2.11 2.11v13.35c-.85.55-1.56 1.27-2.11 2.11-5.57-.54-10.01.06-8.78 6.32Z" }))));
};
const FightingEnergy = React.memo(FightingEnergyComponent);

const FireEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-a3c4e178-a185-4aab-883b-a1371ef7ff54", width: width, height: height, viewBox: "0 0 80.96 80.96" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-3486d1a1-d5ac-4d65-b5f8-7344b92d0317", cx: "40.48", cy: "40.48", r: "40.48", fx: "40.48", fy: "40.48", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#fff" }),
                React.createElement("stop", { offset: ".55", stopColor: "#f39db4" }),
                React.createElement("stop", { offset: ".9", stopColor: "#ed3930" }),
                React.createElement("stop", { offset: "1", stopColor: "#ed3930" })),
            React.createElement("filter", { id: "uuid-e393c0ca-f53e-4aae-a01f-990f6cc6221a", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-8c9dd7ed-2638-49d0-8b44-d776c2c91b82", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-8c9dd7ed-2638-49d0-8b44-d776c2c91b82", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-c200d58a-916b-44b9-96bc-47e4e12e9fee" },
            React.createElement("circle", { cx: "40.48", cy: "40.48", r: "40.48", fill: "url(#uuid-3486d1a1-d5ac-4d65-b5f8-7344b92d0317)" }),
            React.createElement("path", { fill: "#fff", d: "M22.16 21.08c-2.63 2.63-4.99 4.54-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.98-2.55 1.22 1.22-.69 3.58-3.32 6.21Z", filter: "url(#uuid-e393c0ca-f53e-4aae-a01f-990f6cc6221a)" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M37.77 12.16c9.58 3.18 13.77 13.57 12.28 26.53 5.97.95 11.08-2.38 12.67-7.13 6.27 7.38-2.16 15.9-7.53 19.01 6.57-.04 9.91-3.3 13.86-5.94-3.9 11.89-11.18 22.49-25.74 23.76-15.44 1.35-25.31-7.21-28.92-19.8 2.46 2.02 5.19 3.78 8.32 5.14.36-1.59-1.56-2.59-2.38-3.96-1.36-2.28-2.97-6.13-2.77-10.3.28-5.8 3.93-9.73 7.92-12.28-4.11 4.8-1.6 12.7 3.17 15.05-5.28-10.96 6.32-16.26 11.49-21.78.62-4.18-1.32-5.81-2.38-8.32ZM34.2 48.6c.07 1.77 3.24 3.17 3.17 5.54-.03 1.27-.81 1.93-1.98 3.17-.07-2.7-3-4.65-5.55-3.57 5.62 2.14-.05 4.83 0 7.92.12 7.04 19.54 7.32 20.99 1.98.9-3.28-2.65-4.96-2.37-8.32.08-1.06 1.15-2.57 1.59-3.17-.03.04 2.11-1.1.4-1.19-.85.48-2.28.34-3.17.79-1.58.82-2.16 2.9-3.17 2.77.74-4.57-2.63-5.02-3.96-7.52-.1-2.21 1.6-2.63 1.98-4.36-3.93.86-8.05 2.53-7.92 5.94Z" }))));
};
const FireEnergy = React.memo(FireEnergyComponent);

const GrassEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-e8a157e1-2c75-432f-88d8-f8fc147780d7", width: width, height: height, viewBox: "0 0 76.86 76.85" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-ad5ae3ea-f158-4a03-aa81-6d15c1e69e67", cx: "16.94", cy: "16.55", r: "67.09", fx: "16.94", fy: "16.55", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#e7e97f" }),
                React.createElement("stop", { offset: ".2", stopColor: "#c8d93a" }),
                React.createElement("stop", { offset: ".4", stopColor: "#83af40" }),
                React.createElement("stop", { offset: ".61", stopColor: "#629e43" }),
                React.createElement("stop", { offset: ".8", stopColor: "#47863f" }),
                React.createElement("stop", { offset: "1", stopColor: "#286c36" })),
            React.createElement("filter", { id: "uuid-cc8c2a77-e3a9-4bda-b88b-8a06eab6b55b", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-a8a7c0ed-e19a-4d6b-84ad-ae3a55e32765", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-a8a7c0ed-e19a-4d6b-84ad-ae3a55e32765", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-0f1937d2-2a34-4639-b69b-6f9ca74073bf" },
            React.createElement("path", { fill: "url(#uuid-ad5ae3ea-f158-4a03-aa81-6d15c1e69e67)", d: "M76.86 38.43c0 21.22-17.2 38.42-38.42 38.42S0 59.65 0 38.43 17.21 0 38.43 0s38.42 17.2 38.42 38.43Z" }),
            React.createElement("path", { fill: "#fff", d: "M18.86 19.16c-2.63 2.63-4.99 4.54-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.97-2.55 1.22 1.22-.68 3.58-3.31 6.21Z", filter: "url(#uuid-cc8c2a77-e3a9-4bda-b88b-8a06eab6b55b)" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M37.35 59.31c-.39 1.43.7 4.63.35 7.37-2.61-.08-4.65-.83-6.63-1.64-.13-2.57-.82-4.51-1.05-6.96-5.85-3.06-9.71-4.57-11.87-9.83-2.67-6.47.04-15.09 3.14-19.65 2.72-4.01 6.84-7.32 10.83-10.24 4.96-3.63 9.75-6.08 14.31-8.19 4.16 6.87 12.27 19.5 13.27 30.71 1.33 14.7-11.78 16.5-22.35 18.42ZM37 28.2c-1.91-1.16-5.31-4.51-7.68-2.46 3.99.78 8.29 5.9 4.54 9.83-2.11-1.85-6.26-3.92-9.43-2.05 3.78 1.02 7.25 2.41 8.73 6.14-.42 1.83-.62 3.91-1.04 5.73-2.08-1.95-7.11-4.27-10.48-2.05 4.5.68 9.41 2.96 10.48 7.37.07.33-.37 1.73-.35 2.05.09 1.26.42 2.58.7 3.69.21.85.33 2.47 1.4 2.86-.14-2.9.13-5.3.35-7.78 3.73-4.2 10.44-6.25 17.11-5.73-4.75-2.15-12.29-1.33-16.41.82.2-2.35.47-4.64 1.05-6.55 2.94-1.73 6.93-4.19 11.18-4.1 2.13.05 3.74 1.25 5.58.82-2.62-1.55-7.04-3.17-11.17-2.45-1.87.33-3.27 1.87-4.54 1.64.92-7.12 7.31-7.81 13.62-8.6-3.63-1.54-8.45-.64-11.53.82.94-3.13 2.93-7.21 3.15-9.83-1.88 3.12-3.6 6.43-5.24 9.83Z" }))));
};
const GrassEnergy = React.memo(GrassEnergyComponent);

const LightningEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-26336293-5627-4a33-982d-e2231856600f", width: width, height: height, viewBox: "0 0 76.86 76.85" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-a9c292f6-12e1-4e6a-831f-233c3ff044a6", cx: "16.94", cy: "16.55", r: "67.09", fx: "16.94", fy: "16.55", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#fcf5b4" }),
                React.createElement("stop", { offset: ".2", stopColor: "#f2e925" }),
                React.createElement("stop", { offset: ".4", stopColor: "#f1c217" }),
                React.createElement("stop", { offset: ".61", stopColor: "#c7982c" }),
                React.createElement("stop", { offset: ".8", stopColor: "#a3752a" }),
                React.createElement("stop", { offset: "1", stopColor: "#844f20" })),
            React.createElement("filter", { id: "uuid-7133b485-72cc-43ab-82ad-90be19d78ac3", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-c8b9395e-aaa5-4170-820d-bb30a2530a0e", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-c8b9395e-aaa5-4170-820d-bb30a2530a0e", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-10809c60-a9fa-4f83-a113-80dc99c4fb72" },
            React.createElement("path", { fill: "url(#uuid-a9c292f6-12e1-4e6a-831f-233c3ff044a6)", d: "M76.86 38.42c0 21.22-17.21 38.43-38.43 38.43S0 59.65 0 38.42 17.2 0 38.43 0s38.43 17.2 38.43 38.42Z" }),
            React.createElement("path", { fill: "#fff", d: "M18.85 19.15c-2.63 2.63-4.99 4.54-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.98-2.55 1.22 1.22-.69 3.58-3.32 6.21Z", filter: "url(#uuid-7133b485-72cc-43ab-82ad-90be19d78ac3)" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M43.49 9.46C40.38 20.33 37.91 27.69 37 31.34c8.26-1.91 17.95-4.62 21.48-5.67C50.53 39.73 42.1 53.32 34.17 67.4c2.16-10.31 6.04-23.99 7.29-28.77-7.89 2.1-10.19 3.03-23.09 6.89 8.02-12.37 16.86-23.93 25.12-36.06Z" }))));
};
const LightningEnergy = React.memo(LightningEnergyComponent);

const PsychicEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-a1ce5462-ddb1-40a7-8074-2e9e6bc0aa16", width: width, height: height, viewBox: "0 0 76.85 76.85" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-28a5cdb2-e96b-49ff-9f27-167f75319f74", cx: "16.94", cy: "16.55", r: "67.09", fx: "16.94", fy: "16.55", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#f0f1ea" }),
                React.createElement("stop", { offset: ".2", stopColor: "#f2adbf" }),
                React.createElement("stop", { offset: ".4", stopColor: "#d07ba3" }),
                React.createElement("stop", { offset: ".61", stopColor: "#af4990" }),
                React.createElement("stop", { offset: ".8", stopColor: "#922986" }),
                React.createElement("stop", { offset: "1", stopColor: "#38205f" })),
            React.createElement("filter", { id: "uuid-de2bcede-ce09-4cef-98ee-e1a46fa1860d", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-d2362fbf-043e-4141-9281-b27c36c808bd", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-d2362fbf-043e-4141-9281-b27c36c808bd", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-79749bc1-4f15-4a04-8daf-e116bb5e3f28" },
            React.createElement("path", { fill: "url(#uuid-28a5cdb2-e96b-49ff-9f27-167f75319f74)", d: "M76.85 38.42c0 21.22-17.2 38.43-38.43 38.43S0 59.65 0 38.42 17.2 0 38.43 0s38.43 17.2 38.43 38.42Z" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M64.39 39.38C58.83 49.4 50.54 58.8 35.08 57.22c-11.13-1.14-17.81-9.61-22.62-17.52 2.12-4.81 4.91-9.49 8.6-13.06 3.42-3.31 8.61-6.4 14.34-7.01 15.69-1.67 23.55 9.33 28.99 19.75Zm-13.38-3.82c1.2 10.53-8.09 15.84-15.29 14.66-5.25-.86-9.7-6.11-10.19-11.79-.55-6.27 2.17-8.58 5.73-12.11-6.39 2.42-10.41 7.22-13.38 13.06 4.64 6.53 10.86 13.06 21.02 13.06s15.67-6.69 20.07-13.38c-3.23-5.48-7.86-11.25-14.02-12.74 3.17 2.22 5.57 4.99 6.06 9.24Zm-12.42-.63c-.08 2.68-2.91 5.07-6.06 3.82 1.72 6.76 11.62 4.58 11.47-1.91-.07-3.14-2.46-5.99-7.01-5.73.54 1.37 1.64 2.23 1.59 3.82Z" }),
            React.createElement("path", { fill: "#fff", d: "M18.85 19.15c-2.63 2.63-4.99 4.54-6.21 3.32-1.22-1.22-.08-4.34 2.55-6.98 2.63-2.63 5.75-3.77 6.98-2.55 1.22 1.22-.69 3.58-3.32 6.21Z", filter: "url(#uuid-de2bcede-ce09-4cef-98ee-e1a46fa1860d)" }))));
};
const PsychicEnergy = React.memo(PsychicEnergyComponent);

const ColorlessEnergyComponent = (props) => {
    const { fill = '#010101', height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 76.86 76.85" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "uuid-9f755445-1033-4816-804c-74fe126c8d3c", cx: "16.99", cy: "16.51", r: "66.93", fx: "16.99", fy: "16.51", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#fff" }),
                React.createElement("stop", { offset: ".2", stopColor: "#ece6d6" }),
                React.createElement("stop", { offset: ".4", stopColor: "#ddcba5" }),
                React.createElement("stop", { offset: ".61", stopColor: "#c8ab8d" }),
                React.createElement("stop", { offset: "1", stopColor: "#806a59" })),
            React.createElement("radialGradient", { id: "uuid-b74cb57a-e6fa-4ed9-8a2e-a525b8ab1d7a", cx: "32.58", cy: "32.49", r: "38.34", fx: "32.58", fy: "32.49", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: ".5", stopColor: "#c8ab8d", stopOpacity: "0" }),
                React.createElement("stop", { offset: ".55", stopColor: "#c6a98a", stopOpacity: ".03" }),
                React.createElement("stop", { offset: ".62", stopColor: "#c0a382", stopOpacity: ".11" }),
                React.createElement("stop", { offset: ".68", stopColor: "#b79a76", stopOpacity: ".26" }),
                React.createElement("stop", { offset: ".75", stopColor: "#aa8d64", stopOpacity: ".45" }),
                React.createElement("stop", { offset: ".8", stopColor: "#9e8053", stopOpacity: ".65" }),
                React.createElement("stop", { offset: ".85", stopColor: "#917755", stopOpacity: ".77" }),
                React.createElement("stop", { offset: ".93", stopColor: "#846d58", stopOpacity: ".9" }),
                React.createElement("stop", { offset: "1", stopColor: "#806a59", stopOpacity: ".95" })),
            React.createElement("radialGradient", { id: "uuid-d023a6ab-902f-4454-9a2d-c3671997e41d", cx: "32.58", cy: "32.49", r: "38.34", fx: "32.58", fy: "32.49", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: ".6", stopColor: "#c8ab8d", stopOpacity: "0" }),
                React.createElement("stop", { offset: ".9", stopColor: "#9e8053", stopOpacity: "0" }),
                React.createElement("stop", { offset: ".9", stopColor: "#9b7e53", stopOpacity: ".07" }),
                React.createElement("stop", { offset: ".92", stopColor: "#917755", stopOpacity: ".38" }),
                React.createElement("stop", { offset: ".95", stopColor: "#8a7156", stopOpacity: ".63" }),
                React.createElement("stop", { offset: ".96", stopColor: "#846d58", stopOpacity: ".81" }),
                React.createElement("stop", { offset: ".98", stopColor: "#816a58", stopOpacity: ".91" }),
                React.createElement("stop", { offset: "1", stopColor: "#806a59", stopOpacity: ".95" })),
            React.createElement("linearGradient", { id: "uuid-f6752dd2-2531-429b-baf4-dbe1bfcf3b19", x1: "11.32", x2: "65.53", y1: "11.23", y2: "65.44", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#fff" }),
                React.createElement("stop", { offset: ".5", stopColor: "#ece6d6" }),
                React.createElement("stop", { offset: "1", stopColor: "#806a59" })),
            React.createElement("filter", { id: "uuid-ebba4e3c-5280-4551-96a6-5f4fba7fbd15", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-caabc8df-8aa1-441d-b182-c4ff1f969a58", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: "1" }),
                React.createElement("feComposite", { in2: "uuid-caabc8df-8aa1-441d-b182-c4ff1f969a58", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-4eb97f53-66fa-4965-9a08-580c9a38d553" },
            React.createElement("path", { fill: "#638da8", d: "M76.86 38.43c0 21.22-17.2 38.42-38.43 38.42S0 59.65 0 38.43 17.21 0 38.43 0s38.43 17.21 38.43 38.43Z" }),
            React.createElement("path", { fill: "url(#uuid-9f755445-1033-4816-804c-74fe126c8d3c)", d: "M76.76 38.34c0 21.17-17.16 38.34-38.33 38.34S.09 59.51.09 38.34 17.26 0 38.43 0s38.33 17.16 38.33 38.34Z" }),
            React.createElement("path", { fill: "url(#uuid-f6752dd2-2531-429b-baf4-dbe1bfcf3b19)", d: "M76.76 38.34c0 21.17-17.16 38.34-38.33 38.34S.09 59.51.09 38.34 17.26 0 38.43 0s38.33 17.16 38.33 38.34Z", opacity: ".3" }),
            React.createElement("path", { fill: "#fff", d: "M76.76 38.34c0 21.17-17.16 38.34-38.33 38.34S.09 59.51.09 38.34 17.26 0 38.43 0s38.33 17.16 38.33 38.34Z", opacity: ".5" }),
            React.createElement("path", { fill: "url(#uuid-b74cb57a-e6fa-4ed9-8a2e-a525b8ab1d7a)", d: "M76.76 38.34c0 21.17-17.16 38.34-38.33 38.34S.09 59.51.09 38.34 17.26 0 38.43 0s38.33 17.16 38.33 38.34Z", opacity: ".7" }),
            React.createElement("path", { fill: "url(#uuid-d023a6ab-902f-4454-9a2d-c3671997e41d)", d: "M76.76 38.34c0 21.17-17.16 38.34-38.33 38.34S.09 59.51.09 38.34 17.26 0 38.43 0s38.33 17.16 38.33 38.34Z", opacity: ".3" }),
            React.createElement("path", { fill: fill, d: "M54.67 45.24c-1.8-1.79-5.07-4.54-5.27-6.9.2-2.37 3.48-5.1 5.27-6.91 2.32-2.31 4.72-3.71 6.36-6.01-4.47 1.47-13.06 5.05-17.32 2.48-3.59-2.16-3.66-9.93-5.19-14.82-.02-.14-.05-.26-.08-.39v.05c0-.02-.01-.03-.02-.05-.03.13-.05.25-.08.39-1.51 4.89-1.6 12.66-5.19 14.82-4.25 2.57-12.85-1.01-17.32-2.48 1.64 2.3 4.05 3.7 6.37 6.01 1.8 1.8 5.07 4.54 5.27 6.91-.2 2.37-3.48 5.11-5.27 6.9-2.32 2.32-4.72 3.71-6.37 6.01 4.48-1.47 13.07-5.04 17.32-2.47 3.59 2.14 3.68 9.92 5.19 14.82.03.13.06.26.08.38 0-.01.01-.03.02-.05v.05c.03-.12.06-.25.08-.38 1.53-4.9 1.6-12.67 5.19-14.82 4.26-2.57 12.85 1.01 17.32 2.47-1.63-2.3-4.04-3.69-6.36-6.01Z" }),
            React.createElement("path", { fill: "#fff", d: "M18.9 19.11c-2.62 2.63-4.97 4.53-6.19 3.31-1.22-1.22-.08-4.34 2.54-6.95 2.63-2.63 5.74-3.77 6.96-2.55 1.22 1.21-.69 3.57-3.31 6.19Z", filter: "url(#uuid-ebba4e3c-5280-4551-96a6-5f4fba7fbd15)" }))));
};
const ColorlessEnergy = React.memo(ColorlessEnergyComponent);

const DarknessEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: height, width: width, viewBox: "0 0 76.86 76.85" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "uuid-f3bf1ec5-642a-4172-915b-292fbb033a5e", x1: "-4.22", x2: "71.59", y1: "9.43", y2: "60.97", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#38586b" }),
                React.createElement("stop", { offset: ".07", stopColor: "#425a65" }),
                React.createElement("stop", { offset: ".35", stopColor: "#5e6568" }),
                React.createElement("stop", { offset: ".6", stopColor: "#344043" }),
                React.createElement("stop", { offset: ".8", stopColor: "#545b5d" }),
                React.createElement("stop", { offset: "1", stopColor: "#8cacb7" })),
            React.createElement("filter", { id: "uuid-7539f4e7-bff1-485e-a967-c1877b0c1b6c", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-21c40e40-8385-4fac-8bcf-4e41dd3880c3", stdDeviation: "2" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: ".5" }),
                React.createElement("feComposite", { in2: "uuid-21c40e40-8385-4fac-8bcf-4e41dd3880c3", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-12496e9f-e12e-456d-b50a-ff28de7bb15e" },
            React.createElement("path", { fill: "url(#uuid-f3bf1ec5-642a-4172-915b-292fbb033a5e)", d: "M76.86 38.43c0 21.22-17.2 38.42-38.43 38.42S0 59.65 0 38.43 17.21 0 38.43 0s38.43 17.2 38.43 38.43Z" }),
            React.createElement("path", { fill: "#231f20", fillRule: "evenodd", d: "M45.74 12.91c.3-.06.34.15.36.38 10.79 3.25 18.99 10.73 20.08 22.01 1.61 16.51-12.62 30.55-31.91 28.46-11.83-1.28-22.99-11.07-23.67-24.28-.75-14.77 9.26-22.36 19.37-26.18 1.17.08-.57 1.79-1.08 2.66-.77 1.29-1.87 2.64-2.16 4.55-.99 6.73 3.16 12.94 7.89 14.41 8.25 2.59 18.15-4.76 14.7-15.93-.84-2.74-1.94-3.59-3.58-6.07Z", filter: "url(#uuid-7539f4e7-bff1-485e-a967-c1877b0c1b6c)" }))));
};
const DarknessEnergy = React.memo(DarknessEnergyComponent);

const MetalEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "uuid-245a1da6-39fc-40e2-9dfc-9f5eaf6819d5", width: width, height: height, viewBox: "0 0 76.86 76.87" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "uuid-b102b685-2a67-45a7-b4bb-9ca1758a95e0", x1: "11.26", x2: "65.6", y1: "65.6", y2: "11.26", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: ".05", stopColor: "#4e463e" }),
                React.createElement("stop", { offset: ".2", stopColor: "#a09483" }),
                React.createElement("stop", { offset: ".36", stopColor: "#c9c3b5" }),
                React.createElement("stop", { offset: ".5", stopColor: "#dddbc6" }),
                React.createElement("stop", { offset: ".65", stopColor: "#c9c3b5" }),
                React.createElement("stop", { offset: ".8", stopColor: "#a09483" }),
                React.createElement("stop", { offset: ".95", stopColor: "#4e463e" })),
            React.createElement("linearGradient", { id: "uuid-a0db7f13-c34b-4ef8-9865-46dcdf5de8e2", x1: "2162.91", x2: "2162.91", y1: "-1536.02", y2: "-1459.17", gradientTransform: "rotate(-180 1100.665 -729.575)", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#4e463e" }),
                React.createElement("stop", { offset: "1", stopColor: "#4e463e", stopOpacity: "0" })),
            React.createElement("filter", { id: "uuid-7307bf33-99ee-4a1b-a300-a36c2e969499", filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { result: "uuid-f8b397fd-d88f-42a6-b8cb-c2eb5b28bffa", stdDeviation: "1.64" }),
                React.createElement("feFlood", { floodColor: "#fff", floodOpacity: ".75" }),
                React.createElement("feComposite", { in2: "uuid-f8b397fd-d88f-42a6-b8cb-c2eb5b28bffa", operator: "in" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { id: "uuid-e592f95a-bfdd-44a2-8122-faad5ad84344" },
            React.createElement("path", { fill: "#638da8", d: "M76.86 38.43c0 21.22-17.21 38.43-38.43 38.43S0 59.65 0 38.43 17.21 0 38.43 0s38.43 17.2 38.43 38.43Z" }),
            React.createElement("path", { fill: "url(#uuid-b102b685-2a67-45a7-b4bb-9ca1758a95e0)", d: "M76.86 38.43c0 21.22-17.21 38.43-38.43 38.43S0 59.65 0 38.43 17.21 0 38.43 0s38.43 17.2 38.43 38.43Z" }),
            React.createElement("path", { fill: "url(#uuid-a0db7f13-c34b-4ef8-9865-46dcdf5de8e2)", d: "M0 38.44C0 17.22 17.2.02 38.43.02s38.43 17.2 38.43 38.42-17.21 38.43-38.43 38.43S0 59.67 0 38.44Z", opacity: ".5" }),
            React.createElement("g", { fill: "#231f20", fillRule: "evenodd", filter: "url(#uuid-7307bf33-99ee-4a1b-a300-a36c2e969499)" },
                React.createElement("path", { d: "M31.69 23.49h-9.46l-4.73 7.65 4.37 8.37h-6.56l-4-7.65c2.43-4.97 5.51-9.29 8-14.19l8.74-.73 3.64 6.55ZM57.54 17.66l8.01 13.83c-1.33 2.67-2.67 5.34-4 8.01H55c1.11-2.89 2.81-5.2 4-8.01l-4-8.01h-9.83l3.64-6.55 8.74.73Z" }),
                React.createElement("path", { d: "M26.77 31.24h22.59l-10.83 19.8-11.76-19.8ZM28.42 51.16l5.46 8.01h8.37l5.1-8.01 4.01 5.46-4.73 8.01H30.25l-4.73-7.65 2.91-5.82Z" })))));
};
const MetalEnergy = React.memo(MetalEnergyComponent);

const RainbowEnergyComponent = (props) => {
    const { height, width } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", height: height, width: width, viewBox: "0 0 57.91 57.91" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "rainbow-energy-radial-gradient", cx: "28.96", cy: "28.96", r: "28.96", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#332d21" }),
                React.createElement("stop", { offset: "1", stopColor: "#bdb193" })),
            React.createElement("linearGradient", { id: "rainbow-linear-gradient", x1: "99.26", y1: "108.25", x2: "99.26", y2: "87.89", gradientTransform: "translate(-121.18 7.67) rotate(-40.2)", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0.25", stopColor: "#fff", stopOpacity: "0" }),
                React.createElement("stop", { offset: "1", stopColor: "#fff" }))),
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("circle", { fill: "url(#rainbow-energy-radial-gradient)", cx: "28.96", cy: "28.96", r: "28.96" }),
                React.createElement("g", { opacity: "0.5" },
                    React.createElement("circle", { fill: "url(#rainbow-energy-radial-gradient)", cx: "28.96", cy: "28.96", r: "28.96" })),
                React.createElement("path", { fill: "url(#rainbow-linear-gradient)", d: "M27.65,10.29c3.62,4.29,2.22,11.45-3.15,16S11.84,31,8.21,26.72,6,15.27,11.36,10.73,24,6,27.65,10.29Z" }),
                React.createElement("path", { fill: "#dbca6b", d: "M28.8,49c-3.09,0-4.94-9.67-4.94-19s1.85-19,4.94-19,4.93,9.67,4.93,19S31.89,49,28.8,49Zm0-37.3c-2.07,0-4.28,7.35-4.28,18.28s2.21,18.28,4.28,18.28S33.08,40.91,33.08,30,30.86,11.69,28.8,11.69Z" }),
                React.createElement("path", { fill: "#dbca6b", d: "M28.78,52.9c-3.72,0-5.94-11.66-5.94-22.93S25.06,7,28.78,7,34.73,18.7,34.73,30,32.5,52.9,28.78,52.9Zm0-45c-2.49,0-5.16,8.85-5.16,22s2.67,22,5.16,22,5.16-8.86,5.16-22-2.67-22-5.16-22Z" }),
                React.createElement("path", { fill: "#c9d16a", d: "M11.19,30c0-3.09,9-4.94,17.77-4.94S46.73,26.9,46.73,30s-9,4.93-17.77,4.93S11.19,33.07,11.19,30ZM46,30c0-2.07-6.86-4.28-17.07-4.28S11.88,27.92,11.88,30,18.74,34.27,29,34.27,46,32.05,46,30Z" }),
                React.createElement("path", { fill: "#c9d16a", d: "M7.54,30C7.54,26.25,18.43,24,29,24S50.37,26.25,50.37,30s-10.89,6-21.41,6S7.54,33.69,7.54,30Zm42,0c0-2.49-8.27-5.16-20.58-5.16S8.37,27.48,8.37,30,16.64,35.13,29,35.13,49.54,32.46,49.54,30Z" }),
                React.createElement("path", { fill: "#8ea7ba", d: "M19.47,45.43c-2.85-1.71.18-10.59,4.75-18.18s11-14.43,13.83-12.72-.18,10.59-4.74,18.18-11,14.43-13.84,12.72Zm18.22-30.3c-1.9-1.15-7.53,3.6-12.87,12.48s-6.89,16.08-5,17.22,7.53-3.59,12.87-12.48,6.89-16.08,5-17.22Z" }),
                React.createElement("path", { fill: "#8ea7ba", d: "M17.55,48.6c-3.43-2.06.21-12.77,5.72-21.92S36.52,9.28,40,11.35s-.22,12.76-5.72,21.92S21,50.66,17.55,48.6Zm22-36.53c-2.29-1.38-9.08,4.34-15.52,15s-8.3,19.38-6,20.76,9.08-4.33,15.52-15,8.31-19.38,6-20.76Z" }),
                React.createElement("path", { fill: "#8bb5b7", d: "M38.63,45.07c-2.78,1.81-9.45-4.78-14.29-12.21s-8.18-16.19-5.4-18,9.45,4.78,14.29,12.21,8.18,16.19,5.4,18ZM19.32,15.45c-1.86,1.21-.05,8.34,5.61,17s11.46,13.21,13.32,12,0-8.35-5.61-17-11.46-13.22-13.32-12Z" }),
                React.createElement("path", { fill: "#8bb5b7", d: "M40.64,48.18c-3.35,2.18-11.39-5.77-17.22-14.72S13.55,14,16.9,11.77s11.39,5.76,17.23,14.71S44,46,40.64,48.18ZM17.36,12.47C15.12,13.94,17.3,22.54,24.13,33S37.94,48.93,40.18,47.47s.06-10.06-6.76-20.53S19.61,11,17.36,12.47Z" }),
                React.createElement("path", { fill: "#b29c69", d: "M44.77,38.16c-1.51,3-10.57.55-18.47-3.48s-15.16-10-13.65-12.92,10.58-.55,18.48,3.48,15.15,10,13.64,12.92ZM13.28,22.08c-1,2,4.11,7.26,13.34,12s16.52,5.76,17.53,3.78-4.11-7.27-13.34-12S14.29,20.1,13.28,22.08Z" }),
                React.createElement("path", { fill: "#b29c69", d: "M48.07,39.85c-1.82,3.57-12.75.67-22.27-4.18S7.53,23.65,9.35,20.09s12.75-.67,22.26,4.19,18.27,12,16.46,15.57Zm-38-19.37c-1.22,2.38,5,8.75,16.09,14.43s19.9,7,21.12,4.56-5-8.76-16.08-14.44S11.32,18.09,10.1,20.48Z" }),
                React.createElement("path", { fill: "#b7bc6c", d: "M12.55,38.16C11,35.2,18.3,29.27,26.2,25.24s17-6.44,18.47-3.48S38.92,30.65,31,34.68s-17,6.43-18.47,3.48ZM44,22.08c-1-2-8.29-.93-17.52,3.78s-14.36,10-13.34,12,8.29.93,17.52-3.78,14.36-10,13.34-12Z" }),
                React.createElement("path", { fill: "#b7bc6c", d: "M9.26,39.85C7.44,36.29,16.2,29.14,25.71,24.28S46.16,16.53,48,20.09,41,30.81,31.52,35.67,11.08,43.42,9.26,39.85Zm38-19.37C46,18.09,37.22,19.35,26.1,25S8.79,37.08,10,39.47s10,1.12,21.13-4.56,17.3-12,16.08-14.43Z" }),
                React.createElement("circle", { fill: "#231f20", cx: "28.78", cy: "29.97", r: "5.16" })))));
};
const RainbowEnergy = React.memo(RainbowEnergyComponent);

const EnergySymbolComponent = (props) => {
    const { fill, size = ENERGY_SIZES.MEDIUM, type = pokemonCardLibrary.ENERGY_TYPES.COLORLESS, } = props;
    const iconSize = size === ENERGY_SIZES.SMALL
        ? DEFAULT_ENERGY_ICON_SIZE_SMALL
        : size === ENERGY_SIZES.TINY
            ? DEFAULT_ENERGY_ICON_SIZE_TINY
            : DEFAULT_ENERGY_ICON_SIZE;
    return (React.createElement(React.Fragment, null,
        type === pokemonCardLibrary.ENERGY_TYPES.COLORLESS && (React.createElement(ColorlessEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.DARKNESS && (React.createElement(DarknessEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.FIGHTING && (React.createElement(FightingEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.FIRE && (React.createElement(FireEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.GRASS && (React.createElement(GrassEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.LIGHTNING && (React.createElement(LightningEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.METAL && (React.createElement(MetalEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.PSYCHIC && (React.createElement(PsychicEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.ENERGY_TYPES.WATER && (React.createElement(WaterEnergy, { height: iconSize, width: iconSize, fill: fill })),
        type === pokemonCardLibrary.SPECIAL_ENERGY_TYPES.RAINBOW && (React.createElement(RainbowEnergy, { height: iconSize, width: iconSize, fill: fill }))));
};
const EnergySymbol = React.memo(EnergySymbolComponent);

function createMarkup$1(markup) {
    return { __html: markup };
}
const CardDescriptionComponent = (props) => {
    const { description, pokemonLevel, pokemonLevelLabel, pokemonNumber, pokemonNumberLabel, } = props;
    const descriptionLength = description && description.length;
    const cardDescriptionClassNames = classNames({
        'card-description': true,
        'card-description--small': descriptionLength > 95,
        'card-description--extra-small': descriptionLength > 120,
    });
    return (React.createElement("div", { className: cardDescriptionClassNames },
        React.createElement("div", { className: "card-description__borderside" }),
        React.createElement("span", { className: "card-description__text" },
            description ? (React.createElement("span", { className: "card-description__text__content", dangerouslySetInnerHTML: createMarkup$1(description) })) : undefined,
            pokemonLevel ? (React.createElement("span", { className: "card-description__text__level" },
                pokemonLevelLabel,
                " ",
                pokemonLevel)) : undefined,
            pokemonNumber && (React.createElement("span", { className: "card-description__text__number" },
                pokemonNumberLabel,
                pokemonNumber)))));
};
const CardDescription = React.memo(CardDescriptionComponent);

const renderRetreatCostEnergy = (amount) => {
    if (!amount)
        return undefined;
    const retreatCostMarkup = [];
    for (let i = 0; i < amount; i++) {
        retreatCostMarkup.push(React.createElement(EnergySymbol, { key: `retreat-cost-${i}`, type: pokemonCardLibrary.ENERGY_TYPES.COLORLESS }));
    }
    return retreatCostMarkup;
};
const CardEnergyCostTableComponent = (props) => {
    const { appendResistanceToTitle, energyResistance, energyRetreatCost, energyWeakness, isGymLayout, pokemonLevel, pokemonLevelLabel, pokemonNumber, pokemonNumberLabel, resistanceAmount, resistanceLabel, retreatCostLabel, weaknessLabel, } = props;
    const energyCostTableClassNames = classNames({
        'energy-cost-grid__energy-costs': true,
        'd-grid': !isGymLayout,
    });
    const energyWeaknessClassNames = classNames({
        'cost weakness': true,
        'no-weakness': !energyWeakness,
    });
    const WeaknessAndResistance = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: energyWeaknessClassNames },
                React.createElement("span", { className: "cost-label" }, weaknessLabel),
                energyWeakness && React.createElement(EnergySymbol, { type: energyWeakness })),
            React.createElement("div", { className: "cost resistance" },
                React.createElement("span", { className: "cost-label" },
                    resistanceLabel,
                    appendResistanceToTitle ? ` -${resistanceAmount}` : undefined),
                energyResistance && (React.createElement("div", { className: "resistance-cost-wrapper" },
                    React.createElement(EnergySymbol, { type: energyResistance }),
                    !appendResistanceToTitle ? (React.createElement("span", { className: "modifier" },
                        "-",
                        resistanceAmount)) : undefined)))));
    };
    return (React.createElement("div", { className: energyCostTableClassNames },
        isGymLayout ? (React.createElement("div", { className: "d-flex" },
            React.createElement(WeaknessAndResistance, null))) : (React.createElement(WeaknessAndResistance, null)),
        React.createElement("div", { className: "cost retreat-cost" },
            React.createElement("span", { className: "cost-label" }, retreatCostLabel),
            energyRetreatCost
                ? renderRetreatCostEnergy(energyRetreatCost)
                : undefined),
        isGymLayout ? (React.createElement(CardDescription, { pokemonLevelLabel: pokemonLevelLabel, pokemonLevel: pokemonLevel, pokemonNumber: pokemonNumber, pokemonNumberLabel: pokemonNumberLabel })) : undefined));
};
const CardEnergyCostTable = React.memo(CardEnergyCostTableComponent);

const CardCostGridComponent = (props) => {
    const { appendResistanceToTitle, energyResistance, energyRetreatCost, energyWeakness, isFloatedGrid, resistanceLabel = 'resistance', retreatCostLabel = 'retreat cost', weaknessLabel = 'weakness', pokemonLevel, pokemonLevelLabel, pokemonNumber, pokemonNumberLabel, resistanceAmount = 30, showSwooshes, trainerImageUrl, } = props;
    const energyCostGridClassNames = classNames({
        'energy-cost-grid d-flex': true,
    });
    return (React.createElement("div", { className: energyCostGridClassNames }, isFloatedGrid ? (React.createElement("div", { className: "d-flex" },
        React.createElement(CardEnergyCostTable, { appendResistanceToTitle: appendResistanceToTitle, isGymLayout: true, resistanceLabel: resistanceLabel, retreatCostLabel: retreatCostLabel, weaknessLabel: weaknessLabel, energyResistance: energyResistance, energyRetreatCost: energyRetreatCost, energyWeakness: energyWeakness, resistanceAmount: resistanceAmount, pokemonLevel: pokemonLevel, pokemonLevelLabel: pokemonLevelLabel, pokemonNumber: pokemonNumber, pokemonNumberLabel: pokemonNumberLabel }),
        trainerImageUrl ? (React.createElement("div", { className: "trainer-image", style: { backgroundImage: `url('${trainerImageUrl}')` } })) : undefined)) : (React.createElement(React.Fragment, null,
        React.createElement(CardEnergyCostTable, { appendResistanceToTitle: appendResistanceToTitle, resistanceLabel: resistanceLabel, retreatCostLabel: retreatCostLabel, weaknessLabel: weaknessLabel, energyResistance: energyResistance, energyRetreatCost: energyRetreatCost, energyWeakness: energyWeakness, resistanceAmount: resistanceAmount }),
        showSwooshes ? (React.createElement("div", { className: "neo-swooshes" },
            React.createElement("span", { className: "swoosh left" },
                React.createElement(NeoLeftSwoosh, null)),
            React.createElement("span", { className: "swoosh right" },
                React.createElement(NeoRightSwoosh, null)))) : undefined))));
};
const CardCostGrid = React.memo(CardCostGridComponent);

const replaceApostrophe = (inputStr) => {
    if (!inputStr || !inputStr.length)
        return '';
    return inputStr.replace(/'/g, '’');
};
const getNameLength = (name) => {
    return (name && name.length) || 0;
};
const getNameMaxLength = (isTrainerTemplate) => {
    return isTrainerTemplate ? NAME_MAX_LENGTH_TRAINER : NAME_MAX_LENGTH;
};
const getStrippedDescriptionLength = (rawDescription) => {
    if (!rawDescription || !rawDescription.length)
        return 0;
    const strippedDescription = rawDescription.replace(/(<([^>]+)>)/gi, '');
    return strippedDescription.length;
};
const capitalizeFirstLetter = (inputStr) => {
    return inputStr.charAt(0).toUpperCase() + inputStr.slice(1);
};

const CardMoveAbilityBadgeComponent = (props) => {
    const { type = pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_POWER } = props;
    const cardMoveAbilityBadgeClassNames = classNames({
        'card-move-ability-badge': true,
        [`card-move-ability-badge--${type}`]: type,
    });
    return React.createElement("div", { className: cardMoveAbilityBadgeClassNames });
};
const CardMoveAbilityBadge = React.memo(CardMoveAbilityBadgeComponent);

const CardMoveAbilityBoomerangComponent = () => {
    const cardMoveAbilityBoomerangClassNames = classNames({
        'card-move-ability-boomerang': true,
    });
    return React.createElement("div", { className: cardMoveAbilityBoomerangClassNames });
};
const CardMoveAbilityBoomerang = React.memo(CardMoveAbilityBoomerangComponent);

const isBasic = (stage) => {
    return !stage || stage === '' || Number(stage) <= 0;
};
const isNeoTemplate = (cardTemplate) => {
    return cardTemplate && cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.NEO;
};
const isESeriesTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.VS ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.WEB ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER_E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER_VS ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS));
};
const isGymTemplate = (cardTemplate) => {
    return cardTemplate && cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.GYM;
};
const isVsTemplate = (cardTemplate) => {
    return cardTemplate && cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.VS;
};
const isWebTemplate = (cardTemplate) => {
    return cardTemplate && cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.WEB;
};
const isAnyVsTemplate = (cardTemplate) => {
    return (isVsTemplate(cardTemplate) ||
        cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER_VS ||
        cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS);
};
const isVsOrWebTemplate = (cardTemplate) => {
    return isVsTemplate(cardTemplate) || isWebTemplate(cardTemplate);
};
const isEnergySymbolChunk = (chunk) => {
    return ENERGY_SYMBOL_CODES.includes(chunk);
};
const isESeriesTrainerTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER_E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER_VS));
};
const isESeriesEnergyTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS));
};
const isBaseTrainerTemplate = (cardTemplate) => {
    return cardTemplate && cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER;
};
const isTrainerTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (isBaseTrainerTemplate(cardTemplate) ||
            isESeriesTrainerTemplate(cardTemplate)));
};
const isEnergyTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_E_SERIES ||
            cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS));
};
const isTrainerOrEnergyTemplate = (cardTemplate) => {
    return (cardTemplate &&
        (isEnergyTemplate(cardTemplate) || isTrainerTemplate(cardTemplate)));
};
const isBaseNeoOrGymTemplate = (cardTemplate) => {
    return (!cardTemplate ||
        cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.BASE ||
        isGymTemplate(cardTemplate) ||
        isNeoTemplate(cardTemplate));
};
const isNeoOrESeriesTemplate = (cardTemplate) => {
    return (!cardTemplate ||
        isESeriesTemplate(cardTemplate) ||
        isNeoTemplate(cardTemplate));
};
const getEnergyTypeByCode = (code) => {
    let energyIconType;
    switch (code) {
        case ENERGY_SYMBOL_CODES[0]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.WATER;
            break;
        case ENERGY_SYMBOL_CODES[1]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.PSYCHIC;
            break;
        case ENERGY_SYMBOL_CODES[2]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.FIGHTING;
            break;
        case ENERGY_SYMBOL_CODES[3]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.LIGHTNING;
            break;
        case ENERGY_SYMBOL_CODES[4]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.GRASS;
            break;
        case ENERGY_SYMBOL_CODES[5]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.COLORLESS;
            break;
        case ENERGY_SYMBOL_CODES[6]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.FIRE;
            break;
        case ENERGY_SYMBOL_CODES[7]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.DARKNESS;
            break;
        case ENERGY_SYMBOL_CODES[8]:
            energyIconType = pokemonCardLibrary.ENERGY_TYPES.METAL;
            break;
        case ENERGY_SYMBOL_CODES[9]:
            energyIconType = pokemonCardLibrary.SPECIAL_ENERGY_TYPES.RAINBOW;
            break;
    }
    return energyIconType;
};
const isGymTrainerSettingsDisabled = (cardTemplate) => {
    return (!cardTemplate ||
        (cardTemplate !== pokemonCardLibrary.CARD_TEMPLATES.GYM && cardTemplate !== pokemonCardLibrary.CARD_TEMPLATES.VS));
};
const isBabySubtype = (cardTemplateSubtype) => {
    return cardTemplateSubtype === pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.BABY;
};
const isShiningSubtype = (cardTemplateSubtype) => {
    return cardTemplateSubtype === pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.SHINING;
};
const isUnownSubtype = (cardTemplateSubtype) => {
    return cardTemplateSubtype === pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.UNOWN;
};
const isShiningBabyUnownSubtype = (cardTemplateSubtype) => {
    if (!cardTemplateSubtype)
        return false;
    return (isBabySubtype(cardTemplateSubtype) ||
        isShiningSubtype(cardTemplateSubtype) ||
        isUnownSubtype(cardTemplateSubtype));
};
const isBasicETemplate = (stage, cardTemplate, cardTemplateSubtype) => {
    return (isBasic(stage) &&
        isESeriesTemplate(cardTemplate) &&
        !isShiningBabyUnownSubtype(cardTemplateSubtype));
};
const isReverseHoloEnergyTemplate = (cardTemplate, holo) => {
    return isEnergyTemplate(cardTemplate) && holo && holo === 'reverse';
};
const getTextCondensedLevel = (name, isBasicPokemon, hitPoints) => {
    const hasHitPoints = !!hitPoints;
    let condenseLevel = 0;
    const isNameCondensed = (isBasicPokemon && getNameLength(name) > 27) ||
        (isBasicPokemon && getNameLength(name) > 24 && hasHitPoints) ||
        (isBasicPokemon && getNameLength(name) > 20 && hitPoints > 9) ||
        (!isBasicPokemon && getNameLength(name) > 18) ||
        (!isBasicPokemon && getNameLength(name) > 14 && hasHitPoints);
    const isNameXCondensed = (isBasicPokemon && getNameLength(name) > 28) ||
        (isBasicPokemon && getNameLength(name) > 24 && hasHitPoints) ||
        (!isBasicPokemon && getNameLength(name) >= 18);
    const isNameXXCondensed = !isBasicPokemon && getNameLength(name) >= 20 && hasHitPoints;
    const isNameXXXCondensed = getNameLength(name) > 24 && !isBasicPokemon;
    if (isNameCondensed)
        condenseLevel = 2;
    if (isNameXCondensed)
        condenseLevel = 3;
    if (isNameXXCondensed)
        condenseLevel = 4;
    if (isNameXXXCondensed)
        condenseLevel = 5;
    return condenseLevel;
};
const getTrainerTextCondenseLevel = (name, subtitle, hitPoints, isESeries) => {
    if (isESeries) {
        return 1;
    }
    let condenseLevel = 1;
    const subtitleOrHitPoints = subtitle || hitPoints;
    const isNameCondensed = getNameLength(name) > 26 ||
        (getNameLength(name) > 14 && subtitleOrHitPoints);
    const isNameXCondensed = getNameLength(name) > 28 ||
        (getNameLength(name) > 17 && subtitleOrHitPoints);
    const isNameXXCondensed = getNameLength(name) > 30 ||
        (getNameLength(name) > 21 && subtitleOrHitPoints) ||
        (getNameLength(name) > 15 && subtitle && subtitle.length > 10);
    const isNameXXXCondensed = getNameLength(name) > 30 && subtitleOrHitPoints;
    if (isNameCondensed)
        condenseLevel = 2;
    if (isNameXCondensed)
        condenseLevel = 3;
    if (isNameXXCondensed)
        condenseLevel = 4;
    if (isNameXXXCondensed)
        condenseLevel = 5;
    return condenseLevel;
};

function createMarkup(markup) {
    return { __html: markup };
}
const CardMoveDescriptionTextComponent = (props) => {
    const { description, moveId } = props;
    const getMovesDescriptionOutput = () => {
        const output = [];
        if (description && description.length > 0) {
            const descriptionChunks = description.split(/[{\}]{1,2}/);
            descriptionChunks.map((chunk) => {
                if (isEnergySymbolChunk(chunk)) {
                    output.push(React.createElement(EnergySymbol, { type: getEnergyTypeByCode(chunk), size: ENERGY_SIZES.TINY }));
                }
                else {
                    output.push(chunk);
                }
            });
        }
        return output;
    };
    const movesDescriptionOutput = getMovesDescriptionOutput();
    return (React.createElement(React.Fragment, null, movesDescriptionOutput && movesDescriptionOutput.length
        ? movesDescriptionOutput.map((chunk, index) => (React.createElement(React.Fragment, { key: `move-${moveId || 'no-id'}-chunk-${index}` }, typeof chunk === 'string' ? (React.createElement("span", { dangerouslySetInnerHTML: createMarkup(chunk) })) : (chunk))))
        : undefined));
};
const CardMoveDescriptionText = React.memo(CardMoveDescriptionTextComponent);

const CardMoveDescriptionComponent = (props) => {
    const { description, descriptionStyle, isESeriesTemplate, isVsTemplate, moveId, name, nameStyle, specialMoveTypePrefix, specialMoveType, } = props;
    const isSmallDesc = getStrippedDescriptionLength(description) > 150;
    const isExtraSmallDesc = getStrippedDescriptionLength(description) > 300;
    const isSpecialMoveType = specialMoveType &&
        (specialMoveType === pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_BODY ||
            specialMoveType === pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_POWER);
    const DEFAULT_SPECIAL_POWER_PREFIX = isSpecialMoveType && specialMoveType === pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_BODY
        ? pokemonCardLibrary.POKE_BODY_LABEL
        : pokemonCardLibrary.POKE_POWER_LABEL;
    const nameClassNames = classNames({
        'move-name': true,
        [`${specialMoveType}`]: specialMoveType,
    });
    const nameTextClassNames = classNames({
        'move-name__text': true,
    });
    const descriptionClassNames = classNames({
        'move-description': true,
        small: isSmallDesc,
        'extra-small': isExtraSmallDesc,
    });
    return (React.createElement("div", { className: descriptionClassNames, style: descriptionStyle },
        name || isSpecialMoveType ? (React.createElement(React.Fragment, null, isSpecialMoveType ? (React.createElement(React.Fragment, null, isESeriesTemplate ? (React.createElement("div", { className: "move-special-ability-name-row" },
            React.createElement(CardMoveAbilityBadge, { type: specialMoveType }),
            React.createElement("strong", { className: nameClassNames, style: nameStyle }, name),
            React.createElement(CardMoveAbilityBoomerang, null))) : (React.createElement("strong", { className: nameClassNames, style: nameStyle },
            specialMoveTypePrefix && specialMoveTypePrefix !== ''
                ? specialMoveTypePrefix
                : DEFAULT_SPECIAL_POWER_PREFIX,
            ': ',
            React.createElement("span", { className: nameTextClassNames }, name))))) : (React.createElement("strong", { className: nameClassNames, style: nameStyle }, name)))) : undefined,
        !isVsTemplate ? (React.createElement(CardMoveDescriptionText, { moveId: moveId, description: description })) : undefined));
};
const CardMoveDescription = React.memo(CardMoveDescriptionComponent);

const CardDescriptionEnergyComponent = (props) => {
    const { description, name, opacity, subtitle } = props;
    const cardDescriptionClassNames = classNames({
        'card-description--energy': true,
    });
    return (React.createElement(React.Fragment, null, description ? (React.createElement("div", { className: cardDescriptionClassNames, style: opacity ? { opacity } : undefined },
        React.createElement("div", { className: "energy-name" },
            name ? (React.createElement("span", { className: "energy-name__title" }, name)) : undefined,
            subtitle ? (React.createElement("span", { className: "energy-name__subtitle" }, subtitle)) : undefined),
        React.createElement(CardMoveDescription, { description: description }))) : undefined));
};
const CardDescriptionEnergy = React.memo(CardDescriptionEnergyComponent);

const TrainerScrewComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 11.38 10.41" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "trainer-screw-liner-gradient", x1: "0.49", y1: "-1.15", x2: "7.52", y2: "7.45", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0.15", stopColor: "#ececec" }),
                React.createElement("stop", { offset: "0.29", stopColor: "#dadadb" }),
                React.createElement("stop", { offset: "0.57", stopColor: "#acadae" }),
                React.createElement("stop", { offset: "0.97", stopColor: "#636467" }),
                React.createElement("stop", { offset: "1", stopColor: "#5c5d60" })),
            React.createElement("radialGradient", { id: "trainer-screw-radial-gradient", cx: "16.34", cy: "4.73", r: "8.75", gradientTransform: "translate(-15.46 -2.79) scale(1.07 1.07)", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#e8e7e6" }),
                React.createElement("stop", { offset: "0.5", stopColor: "#c3c3c2" }),
                React.createElement("stop", { offset: "0.71", stopColor: "#979898" }),
                React.createElement("stop", { offset: "0.92", stopColor: "#626364" }))),
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("polygon", { fill: "url(#trainer-screw-liner-gradient)", points: "8.04 0 3.33 0 0 3.05 0 7.36 3.33 10.41 8.04 10.41 11.38 7.36 11.38 3.05 8.04 0" }),
                React.createElement("path", { fill: "url(#trainer-screw-radial-gradient)", d: "M9.81,4.56a4.8,4.8,0,0,1-9.6,0A3.81,3.81,0,0,1,1.47,1.74,6.51,6.51,0,0,1,2.27,1,9.29,9.29,0,0,1,3.37.19,3.48,3.48,0,0,1,4.81,0,4.75,4.75,0,0,1,9.81,4.56Z" }),
                React.createElement("line", { fill: "none", stroke: "#525255", strokeMiterlimit: 10, strokeWidth: "0.5px", opacity: "0.55", x1: "8.95", y1: "1.98", x2: "2.05", y2: "8.45" })))));
};
const TrainerScrew = React.memo(TrainerScrewComponent);

const CardDescriptionTrainerComponent = (props) => {
    const { description, rule, showScrews } = props;
    const cardDescriptionClassNames = classNames({
        'card-description--trainer': true,
    });
    return (React.createElement("div", { className: cardDescriptionClassNames },
        rule ? React.createElement("div", { className: "trainer-rule" }, rule) : undefined,
        React.createElement(CardMoveDescription, { description: description }),
        showScrews ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "trainer-screw trainer-screw--top-left" },
                React.createElement(TrainerScrew, null)),
            React.createElement("div", { className: "trainer-screw trainer-screw--top-right" },
                React.createElement(TrainerScrew, null)),
            React.createElement("div", { className: "trainer-screw trainer-screw--bottom-left" },
                React.createElement(TrainerScrew, null)),
            React.createElement("div", { className: "trainer-screw trainer-screw--bottom-right" },
                React.createElement(TrainerScrew, null)))) : undefined));
};
const CardDescriptionTrainer = React.memo(CardDescriptionTrainerComponent);

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min)) + min;
const getRangeNumbers = (start, end, step = 1) => {
    const output = [];
    if (typeof end === 'undefined') {
        end = start;
        start = 0;
    }
    for (let i = start; i < end; i += step) {
        output.push(i);
    }
    return output;
};
const getBooleanWithOdds = (odds) => {
    const randomOdds = odds || 0.7;
    return Math.random() < randomOdds;
};
const isNumeric = (str) => {
    if (typeof str != 'string')
        return false;
    return !isNaN(parseFloat(str));
};
const randomNumberWithinRange = (min, max) => {
    const newMin = Math.ceil(min);
    const newMax = Math.floor(max);
    return Math.floor(Math.random() * (newMax - newMin + 1)) + newMin;
};

const CardEvolutionBoxComponent = (props) => {
    const { evolutionBoxBackgroundVariant, evolutionBoxBackgroundImageSize, evolutionBoxImageUrl, stageText, } = props;
    const baseClassName = 'card-evolution-box';
    const cardEvolutionBoxClassNames = classNames({
        [`${baseClassName}`]: true,
        [`${baseClassName}--${evolutionBoxBackgroundVariant}`]: evolutionBoxBackgroundVariant,
    });
    const imageSizeString = evolutionBoxBackgroundImageSize
        ? isNumeric(evolutionBoxBackgroundImageSize)
            ? `${evolutionBoxBackgroundImageSize}%`
            : evolutionBoxBackgroundImageSize
        : undefined;
    return (React.createElement("div", { className: cardEvolutionBoxClassNames },
        React.createElement("div", { className: "card-evolution-box__inner" },
            React.createElement("div", { className: "card-evolution-box__content" },
                React.createElement("div", { className: "card-evolution-box__title" }, stageText),
                React.createElement("div", { className: "card-evolution-box__img-wrapper" }, evolutionBoxImageUrl && (React.createElement("div", { className: "card-evolution-box__img-wrapper__img", style: {
                        backgroundImage: `url("${evolutionBoxImageUrl}")`,
                        backgroundSize: imageSizeString,
                    } })))))));
};
const CardEvolutionBox = React.memo(CardEvolutionBoxComponent);

const CardEvolutionBoxBabyInfoComponent = (props) => {
    const { evolvesToLabel, putBabyLabel } = props;
    return (React.createElement("div", { className: "card-evolution-box-baby__evolution-info" }, evolvesToLabel ? (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "card-evolution-box-baby__evolves-to" }, evolvesToLabel),
        React.createElement("span", { className: "card-evolution-box-baby__put-text" }, putBabyLabel))) : undefined));
};
const CardEvolutionBoxBabyInfo = React.memo(CardEvolutionBoxBabyInfoComponent);

const CardEvolutionBoxBabyComponent = (props) => {
    const { babyDescription, evolvesToLabel, evolutionBoxImageUrl, evolutionBoxBackgroundImageSize, isESeriesTemplate, putBabyLabel, } = props;
    const defaultDescription = isESeriesTemplate
        ? "If your Active Pokémon is a Baby Pokémon and your opponent announces an attack, your opponent flips a coin (before they do anything else). If tails, your opponent's turn ends."
        : "If this Baby Pokémon is your Active Pokémon and your opponent tries to attack, your opponent flips a coin (before doing anything required in order to use that attack). If tails, your opponent's turn ends without an attack.";
    const imageSizeString = evolutionBoxBackgroundImageSize
        ? isNumeric(evolutionBoxBackgroundImageSize)
            ? `${evolutionBoxBackgroundImageSize}%`
            : evolutionBoxBackgroundImageSize
        : undefined;
    return (React.createElement("div", { className: "card-evolution-box-baby-wrapper" },
        React.createElement("div", { className: "card-evolution-box-baby" },
            React.createElement("div", { className: "card-evolution-box-baby__image" },
                React.createElement("div", { className: "card-evolution-box__img-wrapper" }, evolutionBoxImageUrl && (React.createElement("div", { className: "card-evolution-box__img-wrapper__img", style: {
                        backgroundImage: `url("${evolutionBoxImageUrl}")`,
                        backgroundSize: imageSizeString,
                    } })))),
            React.createElement("div", { className: "card-evolution-box-baby__description" },
                isESeriesTemplate ? (React.createElement(CardEvolutionBoxBabyInfo, { evolvesToLabel: evolvesToLabel, putBabyLabel: putBabyLabel })) : undefined,
                babyDescription || defaultDescription)),
        !isESeriesTemplate ? (React.createElement(CardEvolutionBoxBabyInfo, { evolvesToLabel: evolvesToLabel, putBabyLabel: putBabyLabel })) : undefined,
        isESeriesTemplate ? React.createElement("hr", { className: "e-divider" }) : undefined));
};
const CardEvolutionBoxBaby = React.memo(CardEvolutionBoxBabyComponent);

const TripleStarComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 35.84 31.19", width: width, height: height },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M2.78,13.77,7.25,0l4.47,13.77L0,5.25H14.49" }),
                React.createElement("path", { fill: fill, d: "M24.12,13.77,28.59,0l4.47,13.77L21.34,5.25h14.5" }),
                React.createElement("path", { fill: fill, d: "M13.7,31.19l4.47-13.77,4.47,13.77L10.92,22.67H25.41" })))));
};
const TripleStar = React.memo(TripleStarComponent);

const SingleStarComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 39.36 37.39", width: width, height: height },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M7.54,37.39,19.68,0,31.82,37.39,0,14.27H39.36" })))));
};
const SingleStar = React.memo(SingleStarComponent);

const UncommonComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 37.69 37.69", width: width, height: height },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("rect", { fill: fill, x: "5.52", y: "5.52", width: "26.65", height: "26.65", transform: "translate(18.84 -7.81) rotate(45)" })))));
};
const Uncommon = React.memo(UncommonComponent);

const CommonComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31.44 31.44", width: width, height: height },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("circle", { fill: fill, cx: "15.72", cy: "15.72", r: "15.72" })))));
};
const Common = React.memo(CommonComponent);

const RarityIconComponent = (props) => {
    const { fill, rarity, width, height } = props;
    return (React.createElement(React.Fragment, null,
        rarity === pokemonCardLibrary.RARITY_TYPES.SHINING ? (React.createElement(TripleStar, { fill: fill, width: width, height: height })) : undefined,
        rarity === pokemonCardLibrary.RARITY_TYPES.RARE || rarity === 'holo-rare' ? (React.createElement(SingleStar, { fill: fill, width: width, height: height })) : undefined,
        rarity === pokemonCardLibrary.RARITY_TYPES.UNCOMMON && (React.createElement(Uncommon, { fill: fill, width: width, height: height })),
        rarity === pokemonCardLibrary.RARITY_TYPES.COMMON && (React.createElement(Common, { fill: fill, width: width, height: height }))));
};
const RaritySymbol = React.memo(RarityIconComponent);

const CardFooterComponent = (props) => {
    const { copyright, illustrator, isESeriesTemplate, rarity, setNumber, setTotal, } = props;
    const cardFooterClassNames = classNames({
        card__footer: true,
        'card__footer--with-copyright': copyright,
    });
    const CopyrightText = () => (React.createElement("p", { className: "copyright" }, copyright || ' '));
    return (React.createElement("div", { className: cardFooterClassNames },
        isESeriesTemplate ? React.createElement(CopyrightText, null) : undefined,
        React.createElement("p", { className: "illustrator" }, illustrator ? `Illus. ${illustrator}` : ''),
        !isESeriesTemplate ? React.createElement(CopyrightText, null) : undefined,
        React.createElement("div", { className: "set-number" },
            setNumber,
            setTotal && React.createElement(React.Fragment, null, `/${setTotal}`),
            React.createElement("div", { className: "rarity-symbol" },
                React.createElement(RaritySymbol, { rarity: rarity })))));
};
const CardFooter = React.memo(CardFooterComponent);

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: no-preference)';
const isRenderingOnServer = typeof window === 'undefined';
const useRandomInterval = (callback, minDelay, maxDelay) => {
    const random = (min, max) => Math.floor(Math.random() * (max - min)) + min;
    const timeoutId = React.useRef(null);
    const savedCallback = React.useRef(callback);
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    React.useEffect(() => {
        const isEnabled = typeof minDelay === 'number' && typeof maxDelay === 'number';
        if (isEnabled) {
            const handleTick = () => {
                const nextTickAt = random(minDelay, maxDelay);
                timeoutId.current = window.setTimeout(() => {
                    savedCallback.current();
                    handleTick();
                }, nextTickAt);
            };
            handleTick();
        }
        return () => window.clearTimeout(timeoutId.current);
    }, [minDelay, maxDelay]);
    const cancel = React.useCallback(function () {
        window.clearTimeout(timeoutId.current);
    }, []);
    return cancel;
};
const getInitialState = () => {
    return isRenderingOnServer
        ? true
        : !window.matchMedia(REDUCED_MOTION_QUERY).matches;
};
const usePrefersReducedMotion = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(getInitialState);
    React.useEffect(() => {
        const mediaQueryList = window.matchMedia(REDUCED_MOTION_QUERY);
        const listener = (event) => {
            setPrefersReducedMotion(!event.matches);
        };
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', listener);
        }
        else {
            mediaQueryList.addListener(listener);
        }
        return () => {
            if (mediaQueryList.removeEventListener) {
                mediaQueryList.removeEventListener('change', listener);
            }
            else {
                mediaQueryList.removeListener(listener);
            }
        };
    }, []);
    return prefersReducedMotion;
};

const HoloSparkleComponent = ({ size, color, style }) => {
    const path = 'M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z';
    return (React.createElement("span", { className: "sparkle-wrapper", style: style },
        React.createElement("svg", { className: "sparkle-svg", width: size, height: size, viewBox: "0 0 68 68", fill: "none" },
            React.createElement("path", { d: path, fill: color }))));
};
const HoloSparkle = React.memo(HoloSparkleComponent);

const DEFAULT_COLOR = '#FFC700';
const generateSparkle = (color) => {
    const sparkle = {
        id: String(getRandomNumber(10000, 99999)),
        createdAt: Date.now(),
        color,
        size: getRandomNumber(15, 25),
        style: {
            top: getRandomNumber(0, 100) + '%',
            left: getRandomNumber(0, 100) + '%',
        },
    };
    return sparkle;
};
const AnimatedSparkleHoloSheetComponent = ({ color = DEFAULT_COLOR, ...delegated }) => {
    const [sparkles, setSparkles] = React.useState(() => {
        return getRangeNumbers(3).map(() => generateSparkle(color));
    });
    const prefersReducedMotion = usePrefersReducedMotion();
    useRandomInterval(() => {
        const sparkle = generateSparkle(color);
        const now = Date.now();
        const nextSparkles = sparkles.filter(sp => {
            const delta = now - sp.createdAt;
            return delta < 750;
        });
        nextSparkles.push(sparkle);
        setSparkles(nextSparkles);
    }, prefersReducedMotion ? null : 50, prefersReducedMotion ? null : 50);
    return (React.createElement("div", { className: "card-holo-sheet animated-sparkle", ...delegated }, sparkles.map(sparkle => (React.createElement(HoloSparkle, { key: sparkle.id, color: sparkle.color, size: sparkle.size, style: sparkle.style })))));
};
const AnimatedSparkleHoloSheet = React.memo(AnimatedSparkleHoloSheetComponent);

const CardHoloSheetComponent = (props) => {
    const { className, full, holoBlendMode, holoStrength = DEFAULT_HOLO_STRENGTH, isAnimated, randomizeHoloSheetPosition, type, } = props;
    const randomizerBoolean = Math.random() < 0.5;
    const holoSheetClassNames = classNames({
        'card-holo-sheet': true,
        [`card-holo-sheet--${type}`]: type,
        'card-holo-sheet--full': full,
        'card-holo-sheet--inverted': randomizeHoloSheetPosition
            ? randomizerBoolean
            : false,
        'card-holo-sheet--animated': isAnimated,
        [`blend-mode--${holoBlendMode}`]: holoBlendMode,
        [`${className}`]: className,
    });
    const holoSheetStyle = {
        opacity: holoStrength && type !== pokemonCardLibrary.CARD_HOLO_SHEETS.ANIMATED_SPARKLE
            ? holoStrength
            : undefined,
        backgroundColor: `rgba(0,0,0,${holoStrength})`,
    };
    return (React.createElement(React.Fragment, null, type === pokemonCardLibrary.CARD_HOLO_SHEETS.ANIMATED_SPARKLE ? (React.createElement(AnimatedSparkleHoloSheet, { className: holoSheetClassNames, style: holoSheetStyle })) : (React.createElement("div", { className: holoSheetClassNames, style: holoSheetStyle }))));
};
const CardHoloSheet = React.memo(CardHoloSheetComponent);

const PreReleaseStampComponent = (props) => {
    const { fill = '#000000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 204.34 38.22" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M15.54.09l1.82,1.78.36,20-2,3.22H7.28V38.13H0V.09ZM10,18V6.73H7.28V18Z" }),
                React.createElement("path", { fill: fill, d: "M36.7,21l4.64,17.12H34.66L31.08,24.69H29.91V38.13H22.52V.09H37.66l2.21,2.48L40,18.73Zm-4.08-4.32V5.84l-2.71.06V16.62Z" }),
                React.createElement("path", { fill: fill, d: "M59.63,6H53V15h5.81l-.12,6.64-5.75-.06-.18,10h7.51v6.57H45.61V0l14,.09Z" }),
                React.createElement("path", { fill: fill, d: "M114.28,31.54h5.82V38H107V0h7.26Z" }),
                React.createElement("path", { fill: fill, d: "M158.15.11l5.24,38.11h-6.78l-.84-6-4.82,0-.41,6h-6.95L149.07.1Zm-5.83,25.71,2.35-.05-.87-10.7h-1Z" }),
                React.createElement("path", { fill: fill, d: "M184.61,12.51h-7.22V5.9h-2.68v6.62l9.9,9.94V34.87l-.26.43a5.88,5.88,0,0,1-4,2.76l-.88.16h-6.94L171,38a4.75,4.75,0,0,1-3.25-2.3l-.09-.15a2.87,2.87,0,0,1-.37-1.4V25.76h6.58l0,5.86,3.32,0V25.78l-9.91-10.09V1.77L169,.1h13.81l1.76,3.33Z" }),
                React.createElement("path", { fill: fill, d: "M78.89,20.92l4.75,17.27H76.23l-3-13.6H72.11l0,13.6H64.59V.1H80.26l1.8,2.39.12,15.94a.69.69,0,0,1-.11.41h0a4.23,4.23,0,0,1-3.18,2.09Zm-4.07-4.25V5.89H72.11V16.67Z" }),
                React.createElement("path", { fill: fill, d: "M101,6H94.41V15h5.81l-.13,6.64-5.75-.06-.18,10h7.51v6.57H87L87,.11,101,.09Z" }),
                React.createElement("path", { fill: fill, d: "M139.12,6H132.5V15h5.81l-.12,6.64-5.75-.06-.18,10h7.51v6.57H125.1V.11l14,0Z" }),
                React.createElement("path", { fill: fill, d: "M203.71,6h-6.63V15h5.81l-.12,6.64L197,21.6l-.18,10h7.51v6.57H189.68V.11l14,0Z" })))));
};
const PreReleaseStamp = React.memo(PreReleaseStampComponent);

const WinnerStampComponent = (props) => {
    const { fill = '#000000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 203.01 58.7" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M46.71,36,42.56,45q-1.65,3.54-2.77,5.79c-.75,1.5-1.37,2.67-1.87,3.5a17,17,0,0,1-1.38,2,4.46,4.46,0,0,1-1.48,1.13,9,9,0,0,1-1.74.61,9.17,9.17,0,0,1-1.77.24l-1.51,0h-.32q-1.16-.06-2.58-.09a4.17,4.17,0,0,1-2.31-.64c-1.19-.66-1.42-1.95-1.58-3.17s-.06-2.79-.16-4L23,47.47c0-1.3,0-3.12-.07-4.48,0-.75-.09-1.38-.16-1.89-.19-1.28-.58-.8-1.16.31-.36.71-.79,1.6-1.28,2.68s-1,2.26-1.58,3.56-1.13,2.56-1.71,3.78-1.13,2.31-1.67,3.29a7.65,7.65,0,0,1-1.45,2,5.63,5.63,0,0,1-3,1.37,23,23,0,0,1-3,.21H6.55A12.69,12.69,0,0,1,4,58.07a4.41,4.41,0,0,1-1.93-.88A3.87,3.87,0,0,1,.89,55.42a7.73,7.73,0,0,1-.26-3C.46,47.92.33,44.29.25,41.59c-.07-4.21-.37-6.89-.2-10A4,4,0,0,1,1,29.68a4.46,4.46,0,0,1,1.54-1.1,7.05,7.05,0,0,1,1.83-.48,11,11,0,0,1,4.41.21,3.35,3.35,0,0,1,2,1.55,5.49,5.49,0,0,1,.39,1.83c.09.9.14,1.93.16,3.11s0,2.39,0,3.65c.13,3.09-.87,11.68,2.25,3.84.41-1,.85-2.06,1.32-3.26s1-2.37,1.52-3.53a32.55,32.55,0,0,1,1.7-3.23,12.89,12.89,0,0,1,1.8-2.41,5.79,5.79,0,0,1,3.19-1.64,19.7,19.7,0,0,1,3.31-.31h1a13,13,0,0,1,2.22.19,4.52,4.52,0,0,1,2,.85,3.33,3.33,0,0,1,1,1.89,19.59,19.59,0,0,1,.48,3.23c.09,1.22.14,2.49.16,3.84s0,2.56.07,3.68a27.5,27.5,0,0,0,.16,2.77c.08.73.23,1.1.45,1.1l3.15-6.58c.73-1.58,1.37-3,1.93-4.36a21.11,21.11,0,0,1,1.77-3.38A8.22,8.22,0,0,1,42.88,29,4.66,4.66,0,0,1,48,28.89,1.79,1.79,0,0,1,48.77,31a6,6,0,0,1-.2.67c-.08.24-.19.55-.32.91Z" }),
                React.createElement("path", { fill: fill, d: "M60.8,54.77a3.58,3.58,0,0,1-1,1.8A6,6,0,0,1,58,57.78a9.64,9.64,0,0,1-2.09.68,12.5,12.5,0,0,1-1.89.24,10.12,10.12,0,0,1-1.77-.13A6.23,6.23,0,0,1,50.5,58a3.34,3.34,0,0,1-1.32-1.11,2.1,2.1,0,0,1-.26-1.76c.59-2.87,1.11-5.4,1.57-7.61s.86-4.14,1.21-5.8.66-3,.89-4.2.44-2.08.6-2.82c.39-1.76.61-2.8.65-3.13a3.69,3.69,0,0,1,1-1.92,5.86,5.86,0,0,1,1.69-1.21,8.05,8.05,0,0,1,2-.64,14.63,14.63,0,0,1,2-.21c2-.06,3.41.23,4.24.87s1,2,.6,4Z" }),
                React.createElement("path", { fill: fill, d: "M90.56,58.56a7.41,7.41,0,0,1-1.62-.19,4.87,4.87,0,0,1-1.56-.6,2.73,2.73,0,0,1-1-1.16,3,3,0,0,1-.11-1.89l3.3-16.39a1.81,1.81,0,0,0-.2-1.4,3.23,3.23,0,0,0-1.07-1,5,5,0,0,0-1.57-.6,7.93,7.93,0,0,0-1.74-.19,5.41,5.41,0,0,0-3.16.95,5.15,5.15,0,0,0-1.94,2.89q-.87,4.2-1.48,7.13c-.4,2-.74,3.57-1,4.87q-.46,2.25-.75,3.72a4.18,4.18,0,0,1-.87,2,5.54,5.54,0,0,1-3.25,1.79,11.34,11.34,0,0,1-1.8.16,7.93,7.93,0,0,1-1.74-.19,4,4,0,0,1-1.53-.64,2.67,2.67,0,0,1-1-1.21,3.46,3.46,0,0,1-.08-2L71,31.63a3.57,3.57,0,0,1,.76-1.43A7.69,7.69,0,0,1,73,29,7.26,7.26,0,0,1,74.57,28,3.4,3.4,0,0,1,76,27.67H91a14.08,14.08,0,0,1,4.2.58,7.5,7.5,0,0,1,3.13,1.8A6.15,6.15,0,0,1,100,33.18a11.4,11.4,0,0,1-.08,4.6L96.48,54.6a4.4,4.4,0,0,1-.87,2,5,5,0,0,1-1.48,1.21,5.4,5.4,0,0,1-1.8.61A11.61,11.61,0,0,1,90.56,58.56Z" }),
                React.createElement("path", { fill: fill, d: "M171,40.53c-.51,2.42-2.46,5-5.16,5.08l-15.53.24c-1.24,0-1.94,1.55-2.22,2.59-.55,2.3,1.22,3,3.16,2.87l12-.18c2.17-.1,2.72,1.77,2.38,3.56-.32,2.67-2.69,3.49-5,3.36l-6.82.11c-5.63-.18-10.25.66-14.2-1.66a2.59,2.59,0,0,1-.55-.44c-2.89-3.1-1.53-6.87-.82-11.85,1-5,1.29-11.07,5.38-14.5,3.79-3.49,11.31-2.46,16.17-2.53,8.91-.13,12.67,1.27,11.66,9.51ZM152.26,37.3l4.25,0H158c.68-.07.57-2.09.57-2.09s-.09-1.87-.49-1.87h-4.17c-1.18,0-1.81.91-1.83,2.09C152,35.41,151.9,37.21,152.26,37.3Z" }),
                React.createElement("path", { fill: fill, d: "M202.88,33.85c-.08.68-2.67,2.3-3.57,2.7C196.24,38,194.25,34,192.24,34l-3,.12c-2.21.57-2.15,3.34-2.62,5.47l-2.41,14.75a4,4,0,0,1-.82,2c-2.12,2.83-10.57,3.65-10-1.42l3.77-23.3a6.39,6.39,0,0,1,5.07-4.71l9.71-.05a24.86,24.86,0,0,1,4.64.41A14.41,14.41,0,0,1,201,29.15C203.33,30.22,203.09,32.73,202.88,33.85Z" }),
                React.createElement("path", { fill: fill, d: "M125.38,58.56a7.43,7.43,0,0,1-1.63-.19,4.87,4.87,0,0,1-1.56-.6,2.79,2.79,0,0,1-1-1.16,3,3,0,0,1-.11-1.89l3.3-16.39a1.81,1.81,0,0,0-.2-1.4,3.23,3.23,0,0,0-1.07-1,5,5,0,0,0-1.57-.6,7.93,7.93,0,0,0-1.74-.19,5.43,5.43,0,0,0-3.16.95,5.2,5.2,0,0,0-1.94,2.89q-.87,4.2-1.48,7.13c-.4,2-.74,3.57-1,4.87q-.47,2.25-.75,3.72a4.18,4.18,0,0,1-.87,2,5.54,5.54,0,0,1-3.25,1.79,11.34,11.34,0,0,1-1.8.16,8,8,0,0,1-1.74-.19,4.11,4.11,0,0,1-1.53-.64,2.73,2.73,0,0,1-1-1.21,3.46,3.46,0,0,1-.08-2l4.63-22.91a3.57,3.57,0,0,1,.76-1.43,7.69,7.69,0,0,1,1.3-1.25,7.51,7.51,0,0,1,1.54-.91,3.4,3.4,0,0,1,1.39-.37h15a14.08,14.08,0,0,1,4.2.58,7.61,7.61,0,0,1,3.14,1.8,6.23,6.23,0,0,1,1.68,3.13,11.42,11.42,0,0,1-.09,4.6L131.29,54.6a4.4,4.4,0,0,1-.87,2,5,5,0,0,1-1.48,1.21,5.4,5.4,0,0,1-1.8.61A11.38,11.38,0,0,1,125.38,58.56Z" }),
                React.createElement("path", { fill: fill, d: "M52,26.27,60.56,0l8.53,26.27L46.74,10H74.39" })))));
};
const WinnerStamp = React.memo(WinnerStampComponent);

const WizardsStampComponent = (props) => {
    const { fill = '#000000', width, height } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 96.3 62.98" },
        React.createElement("g", null,
            React.createElement("path", { fill: fill, d: "M51.07 63a2 2 0 0 1-.9-.21L26.56 51.34 5.71 41.68 0 40.36l16-7.24-.87 1.67a6.58 6.58 0 0 0-.74 2.79.79.79 0 0 0 .47.74l11.73 4.89 10.92 5a.46.46 0 0 0 .59-.64l-10.42-18.2a.72.72 0 0 1 .05-.81l.29-.39a.93.93 0 0 1 1-.33l25.48 8.42a.32.32 0 0 0 .35-.52L45.12 24a2 2 0 0 0-1.62-.71h-.35a2.66 2.66 0 0 0-1.07.28l-1.25.62-1.65-1 8.64-4.06.36.88-.4.82A1.44 1.44 0 0 0 48 22.5l23.06 24a2 2 0 0 1 .51 1v.35a1.1 1.1 0 0 1-.93 1.26h-.23a2.67 2.67 0 0 1-1.27-.11L36.26 35.42l15.88 25.46a1.58 1.58 0 0 1 .21.52l.09.35a1 1 0 0 1-1 1.23Z" }),
            React.createElement("path", { fill: fill, d: "m69.9 59.26 7.8-17.18 5.37 6.14-.72-8.08 14 2.16-12.68-7 6.26-5.09-7.47 1.36 3.52-16.17-6.64 10.27C77 19.23 74 11.25 69.46 6c-13.25-12.86-28-3.36-34 11.74C42.1 14.48 49.1 2.37 57.94 5.7c9.4 3.13 14.76 15.93 14.5 25.3-6.85-.4-13.66-3-20.43-3.46l2.09 2.12c5.41 2.15 13.5 3.45 17.12 8.24l-6 2.52L66 42c1.85-.1 5.58-1.15 7.35-1Z" }))));
};
const WizardsStamp = React.memo(WizardsStampComponent);

const CardFrameStampComponent = (props) => {
    const { stamp } = props;
    const frameStampClassNames = classNames({
        'card-frame__stamp': true,
        [`card-frame__stamp--${stamp}`]: stamp,
    });
    return (React.createElement("div", { className: frameStampClassNames }, stamp === pokemonCardLibrary.STAMP_TYPES.PRERELEASE ? (React.createElement(PreReleaseStamp, null)) : stamp === pokemonCardLibrary.STAMP_TYPES.WINNER ? (React.createElement(WinnerStamp, null)) : stamp === pokemonCardLibrary.STAMP_TYPES.WIZARDS ? (React.createElement(WizardsStamp, null)) : undefined));
};
const CardFrameStamp = React.memo(CardFrameStampComponent);

const CardFrameComponent = (props) => {
    const { backgroundColor, backgroundImageBlendMode, backgroundImageOpacity, backgroundImagePositionX, backgroundImagePositionY, backgroundImageUrl, cardTemplate, creatureImageBlendMode, energyType, frameBadgeText, holo, holoBlendMode, holoSheetType, holoStrength, isHoloAnimation, pokemonImagePositionX, pokemonImagePositionY, pokemonImageRotation, pokemonImageShadowColor, pokemonImageShadowOffsetX, pokemonImageShadowOffsetY, pokemonImageShadowSize, pokemonImageSize, pokemonImageUrl, randomizeHoloSheetPosition, reverseHoloSheetType, shadowless, size, stamp, } = props;
    const frameClassNames = classNames({
        'card-frame': true,
        'card-frame--shadowed': !shadowless,
        [`card-frame--${size}`]: size,
    });
    const framePokemonImageClassNames = classNames({
        'card-frame__pokemon-image': true,
        [`blend-mode--${creatureImageBlendMode}`]: creatureImageBlendMode,
    });
    const framePokemonImageWrapperClassNames = classNames({
        'card-frame__pokemon-image-wrapper': true,
    });
    const frameBackgroundImageClassNames = classNames({
        'card-frame__background-image': true,
        [`blend-mode--${backgroundImageBlendMode}`]: backgroundImageBlendMode,
    });
    const cardFrameEnergyClassNames = classNames({
        'card-frame__energy': true,
        [`card-frame__energy--${energyType}`]: energyType,
        'card-frame__energy--special': energyType === pokemonCardLibrary.SPECIAL_ENERGY_TYPES.CRYSTAL ||
            energyType === pokemonCardLibrary.SPECIAL_ENERGY_TYPES.RAINBOW,
    });
    const cardFrameInnerStyle = {
        backgroundColor: backgroundColor || undefined,
    };
    const framePokemonImageStyle = {
        backgroundImage: pokemonImageUrl ? `url(${pokemonImageUrl})` : undefined,
        backgroundSize: pokemonImageSize ? `${pokemonImageSize}%` : undefined,
        backgroundPositionX: pokemonImagePositionX
            ? `${pokemonImagePositionX}%`
            : undefined,
        backgroundPositionY: pokemonImagePositionY
            ? `${pokemonImagePositionY}%`
            : undefined,
        transform: pokemonImageRotation
            ? `rotate(${pokemonImageRotation}deg)`
            : 'none',
        filter: `drop-shadow(${pokemonImageShadowOffsetX || 0} ${pokemonImageShadowOffsetY || 0} ${pokemonImageShadowSize}vh ${pokemonImageShadowColor})`,
    };
    const frameBackgroundImageStyle = {
        backgroundImage: backgroundImageUrl
            ? `url(${backgroundImageUrl})`
            : undefined,
        opacity: backgroundImageOpacity || undefined,
        backgroundPositionX: backgroundImagePositionX
            ? `${backgroundImagePositionX}%`
            : undefined,
        backgroundPositionY: backgroundImagePositionY
            ? `${backgroundImagePositionY}%`
            : undefined,
    };
    const isRegularHolo = holo && holo !== 'reverse';
    const showCardFrameHoloSheet = isRegularHolo || isReverseHoloEnergyTemplate(cardTemplate, holo);
    return (React.createElement(React.Fragment, null,
        isESeriesTemplate(cardTemplate) ? (React.createElement("div", { className: "card-frame-e-backdrop" })) : undefined,
        React.createElement("div", { className: frameClassNames },
            cardTemplate &&
                frameBadgeText &&
                !isTrainerOrEnergyTemplate(cardTemplate) &&
                (isNeoTemplate(cardTemplate) || isESeriesTemplate(cardTemplate)) ? (React.createElement("div", { className: "neo-frame-badge" },
                React.createElement("span", null, frameBadgeText))) : undefined,
            isBaseNeoOrGymTemplate(cardTemplate) ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "card-frame__corner card-frame__corner--top-left" }),
                React.createElement("div", { className: "card-frame__corner card-frame__corner--top-right" }),
                React.createElement("div", { className: "card-frame__corner card-frame__corner--bottom-left" }),
                React.createElement("div", { className: "card-frame__corner card-frame__corner--bottom-right" }))) : undefined,
            React.createElement("div", { className: "card-frame__inner", style: cardFrameInnerStyle },
                React.createElement("div", { className: framePokemonImageWrapperClassNames },
                    pokemonImageUrl && (React.createElement("div", { className: framePokemonImageClassNames, style: pokemonImageUrl ? framePokemonImageStyle : undefined })),
                    isEnergyTemplate(cardTemplate) ? (React.createElement("div", { className: cardFrameEnergyClassNames },
                        React.createElement(EnergySymbol, { type: energyType }))) : undefined),
                showCardFrameHoloSheet ? (React.createElement(CardHoloSheet, { holoStrength: holoStrength, isAnimated: isHoloAnimation, randomizeHoloSheetPosition: randomizeHoloSheetPosition, type: isReverseHoloEnergyTemplate(cardTemplate, holo)
                        ? reverseHoloSheetType
                        : holoSheetType, holoBlendMode: holoBlendMode })) : undefined,
                React.createElement("div", { className: frameBackgroundImageClassNames, style: frameBackgroundImageStyle }),
                stamp && React.createElement(CardFrameStamp, { stamp: stamp })))));
};
const CardFrame = React.memo(CardFrameComponent);

const CardScanStripComponent = (props) => {
    const { bars = 14, isVertical } = props;
    const cardScanStripClassNames = classNames({
        'card-scan-strip': true,
        'card-scan-strip--vertical': isVertical,
    });
    const renderBars = () => {
        const barMarkup = [];
        for (let i = 0; i < bars; i++) {
            const barKey = `bar-${i}`;
            barMarkup.push(React.createElement("div", { key: barKey, className: "card-scan-strip__bar" }));
        }
        return barMarkup;
    };
    return React.createElement("div", { className: cardScanStripClassNames }, bars && renderBars());
};
const CardScanStrip = React.memo(CardScanStripComponent);

const EReaderLogoComponent = (props) => {
    const { width, height } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", id: "uuid-82dedf02-2fa2-473d-adfd-5369f6dae9cb", viewBox: "0 0 133.79 88.32", width: width, height: height },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "uuid-63912c4b-2332-4b55-a202-fb7ad0cd3e7e", x1: "0", x2: "133.79", y1: "44.16", y2: "44.16", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#f8c704" }),
                React.createElement("stop", { offset: "1", stopColor: "#f1b208" })),
            React.createElement("linearGradient", { id: "uuid-157bd90a-815b-4c27-8efc-4f855acfe3ad", x1: "17.05", x2: "125.15", y1: "68.15", y2: "16.04", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#004eee" }),
                React.createElement("stop", { offset: "1", stopColor: "#0f1e87" })),
            React.createElement("linearGradient", { xlinkHref: "#uuid-157bd90a-815b-4c27-8efc-4f855acfe3ad", id: "uuid-10b7ad74-3a3f-49d0-8b30-f941198d8ae0", x1: "62.76", x2: "94.15", y1: "45.38", y2: "30.73" }),
            React.createElement("linearGradient", { id: "uuid-f9990e7b-6524-4d8e-bf32-e33907aae78d", x1: "85.26", x2: "125.98", y1: "61.64", y2: "61.64", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#a49e10" }),
                React.createElement("stop", { offset: ".52", stopColor: "#ecec74" }),
                React.createElement("stop", { offset: "1", stopColor: "#c1b228" }))),
        React.createElement("g", { id: "uuid-7f4143bb-a533-4570-92a7-d58f7b071725" },
            React.createElement("path", { fill: "url(#uuid-63912c4b-2332-4b55-a202-fb7ad0cd3e7e)", d: "M100.37 29.51c-.92-2.04-2.55-4.25-4.74-5.18-5-2.23-12.44-.25-20.43 4.41-3.58 2.1-8.38 5.61-11.34 8.65h-9.04c15.62-14.98 35.31-21.7 43-17.55 1.56.84 2.43 2 2.83 3.66.2.69.25 1.47.25 2.25 0 1.13-.2 2.4-.53 3.75m33.33-11.37c-.54-5.46-3.21-10.21-7.57-13.38-14.63-10.62-47.27-2.92-76 17.94-6.38 4.62-11.94 9.57-16.74 14.7H11.87L0 52.76h22.1c-2.83 5.42-4.38 10.61-4.38 15.32 0 6.39 2.7 11.9 7.64 15.48 9.39 6.86 26.28 6.29 46.29-1.56l8.7-3.42-9.7-10.79h-4.88c-9.33 4.35-18.39 5.48-23.03 3-1.77-.93-2.73-2.29-3-4.4-.1-.51-.12-1-.12-1.54 0-3.34 1.4-7.59 3.87-12.09H58.6c.78 2.53 2.52 4.59 5.04 5.71 4.98 2.19 12.45.79 20.46-3.87.92-.57 1.89-1.17 2.83-1.84h29.04s.58-.12 1.02-.54c.52-.5 1.86-1.98 1.86-1.98 9.79-10.68 14.92-21 14.92-29.99 0-.68-.03-1.41-.09-2.12" }),
            React.createElement("path", { fill: "url(#uuid-157bd90a-815b-4c27-8efc-4f855acfe3ad)", d: "M48.38 32.91C64.63 16.18 86.7 7.36 97.61 13.26c2.67 1.46 4.41 3.71 5.15 6.71 1.19 5.02-.48 11.88-4.52 19.07H43.11c1.58-2.06 3.33-4.13 5.27-6.12m78.65-17.66c-.38-4.2-2.33-7.73-5.65-10.14-12.93-9.57-44.12-1.6-70.94 18.17-6.87 5.06-12.75 10.39-17.5 15.74H11.77L7.1 45.18H28c-5.19 7.2-8.07 14.21-8.07 20.25 0 4.94 2 9.04 5.75 11.79 8.07 5.97 23.84 5.19 42.2-2.13l2.5-.98-4.56-5.19-1.17.54C53.94 74.5 44.4 75.57 38.51 72.4c-3.04-1.65-4.87-4.33-5.39-8-.75-5.38 1.31-12.19 5.63-19.23h72.95s.69.02 1.21-.57l.54-.56c9.51-10.54 14.34-20.76 13.59-28.79" }),
            React.createElement("path", { fill: "url(#uuid-10b7ad74-3a3f-49d0-8b30-f941198d8ae0)", d: "M94.25 27.55c.78 5.52-6.25 15-15.79 21.18-9.5 6.18-17.88 6.75-18.72 1.23-.83-5.5 6.25-15 15.77-21.21 9.52-6.18 17.9-6.74 18.74-1.2" }),
            React.createElement("path", { fill: "#fff", d: "M89.76 26.82c.27 1.83-2.08 5-5.25 7.06-3.17 2.08-5.98 2.25-6.24.41-.25-1.84 2.08-5.02 5.27-7.06 3.19-2.06 5.98-2.25 6.23-.41" }),
            React.createElement("path", { fill: "#0069b2", stroke: "url(#uuid-f9990e7b-6524-4d8e-bf32-e33907aae78d)", strokeMiterlimit: "10", strokeWidth: "2", d: "m103.48 75.74-1.68-8.16-12.02 4.44 11.14-10.06-.96-6.35 7.1 1.72 14.37-8.69-8.85 10.68 7.66 2.87-10.77 2.86-5.99 10.69z" }))));
};
const EReaderLogo = React.memo(EReaderLogoComponent);

const CardScanStripRightComponent = () => {
    return (React.createElement("div", { className: "e-reader-card-scan-strip e-reader-card-scan-strip--right" },
        React.createElement(CardScanStrip, { bars: 27 })));
};
const CardScanStripRight = React.memo(CardScanStripRightComponent);

const CardFrameESeriesComponent = (props) => {
    const { cardTemplate, dotMatrixVariant, holo, logoIcon = React.createElement(EReaderLogo, { fill: "#FFBA52" }), trainerImageUrl, } = props;
    const eReaderLogoClassNames = classNames({
        'e-reader-logo': true,
        holo: holo,
    });
    const eReaderCardFrameLeftClassNames = classNames({
        'e-reader-card-frame__left': true,
        holo: holo,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: eReaderCardFrameLeftClassNames },
            dotMatrixVariant &&
                dotMatrixVariant === pokemonCardLibrary.DOT_MATRIX_POSITIONS.LEFT_AND_BOTTOM ? (React.createElement("div", { className: "dot-matrix-strip" })) : undefined,
            React.createElement(CardScanStrip, { bars: 10 }),
            React.createElement(CardScanStrip, null)),
        dotMatrixVariant &&
            (dotMatrixVariant === pokemonCardLibrary.DOT_MATRIX_POSITIONS.BOTTOM_ONLY ||
                dotMatrixVariant === pokemonCardLibrary.DOT_MATRIX_POSITIONS.LEFT_AND_BOTTOM) ? (React.createElement("div", { className: "dot-matrix-strip dot-matrix-strip--bottom" })) : undefined,
        React.createElement("div", { className: "e-reader-card-scan-strip e-reader-card-scan-strip--bottom" },
            React.createElement(CardScanStrip, { bars: 13, isVertical: true })),
        React.createElement("div", { className: eReaderLogoClassNames },
            logoIcon,
            holo && !isAnyVsTemplate(cardTemplate) ? (React.createElement("div", { className: "e-reader-logo__holo-line" })) : undefined),
        isVsTemplate(cardTemplate) ? (React.createElement("div", { className: "e-reader-card-gym-trainer" },
            React.createElement("div", { className: "e-reader-card-gym-trainer__frame" },
                React.createElement("div", { className: "e-reader-card-gym-trainer__image", style: { backgroundImage: `url("${trainerImageUrl}")` } })))) : undefined,
        isTrainerTemplate(cardTemplate) ? React.createElement(CardScanStripRight, null) : undefined));
};
const CardFrameESeries = React.memo(CardFrameESeriesComponent);

const CardHeaderComponent = (props) => {
    const { babyRuleLabel, basicLabel, cardTemplate, cardTemplateSubtype, evolvesFromLabel, putLabel, shiningRuleLabel, stage, unownRuleLabel, } = props;
    const isCardHeaderSmall = (evolvesFromLabel &&
        evolvesFromLabel.length > 20 &&
        putLabel &&
        putLabel.length > 30) ||
        (putLabel && putLabel.length > 40);
    const isCardHeaderExtraSmall = evolvesFromLabel &&
        evolvesFromLabel.length > 25 &&
        putLabel &&
        putLabel.length > 30;
    const cardHeaderClassNames = classNames({
        'card-header': true,
        'card-header--indented': !isShiningBabyUnownSubtype(cardTemplateSubtype) && Number(stage) > 0,
        'card-header--basic': isBasic(stage),
        'card-header--small': isCardHeaderSmall,
        'card-header--extra-small': isCardHeaderExtraSmall,
        'justify-content-end': isShiningBabyUnownSubtype(cardTemplateSubtype),
    });
    const evolvesFromClassNames = classNames({
        'evolves-from': true,
    });
    const getHeaderSubtext = () => {
        if (isShiningBabyUnownSubtype(cardTemplateSubtype)) {
            if (isShiningSubtype(cardTemplateSubtype)) {
                return shiningRuleLabel;
            }
            else if (isUnownSubtype(cardTemplateSubtype)) {
                return unownRuleLabel;
            }
            else {
                return babyRuleLabel;
            }
        }
        return putLabel;
    };
    const getBasicLabel = () => {
        return !cardTemplate ||
            (cardTemplate &&
                !isNeoTemplate(cardTemplate) &&
                !isESeriesTemplate(cardTemplate))
            ? basicLabel
            : undefined;
    };
    return (React.createElement(React.Fragment, null, !isBasicETemplate(stage, cardTemplate, cardTemplateSubtype) ? (React.createElement("div", { className: cardHeaderClassNames },
        !isShiningBabyUnownSubtype(cardTemplateSubtype) ? (React.createElement("span", { className: evolvesFromClassNames }, !isBasic(stage) ? (React.createElement(React.Fragment, null, evolvesFromLabel)) : (React.createElement(React.Fragment, null, getBasicLabel())))) : undefined,
        React.createElement("span", { className: "put-card" }, getHeaderSubtext()))) : undefined));
};
const CardHeader = React.memo(CardHeaderComponent);

const FirstEditionStampComponent = (props) => {
    const { fill = '#000000', height = DEFAULT_FIRST_EDITION_ICON_SIZE, width = DEFAULT_FIRST_EDITION_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 208 154.89", height: height, width: width },
        React.createElement("defs", null),
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M208,97.81l-14.5,3.11-21.77,4.61L164.9,107a5.16,5.16,0,0,1-.73,0c-.62-3-1.06-5.92-1.9-8.77-.55-1.9,0-2.86,1.52-4,4.14-3,8.12-6.19,12.16-9.31.14-.1.29-.19.44-.28l-.12-.18-16.14,3.42c-.9-4.19-1.79-8.36-2.71-12.64l4-.88,28.43-6,10.63-2.25c.52-.11.81-.09.95.58.69,3.4,1.43,6.79,2.18,10.18a1.19,1.19,0,0,1-.51,1.39c-4.16,3.15-8.29,6.34-12.43,9.53a9.16,9.16,0,0,0-.7.62l15.36-3.25c.55,2.57,1.08,5.09,1.63,7.61.33,1.51.7,3,1.05,4.5Z" }),
                React.createElement("path", { fill: fill, d: "M0,99.55c.29-1.66.6-3.32.87-5q1-6.33,2-12.68c.43-2.7.84-5.4,1.26-8.09,0-.25.1-.5.17-.85l11.1,1.73L13.21,88.89c1.56.26,3.08.53,4.62.74.16,0,.51-.33.55-.55.49-2.92.95-5.85,1.41-8.77.2-1.25.38-2.49.59-3.83L31.5,78.23c-.23,1.52-.45,3-.69,4.45l-1.29,8c-.1.6.05.86.74.93,1.28.12,2.55.4,3.83.6.33.06.68.06,1.07.1L37.5,77.62l11.13,1.77c-1.48,9.35-2.94,18.6-4.43,28-1.06-.15-2.13-.29-3.19-.45l-12.88-2c-4.54-.73-9.09-1.48-13.63-2.2S5.4,101.29.85,100.58c-.29,0-.57-.11-.85-.16Z" }),
                React.createElement("path", { fill: fill, d: "M116.5,0c.15,3.71.3,7.42.46,11.21l-9.27.32c.39,11.15.78,22.24,1.17,33.47l-13.4.46c0-.45-.1-.83-.12-1.22-.12-4.18-.22-8.37-.37-12.55-.21-5.88-.45-11.76-.68-17.63,0-.09,0-.18,0-.26,0-1.88,0-1.8-2-1.73-2.39.09-4.79,0-7.34,0-.13-3.52-.26-7.22-.41-11C86.19,1,87.8.94,89.4.89l20-.71c1.21,0,2.42-.12,3.63-.18Z" }),
                React.createElement("path", { fill: fill, d: "M104.18,48.22A53.34,53.34,0,1,1,50.86,99.37,53.35,53.35,0,0,1,104.18,48.22Zm16.64,82.28c-1.62-.09-3.17-.14-4.72-.27a4.32,4.32,0,0,1-4.12-3.66,15,15,0,0,1-.24-2.84q0-28.7,0-57.39A1.5,1.5,0,0,0,109.46,65a115.62,115.62,0,0,1-15.4,6.28l-6.27,2,.45,4.19.84-.24c1.41-.4,2.8-.91,4.23-1.17,2.09-.38,3.68-.43,4.14,2.71a25.94,25.94,0,0,1,.27,3.62q0,11.88,0,23.76,0,9.66-.16,19.32A4.53,4.53,0,0,1,93,130.23c-1.64.13-3.28.18-5,.27v4.1h32.82Z" }),
                React.createElement("path", { fill: fill, d: "M49.76,76.65,16.49,46.72,18.89,44c2.53-2.81,5-5.68,7.61-8.41,4-4.23,9-6.46,14.9-5.92a23.11,23.11,0,0,1,12.16,5.12,27.89,27.89,0,0,1,9.55,12.46c2.52,6.86,1.31,13.07-3.57,18.54-2.88,3.23-5.79,6.44-8.69,9.66C50.51,75.87,50.14,76.24,49.76,76.65ZM50.5,59.2a5.12,5.12,0,0,0,1.19-6.29,22.54,22.54,0,0,0-6-6.94,17.81,17.81,0,0,0-6.18-3.71,4.74,4.74,0,0,0-5.67,1.93Z" }),
                React.createElement("path", { fill: fill, d: "M182.76,42.76a21.39,21.39,0,0,1-4.13,11.83,33.42,33.42,0,0,1-13.31,11.56c-6.1,2.81-12.13,2.79-17.83-1.09a16,16,0,0,1-7.16-11.82,18.82,18.82,0,0,1,2.92-12.19A32.53,32.53,0,0,1,157.42,28c5.06-2.33,10.28-2.75,15.47-.4a16.17,16.17,0,0,1,9.39,11.58A35.6,35.6,0,0,1,182.76,42.76ZM166.59,38.5a7.62,7.62,0,0,0-3.51,1.43,30.88,30.88,0,0,0-10,10.62,3.07,3.07,0,0,0,.67,3.94,3.22,3.22,0,0,0,4,.69,10.11,10.11,0,0,0,1.32-.65,36.71,36.71,0,0,0,8.37-7.45A10.87,10.87,0,0,0,170,42.64,3.53,3.53,0,0,0,166.59,38.5Z" }),
                React.createElement("path", { fill: fill, d: "M129.9,50.67l-12.75-4.38C122,32.18,126.86,18.13,131.74,4l12.75,4.39Z" }),
                React.createElement("path", { fill: fill, d: "M56.46,11.7,68.78,6.24,87,47.11l-12.32,5.5Z" })))));
};
const FirstEditionStamp = React.memo(FirstEditionStampComponent);

const CardMastheadComponent = (props) => {
    const { isDoubleEnergyType, energyHeadingLabel = DEFAULT_ENERGY_HEADING, energyType, firstEdition, trainerHeadingLabel = DEFAULT_TRAINER_HEADING, type = MASTHEAD_TYPES.TRAINER, } = props;
    const cardMastheadClassNames = classNames({
        'card-masthead': true,
        'card-masthead--double-energy': isDoubleEnergyType,
    });
    return (React.createElement("div", { className: cardMastheadClassNames }, type === MASTHEAD_TYPES.TRAINER ? (React.createElement("div", { className: "trainer-energy-heading" }, trainerHeadingLabel)) : type === MASTHEAD_TYPES.ENERGY ? (React.createElement("div", { className: "card-masthead__energy-row" },
        React.createElement("div", { className: "card-masthead__energy-row__energy" }, energyType && (React.createElement(React.Fragment, null,
            energyType && React.createElement(EnergySymbol, { type: energyType }),
            isDoubleEnergyType && React.createElement(EnergySymbol, { type: energyType })))),
        React.createElement("div", { className: "card-masthead__energy-row__heading" },
            React.createElement("div", { className: "trainer-energy-heading" }, energyHeadingLabel)),
        React.createElement("div", { className: "card-masthead__energy-row__first-edition-symbol" }, firstEdition && React.createElement(FirstEditionStamp, null)))) : undefined));
};
const CardMasthead = React.memo(CardMastheadComponent);

const CardNameComponent = (props) => {
    const { condenseLevel = 0, isBold, name } = props;
    const cardNameClassNames = classNames({
        'card-name': true,
        'card-name--bold': isBold,
        'card-name--lt-condensed': condenseLevel && condenseLevel === 1,
        'card-name--condensed': condenseLevel && condenseLevel === 2,
        'card-name--x-condensed': condenseLevel && condenseLevel === 3,
        'card-name--xx-condensed': condenseLevel && condenseLevel === 4,
        'card-name--xxx-condensed': condenseLevel && condenseLevel === 5,
    });
    return React.createElement("h1", { className: cardNameClassNames }, replaceApostrophe(name));
};
const CardName = React.memo(CardNameComponent);

const TrainerHeadingESeriesComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 285.32 46.97" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "a", x1: "18.06", x2: "18.06", y1: "43.27", y2: "1.31", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#b1a9b0" }),
                React.createElement("stop", { offset: ".49", stopColor: "#d4d1c4" }),
                React.createElement("stop", { offset: "1", stopColor: "#8e8797" })),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "b", x1: "110.62", x2: "110.62", y2: "0" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "c", x1: "143.92", x2: "143.92", y1: "43.75", y2: ".99" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "d", x1: "178.44", x2: "178.44", y1: "45.1", y2: "0" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "e", x1: "221.91", x2: "221.91", y1: "44.18", y2: ".4" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "f", x1: "265.63", x2: "265.63", y2: "0" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "g", x1: "63.06", x2: "63.06", y1: "42.83", y2: ".51" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "h", x1: "110.63", x2: "110.63", y1: "33.42", y2: "24.96" })),
        React.createElement("path", { d: "M37.54 3.18v8.77H24.21v33.19h-9.4V11.95H1.42V3.18h36.12ZM134.23 45.14h-9.75l-3.23-9.85-2.39-7.28-5.18-15.76c-.31-1.04-.87-1.47-1.68-1.47s-1.3.43-1.61 1.47l-5.17 15.73-5.64 17.15h-9.75l11.86-35.44c1.8-5.38 4.84-7.82 10.31-7.82s8.75 2.57 10.31 7.82l11.92 35.44ZM149.8 2.87v42.75h-8.91V2.87h8.91ZM186.57 34.85c.49 2 .93 3 2.35 3 1.31 0 2.02-.94 2.02-2.75V2.75h8.08v33.41c0 6.81-3.71 10.81-9.88 10.81s-8.62-3.12-10.31-9.99L173.16 14c-.49-2-.93-3-2.35-3-1.31 0-2.02.87-2.02 2.69v32.42h-8.07V12.62c0-6.81 3.71-10.74 9.88-10.74s8.62 3.12 10.31 9.99l5.67 22.98ZM240.16 2.27v9.15H220.2c-3.67 0-4.81 1.26-4.81 5.11v2.78h24.77v9.21h-24.77v3.28c0 3.85 1.14 5.05 4.81 5.05h19.96v9.21h-20.62c-9.44 0-13.04-3.85-13.04-13.75V15.96c0-9.9 3.61-13.69 13.04-13.69h20.62ZM260.03 26.44l3.66-4.78c.75-.99 1.82-1.6 2.98-1.71l5.04-.49c2.8 0 4.25-1.19 4.25-3.12v-2.31c0-1.93-1.46-3.12-4.25-3.12h-13.92v34.23h-8.99V1.87h23.27c8.69 0 12.88 2.93 12.88 9.54v3.43c0 2.43-.2 8.51-3.32 10.74-3.28 2.35-9.53.81-11.46 1.41 2.31.93 6.95 7.81 6.95 7.81l8.2 10.33h-11.84M57.09 26.41l3.85-4.68c.79-.97 1.92-1.57 3.14-1.68l5.3-.48c2.94 0 4.48-1.16 4.48-3.05v-2.26c0-1.89-1.54-3.05-4.48-3.05H54.73v33.48h-9.47V2.38h24.5c9.15 0 13.56 2.87 13.56 9.33v3.35c0 2.38-.22 8.32-3.5 10.51-3.45 2.3-10.03.79-12.06 1.38 2.43.91 7.31 7.64 7.31 7.64l8.64 10.11H71.25" }),
        React.createElement("path", { d: "m102.85 35.22 18.4.07-2.78-8.46h-13.52l-2.1 8.39z" }),
        React.createElement("path", { fill: "url(#a)", d: "M36.12 1.31v8.77H22.79v33.19h-9.4V10.08H0V1.31h36.12Z" }),
        React.createElement("path", { fill: "url(#b)", d: "M132.81 43.27h-9.75l-3.23-9.85-2.39-7.28-5.18-15.76c-.31-1.04-.87-1.47-1.68-1.47s-1.3.43-1.61 1.47l-5.17 15.73-5.64 17.15h-9.75l11.86-35.44c1.8-5.38 4.84-7.82 10.31-7.82s8.75 2.57 10.31 7.82l11.92 35.44Z" }),
        React.createElement("path", { fill: "url(#c)", d: "M148.38.99v42.75h-8.91V.99h8.91Z" }),
        React.createElement("path", { fill: "url(#d)", d: "M185.15 32.98c.49 2 .93 3 2.35 3 1.31 0 2.02-.94 2.02-2.75V.87h8.08v33.41c0 6.81-3.71 10.81-9.88 10.81s-8.62-3.12-10.31-9.99l-5.67-22.98c-.49-2-.93-3-2.35-3-1.31 0-2.02.87-2.02 2.69v32.42h-8.07V10.74c0-6.81 3.71-10.74 9.88-10.74s8.62 3.12 10.31 9.99l5.67 22.98Z" }),
        React.createElement("path", { fill: "url(#e)", d: "M238.74.4v9.15h-19.96c-3.67 0-4.81 1.26-4.81 5.11v2.78h24.77v9.21h-24.77v3.28c0 3.85 1.14 5.05 4.81 5.05h19.96v9.21h-20.62c-9.44 0-13.04-3.85-13.04-13.75V14.09c0-9.9 3.61-13.69 13.04-13.69h20.62Z" }),
        React.createElement("path", { fill: "url(#f)", d: "m258.61 24.57 3.66-4.78c.75-.99 1.82-1.6 2.98-1.71l5.04-.49c2.8 0 4.25-1.19 4.25-3.12v-2.31c0-1.93-1.46-3.12-4.25-3.12h-13.92v34.23h-8.99V0h23.27c8.69 0 12.88 2.93 12.88 9.54v3.43c0 2.43-.2 8.51-3.32 10.74-3.28 2.35-9.53.81-11.46 1.41 2.31.93 6.95 7.81 6.95 7.81l8.2 10.33h-11.84" }),
        React.createElement("path", { fill: "url(#g)", d: "m55.67 24.54 3.85-4.68c.79-.97 1.92-1.57 3.14-1.68l5.3-.48c2.94 0 4.48-1.16 4.48-3.05v-2.26c0-1.89-1.54-3.05-4.48-3.05H53.31v33.48h-9.47V.51h24.5c9.15 0 13.56 2.87 13.56 9.33v3.35c0 2.38-.22 8.32-3.5 10.51-3.45 2.3-10.03.79-12.06 1.38 2.43.91 7.31 7.64 7.31 7.64l8.64 10.11H69.83" }),
        React.createElement("path", { fill: "url(#h)", d: "m101.43 33.35 18.4.07-2.78-8.46h-13.52l-2.1 8.39z" })));
};
const TrainerHeadingESeries = React.memo(TrainerHeadingESeriesComponent);

const CardHeaderESeriesComponent = (props) => {
    const { name, nameCondenseLevel, subtitle } = props;
    return (React.createElement("div", { className: "card-header--e-series card-header--e-series--trainer" },
        React.createElement("div", { className: "trainer-energy__heading" },
            React.createElement("div", { className: "trainer-energy-title" },
                React.createElement(TrainerHeadingESeries, null)),
            subtitle ? React.createElement("div", { className: "card-subtitle" }, subtitle) : undefined),
        React.createElement("div", { className: "trainer-divider" }),
        React.createElement(CardName, { name: name, condenseLevel: nameCondenseLevel })));
};
const CardHeaderESeries = React.memo(CardHeaderESeriesComponent);

const CardHeaderTrainerComponent = (props) => {
    const { cardTemplate, hitPoints, isBoldName, name, nameCondenseLevel, subtitle, trainerHeadingLabel, } = props;
    const isSubtitleSmall = subtitle && subtitle.length > 10;
    const isSubtitleXSmall = subtitle && subtitle.length > 15;
    const isSubtitleXXSmall = (subtitle && subtitle.length > 20) || getNameLength(name) > 25;
    const trainerTextCondenseLevel = getTrainerTextCondenseLevel(name, subtitle, hitPoints, isESeriesTrainerTemplate(cardTemplate));
    const trainerSubtitleClassNames = classNames({
        'trainer-subtitle': true,
        'trainer-subtitle--small': isSubtitleSmall,
        'trainer-subtitle--x-small': isSubtitleXSmall,
        'trainer-subtitle--xx-small': isSubtitleXXSmall,
    });
    return (React.createElement(React.Fragment, null, isESeriesTrainerTemplate(cardTemplate) ? (React.createElement(CardHeaderESeries, { name: name, nameCondenseLevel: nameCondenseLevel, subtitle: subtitle })) : (React.createElement(React.Fragment, null,
        React.createElement(CardMasthead, { trainerHeadingLabel: trainerHeadingLabel }),
        React.createElement("div", { className: "card-name-bar--trainer" },
            React.createElement(CardName, { condenseLevel: nameCondenseLevel || trainerTextCondenseLevel, isBold: isBoldName, name: name }),
            hitPoints ? (React.createElement("div", { className: "hit-points" },
                hitPoints,
                " HP")) : subtitle ? (React.createElement("div", { className: trainerSubtitleClassNames }, subtitle)) : undefined)))));
};
const CardHeaderTrainer = React.memo(CardHeaderTrainerComponent);

const CardMoveCostGridComponent = (props) => {
    const { energyCost, moveId } = props;
    const energyCostLength = (energyCost && energyCost.length) || 0;
    const cardMoveCostGridClassNames = classNames({
        'move-cost-grid': true,
        [`move-cost-grid--${energyCostLength}`]: energyCostLength,
    });
    return (React.createElement("div", { className: cardMoveCostGridClassNames }, energyCost.map((energyType, costIndex) => (React.createElement("div", { className: "move-cost", key: `move-${moveId}-cost-${costIndex}` },
        React.createElement(EnergySymbol, { type: energyType }))))));
};
const CardMoveCostGrid = React.memo(CardMoveCostGridComponent);

const CardMoveComponent = (props) => {
    const { damage, damageModifier, description, descriptionSize, dividerColor, energyCost, id, isESeriesTemplate, isVsTemplate, isVariableDamage, lineHeight, name, nameSize, specialMoveType, specialMoveTypePrefix, } = props;
    const isSpecialMoveType = specialMoveType &&
        (specialMoveType === pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_BODY ||
            specialMoveType === pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_POWER);
    const cardMoveClassNames = classNames({
        move: true,
        [`${specialMoveType}`]: specialMoveType,
        'has-energy': energyCost && energyCost.length,
        'has-damage': (damage || isVariableDamage) && !specialMoveType,
        'has-description': description,
        'full-width': specialMoveType && getStrippedDescriptionLength(description) > 500,
    });
    const moveNameStyle = nameSize
        ? { fontSize: `calc(var(--pkmn-card-width) * ${nameSize})` }
        : undefined;
    const moveDescriptionSize = descriptionSize
        ? `calc(var(--pkmn-card-width) * ${descriptionSize})`
        : undefined;
    const moveDescriptionLineHeight = lineHeight
        ? `calc(var(--pkmn-card-width) * ${lineHeight})`
        : undefined;
    const moveDamageNumberClassNames = classNames({
        'move-damage-number': true,
        'has-modifier': !!damageModifier,
    });
    const moveDescriptionStyle = {
        fontSize: moveDescriptionSize || undefined,
        lineHeight: moveDescriptionLineHeight || undefined,
    };
    const moveStyle = dividerColor
        ? { borderBottomColor: dividerColor }
        : undefined;
    const getDamageModifierPositionClassName = () => {
        if (!damageModifier) {
            return '';
        }
        switch (damageModifier) {
            case pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.MINUS:
            case pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.PLUS:
                return 'middle';
            case pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.TIMES:
                return 'bottom';
            default:
                return 'middle';
        }
    };
    return (React.createElement("li", { className: cardMoveClassNames, style: moveStyle, key: `${name}-move-${id}` },
        React.createElement("div", { className: "move-row" },
            !isSpecialMoveType &&
                energyCost &&
                Array.isArray(energyCost) &&
                energyCost.length ? (React.createElement(CardMoveCostGrid, { energyCost: energyCost, moveId: id })) : undefined,
            React.createElement("div", { className: "move-meta" },
                React.createElement(CardMoveDescription, { description: description, descriptionStyle: moveDescriptionStyle, isESeriesTemplate: isESeriesTemplate, isVsTemplate: isVsTemplate, moveId: id, name: name, nameStyle: moveNameStyle, specialMoveType: specialMoveType, specialMoveTypePrefix: specialMoveTypePrefix })),
            !isSpecialMoveType && (damage || isVariableDamage) ? (React.createElement("div", { className: "move-damage" }, isVariableDamage ? (React.createElement("span", { className: "move-damage--variable" }, "?")) : (React.createElement(React.Fragment, null,
                React.createElement("span", { className: moveDamageNumberClassNames }, damage),
                damageModifier ? (React.createElement("span", { className: `move-damage-modifier modifier--${getDamageModifierPositionClassName()}` }, damageModifier)) : undefined)))) : undefined),
        isVsTemplate && description ? (React.createElement("div", { className: "move-text" },
            React.createElement(CardMoveDescriptionText, { moveId: id, description: description }))) : undefined));
};
const CardMove = React.memo(CardMoveComponent);

const CardMovesListComponent = (props) => {
    const { dividerColor, isESeriesTemplate, isVsTemplate, moves } = props;
    const [currentMoves, setCurrentMoves] = React.useState(moves);
    const findLongestEnergyCostArray = (movesArray) => {
        if (!movesArray || movesArray.length === 0) {
            return undefined;
        }
        let longestLength = 0;
        let longestArrayElement = [];
        for (const move of movesArray) {
            if (move.energyCost &&
                Array.isArray(move.energyCost) &&
                move.energyCost.length > longestLength) {
                longestLength = move.energyCost.length;
                longestArrayElement = move.energyCost;
            }
        }
        return longestArrayElement.length;
    };
    const longestEnergyCount = findLongestEnergyCostArray(moves);
    const movesListClassNames = classNames({
        'card-moves-list': true,
        'card-moves-list--large': currentMoves && currentMoves.length > 2,
        [`card-moves-list--max-${longestEnergyCount}`]: isVsTemplate && longestEnergyCount,
    });
    React.useEffect(() => {
        if (moves)
            setCurrentMoves(moves);
    }, [moves]);
    return (React.createElement("ul", { className: movesListClassNames }, moves && moves.length
        ? moves.map((move, moveIndex) => (React.createElement(CardMove, { ...move, dividerColor: dividerColor, id: moveIndex.toString(), isESeriesTemplate: isESeriesTemplate, isVsTemplate: isVsTemplate, key: `card-moves-list-move-${moveIndex.toString()}` })))
        : undefined));
};
const CardMovesList = React.memo(CardMovesListComponent);

const CardNameBarComponent = (props) => {
    const { cardTemplate, cardTemplateSubtype, energyType, hitPoints, hitPointsLabel, name, nameCondenseLevel, stage, unownLetter, } = props;
    const isStageTwo = stage && Number(stage) >= 2;
    const cardNameBarClassNames = classNames({
        'card-name-bar': true,
        'card-name-bar--basic': isBasic(stage),
        'card-name-bar--indented': !isBasic(stage),
        'card-name-bar--full': isBasicETemplate(stage, cardTemplate, cardTemplateSubtype),
    });
    const cardNameCondenseLevel = getTextCondensedLevel(name, isBasic(stage), hitPoints);
    return (React.createElement("div", { className: cardNameBarClassNames },
        isStageTwo &&
            (isNeoTemplate(cardTemplate) || isESeriesTemplate(cardTemplate)) ? (React.createElement("div", { className: "neo-accent-bar" })) : undefined,
        React.createElement("div", { className: "card-name-bar-left" },
            React.createElement(CardName, { name: name, condenseLevel: nameCondenseLevel || cardNameCondenseLevel, isBold: true }),
            unownLetter && isUnownSubtype(cardTemplateSubtype) ? (React.createElement("div", { className: "unown-letter" },
                React.createElement("span", { className: "unown-letter__main" }, unownLetter),
                React.createElement("span", { className: "unown-letter__readable" },
                    "[",
                    unownLetter,
                    "]"))) : undefined),
        React.createElement("div", { className: "card-name-bar-right" },
            hitPoints ? (React.createElement("span", { className: "hit-points" }, hitPointsLabel)) : undefined,
            React.createElement("div", { className: "card-energy-symbol" },
                React.createElement(EnergySymbol, { type: energyType })))));
};
const CardNameBar = React.memo(CardNameBarComponent);

const IconAquapolisComponent = (props) => {
    const { fill, fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.54 80.9" },
        React.createElement("defs", null),
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "qqvtHj.tif" },
                    React.createElement("path", { fill: fillAlt, d: "M50.91,40.69l7.58.82v18H11.16v-18l7.38-.86,1-7.83,7.64-1.46,1.6-7.49h12.1l1.22,7.37,8,1.57Z" }),
                    React.createElement("path", { fill: fill, d: "M34.77,0c7.32,7.34,15.61,15.62,23.85,23.94,11.07,11.17,14,26.25,7.54,38.57C59.55,75.09,43.21,83,29.23,80.4,12.89,77.35,1.5,66.27.13,51.14-.83,40.49,3.45,31.46,10.89,24,19.13,15.62,27.43,7.36,34.77,0ZM50.16,41.45,50,32.83l-9,.11-.19-9H28.74l0,8.89-9.19.06,0,8.62-8.32.07v18H58.49v-18Z" }))))));
};
const IconAquapolis = React.memo(IconAquapolisComponent);

const IconBestOfGameComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 86.54 84.02" },
        React.createElement("g", null,
            React.createElement("path", { fill: fillAlt, stroke: fill, strokeMiterlimit: 10, strokeWidth: "9px", d: "M79.26,4.7c-2.33-.62-4.5.25-6.79,2.05-10.08,8-20.42,15.6-30.45,23.62l-3.24,2.3s-13.17-6.22-18-8a6.86,6.86,0,0,0-5.67.75c-.88.68-.61,3.49-.13,5.13a46.5,46.5,0,0,0,2.92,6.64l4.8,9,5.82,13.07c.91,1.84,3.86,8.81,4.6,10.35.83,1.72,1.56,3.49,2.46,5.17L37.7,79a.92.92,0,0,0,1.6.09c2-3.21,7.13-11.23,9.44-15.27L82,8.89A3.59,3.59,0,0,0,79.26,4.7Z" }),
            React.createElement("path", { d: "M49.7,67.53s8.11,1.12,8.36,1.2c5.32,1.65,11.87,2.88,9.52,8.92-.76,2,0,1.28,1.7-.07,3-2.36,6.29-8.89,2.8-12.12A23.92,23.92,0,0,0,62.15,60a77.38,77.38,0,0,0-22.78-3.36,72.18,72.18,0,0,0-27.26,5.13A12.43,12.43,0,0,0,5.2,68a7.68,7.68,0,0,0,2.17,8.76c.75.67,4.28,3.06,5.26,2.79.59-.16-.79-1.38-1.25-2.18a4.48,4.48,0,0,1-.36-4,14.15,14.15,0,0,1,9.14-4.7l19.47-1.34" }),
            React.createElement("path", { fill: fill, d: "M22.64,52.36c0,2.45-1.92,6.53-9.11,6.53H2.47L6.61,39.44H17.39c4.06,0,6.42,1.45,6.42,4.25,0,2.39-1.34,4.2-4,5.06C21.61,49.45,22.64,50.61,22.64,52.36Zm-9,1.45c1.42,0,2.25-.67,2.25-1.56s-.58-1.17-1.44-1.17H11.06l-.59,2.73Zm.92-6.7c1.27,0,2-.72,2-1.58,0-.67-.55-1-1.5-1H12.44l-.55,2.58Z" }),
            React.createElement("path", { fill: fill, d: "M13.53,60.89H0L5,37.44h12.4c7.81,0,8.42,4.79,8.42,6.25A6.83,6.83,0,0,1,23.5,49a5.51,5.51,0,0,1,1.14,3.4C24.64,59.11,17.37,60.89,13.53,60.89Zm-8.59-4h8.59c6.91,0,7.11-4.06,7.11-4.53s0-1.15-1.55-1.74l-2.75-1.06a3,3,0,0,1,1.55,2.69c0,1.77-1.46,3.56-4.25,3.56H8l1.43-6.7h0l1.42-6.58h4.25c2.42,0,3.5,1.5,3.5,3a3.4,3.4,0,0,1-.42,1.65l1-.33c2.35-.76,2.62-2.16,2.62-3.16,0-1.49-1.49-2.25-4.42-2.25H8.23Zm9.91-7.79a4.34,4.34,0,0,1,.52.09l-.27-.11Z" }),
            React.createElement("path", { fill: fill, d: "M43.06,44.78H32.89l-.39,1.89h8.75l-1,4.77H31.47L31,53.56H41.44l-1.13,5.33H23.14l4.14-19.45H44.2Z" }),
            React.createElement("path", { fill: fill, d: "M41.92,60.89H20.67l5-23.45h21l-2,9.34h-1.4l-1,4.78h1.68Zm-16.31-4H38.69L39,55.56H28.56l1.29-6.12h8.76l.16-.77H30.05l1.21-5.89H41.44l.28-1.34H28.9Z" }),
            React.createElement("path", { fill: fill, d: "M41.88,57.6l1.89-4.88a18.6,18.6,0,0,0,7.45,1.56c1,0,1.78-.33,1.78-1.06s-.56-1.46-2.23-1.85c-3.72-.8-7-2.43-7-5.54,0-3.3,2.14-6.77,8.67-6.77,3.89,0,6.77.24,9,1.79l-1.81,5c-1.73-1.19-5.11-1.76-7.14-1.76-1,0-1.61.22-1.61.88s.72.84,2.47,1.34c4.83,1.28,6.75,2.5,6.75,5.89,0,2.72-1.66,6.87-8.46,6.87C47.9,59,44.38,59.1,41.88,57.6Z" }),
            React.createElement("path", { fill: fill, d: "M50.75,61c-3.68,0-7.14-.07-9.9-1.72l-1.45-.87,3.27-8.4,1.56.69a6.11,6.11,0,0,1-2.45-4.91c0-4.24,2.8-8.77,10.67-8.77,3.71,0,7.29.16,10.16,2.15l1.27.88-2.91,8a6.78,6.78,0,0,1,1.17,4.09c0,4.09-2.74,8.87-10.46,8.87h-.93Zm-6.31-4.52a26.57,26.57,0,0,0,6.77.52h.47c5.83,0,6.46-3.41,6.46-4.87,0-1.69-.23-2.63-5.26-4-1.79-.51-4-1.13-4-3.27,0-.48.17-2.88,3.61-2.88a19.92,19.92,0,0,1,6,1L59,41.81a19.34,19.34,0,0,0-6.55-.75c-4.3,0-6.67,1.69-6.67,4.77,0,2.1,3.39,3.15,5.42,3.59,3.43.8,3.8,2.93,3.8,3.8,0,1.52-1.17,3.06-3.78,3.06a20.69,20.69,0,0,1-6.3-1Zm6.71-2.88Z" }),
            React.createElement("path", { fill: fill, d: "M81.09,39.44l-1.2,5.7H74.28L71.36,58.89H64.42l2.91-13.75H61.78L63,39.44Z" }),
            React.createElement("path", { fill: fill, d: "M73,60.89H62l2.92-13.75H59.3l2.08-9.7H83.55l-2,9.7H75.9Zm-6.09-4h2.85l2.92-13.75h5.61l.35-1.7h-14l-.37,1.7H69.8Z" }),
            React.createElement("path", { fill: fillAlt, d: "M22.64,52.36c0,2.45-1.92,6.53-9.11,6.53H2.47L6.61,39.44H17.39c4.06,0,6.42,1.45,6.42,4.25,0,2.39-1.34,4.2-4,5.06C21.61,49.45,22.64,50.61,22.64,52.36Zm-9.46,3.07c1.42,0,1.92-1.45,1.92-2.34,0-.41,0-.64-.86-.64H10.76l-.64,3Zm1.38-8.32c1.27,0,2-.72,2-1.58,0-.67-.55-1-1.5-1H12.44l-.55,2.58Z" }),
            React.createElement("path", { fill: fillAlt, d: "M43.06,44.78H32.89l-.39,1.89h8.75l-1,4.77H31.47L31,53.56H41.44l-1.13,5.33H23.14l4.14-19.45H44.2Z" }),
            React.createElement("path", { fill: fillAlt, d: "M41.88,57.6l1.89-4.88a18.6,18.6,0,0,0,7.45,1.56c1,0,1.78-.33,1.78-1.06s-.56-1.46-2.23-1.85c-3.72-.8-7-2.43-7-5.54,0-3.3,2.14-6.77,8.67-6.77,3.89,0,6.77.24,9,1.79l-1.81,5c-1.73-1.19-5.11-1.76-7.14-1.76-1,0-1.61.22-1.61.88s.72.84,2.47,1.34c4.83,1.28,6.75,2.5,6.75,5.89,0,2.72-1.66,6.87-8.46,6.87C47.9,59,44.38,59.1,41.88,57.6Z" }),
            React.createElement("path", { fill: fillAlt, d: "M81.09,39.44l-1.2,5.7H74.28L71.36,58.89H64.42l2.91-13.75H61.78L63,39.44Z" }))));
};
const IconBestOfGame = React.memo(IconBestOfGameComponent);

const IconBase2Component = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 73.67 81.25" },
        React.createElement("path", { fill: fill, d: "M17.07,61.88c7.12-3.39,13.2-6.7,19.61-9.19,5.42-2.11,11.2-3.27,16.83-4.84.41-.11,1-.27,1.26-.08,3.84,2.68,7.47.14,11.17-.41,2.49-.37,5-.83,7.47-1.25l.26.87L60.23,51.92l2.39.34c-.08.21-.11.46-.2.48A131.81,131.81,0,0,0,23.76,68.88c-2.61,1.64-4.2,5-6.14,7.59-1.56,2.12-2.64,4.76-5.87,4.78-2.74,0-4.6-1.6-4.48-4.31C7.69,67.39,9.05,58,14.88,50c1.63-2.21,1.66-3.92-.1-5.83C4.64,33.15,10.58,14.66,26.2,10.83c4.81-1.18,9.51-.34,14.07,1.44.58.23,1.18.44,1.78.64.07,0,.18-.1.46-.25-1.3-4.09-5-5-8.37-5.72-5.84-1.26-11.4.5-17,2.35A27.87,27.87,0,0,0,.84,22.51L0,21.92,6,11l-.25,0c.29-.65.4-1.52.89-1.91C14.27,2.92,22.76-.8,32.83.14,38,.62,42.77,2.18,46.25,6s5.59,8.73,4.16,14.35a5.73,5.73,0,0,0,.05,3c4.13,12.78-1.29,21-9.09,26.12A18.29,18.29,0,0,1,26,51.5c-2.45-.7-3.83-.06-4.85,2C19.85,56.13,18.6,58.73,17.07,61.88ZM50.13,30.29c-.83-11.82-10.57-19.51-22.06-18-9.08,1.21-17.23,10.33-15.78,18,3.13,0,6.33.14,9.51-.08a4.21,4.21,0,0,0,2.8-1.76c1.56-2.44,3.44-4,6.46-4s4.75,1.54,6.14,3.94c.43.73,1.22,1.73,1.88,1.76C42.68,30.39,46.29,30.29,50.13,30.29ZM12,32.76c.16,10,9.22,17.77,19.88,17.55,9.5-.21,18.27-8.6,18-17.5-3.6,0-7.22-.07-10.83.07-.62,0-1.38.78-1.79,1.39-3.49,5-8.75,5.1-12.32.14a3.8,3.8,0,0,0-2.41-1.58C19.08,32.65,15.67,32.76,12,32.76Zm19,3.7a5.27,5.27,0,1,0-.07-10.54,5.23,5.23,0,0,0-5.14,5.69A4.91,4.91,0,0,0,31,36.46Z" })));
};
const IconBase2 = React.memo(IconBase2Component);

const IconBlackStarPromoComponent = (props) => {
    const { fill, fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 85.77 77.58" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("path", { fill: fill, d: "M85.77,59c-.65,1.77-1,3.73-2,5.26-4,6.06-11.7,6.61-16.73,1.35a1.58,1.58,0,0,0-.88-.55l2.4,7.19a32.16,32.16,0,0,1,1,3.24,8.07,8.07,0,0,1-.08,2.13,7,7,0,0,1-2.1-.56C60,72,52.65,66.94,45.28,61.89c-2.19-1.49-2.21-1.52-4.34-.09C33.35,66.9,25.78,72,18.17,77.1a5.6,5.6,0,0,1-2.06.39,6.84,6.84,0,0,1,0-2c.75-2.46,1.62-4.88,2.5-7.5L3,63.35C0,62.44-.3,61.88.19,58.7c.37-2.44.57-4.91,1.91-7.09,2-3.26,4.91-4.88,8.74-4.41a8.22,8.22,0,0,1,7.23,5.74,28.92,28.92,0,0,1,.74,5l2.72.76c1.21-1.7,1.2-2.31,0-3.73-3.56-4.1-7.12-8.19-10.65-12.31-1.54-1.8-1.42-2.59.59-4.11C8.22,36.24,5,34,1.86,31.66c-.71-.53-1.7-1.48-1.61-2.1.19-1.33,1.59-.76,2.48-.76q13.68-.06,27.37,0A2.34,2.34,0,0,0,32.69,27c2.91-8.42,5.91-16.81,8.94-25.19.25-.68,1-1.18,1.45-1.77A7,7,0,0,1,44.4,1.71C47.24,9.89,50,18.09,52.82,26.28c.85,2.49.85,2.5,3.51,2.5q13.68,0,27.37,0c.88,0,1.66,0,2.07,1V30a17.73,17.73,0,0,1-1.58,1.43c-3.43,2.47-6.89,4.9-9.85,7-.21,1.31-.09,2.35-.53,3-1.54,2.39-3.26,4.66-4.92,7a1.62,1.62,0,0,0,1.2-.16,10.46,10.46,0,0,1,12.47,2.25c1.91,1.93,2.54,4.39,3.21,6.86ZM51.25,34.24a9.66,9.66,0,1,0-19.3,0,9.87,9.87,0,0,0,9.68,10A9.71,9.71,0,0,0,51.25,34.24ZM36.06,44.35c-2.52-2.22-4.91-4.65-8.63-4-1.26-6.64-6.85-8.59-11.9-4.16-1.51,1.33-2.77,2.92-4.19,4.44C15,45,18.85,49.42,22.67,53.9a1.33,1.33,0,0,0,2.13.17c1.28-1,2.49-2.16,3.64-3.16l-3.68-4c2.12-1.13,4.14-1,5.36.46.85,1,1.5.79,2.31.08C33.64,46.41,34.86,45.38,36.06,44.35ZM74.91,67.67c4.84.37,9.36-4.24,9.31-9.5a9.48,9.48,0,0,0-9.3-9.59,9.38,9.38,0,0,0-9.38,9.47C65.48,63.37,70,68,74.91,67.67ZM63,40.51c.66-2.32,1.78-4.19,1.47-5.78s-2.09-2.81-3.28-4.29a15.89,15.89,0,0,1-1.26,1.68c-3.36,3.23-6.7,6.47-10.13,9.63-.7.64-.55,1,0,1.5,1.11,1,2.28,1.92,3.18,2.66l6.18-6.57.22.15-3,8.4.52.35,7.43-4.54c-1.23,2.37-2.69,4.44-4,6.57a1.65,1.65,0,0,0-.07,1.49c1,1.05,2.21,1.94,3.25,2.82L72.11,40.1C69.4,36,66.31,37.31,63,40.51Zm-46,18.85c0-2,.3-3.7-.06-5.29a6.77,6.77,0,0,0-5.6-5.34,7.08,7.08,0,0,0-7.56,3.05c-1.91,2.61-1.62,5.79-2.42,8.68-.05.2.33.64.61.79a8.62,8.62,0,0,0,1.59.58l15.87,4.66L21,60.3Z" }),
            React.createElement("path", { fill: fillAlt, d: "M51.25,34.24a9.71,9.71,0,0,1-9.62,10,9.87,9.87,0,0,1-9.68-10,9.66,9.66,0,1,1,19.3,0Zm-9.57,4.21a4,4,0,0,0,3.92-4.28A4,4,0,0,0,41.55,30a4,4,0,0,0-3.92,4.13A4.08,4.08,0,0,0,41.68,38.45Z" }),
            React.createElement("path", { fill: fillAlt, d: "M36.06,44.35c-1.2,1-2.42,2.06-3.63,3.11-.81.71-1.46.94-2.31-.08-1.22-1.46-3.24-1.59-5.36-.46l3.68,4c-1.15,1-2.36,2.12-3.64,3.16a1.33,1.33,0,0,1-2.13-.17C18.85,49.42,15,45,11.34,40.68c1.42-1.52,2.68-3.11,4.19-4.44,5-4.43,10.64-2.48,11.9,4.16C31.15,39.7,33.54,42.13,36.06,44.35Zm-14.31-.26c.55-1.16,1.56-2.31,1.3-2.93a6.32,6.32,0,0,0-2.71-2.89c-.6-.31-1.82.56-3,1Z" }),
            React.createElement("path", { fill: fillAlt, d: "M74.91,67.67c-4.93.33-9.43-4.3-9.37-9.62a9.38,9.38,0,0,1,9.38-9.47,9.48,9.48,0,0,1,9.3,9.59C84.27,63.43,79.75,68,74.91,67.67Zm3.71-9.44A3.94,3.94,0,0,0,74.86,54a3.86,3.86,0,0,0-3.72,4.09c0,2.45,1.55,4.19,3.76,4.19A3.75,3.75,0,0,0,78.62,58.23Z" }),
            React.createElement("path", { fill: fillAlt, d: "M63,40.51c3.35-3.2,6.44-4.49,9.15-.41L63.37,54.58c-1-.88-2.22-1.77-3.25-2.82a1.65,1.65,0,0,1,.07-1.49c1.36-2.13,2.82-4.2,4-6.57l-7.43,4.54-.52-.35,3-8.4-.22-.15-6.18,6.57c-.9-.74-2.07-1.67-3.18-2.66-.5-.45-.65-.86,0-1.5,3.43-3.16,6.77-6.4,10.13-9.63a15.89,15.89,0,0,0,1.26-1.68c1.19,1.48,3,2.74,3.28,4.29S63.62,38.19,63,40.51Z" }),
            React.createElement("path", { fill: fillAlt, d: "M16.91,59.36,21,60.3l-1.63,6.19L3.47,61.83a8.62,8.62,0,0,1-1.59-.58c-.28-.15-.66-.59-.61-.79.8-2.89.51-6.07,2.42-8.68a7.08,7.08,0,0,1,7.56-3.05,6.77,6.77,0,0,1,5.6,5.34C17.21,55.66,16.91,57.4,16.91,59.36ZM6.08,56.13,12.14,58c1.23-2.95,0-4.79-1.39-5.2C8.65,52.14,7.08,53.22,6.08,56.13Z" }),
            React.createElement("path", { fill: fill, d: "M41.68,38.45a4.08,4.08,0,0,1-4-4.33A4,4,0,0,1,41.55,30a4,4,0,0,1,4.05,4.18A4,4,0,0,1,41.68,38.45Z" }),
            React.createElement("path", { fill: fill, d: "M21.75,44.09l-4.37-4.85c1.14-.41,2.36-1.28,3-1a6.32,6.32,0,0,1,2.71,2.89C23.31,41.78,22.3,42.93,21.75,44.09Z" }),
            React.createElement("path", { fill: fill, d: "M78.62,58.23a3.75,3.75,0,0,1-3.72,4c-2.21,0-3.76-1.74-3.76-4.19A3.86,3.86,0,0,1,74.86,54,3.94,3.94,0,0,1,78.62,58.23Z" }),
            React.createElement("path", { fill: fill, d: "M6.08,56.13c1-2.91,2.57-4,4.67-3.36,1.37.41,2.62,2.25,1.39,5.2Z" }))));
};
const IconBlackStarPromo = React.memo(IconBlackStarPromoComponent);

const IconExpeditionComponent = (props) => {
    const { fill = '#000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", null,
            React.createElement("path", { fill: fill, d: "M54.46,34.88A19.75,19.75,0,0,1,34.71,54.63c-26.19-1-26.18-38.46,0-39.49A19.74,19.74,0,0,1,54.46,34.88Z" }),
            React.createElement("polygon", { fill: fill, points: "8.1 51.9 65.62 23.91 61.05 15.15 3.8 43.07 8.1 51.9" }),
            React.createElement("path", { fill: "none", stroke: fill, strokeMiterlimit: 10, strokeWidth: 7, d: "M66.09,36.21c0,17.33-14.05,30.05-31.38,30.05C-6.83,64.5-7,5.66,34.71,3.51,54.89,3.05,64.65,24.4,64.65,24.4" }))));
};
const IconExpedition = React.memo(IconExpeditionComponent);

const IconGymChallengeComponent = (props) => {
    const { fill, fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 101.89 58.37" },
        React.createElement("g", null,
            React.createElement("path", { fill: fill, d: "M52.25,0C67.81.82,81.52,2.08,93.77,9.43a24,24,0,0,1,5.66,4.84c3.49,4,3.16,9.67-.28,13.72-5.71,6.74-13.75,8.25-21.76,9.85-1.84.36-3.73.42-5.6.64-.74.09-2,.06-2.12.39-1.38,4-5.16,3-8,4.07-4.64,1.72-7,5.38-7.61,10.26-.63,5.39-1,5.53-6.32,4.92A81.9,81.9,0,0,1,14.18,46.83C6.54,42.19,1.49,35.66.25,26.51c-1.06-7.79,1.19-14,8.44-17.14a127.56,127.56,0,0,1,23.94-7.3C39.57.6,46.81.53,52.25,0Zm-.72,36.82.08-.44c2,0,4.07.3,6-.12,1.18-.25,2.9-1.51,3-2.47a66.47,66.47,0,0,0,.08-10.08c-.09-2.15-1.18-3.44-3.64-3.11-4.95.68-9.95,1.06-14.85,2-3,.56-5.15,2.39-5.41,5.85-.26,3.67,1.81,5.73,4.88,6.62A87.46,87.46,0,0,0,51.53,36.82Zm-8.47-26c-8,.05-16.08,2.38-22.23,9-1.59,1.7-1.59,5-2,7.58-.11.62.92,1.44,1.42,2.17a11.15,11.15,0,0,0,2.09-1.68c2.07-2.73,3.54-6.2,6.16-8.17C33.13,16.19,38.46,13.56,43.06,10.84ZM34.73,8.92c-.87-.44-1.3-.86-1.71-.84A34.53,34.53,0,0,0,13.3,15.37c-2.91,2.3-3.56,5.63-3.25,9.12.07.74,1,1.41,1.56,2.11a8.81,8.81,0,0,0,1.76-1.55c1.19-1.74,2-3.74,3.39-5.33A32.74,32.74,0,0,1,34.73,8.92Zm20.9,5.37c-9.08-.28-17.48,2-24.31,8.18-1.5,1.36-1.6,4.38-2.1,6.68-.13.56.73,1.34,1.14,2a9.63,9.63,0,0,0,2.19-1.43c1.8-2,3.22-4.47,5.23-6.26A41,41,0,0,1,55.63,14.29ZM26.76,6.6C20.83,4.12,6.36,10,3.57,16c-.78,1.68-.57,3.85-.65,5.8,0,.47.64,1.39.9,1.36a2.39,2.39,0,0,0,1.73-1C9.51,13.07,17.43,9.27,26.76,6.6Z" }),
            React.createElement("path", { fill: fillAlt, d: "M51.53,36.82A87.46,87.46,0,0,1,41.66,35c-3.07-.89-5.14-2.95-4.88-6.62.26-3.46,2.44-5.29,5.41-5.85,4.9-.91,9.9-1.29,14.85-2,2.46-.33,3.55,1,3.64,3.11a66.47,66.47,0,0,1-.08,10.08c-.11,1-1.83,2.22-3,2.47-1.91.42-4,.12-6,.12Z" }),
            React.createElement("path", { fill: fillAlt, d: "M43.06,10.84c-4.6,2.72-9.93,5.35-14.6,8.86-2.62,2-4.09,5.44-6.16,8.17a11.15,11.15,0,0,1-2.09,1.68c-.5-.73-1.53-1.55-1.42-2.17.45-2.6.45-5.88,2-7.58C27,13.22,35,10.89,43.06,10.84Z" }),
            React.createElement("path", { fill: fillAlt, d: "M34.73,8.92a32.74,32.74,0,0,0-18,10.8c-1.36,1.59-2.2,3.59-3.39,5.33a8.81,8.81,0,0,1-1.76,1.55c-.54-.7-1.49-1.37-1.56-2.11-.31-3.49.34-6.82,3.25-9.12A34.53,34.53,0,0,1,33,8.08C33.43,8.06,33.86,8.48,34.73,8.92Z" }),
            React.createElement("path", { fill: fillAlt, d: "M55.63,14.29a41,41,0,0,0-17.85,9.18c-2,1.79-3.43,4.22-5.23,6.26a9.63,9.63,0,0,1-2.19,1.43c-.41-.67-1.27-1.45-1.14-2,.5-2.3.6-5.32,2.1-6.68C38.15,16.3,46.55,14,55.63,14.29Z" }),
            React.createElement("path", { fill: fillAlt, d: "M26.76,6.6C17.43,9.27,9.51,13.07,5.55,22.22a2.39,2.39,0,0,1-1.73,1c-.26,0-.92-.89-.9-1.36.08-1.95-.13-4.12.65-5.8C6.36,10,20.83,4.12,26.76,6.6Z" }))));
};
const IconGymChallenge = React.memo(IconGymChallengeComponent);

const IconFossilComponent = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 93.91 71.62" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "WK0XGY.tif" },
                    React.createElement("path", { fill: fill, d: "M63,52.57a22.7,22.7,0,0,0-3.75-.83,4,4,0,0,1-3.71-2.52c-.7-1.59.18-2.76,1.26-3.87,2.4-2.46,4-2.63,7-.9a16.1,16.1,0,0,0,3.49,1.32,5.7,5.7,0,0,0,1.65,0c-.19-.64-.17-1.52-.59-1.88a32.31,32.31,0,0,0-4.46-3.27c-2-1.19-2.35-2.11-1-4.08a41.89,41.89,0,0,1,2.62-3.46c1.31-1.49,2.87-1.06,4.32-.25a23.76,23.76,0,0,1,9.51,10.1,9,9,0,0,0,6.91,4.69c3.07.52,5,2.29,6.71,4.48a3.26,3.26,0,0,1-.34,4.25,13.07,13.07,0,0,0-3,6.83c-1.14,5.8-4.71,9.45-12.18,8.19-3.53-.59-6.9-2.08-10.38-3A7.48,7.48,0,0,0,64,68.21c-3.73.59-7,0-9.42-3.17a6.89,6.89,0,0,1-.75-8.12c1.32-2.53,3.93-3.51,7.05-3A6.49,6.49,0,0,0,63,53.58Z" }),
                    React.createElement("path", { fill: fill, d: "M21.58,47.37c2.36.75,4.7,1.61,7.09,2.21a18,18,0,0,0,5.73.79,14.1,14.1,0,0,1,7.43,1.37A27,27,0,0,0,48,53.45c3,.59,4.36,1.66,4.22,3.67-.21,3.14-2.16,5.36-4.9,5.54a12.45,12.45,0,0,1-2.59,0c-2.74-.36-5.51-.63-8.2-1.26A10,10,0,0,0,29,62.41a8.79,8.79,0,0,1-8.74.13,3.68,3.68,0,0,1-2.32-3.79c.12-1.32.16-2.64.17-4a8.44,8.44,0,0,0-.21-2.36C16.83,48.79,17.63,47.72,21.58,47.37Z" }),
                    React.createElement("path", { fill: fill, d: "M40.61,11.09A8.44,8.44,0,0,1,48.12,17c1.27,4.52,4.42,7.54,8.62,9.38,2.4,1.05,4.38,2.5,4.79,5.08S60,35.6,58.29,37c-1.51,1.25-4.55.51-6.37-1.11q-6.29-5.57-12.68-11A25.28,25.28,0,0,0,36,22.76a6,6,0,0,1-3.12-6.18c.33-2.58,2.11-4,4.54-4.67C38.45,11.62,39.53,11.36,40.61,11.09Z" }),
                    React.createElement("path", { fill: fill, d: "M30.05,26.08A17.47,17.47,0,0,1,33.13,28,66.76,66.76,0,0,0,51,40.13a4,4,0,0,1,1.92,5.22c-2.16,5.1-4,5.32-8.41,1.86a19.11,19.11,0,0,0-10-4.18,20.71,20.71,0,0,1-3.73-1.13,37.81,37.81,0,0,0-5.24-1.46c-3.34-.47-5-2.68-3.46-5.62a43.22,43.22,0,0,1,5-7C27.67,27,28.89,26.7,30.05,26.08Z" }),
                    React.createElement("path", { fill: fill, d: "M89.23,43c-3.62-.45-6.23-2-6.6-6.2-.19-2.2-1-4.32-1.4-6.51-.19-1.2-.41-3,.23-3.56,1.19-1,2.78-.48,4.12.63a33.34,33.34,0,0,1,7.64,9.47C95.07,40.14,93.05,43.05,89.23,43Z" }),
                    React.createElement("path", { fill: fill, d: "M23,0c4-.15,7.23,1.91,10.44,3.81.73.43,1.07,1.89,1.18,2.92.16,1.59-2.81,5.33-4.38,5.73-2.15.54-3.63-.64-5-2.08C23.15,8.2,21,6.11,18.91,3.89c-.48-.52-1-1.48-.81-2A3,3,0,0,1,19.87.25,13,13,0,0,1,23,0Z" }),
                    React.createElement("path", { fill: fill, d: "M11,22.81c3.27.3,6.45.41,9,2.8,1.65,1.55,1.66,3.07.16,5.91-1,1.93-2.62,2.81-4.56,2.21a6.64,6.64,0,0,1-2.6-1.7,16.2,16.2,0,0,0-7-4.29A2.92,2.92,0,0,1,4.5,25.68a2.12,2.12,0,0,1,1.11-1.74A50.3,50.3,0,0,1,11,22.81Z" }),
                    React.createElement("path", { fill: fill, d: "M14.87,53.24c0,4.49-3.71,7.27-7,5.39-1.22-.7-3.08-.35-4.64-.37-1.29,0-2.63.08-3.11-1.45s.46-2.3,1.46-3.17c3.25-2.84,7.13-3,11.11-2.7A2.14,2.14,0,0,1,14.87,53.24Z" }))))));
};
const IconFossil = React.memo(IconFossilComponent);

const IconGymHeroesComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 104.63 59.82" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "kvpmT3.tif" },
                    React.createElement("path", { fill: "#ffffff", d: "M53.44,0C43,.79,33.42,1.22,24.12,3.74c-6.49,1.76-12.67,4-18.16,8C-1.19,16.88-2.27,25.18,4.7,31.15a38.73,38.73,0,0,0,16.19,8.17c6.77,1.65,13.35,4.07,20.29,5a3.76,3.76,0,0,1,1.36.57,13,13,0,0,1,6.51,10.6c.26,3.3,1.55,4.7,4.78,4.21a104.37,104.37,0,0,0,15.25-3A111.9,111.9,0,0,0,85,50.28c9.48-4.59,16.47-11.55,19-22.16a23.92,23.92,0,0,0,.66-7.34c-.38-4.54-3.45-7.47-7-9.91C90.31,5.92,82,3.66,73.55,2.16,66.62.94,59.52.62,53.44,0Z" }),
                    React.createElement("path", { d: "M53.44,0c6.08.62,13.18.94,20.11,2.16,8.45,1.5,16.76,3.76,24,8.71,3.56,2.44,6.63,5.37,7,9.91a23.92,23.92,0,0,1-.66,7.34c-2.48,10.61-9.47,17.57-19,22.16a111.9,111.9,0,0,1-15.88,6.45,104.37,104.37,0,0,1-15.25,3c-3.23.49-4.52-.91-4.78-4.21a13,13,0,0,0-6.51-10.6,3.76,3.76,0,0,0-1.36-.57c-6.94-1-13.52-3.38-20.29-5A38.73,38.73,0,0,1,4.7,31.15c-7-6-5.89-14.27,1.26-19.43,5.49-4,11.67-6.22,18.16-8C33.42,1.22,43,.79,53.44,0ZM52.27,3.16c0,.19-3.09-.2-3.1,0-3.22,0-3.39.31-6.57.64A120.15,120.15,0,0,0,20.26,8.2,34.89,34.89,0,0,0,6.49,15.87c-4.34,4-4.11,9.88.75,13.46,5.42,4,11.26,6.84,18,7.64,3.32.4,6.64,1,10,1,4.06.09,4.79-.75,4.88-4.9.1-4.71.17-9.42.05-14.13-.06-2.13,1-2.88,2.77-3.32,2.82-.69,5.64-1.38,8.44-2.16q10-2.79,20-5.7c.41-.12,1.05-.52,1-.77a1.78,1.78,0,0,0-.68-1.38,10.21,10.21,0,0,0-3.24-1C63.08,4.07,57.67,3.63,52.27,3.16ZM44,41l-.34.63c.43.43.84.89,1.3,1.27,1.18,1,2.82,1.68,3.5,2.92a57.84,57.84,0,0,1,3.88,8.87c.48,1.35,1,2,2.37,1.72,2.5-.52,5-1,7.46-1.71,5.71-1.6,11.49-3,17.05-5A37.33,37.33,0,0,0,95.47,38.76c1.83-2.19,3-5,4.4-7.49l-.52-.62C81.39,36.78,62.84,39.76,44,41ZM72,11.55l-.11.52c8.91,3.58,16.34,8.83,20.37,18.66a11.64,11.64,0,0,0,1.27-2.68c.34-2.91-.07-5.7-2.15-7.95C87.4,15.75,82,14,76.59,12.31A31.35,31.35,0,0,0,72,11.55Zm-9,2.8c.27.65.28.83.37.88,3.65,2.1,7.51,3.9,10.9,6.35S80.93,27.18,82,31.7a1.67,1.67,0,0,0,1.4.9c.43-.08.9-.83,1-1.36a8.58,8.58,0,0,0-4-9.93,96.6,96.6,0,0,0-12.14-5.92C66.74,14.74,65,14.71,63.05,14.35Zm-10.19,4v.46a70.53,70.53,0,0,1,6.36,3.1c4.9,3,9.89,6,12.09,11.83a1.4,1.4,0,0,0,1.19.67,1.71,1.71,0,0,0,1.06-1.07c.6-2.87.31-5.45-2.16-7.55-4.66-4-10.25-5.95-16-7.59A7.58,7.58,0,0,0,52.86,18.38ZM80.67,9.73c.53.57.61.73.72.76A28,28,0,0,1,96.81,21.18c.81,1.12,1.27,2.5,2,3.69a8.53,8.53,0,0,0,1.43,1.38,6.69,6.69,0,0,0,.78-1.59,7.57,7.57,0,0,0-2-7.06c-4.37-4.54-9.93-6.72-15.85-8.18A8.19,8.19,0,0,0,80.67,9.73Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M52.27,3.16c5.4.47,10.81.91,16.2,1.46a10.21,10.21,0,0,1,3.24,1A1.78,1.78,0,0,1,72.39,7c0,.25-.63.65-1,.77q-10,2.9-20,5.7c-2.8.78-5.62,1.47-8.44,2.16-1.77.44-2.83,1.19-2.77,3.32.12,4.71,0,9.42-.05,14.13-.09,4.15-.82,5-4.88,4.9-3.32-.07-6.64-.64-10-1-6.74-.8-12.58-3.65-18-7.64-4.86-3.58-5.09-9.5-.75-13.46A34.89,34.89,0,0,1,20.26,8.2,120.15,120.15,0,0,1,42.6,3.8a93.87,93.87,0,0,1,9.64,0Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M44,41c18.86-1.23,37.41-4.21,55.37-10.34l.52.62c-1.45,2.51-2.57,5.3-4.4,7.49A37.33,37.33,0,0,1,79.2,49.65c-5.56,2-11.34,3.44-17.05,5-2.45.68-5,1.19-7.46,1.71-1.36.28-1.89-.37-2.37-1.72a57.84,57.84,0,0,0-3.88-8.87c-.68-1.24-2.32-1.94-3.5-2.92-.46-.38-.87-.84-1.3-1.27Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M72,11.55a31.35,31.35,0,0,1,4.57.76C82,14,87.4,15.75,91.4,20.1c2.08,2.25,2.49,5,2.15,8a11.64,11.64,0,0,1-1.27,2.68c-4-9.83-11.46-15.08-20.37-18.66Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M63.05,14.35c1.93.36,3.69.39,5.17,1a96.6,96.6,0,0,1,12.14,5.92,8.58,8.58,0,0,1,4,9.93c-.13.53-.6,1.28-1,1.36a1.67,1.67,0,0,1-1.4-.9c-1-4.52-4.17-7.59-7.65-10.12s-7.25-4.25-10.9-6.35C63.33,15.18,63.32,15,63.05,14.35Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M52.86,18.38a7.58,7.58,0,0,1,2.53-.15c5.75,1.64,11.34,3.62,16,7.59,2.47,2.1,2.76,4.68,2.16,7.55a1.71,1.71,0,0,1-1.06,1.07,1.4,1.4,0,0,1-1.19-.67C69.1,28,64.11,25,59.21,21.94a70.53,70.53,0,0,0-6.36-3.1Z" }),
                    React.createElement("path", { fill: "#ffffff", d: "M80.67,9.73a8.19,8.19,0,0,1,2.5-.31C89.09,10.88,94.65,13.06,99,17.6a7.57,7.57,0,0,1,2,7.06,6.69,6.69,0,0,1-.78,1.59,8.53,8.53,0,0,1-1.43-1.38c-.73-1.19-1.19-2.57-2-3.69A28,28,0,0,0,81.39,10.49C81.28,10.46,81.2,10.3,80.67,9.73Z" }))))));
};
const IconGymHeroes = React.memo(IconGymHeroesComponent);

const IconGymLeadersComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 77.5 61.93" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("circle", { fill: "#ffffff", cx: "30.96", cy: "30.96", r: "28.46", stroke: "#231f20", strokeMiterlimit: 10, strokeWidth: "5px" }),
                React.createElement("circle", { cx: "31.16", cy: "31.16", r: "11.92" }),
                React.createElement("rect", { x: "3.35", y: "29.16", width: "55.24", height: "3.61" }),
                React.createElement("rect", { fill: "#231f20", x: "23.82", y: "10.22", width: "14.29", height: "3.61" }),
                React.createElement("polyline", { fill: "#ffffff", points: "38.51 42.91 40.36 39.23 31.04 34.45 31.04 34.44 21.74 39.23 21.74 51.15 31.05 55.87 31.05 55.88 31.06 55.88 31.06 55.88 31.07 55.88 40.36 51.15 40.36 51.13 40.38 47 40.39 47 40.39 43.31 35.89 43.31" }),
                React.createElement("polygon", { fill: "#ffffff", points: "54.14 36.6 49.55 42.53 44.47 38.32 40.83 41.13 46.02 46.01 45.96 54.63 51.7 54.63 51.61 46.67 58.08 40.78 54.14 36.6" }),
                React.createElement("polygon", { fill: "#ffffff", points: "72.93 53.74 77.5 53.76 73.43 32.78 66.22 40.46 58.83 32.77 55.44 54.24 62.53 54.24 63.96 42.78 66.17 46.65 66.17 46.65 66.17 46.65 66.17 46.66 66.18 46.64 70.39 42.59 72.93 53.74" }),
                React.createElement("polygon", { points: "30.52 43.99 30.52 47.15 35.08 47.15 35.08 48.49 30.9 50.62 27.04 48.65 27.04 42.49 31.05 40.44 37.34 43.65 38.94 40.5 30.88 36.41 30.88 36.4 22.83 40.5 22.83 50.69 30.89 54.74 30.89 54.74 30.89 54.74 30.9 54.74 30.9 54.74 38.94 50.69 38.94 50.68 38.95 47.15 38.97 47.15 38.97 43.99 35.08 43.99 30.52 43.99" }),
                React.createElement("polygon", { points: "54.06 37.91 48.83 42.62 43.75 38.05 41.32 40.75 47.19 46.04 47.19 53.59 50.6 53.59 50.6 45.92 56.49 40.61 54.06 37.91" }),
                React.createElement("polygon", { points: "72.48 53.55 76.63 53.57 72.93 35.83 66.39 42.33 59.69 35.82 57.22 53.48 61.3 53.55 62.68 44.27 66.34 47.56 66.34 47.56 66.34 47.56 66.35 47.56 66.35 47.55 70.18 44.13 72.48 53.55" })))));
};
const IconGymLeaders = React.memo(IconGymLeadersComponent);

const IconJungleComponent = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 101.67 63.64" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "_1RdL2g.tif", "data-name": "1RdL2g.tif" },
                    React.createElement("path", { fill: fill, d: "M76.31,53.83a8.25,8.25,0,0,1-6.2,8.06,57.64,57.64,0,0,1-14.36,1.72c-4.9,0-9.8.09-14.69-.16a15.86,15.86,0,0,1-5.37-1.62,30.1,30.1,0,0,1-5.26-3.09,6.86,6.86,0,0,1-2.13-7.92c1.58-3.22,3.56-6.4,6.66-8.26a49.46,49.46,0,0,0,8.25-6.18A6.45,6.45,0,0,1,48.55,35a51.24,51.24,0,0,0,7.32.32c4.47-.19,8.24,1.42,11.76,3.94a26.77,26.77,0,0,1,6.53,7.1A8,8,0,0,1,75,48.71C75.49,50.41,75.89,52.12,76.31,53.83ZM60.59,43.61l-.07.22a17.5,17.5,0,0,0-2.91.3c-.7.2-1.73.66-1.87,1.19-.24,1-.32,2.39.23,3a5.74,5.74,0,0,0,7,1.4,2.34,2.34,0,0,1,2.72,0,4.53,4.53,0,0,0,1.83,1c1,.12,2.26.24,2.86-.27.83-.71.56-1.85-.16-2.92a5.42,5.42,0,0,0-4.08-2.32,18.66,18.66,0,0,1-2.65-.66C62.49,44.32,61.54,44,60.59,43.61ZM46,49.18c2.53,0,4.84-1.18,4.53-3.94A4.06,4.06,0,0,0,46,41.39c-1.8,0-4.33,2.48-4.34,4.2C41.7,47.51,43.7,49.2,46,49.18Zm4.58,2.14v-.11a10.37,10.37,0,0,0-3.2.4,5,5,0,0,0-1.94,2.17,1.84,1.84,0,0,0,.39,1.73,6.5,6.5,0,0,0,7.84-.26,3.19,3.19,0,0,0,.65-2.63c-.12-.54-1.21-1-1.94-1.26A5.61,5.61,0,0,0,50.53,51.32ZM54.94,43a5,5,0,0,0,1.78-.83c.53-.55,1.17-1.57,1-2.1a2.87,2.87,0,0,0-2-1.31A5.28,5.28,0,0,0,53,39.1a8.24,8.24,0,0,0-1.89,1.44,18.21,18.21,0,0,0,2,2.12C53.45,43,54.12,42.88,54.94,43Z" }),
                    React.createElement("path", { fill: fill, d: "M19.11,18.5c4,.81,8.76,1.69,13.45,2.76a19.34,19.34,0,0,1,5.08,2c3.62,2,2.55,7,.44,8.86-1.4,1.2-2.74,2.48-4.17,3.65-.61.5-1.45.71-2.07,1.2-2,1.61-4,3.24-6,4.93-1,.85-1.81,1.88-2.75,2.78a6.73,6.73,0,0,1-6.25,1.73,35.88,35.88,0,0,1-9.49-3.14c-3.74-1.79-5.92-5-7.08-8.86a5.48,5.48,0,0,1,.85-5.11A31.29,31.29,0,0,1,9.77,21C12.44,19.4,15.39,19.15,19.11,18.5Zm.55,16c.06-2.16-1-3.56-2.33-3a14.17,14.17,0,0,0-4.11,2.75,2.23,2.23,0,0,0,1.22,3.74,4.32,4.32,0,0,1,3,2.56,2.46,2.46,0,0,0,1.05,1.11,3.11,3.11,0,0,0,3.74-1.16c.71-1.38-.13-2.27-1.14-3S19.33,35.74,19.66,34.54ZM24,24.64c-1.59-.38-2.71.65-3.37,1.85a3.64,3.64,0,0,0-.12,3,2.28,2.28,0,0,0,3.26.89,2.47,2.47,0,0,1,3.36.15,3.79,3.79,0,0,0,1.56.82A2,2,0,0,0,30.1,31a1.46,1.46,0,0,0,.38-1.28C29.72,27.24,26.35,24.23,24,24.64Zm-9.89,5.1c2.14,0,2.88-.66,2.94-2.56,0-1.31-.53-2.17-1.79-2.27-1.42-.1-3.37,1.88-3.39,3.21C11.8,29.74,12.92,29.73,14.06,29.74Z" }),
                    React.createElement("path", { fill: fill, d: "M89.16,51.75c-4-.29-7.28-1.61-9.51-5-.74-1.11-1.19-2.41-1.86-3.57-1.64-2.79-4.24-4.6-6.79-6.46a14.46,14.46,0,0,1-2-1.63c-1.47-1.58-1.43-3.15.21-4.5,2.33-1.9,4.78-3.5,8.07-3.17a17.47,17.47,0,0,0,4.56-.23c3.4-.59,6.39.44,9.32,2,1.13.59,2.37,1,3.53,1.49a12.53,12.53,0,0,1,5.45,4.94,8.48,8.48,0,0,1,1.19,2.62c1.33,6.11-1.11,10.93-7.44,12.43C92.31,51,90.73,51.39,89.16,51.75ZM81.05,33.69c-.23.13-1.21.41-1.27.81a4.37,4.37,0,0,0,.36,3,12.66,12.66,0,0,0,3.53,2.72A1.89,1.89,0,0,0,85.48,40a3.13,3.13,0,0,0,.91-2.21C86.13,36.1,83.13,33.8,81.05,33.69Zm9.53,5.74c.31.65.46,1.68,1,1.88,1.63.67,3.38,1.28,5.17.49,1.14-.5,1.35-1.39.42-2.28A15.41,15.41,0,0,0,94.2,37.3C92.23,36.14,90.84,37,90.58,39.43Zm-1,7.13c.79,0,1.71-.1,1.66-1.63-.06-1.82-1.25-3.41-2.75-3.46a2.21,2.21,0,0,0-2.35,2.32C86.17,45.49,87.32,46.52,89.62,46.56ZM89.46,35.1A2.23,2.23,0,0,0,91.54,33c-.05-1.05-2.15-2.71-3.43-2.5a2.12,2.12,0,0,0-1.9,2.25C86.22,33.78,88.14,35.15,89.46,35.1Z" }),
                    React.createElement("path", { fill: fill, d: "M43.79,1.09c1.33-.25,2.66-.48,4-.75a14.17,14.17,0,0,1,6.9.18c3,.83,6.22,1,9.33,1.54a17.62,17.62,0,0,1,5.16,1.3c3,1.58,3.24,4.27.49,6.33a48.63,48.63,0,0,1-7.82,4.87,16.6,16.6,0,0,1-5.61,1.15,17.07,17.07,0,0,1-3.89-.31A5,5,0,0,0,48.1,17c-1.48,1.39-5.19,2.12-6.74.87-2.85-2.28-6.3-2.45-9.55-3.31-2.81-.75-4-3.12-2.57-5.69,1.66-3,4.48-4.63,7.44-6.05a25.19,25.19,0,0,1,3.19-1.14c1.25-.4,2.51-.78,3.77-1.17ZM54.44,12.22A7.75,7.75,0,0,0,55.82,12c1-.28,2.18-2,1.71-2.77a30.48,30.48,0,0,0-3.28-4.94c-1.46-1.66-3.68-1-5.57-1.14-2.34-.17-3.13.4-3.84,2.63a1.77,1.77,0,0,0,.64,1.6A12.26,12.26,0,0,0,48.79,8c1.2.1,2,.35,2.18,1.82C51.2,11.67,52.08,12.22,54.44,12.22ZM41,6.88a12.8,12.8,0,0,0-2,.16c-1.36.34-2.64.89-2.92,2.45-.2,1.1,1.18,2.26,2.69,2.74A5.78,5.78,0,0,1,40.7,13.6c.44.39.71,1,1.17,1.32,1.21.92,3.06.88,3.7-.13.82-1.3.14-2.26-.82-3.26a5.57,5.57,0,0,1-1.66-2.87C42.9,6.93,42,6.72,41,6.88ZM62.34,6c-.86.13-2.09-.32-2.14,1.24a2.24,2.24,0,0,0,2.33,2.18c1.15,0,1.83-.39,1.87-1.66C64.44,6.29,63.67,5.87,62.34,6Z" }),
                    React.createElement("path", { fill: fill, d: "M84.15,10.26c3.61-.6,6.33,1.43,9.1,3.36a11.41,11.41,0,0,1,5.36,10.09c0,1.3,0,2.69-1.43,3.4s-2.63-.08-3.84-.69c-.19-.09-.31-.3-.48-.43a13.84,13.84,0,0,0-5.25-2.52c-3.4-.95-6.71-.27-10-.65A6.89,6.89,0,0,0,73.12,24c-2.06,1.25-4,1.24-4.84-.15-1.29-2.2-2.09-4.9.11-6.47,2.68-1.9,5.4-3.74,8.21-5.43A11.59,11.59,0,0,1,84.15,10.26ZM79,15.06l-.13.3h-.82a1.85,1.85,0,0,0-2.13,1.77,2,2,0,0,0,1.65,2.3,4.94,4.94,0,0,0,2.41.13,2.6,2.6,0,0,0,1.74-1.17,2.59,2.59,0,0,0-.41-2.2A6.92,6.92,0,0,0,79,15.06Zm8.74,4.65A2.11,2.11,0,0,0,90.05,18a3,3,0,0,0-2.57-2.55c-.93,0-2.23,1.43-2.06,2.37A2.07,2.07,0,0,0,87.75,19.71Z" }),
                    React.createElement("path", { fill: fill, d: "M49.05,22.19a7.58,7.58,0,0,1,4.45-.88,4.39,4.39,0,0,1,3.88,2.23c.21.32.79.41,1.2.61.06-.46.29-1,.15-1.35-.28-.8-1.76-1.32-.54-2.43.72-.64,2.93-.33,3.81.51,1.47,1.39,1.2,3.32,1.37,5a11.81,11.81,0,0,1-.51,3.7,3.72,3.72,0,0,1-3.29,2.46c-1.72.14-3.43.45-5.15.62a12.34,12.34,0,0,1-2.43,0c-1.94-.19-3.87-.51-5.81-.66C44,31.9,43,30.94,43,28.8a8,8,0,0,0,0-1.47c-.72-3.09,1.48-4.92,3.05-7a2,2,0,0,1,1.73-.41,1.91,1.91,0,0,1,1.37,2.3,2.11,2.11,0,0,0-.83,3,3.29,3.29,0,0,0,4.18.86C50.19,25.64,49.55,24,49.05,22.19Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M60.59,43.61c.95.34,1.9.71,2.87,1a18.66,18.66,0,0,0,2.65.66,5.42,5.42,0,0,1,4.08,2.32c.72,1.07,1,2.21.16,2.92-.6.51-1.91.39-2.86.27a4.53,4.53,0,0,1-1.83-1,2.34,2.34,0,0,0-2.72,0,5.74,5.74,0,0,1-7-1.4c-.55-.62-.47-2.06-.23-3,.14-.53,1.17-1,1.87-1.19a17.5,17.5,0,0,1,2.91-.3Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M46,49.18c-2.25,0-4.25-1.67-4.25-3.59,0-1.72,2.54-4.17,4.34-4.2a4.06,4.06,0,0,1,4.44,3.85C50.79,48,48.48,49.16,46,49.18Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M50.53,51.32a5.61,5.61,0,0,1,1.79,0c.73.28,1.82.72,1.94,1.26a3.19,3.19,0,0,1-.65,2.63,6.5,6.5,0,0,1-7.84.26,1.84,1.84,0,0,1-.39-1.73,5,5,0,0,1,1.94-2.17,10.37,10.37,0,0,1,3.2-.4Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M54.94,43c-.82-.13-1.49,0-1.86-.35a18.21,18.21,0,0,1-2-2.12A8.24,8.24,0,0,1,53,39.1a5.28,5.28,0,0,1,2.71-.33,2.87,2.87,0,0,1,2,1.31c.19.53-.45,1.55-1,2.1A5,5,0,0,1,54.94,43Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M19.66,34.54c-.33,1.2.31,2.18,1.4,3s1.85,1.65,1.14,3a3.11,3.11,0,0,1-3.74,1.16,2.46,2.46,0,0,1-1.05-1.11,4.32,4.32,0,0,0-3-2.56,2.23,2.23,0,0,1-1.22-3.74,14.17,14.17,0,0,1,4.11-2.75C18.63,31,19.72,32.38,19.66,34.54Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M24,24.64c2.4-.41,5.77,2.6,6.53,5.08A1.46,1.46,0,0,1,30.1,31a2,2,0,0,1-1.46.34,3.79,3.79,0,0,1-1.56-.82,2.47,2.47,0,0,0-3.36-.15,2.28,2.28,0,0,1-3.26-.89,3.64,3.64,0,0,1,.12-3C21.24,25.29,22.36,24.26,24,24.64Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M14.06,29.74c-1.14,0-2.26,0-2.24-1.62,0-1.33,2-3.31,3.39-3.21,1.26.1,1.83,1,1.79,2.27C16.94,29.08,16.2,29.75,14.06,29.74Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M81.05,33.69c2.08.11,5.08,2.41,5.34,4.06A3.13,3.13,0,0,1,85.48,40a1.89,1.89,0,0,1-1.81.25,12.66,12.66,0,0,1-3.53-2.72,4.37,4.37,0,0,1-.36-3C79.84,34.1,80.82,33.82,81.05,33.69Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M90.58,39.43c.26-2.42,1.65-3.29,3.62-2.13a15.41,15.41,0,0,1,2.92,2.22c.93.89.72,1.78-.42,2.28-1.79.79-3.54.18-5.17-.49C91,41.11,90.89,40.08,90.58,39.43Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M89.62,46.56c-2.3,0-3.45-1.07-3.44-2.77a2.21,2.21,0,0,1,2.35-2.32c1.5.05,2.69,1.64,2.75,3.46C91.33,46.46,90.41,46.59,89.62,46.56Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M89.46,35.1c-1.32,0-3.24-1.32-3.25-2.36a2.12,2.12,0,0,1,1.9-2.25c1.28-.21,3.38,1.45,3.43,2.5A2.23,2.23,0,0,1,89.46,35.1Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M54.44,12.22c-2.36,0-3.24-.55-3.47-2.37C50.79,8.38,50,8.13,48.79,8a12.26,12.26,0,0,1-3.31-.61,1.77,1.77,0,0,1-.64-1.6c.71-2.23,1.5-2.8,3.84-2.63,1.89.14,4.11-.52,5.57,1.14a30.48,30.48,0,0,1,3.28,4.94c.47.81-.66,2.49-1.71,2.77A7.75,7.75,0,0,1,54.44,12.22Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M41,6.88c1-.16,1.88,0,2.07,1.78a5.57,5.57,0,0,0,1.66,2.87c1,1,1.64,2,.82,3.26-.64,1-2.49,1.05-3.7.13-.46-.35-.73-.93-1.17-1.32a5.78,5.78,0,0,0-1.87-1.37c-1.51-.48-2.89-1.64-2.69-2.74C36.42,7.93,37.7,7.38,39.06,7A12.8,12.8,0,0,1,41,6.88Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M62.34,6c1.33-.14,2.1.28,2.06,1.76,0,1.27-.72,1.7-1.87,1.66A2.24,2.24,0,0,1,60.2,7.25C60.25,5.69,61.48,6.14,62.34,6Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M79,15.06a6.92,6.92,0,0,1,2.31,1.13,2.59,2.59,0,0,1,.41,2.2A2.6,2.6,0,0,1,80,19.56a4.94,4.94,0,0,1-2.41-.13,2,2,0,0,1-1.65-2.3,1.85,1.85,0,0,1,2.13-1.77h.82Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M87.75,19.71a2.07,2.07,0,0,1-2.33-1.91c-.17-.94,1.13-2.33,2.06-2.37A3,3,0,0,1,90.05,18,2.11,2.11,0,0,1,87.75,19.71Z" }),
                    React.createElement("path", { fillOpacity: 0, d: "M49.05,22.19c.5,1.78,1.14,3.45,3.39,3.88a3.29,3.29,0,0,1-4.18-.86,2.11,2.11,0,0,1,.83-3Z" }))))));
};
const IconJungle = React.memo(IconJungleComponent);

const IconLegendaryCollectionComponent = (props) => {
    const { fill = '#000', fillAlt = '#ffffff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 46 81.46" },
        React.createElement("path", { fill: fill, d: "M46,0V22.22A28.42,28.42,0,0,1,32.7,33.55c-4.68,2-5.9,4.92-5.1,9.43,0,.2.09.4.15.69l1.9.82c7.93,3.32,12.37,10.4,12,19.19C41.37,71.35,35.81,78.29,28,80.77c-.56.18-1.1.46-1.64.69H19c-.93-.38-1.84-.79-2.78-1.13A19.16,19.16,0,0,1,5.72,53.54c2.68-5.19,7-8.36,12.67-10a15.35,15.35,0,0,1,0-2.55c.59-3.3-.8-5-3.76-6.56A82,82,0,0,1,3,26.16c-1.29-1-2.73-2.78-2.79-4.25C-.11,14.68,0,7.43,0,0ZM22.69,51.21a11.12,11.12,0,1,0,11,11.21A11.08,11.08,0,0,0,22.69,51.21Z" }),
        React.createElement("path", { fill: fillAlt, d: "M22.69,51.21A11.12,11.12,0,1,1,11.62,62.39,11.09,11.09,0,0,1,22.69,51.21Z" })));
};
const IconLegendaryCollection = React.memo(IconLegendaryCollectionComponent);

const IconMcdonaldsComponent = (props) => {
    const { fill = '#d32b1e', fillAlt = '#fbc630' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 70.94 63.67" },
        React.createElement("g", { "fill-rule": "evenodd" },
            React.createElement("path", { fill: fill, stroke: "#fff", strokeMiterlimit: "10", strokeWidth: "2", d: "M4.48 1C2.56 1 1 2.84 1 5.11v53.45c0 2.27 1.56 4.11 3.48 4.11h61.98c1.92 0 3.48-1.84 3.48-4.11V5.11c0-2.27-1.56-4.11-3.48-4.11H4.48Z" }),
            React.createElement("path", { fill: fillAlt, d: "M35.63 29.41c1.08-8.02 4.66-22.49 11.48-22.49 7.96 0 17.32 26.74 17.31 48.89h-7.34c0-23.22-5.69-44.15-9.78-44.15-4.27 0-8.01 14.23-8.01 41.35h-7.33c0-27.12-3.72-41.35-8.01-41.35s-9.77 20.93-9.77 44.15H6.84c0-22.16 9.34-48.89 17.31-48.89 6.81 0 10.39 14.47 11.48 22.49" }))));
};
const IconMcdonalds = React.memo(IconMcdonaldsComponent);

const IconNeoDestinyComponent = (props) => {
    const { fill = '#000', fillAlt = '#ffffff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 123.14 68.06" },
        React.createElement("defs", null),
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("path", { fill: fillAlt, d: "M69.4,40.68,62.17,55.62c-4.28-5.43-9.07-11.68-9.07-11.68h0L6.85,65.51l-.09,0c-.24.1-1.37.55-6.76,2.51L19,53.44,38.76,38.25,25.55,32.17h0l22.88-.54C48.61,31.88,54,25,54,25l4.27,4.38,7.68-2.53c7.31-2.52,14.76-5,22.08-7.51l22-7.31-14.73,9.6L79.42,32l18.51,3.52,18.5,3.52v.08" })),
                React.createElement("g", null,
                    React.createElement("path", { fill: fill, d: "M76.11,28.61,68.88,43.54c-4.28-5.42-9.07-11.68-9.07-11.68h0L13.56,53.44l-.09,0c-.24.1-1.38.54-6.76,2.5l19-14.62L45.47,26.17,32.25,20.1h0l22.89-.54c.18.24,5.51-6.59,5.51-6.59l4.28,4.37,7.68-2.52c7.31-2.52,14.76-5,22.07-7.51l22-7.31L102,9.59,86.13,19.93l18.5,3.52L123.14,27v.07" }))))));
};
const IconNeoDestiny = React.memo(IconNeoDestinyComponent);

const IconNeoDiscoveryComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96.64 70.11" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "zVOsXf.tif" },
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M55.26,36.11v6.63H41.52V36.11Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M41.53,45.71H55.26V53H41.53Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M54.48,26.78v5.88H42.3V26.78Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M41.66,56H55.39v9.12H41.66Z" })),
                React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M60.27,65.11H91.64V52.05l-2.55,0L86.88,52c-.88-2.43-2.25-6.47-3.18-8.87s-2-4.83-3-7.26-1.72-4.65-2.53-7c-.41-1.2-1-2-2.45-1.93-4.48.08-9,0-13.45,0-1.85,0-2,.18-2,2V65.11Z" }),
                React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M36.37,65.11H5V52.05l2.55,0L9.76,52c.88-2.43,2.25-6.47,3.18-8.87s2-4.83,3-7.26,1.72-4.65,2.53-7c.41-1.2,1-2,2.45-1.93,4.48.08,9,0,13.45,0,1.85,0,2,.18,2,2V65.11Z" }),
                React.createElement("g", { id: "zVOsXf.tif-2", "data-name": "zVOsXf.tif" },
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M68.24,21.48H66.56c-12.27,0-25.72,0-38,0v0" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M55.26,36.11v6.63H41.52V36.11Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M41.53,45.71H55.26V53H41.53Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M54.48,26.78v5.88H42.3V26.78Z" }),
                    React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M41.66,56H55.39v9.12H41.66Z" })),
                React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M60.27,65.11H91.64V52.05l-2.55,0L86.88,52c-.88-2.43-2.25-6.47-3.18-8.87s-2-4.83-3-7.26-1.72-4.65-2.53-7c-.41-1.2-1-2-2.45-1.93-4.48.08-9,0-13.45,0-1.85,0-2,.18-2,2V65.11Z" }),
                React.createElement("path", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", d: "M36.37,65.11H5V52.05l2.55,0L9.76,52c.88-2.43,2.25-6.47,3.18-8.87s2-4.83,3-7.26,1.72-4.65,2.53-7c.41-1.2,1-2,2.45-1.93,4.48.08,9,0,13.45,0,1.85,0,2,.18,2,2V65.11Z" }),
                React.createElement("polygon", { stroke: "#fff", strokeMiterlimit: 10, strokeWidth: "10px", points: "67.97 21.5 28.57 21.5 33.05 5 64.14 5 67.97 21.5" }),
                React.createElement("g", { id: "zVOsXf.tif-3", "data-name": "zVOsXf.tif" },
                    React.createElement("path", { d: "M55.26,36.11v6.63H41.52V36.11Z" }),
                    React.createElement("path", { d: "M41.53,45.71H55.26V53H41.53Z" }),
                    React.createElement("path", { d: "M54.48,26.78v5.88H42.3V26.78Z" }),
                    React.createElement("path", { d: "M41.66,56H55.39v9.12H41.66Z" })),
                React.createElement("path", { d: "M60.27,65.11H91.64V52.05l-2.55,0L86.88,52c-.88-2.43-2.25-6.47-3.18-8.87s-2-4.83-3-7.26-1.72-4.65-2.53-7c-.41-1.2-1-2-2.45-1.93-4.48.08-9,0-13.45,0-1.85,0-2,.18-2,2V65.11Z" }),
                React.createElement("path", { d: "M36.37,65.11H5V52.05l2.55,0L9.76,52c.88-2.43,2.25-6.47,3.18-8.87s2-4.83,3-7.26,1.72-4.65,2.53-7c.41-1.2,1-2,2.45-1.93,4.48.08,9,0,13.45,0,1.85,0,2,.18,2,2V65.11Z" }),
                React.createElement("g", { id: "zVOsXf.tif-4", "data-name": "zVOsXf.tif" },
                    React.createElement("path", { d: "M68.24,21.48H66.56c-12.27,0-25.72,0-38,0v0" }),
                    React.createElement("path", { d: "M55.26,36.11v6.63H41.52V36.11Z" }),
                    React.createElement("path", { d: "M41.53,45.71H55.26V53H41.53Z" }),
                    React.createElement("path", { d: "M54.48,26.78v5.88H42.3V26.78Z" }),
                    React.createElement("path", { d: "M41.66,56H55.39v9.12H41.66Z" })),
                React.createElement("path", { d: "M60.27,65.11H91.64V52.05l-2.55,0L86.88,52c-.88-2.43-2.25-6.47-3.18-8.87s-2-4.83-3-7.26-1.72-4.65-2.53-7c-.41-1.2-1-2-2.45-1.93-4.48.08-9,0-13.45,0-1.85,0-2,.18-2,2V65.11Z" }),
                React.createElement("path", { d: "M36.37,65.11H5V52.05l2.55,0L9.76,52c.88-2.43,2.25-6.47,3.18-8.87s2-4.83,3-7.26,1.72-4.65,2.53-7c.41-1.2,1-2,2.45-1.93,4.48.08,9,0,13.45,0,1.85,0,2,.18,2,2V65.11Z" }),
                React.createElement("polygon", { points: "67.97 21.5 28.57 21.5 33.05 5 64.14 5 67.97 21.5" }),
                React.createElement("rect", { fill: "#ffffff", x: "44.93", y: "14.47", width: "6.67", height: "7.77" })))));
};
const IconNeoDiscovery = React.memo(IconNeoDiscoveryComponent);

const IconNeoGenesisComponent = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 121.25 101.02" },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                React.createElement("g", { id: "Layer_2-2", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-2", "data-name": "Layer 1-2" },
                        React.createElement("path", { fill: "#ffffff", d: "M35.28,101,68.08,0l32.79,101-86-62.47H121.25" }))),
                React.createElement("g", { id: "Layer_2-3", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-3", "data-name": "Layer 1-2" },
                        React.createElement("path", { fill: "#000000", d: "M43,90.09l25.1-77.3,25.1,77.3L27.39,42.29h81.37" }))),
                React.createElement("g", { id: "Layer_2-4", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-4", "data-name": "Layer 1-2" },
                        React.createElement("path", { fill: "#ffffff", d: "M51.33,78.16,68.08,26.59,84.82,78.16,40.93,46.27H95.22" }))),
                React.createElement("g", { id: "Layer_2-5", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-5", "data-name": "Layer 1-2" },
                        React.createElement("path", { fill: "#ffffff", d: "M20.37,101,53.17,0,86,101,0,38.55H106.34" }))),
                React.createElement("g", { id: "Layer_2-6", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-6", "data-name": "Layer 1-2" },
                        React.createElement("path", { d: "M28.07,90.09l25.1-77.3,25.1,77.3L12.48,42.29H93.86" }))),
                React.createElement("g", { id: "Layer_2-7", "data-name": "Layer 2" },
                    React.createElement("g", { id: "Layer_1-2-7", "data-name": "Layer 1-2" },
                        React.createElement("path", { fill: "#ffffff", d: "M36.43,78.16,53.17,26.59,69.91,78.16,26,46.27H80.31" })))))));
};
const IconNeoGenesis = React.memo(IconNeoGenesisComponent);

const IconNeoRevelationComponent = (props) => {
    const { fill, strokeWidth = 5, stroke = 'white' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 103.32 61.49" },
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M51.78,61.47a82.48,82.48,0,0,1-31.1-5.85,14.16,14.16,0,0,1-7.88-7c-1.42-3.08-.26-8,2.48-10A4.82,4.82,0,0,1,19,38c.77.21,1.19,1.69,1.76,2.6.68,1.07,1.12,2.49,2.09,3.14a20.2,20.2,0,0,0,9.63,3.55c1.83.16,3.64.61,5.46.66a4.7,4.7,0,0,0,3-.87A11,11,0,0,1,48.4,44c3.42.06,6.83.16,10.23.46A4.86,4.86,0,0,1,61.22,46c2.37,2.31,5.13,2.3,8.12,1.77a34.63,34.63,0,0,0,10.77-3.32,5.63,5.63,0,0,0,3.06-4.27,3.13,3.13,0,0,1,5.1-1.82c3.39,2.7,4.81,9.43.82,13.11a27.19,27.19,0,0,1-11.32,6.18C69.28,60,60.67,61.67,51.78,61.47Z" }),
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M58.7,8.83c-.79,3.95-1.63,7.89-2.33,11.86-.42,2.36-.61,4.76-.94,7.14-.11.8-.4,1.58-.52,2.38-.35,2.22-1.85,2.59-3.76,2.44s-2.35-1.69-2.59-3c-1.22-7-2.48-13.93-3.3-20.95A11,11,0,0,1,46.8,2.4c1.63-2.87,4.64-2.6,7.46-2,2,.4,3.68,2.51,4,5,.16,1.13.16,2.27.23,3.41Z" }),
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M29.78,37A13.82,13.82,0,0,1,26.33,36c-8-4.6-16-9.29-24-14A3.87,3.87,0,0,1,.07,17.8a5.52,5.52,0,0,1,4.2-4.4C7,13,9.49,12.94,11.65,15.2,15.32,19,19.19,22.68,23,26.43c2.07,2.06,4.2,4.06,6.06,6.29.78,1,.94,2.41,1.39,3.63Z" }),
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M96.65,13.17c4.62.09,7,2.29,6.62,5.86a3.68,3.68,0,0,1-1.37,2.44c-3.49,2.25-7.09,4.34-10.68,6.43-4.84,2.83-9.68,5.66-14.58,8.37-.77.42-1.89.21-2.85.29a8.58,8.58,0,0,1,.08-2.64,6.94,6.94,0,0,1,1.63-2.5q7.47-7.56,15-15C92.33,14.66,94.15,12.75,96.65,13.17Z" }),
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M39.64,27.42c1.44.44,3.14.54,4.26,1.4,2.27,1.75,1.71,5-1,5.55a17,17,0,0,1-6.64-.3c-1.65-.32-2.07-1.83-1.73-3.46s1.11-2.95,3.14-2.8c.63.05,1.27,0,1.9,0Z" }),
        React.createElement("path", { stroke: stroke, strokeWidth: strokeWidth, fill: fill, d: "M64.34,27.82c.44,0,.88,0,1.32,0,1.8-.16,3.14.41,3.5,2.33.46,2.49,0,3.82-2.22,4.22a20.13,20.13,0,0,1-6.47-.18c-2-.3-2-2.09-1.74-3.6a3.25,3.25,0,0,1,3-2.75,19.65,19.65,0,0,1,2.66,0Z" })));
};
const IconNeoRevelation = React.memo(IconNeoRevelationComponent);

const IconSkyridgeComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 92.39 70.87" },
        React.createElement("g", null,
            React.createElement("path", { fill: fill, d: "m26.77 4.17-21.31 57a7.17 7.17 0 0 0 6.71 9.68h74a6.25 6.25 0 0 0 5-9.94l-15.49-26.1a6.54 6.54 0 0 0-11.11-.22l-5.36 8.26L38.45 3.42a6.41 6.41 0 0 0-11.68.75Z" }),
            React.createElement("path", { d: "M8.29 42.09c-4.59 0-5.58-2-5.76-3.19-.45-3 2.85-7.18 9.06-11.55 5-3.54 14.21-8.74 29.41-13.44C47.32 12 52.16 11 55.38 11c2.64 0 4.31.68 5 2 .88 1.75-.05 4.42-2.85 8.15a27.7 27.7 0 0 1-6.59 6.06l-.46.3-2.63-4.75.19-.26c1.57-2.1 2.21-3.7 1.8-4.51s-1.57-.86-2.54-.86A35.06 35.06 0 0 0 38 19c-16.53 5.12-25 12.26-24.77 15.45.06.78.72 1.26 1.94 1.43l.64.1-2.33 5.52h-.27c-.75.13-1.51.25-2.27.35a21.44 21.44 0 0 1-2.65.24Z", fill: fillAlt }),
            React.createElement("path", { d: "M55.38 11.47c7 0 5.17 4.74 1.72 9.35a26.78 26.78 0 0 1-6.47 5.94l-2.22-4c2.28-3.05 3.49-6.17-1.14-6.17a35.05 35.05 0 0 0-9.38 1.92C15.69 25.38 8.46 35.42 15.1 36.38l-2 4.67c-.75.13-1.5.25-2.25.35a19.29 19.29 0 0 1-2.6.19c-12.83 0-2.5-16.28 32.87-27.2 6.7-2.07 11.26-2.92 14.23-2.92m0-1c-3.27 0-8.16 1-14.52 3C15.33 21.32 1.07 32.61 2 39c.21 1.34 1.29 3.61 6.25 3.61a20.9 20.9 0 0 0 2.73-.2c.68-.09 1.43-.2 2.29-.35l.54-.1.21-.5 2-4.67.5-1.2-1.28-.18c-1-.14-1.47-.47-1.51-1-.19-2.44 7-9.55 24.46-14.94a34.43 34.43 0 0 1 9.08-1.88c1.13 0 1.92.22 2.1.58.08.16.38 1.13-1.76 4l-.39.52.32.56 2.21 4 .53 1 .91-.62a27.91 27.91 0 0 0 6.71-6.17c2.92-3.9 3.87-6.74 2.9-8.67-.76-1.51-2.58-2.28-5.42-2.28Z", fill: fill }),
            React.createElement("path", { d: "M8.27 43.09c-5.31 0-6.49-2.5-6.72-4C.57 32.69 14 21.35 40.7 13c5.4-1.69 9.78-2.55 13-2.55 3.48 0 5.75 1 6.73 2.95 1.08 2.16.34 5.05-2.14 8.36A28.12 28.12 0 0 1 51.47 28l-1.36.93-2.3-4.14.59-.79c1.21-1.63 1.71-3.36 1.23-4.32s-2.4-1.22-3.47-1.22A27.86 27.86 0 0 0 38.33 20c-18.21 5.62-25.4 14.66-25.19 17.3 0 .21 0 .51.91.64l1.92.28-1.78 4.21-.81.14c-.77.13-1.54.26-2.31.36a22.06 22.06 0 0 1-2.8.16Z", fill: fillAlt }),
            React.createElement("path", { d: "M53.71 11.91c7 0 6.87 4.27 3.39 8.91a26.78 26.78 0 0 1-6.47 5.94l-1-1.85c2.47-3.3 3-7.93-3.44-7.93a29.21 29.21 0 0 0-8.27 1.54c-22.2 6.86-30.7 19.9-24.06 20.86l-.7 1.67c-.75.13-1.5.25-2.25.35a19.54 19.54 0 0 1-2.61.19c-12.81 0-2.42-16.12 32.88-27.2 5.57-1.75 9.67-2.48 12.56-2.48m0-3c-3.39 0-7.91.88-13.46 2.62-24.6 7.71-41.5 19.4-40.21 27.79.24 1.59 1.53 5.27 8.2 5.27a23.32 23.32 0 0 0 3-.21c.71-.1 1.49-.22 2.37-.37l1.62-.28.63-1.51.71-1.67L18.11 37l-3.28-.47c.46-1.06 1.84-3.15 5.32-5.89 3.32-2.61 9.24-6.32 18.63-9.22A26.47 26.47 0 0 1 46.16 20a3.67 3.67 0 0 1 2.15.41 4.27 4.27 0 0 1-1.11 2.72L46 24.66l.94 1.7 1 1.86 1.6 2.87 2.71-1.85a29.57 29.57 0 0 0 7.19-6.62c3.59-4.79 3.22-8 2.28-9.93-.86-1.73-3-3.78-8.07-3.78Z", fill: fill }))));
};
const IconSkyridge = React.memo(IconSkyridgeComponent);

const IconSouthernIslandsComponent = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 95.18 74.66" },
        React.createElement("path", { fill: fill, d: "M43.06,0C46.7,2.05,50.5,3.88,54,6.21c3,2.05,4.74,5.06,3.79,8.75,5.14-1.06,10.17-2.51,15.31-3,6.77-.7,11.08,2.3,12.68,7.91a23.75,23.75,0,0,1,.45,3c-4.65-1.29-8.9-3.15-13.71-1.2,3.58,1.55,7.17,2.58,10.17,4.52A49.19,49.19,0,0,1,93,34.65c3.1,3.53,2.61,7.94.31,12.5L76.4,34.58C79.75,44.9,81,54.72,76,65.3c-.84-1.91-1.34-3-1.79-4.1-4-10-9.19-19.36-17.12-27-4.12-3.95-8.9-5.45-14.5-5.84-12.07-.82-23.39,2.15-34.59,6-2.69.92-5.33,2-8,2.94V34.79c9.07-10.31,19.36-18.2,35-16.73C29,10.52,21.13,14.54,14.59,12.41c9.89-4.12,19.76-8.1,30.47-3.84L41.16,0Z" }),
        React.createElement("path", { fill: fill, d: "M25.78,64.11l13.43,2.11c1.68,7.34.36,9-7,8.3-3-.28-6-1-9.42-1.53Z" }),
        React.createElement("path", { fill: fill, d: "M39.77,63.54,27.38,61.31l4.09-7.37,10.07,2.63Z" }),
        React.createElement("path", { fill: fill, d: "M44.06,48.43l-1.56,5.5-9.37-2.48,2.72-5Z" }),
        React.createElement("path", { fill: fill, d: "M44.52,31.37l6.1,2.26c-1.42,5.69-3.14,6.25-8.91,2.68C42.64,34.68,43.59,33,44.52,31.37Z" }),
        React.createElement("path", { fill: fill, d: "M40.23,39.09l6.75,2c-1.59,5.24-3.68,5.86-9.29,2.59Z" })));
};
const IconSouthernIslands = React.memo(IconSouthernIslandsComponent);

const IconTeamRocketComponent = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 76.37 61.86" },
        React.createElement("path", { fill: fill, d: "M76.27,21.4c-1,6.11-4.1,10.09-9.38,13.33a64,64,0,0,1-6.77,3.19c3.18,7.65,6.36,15.29,9.63,23.17-1.15.13-1.88.27-2.6.27-5.55,0-11.1-.12-16.65,0a2.65,2.65,0,0,1-2.93-2.12C45.51,53.6,43.36,48,41.18,42.46a1.79,1.79,0,0,0-1.2-1c-4.64-.27-9.28-.45-14-.67C25,44.94,24.1,49,23.17,53.11c-.67,2.92-1.37,5.83-2.05,8.75H0q1.89-8.13,3.78-16.27,3.5-14.91,7-29.8C12,10.52,13.31,5.26,14.57,0m0,0c6.34.13,23.68.66,30,1s12.59.42,18.85,1.19c5.38.66,14,4.42,12.84,19.25M32.21,13.45c-.71,3.62-1.33,6.81-2,10-.42,2.18-.38,2.34,1.81,2.42,5,.16,10.08.32,15.12.27,6.62-.05,8-4.72,7.52-8.67-.19-1.76-1-2.81-2.76-2.93C45.44,14.1,38.93,13.81,32.21,13.45Z" })));
};
const IconTeamRocket = React.memo(IconTeamRocketComponent);

const VSLogoComponent = (props) => {
    const { width, height, fill, fillAlt } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 373.34 533.77" },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: "radial-gradient-vs-logo", cx: "521.33", cy: "545.09", r: "194.93", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#2377ec" }),
                React.createElement("stop", { offset: "1", stopColor: "#1c47b7" })),
            React.createElement("linearGradient", { id: "VS_Gradient_Swatch", x1: "417.12", y1: "539.72", x2: "625.88", y2: "539.72", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#a59f10" }),
                React.createElement("stop", { offset: "0.52", stopColor: "#eded74" }),
                React.createElement("stop", { offset: "1", stopColor: "#c2b328" })),
            React.createElement("radialGradient", { id: "radial-gradient-vs-logo-2", cx: "644.24", cy: "610.91", r: "92.43", xlinkHref: "#radial-gradient-vs-logo" }),
            React.createElement("linearGradient", { id: "VS_Gradient_Swatch-2", x1: "561.59", y1: "609.08", x2: "726.93", y2: "609.08", xlinkHref: "#VS_Gradient_Swatch" }),
            React.createElement("linearGradient", { id: "VS_Gradient_Swatch-3", x1: "0", y1: "250.39", x2: "131.79", y2: "250.39", xlinkHref: "#VS_Gradient_Swatch" })),
        React.createElement("path", { d: "M493.57,288.08,421.62,376v19.06h9.18l83.44,404.79c.6,2.91,11.72,3,12.39.15l77.72-384.15,12.52,7.8,4.17-20.8s-30.28-35.5-34.63-41.36c-32.87-44.31-43.42-70.8-43.42-70.8l-4.8,37.82,6.43,13.4s0,15.58-1.59,25.19L517.16,559.66,488.53,361.37a44.77,44.77,0,0,1,6.94-31.14l1.24-1.88Z", transform: "translate(-353.58 -272.83)", strokeMiterlimit: "10", strokeWidth: "9", fill: fill || 'url(#radial-gradient-vs-logo)', stroke: fillAlt || 'url(#VS_Gradient_Swatch)' }),
        React.createElement("path", { d: "M567,711.48l8.54,1.32,5.23-13.45c10.69.91,20.76,3.57,43.39-3.47a56.21,56.21,0,0,0,10.64-5.3,61.34,61.34,0,0,0,9.27-7.82c12.27-11.71,19.44-33.26,19.93-62.25.11-6.17.21-17,.11-25.23l.31-3.9c.53-5.14,1.12-10,3.68-14.41l.22-.39a19.7,19.7,0,0,1,9.54-8.39h0a29.19,29.19,0,0,1,15.73-1.81l5.25.86c6.92,4.84,11.92,16.81,14.18,24.82h6.68c4.93-23,1.58-59.36,2.5-82.87l-7.51-3-5.42,12.13c-62.55-3-106.83,7.94-98.88,88.37-1.2,10.44,3.66,30.19-4.89,38.11-14.88,8.3-24.79,2.24-27.54-14.62l-6.89-.21s-.07,39.69-5,85.72", transform: "translate(-353.58 -272.83)", strokeMiterlimit: "10", strokeWidth: "9", fill: fill || 'url(#radial-gradient-vs-logo-2)', stroke: fillAlt || 'url(#VS_Gradient_Swatch-2)' }),
        React.createElement("polygon", { points: "58.52 298.47 52.74 270.36 11.29 285.64 49.7 250.96 46.41 229.06 70.89 235 120.43 205.03 89.92 241.86 116.33 251.75 79.17 261.62 58.52 298.47", fill: fill || '#0069b3', strokeMiterlimit: "10", strokeWidth: "5", stroke: fillAlt || 'url(#VS_Gradient_Swatch-3)' })));
};
const VSLogo = React.memo(VSLogoComponent);

const IconBaseExpansionComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: fill, d: "M54.46 34.88a19.75 19.75 0 0 1-19.75 19.75c-26.19-1-26.18-38.46 0-39.49a19.74 19.74 0 0 1 19.75 19.74Z" }),
                React.createElement("path", { fill: fill, d: "m8.1 51.9 57.52-27.99-4.57-8.76L3.8 43.07l4.3 8.83z" }),
                React.createElement("path", { d: "M66.09 36.21c0 17.33-14.05 30.05-31.38 30.05C-6.83 64.5-7 5.66 34.71 3.51 54.89 3.05 64.65 24.4 64.65 24.4", fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "7" }),
                React.createElement("path", { d: "M39.39 49h-6.13V28.71a21.92 21.92 0 0 1-7.91 4.07V27.9a18.49 18.49 0 0 0 5.21-2.61 10.17 10.17 0 0 0 3.86-4.48h5Z", fill: fillAlt })))));
};
const IconBaseExpansion = React.memo(IconBaseExpansionComponent);

const IconTownOnNoMapComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("g", { "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M54.46 34.88a19.75 19.75 0 0 1-19.75 19.75c-26.19-1-26.18-38.46 0-39.49a19.74 19.74 0 0 1 19.75 19.74Z" }),
                React.createElement("path", { fill: fill, d: "m8.1 51.9 57.52-27.99-4.57-8.76L3.8 43.07l4.3 8.83z" }),
                React.createElement("path", { d: "M66.09 36.21c0 17.33-14.05 30.05-31.38 30.05C-6.83 64.5-7 5.66 34.71 3.51 54.89 3.05 64.65 24.4 64.65 24.4", fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "7" }),
                React.createElement("path", { d: "M43.54 42.08v4.59h-17.9a11.6 11.6 0 0 1 1.74-4.93 33.19 33.19 0 0 1 5.75-6.17 35.68 35.68 0 0 0 4.23-4.22 5.28 5.28 0 0 0 1.06-3 3.38 3.38 0 0 0-.92-2.54 3.51 3.51 0 0 0-2.5-.91 3.47 3.47 0 0 0-2.54.93 4.7 4.7 0 0 0-1.09 3.1l-5.09-.5q.45-4.07 2.85-5.85a9.83 9.83 0 0 1 6-1.77 8.85 8.85 0 0 1 6.2 2.05A6.65 6.65 0 0 1 43.54 28a8.63 8.63 0 0 1-.64 3.31 13.19 13.19 0 0 1-2 3.29 32.55 32.55 0 0 1-3.34 3.29c-1.61 1.43-2.63 2.38-3.06 2.84a9.13 9.13 0 0 0-1.05 1.37Z", fill: fillAlt })))));
};
const IconTownOnNoMap = React.memo(IconTownOnNoMapComponent);

const IconWindFromTheSeaComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: fill, d: "M54.46 34.88a19.75 19.75 0 0 1-19.75 19.75c-26.19-1-26.18-38.46 0-39.49a19.74 19.74 0 0 1 19.75 19.74Z" }),
                React.createElement("path", { fill: fill, d: "m8.1 51.9 57.52-27.99-4.57-8.76L3.8 43.07l4.3 8.83z" }),
                React.createElement("path", { d: "M66.09 36.21c0 17.33-14.05 30.05-31.38 30.05C-6.83 64.5-7 5.66 34.71 3.51 54.89 3.05 64.65 24.4 64.65 24.4", fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "7" }),
                React.createElement("path", { d: "M25.33 40.87H31a3.91 3.91 0 0 0 1.4 2.62 3.71 3.71 0 0 0 5.33-.21A4.78 4.78 0 0 0 38.87 40a4.49 4.49 0 0 0-1.07-3.15 3.82 3.82 0 0 0-2.21-.85 8.64 8.64 0 0 0-2.27.19v-4.38a4.56 4.56 0 0 0 3.25-.93 3.28 3.28 0 0 0 1.13-2.61 2.85 2.85 0 0 0-3-3 3.2 3.2 0 0 0-2.3.94 4.42 4.42 0 0 0-1.16 2.73l-4.84-.06a15.36 15.36 0 0 1 1.6-4.82 6.91 6.91 0 0 1 2.85-2.34 9.6 9.6 0 0 1 4.08-.85 8.15 8.15 0 0 1 6.21 2.47A6.44 6.44 0 0 1 43 27.91c0 2.4-1.31 4.32-4 5.76a6.38 6.38 0 0 1 3.77 2.26 6.55 6.55 0 0 1 1.42 4.25 8.25 8.25 0 0 1-2.64 6.16 9.12 9.12 0 0 1-6.57 2.54 9.07 9.07 0 0 1-6.17-2.14 9.89 9.89 0 0 1-3.48-5.87Z", fill: fillAlt })))));
};
const IconWindFromTheSea = React.memo(IconWindFromTheSeaComponent);

const IconSplitEarthComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: fill, d: "M54.46 34.88a19.75 19.75 0 0 1-19.75 19.75c-26.19-1-26.18-38.46 0-39.49a19.74 19.74 0 0 1 19.75 19.74Z" }),
                React.createElement("path", { fill: fill, d: "m8.1 51.9 57.52-27.99-4.57-8.76L3.8 43.07l4.3 8.83z" }),
                React.createElement("path", { d: "M66.09 36.21c0 17.33-14.05 30.05-31.38 30.05C-6.83 64.5-7 5.66 34.71 3.51 54.89 3.05 64.65 24.4 64.65 24.4", fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "7" }),
                React.createElement("path", { d: "M35.15 48v-5.48H22.29v-4.61l13.63-17.42H41v17.4h3.9v4.63H41V48Zm0-10.15v-9.33l-7.22 9.37Z", fill: fillAlt })))));
};
const IconSplitEarth = React.memo(IconSplitEarthComponent);

const IconMysteriousMountainsComponent = (props) => {
    const { fill = '#000', fillAlt = '#fff' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 69.59 69.76" },
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("g", { "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M54.46 34.88a19.75 19.75 0 0 1-19.75 19.75c-26.19-1-26.18-38.46 0-39.49a19.74 19.74 0 0 1 19.75 19.74Z" }),
                React.createElement("path", { fill: fill, d: "m8.1 51.9 57.52-27.99-4.57-8.76L3.8 43.07l4.3 8.83z" }),
                React.createElement("path", { d: "M66.09 36.21c0 17.33-14.05 30.05-31.38 30.05C-6.83 64.5-7 5.66 34.71 3.51 54.89 3.05 64.65 24.4 64.65 24.4", fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "7" }),
                React.createElement("path", { d: "M24.52 41.52h5.31c.17 1.25 1.19 2 2 2.75a4.1 4.1 0 0 0 2.83 1.09 4 4 0 0 0 3.1-1.4A6.17 6.17 0 0 0 39 39.71a5.58 5.58 0 0 0-1.26-4 4.3 4.3 0 0 0-3.24-1.31 6.1 6.1 0 0 0-4.5 2.1l-5.15.1 3.4-15.77h15.46V26h-11v4.52a5.35 5.35 0 0 1 3.04-.52 9.07 9.07 0 0 1 6.61 2.67 9.38 9.38 0 0 1 2.7 7A10.07 10.07 0 0 1 42.88 46a9.9 9.9 0 0 1-8.27 3.82 10.67 10.67 0 0 1-6.9-2.14 9.54 9.54 0 0 1-3.19-6.16Z", fill: fillAlt })))));
};
const IconMysteriousMountains = React.memo(IconMysteriousMountainsComponent);

const IconWebComponent = (props) => {
    const { fill, fillAlt } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 143.48 144.15" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "a", x1: "92.71", x2: "141.48", y1: "75.63", y2: "75.63", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#3fac28" }),
                React.createElement("stop", { offset: ".48", stopColor: "#a8d820" }),
                React.createElement("stop", { offset: "1", stopColor: "#33ab1d" })),
            React.createElement("linearGradient", { id: "b", x1: "92.71", x2: "141.48", y1: "75.63", y2: "75.63", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: "#fbd820" }),
                React.createElement("stop", { offset: ".48", stopColor: "#dda50a" }),
                React.createElement("stop", { offset: "1", stopColor: "#b36f04" })),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "c", x1: "4.54", x2: "72.71", y1: "68.2", y2: "68.2" }),
            React.createElement("linearGradient", { xlinkHref: "#b", id: "d", x1: "0", x2: "76.83", y1: "72.08", y2: "72.08" }),
            React.createElement("linearGradient", { xlinkHref: "#a", id: "e", x1: "67.76", x2: "111.97", y1: "69.23", y2: "69.23" }),
            React.createElement("linearGradient", { xlinkHref: "#b", id: "f", x1: "63.76", x2: "115.97", y1: "69.23", y2: "69.23" })),
        React.createElement("path", { fill: "url(#a)", d: "m139.57 81.45-.71-1.39a28.844 28.844 0 0 0-9.26-10.57c-2.98-2.05-6-4.01-7.28-4.23l8.17-18.6-16.24-7.46-21.53 50.56 1.04 4.17c1.4 5.88 6.06 11.49 11.12 14.78 3.1 2.01 6.99 2.63 8.88 2.87l2.15.27c5.34.67 10.77-.36 15.46-3.02 2.93-1.66 3.98-2.97 6.64-6.85 2.04-2.97 3.21-6.46 3.38-10.06l.07-1.42c.16-3.31-.49-6.35-1.89-9.06Zm-16 18.8c-6.47 0-11.37-3.85-11.37-11.5 0-6.44 6.08-10.38 11.78-10.47 7.99-.13 10.93 4.78 11.05 12.59.07 4.24-4.24 9.38-11.45 9.38Z" }),
        React.createElement("path", { fill: "none", stroke: "url(#b)", "stroke-miterlimit": "10", "stroke-width": "4", d: "m139.57 81.45-.71-1.39a28.844 28.844 0 0 0-9.26-10.57c-2.98-2.05-6-4.01-7.28-4.23l8.17-18.6-16.24-7.46-21.53 50.56 1.04 4.17c1.4 5.88 6.06 11.49 11.12 14.78 3.1 2.01 6.99 2.63 8.88 2.87l2.15.27c5.34.67 10.77-.36 15.46-3.02 2.93-1.66 3.98-2.97 6.64-6.85 2.04-2.97 3.21-6.46 3.38-10.06l.07-1.42c.16-3.31-.49-6.35-1.89-9.06Zm-16 18.8c-6.47 0-11.37-3.85-11.37-11.5 0-6.44 6.08-10.38 11.78-10.47 7.99-.13 10.93 4.78 11.05 12.59.07 4.24-4.24 9.38-11.45 9.38Z" }),
        React.createElement("path", { fill: "url(#c)", d: "m4.54 52.57 33.22 63.45.85-37.93 28.45 51.75 5.65-115.22-14.96-8.07-2.99 70.26-23.29-46.48-2.35 42.38-18.03-32.08-6.55 11.94z" }),
        React.createElement("path", { fill: "url(#d)", d: "m57.75 6.55 14.97 8.07-5.65 115.22-28.45-51.75-.85 37.93L4.54 52.57l6.56-11.94 18.03 32.08 2.34-42.38 23.3 46.48 2.98-70.25M54.02.01l-.27 6.38-2.33 54.83-16.38-32.68-6.74-13.45-.83 15.02-1.58 28.68-11.31-20.12-3.53-6.28-3.47 6.31-6.56 11.94-1.03 1.88.99 1.9 33.22 63.45 7.2 13.74.35-15.51.51-23.05 21.28 38.7 6.81 12.38.69-14.11L76.69 14.8l.12-2.52-2.22-1.2-14.97-8.07L54-.02Z" }),
        React.createElement("path", { fill: "url(#e)", d: "m85.78 76.1 26.2-11.71c-11.94-25.53-46.13-21.2-44.12 9.07C69.26 87.91 84.98 92.8 97.79 90l-3-7.46-7.72-.1c-7.04-.32-12.34-8.07-10.95-14.79 3.58-11.74 14.6-18.84 24.3-8.01-5.78 1.81-13.27 6.23-18.88 8.56l4.24 7.9Z" }),
        React.createElement("path", { fill: "url(#f)", d: "M88.25 47.7c8.89 0 18.46 5.45 23.72 16.69L85.77 76.1l-4.24-7.9c5.61-2.33 13.09-6.75 18.88-8.56-3.36-3.75-6.88-5.35-10.19-5.35-6.25 0-11.77 5.69-14.11 13.36-1.39 6.72 3.91 14.47 10.95 14.79l7.72.1 3 7.46c-2.28.5-4.66.75-7.03.75-10.93 0-21.75-5.41-22.9-17.29-1.12-16.95 9.09-25.76 20.4-25.76m0-4c-6.77 0-12.96 2.63-17.42 7.4-3.61 3.86-7.75 10.91-6.97 22.63v.12c1.4 14.44 14.5 20.91 26.88 20.91 2.66 0 5.32-.28 7.88-.85 1.15-.25 2.13-1 2.68-2.04s.61-2.27.18-3.36l-3-7.46a4 4 0 0 0-3.66-2.51l-4.58-.06 23.35-10.44a3.993 3.993 0 0 0 1.99-5.35c-5.48-11.72-15.96-18.99-27.34-19v4-4Zm-5.78 19.7c2.13-3.16 4.95-5.12 7.75-5.12.71 0 1.39.12 2.05.34-1.73.81-3.47 1.67-5.19 2.53-1.61.8-3.16 1.57-4.61 2.25Z" })));
};
const IconWeb = React.memo(IconWebComponent);

const IconTPromotionalCardsComponent = (props) => {
    const { fill = '#fff', stroke = '#000', strokeWidth = '3' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 71.44 72.6" },
        React.createElement("g", { stroke: stroke, strokeMiterlimit: "10", strokeWidth: strokeWidth },
            React.createElement("path", { fill: fill, d: "M33.83 65.16s-6.47-1.74-15.34-.16c-5.27.94-11.98 3.25-16.99 5.27V11.68c9.97-4.4 22.36-7.33 32.33-2.92v56.41ZM34.97 8.75c10.78-4.4 24.18-1.48 34.97 2.92v58.59c-5.41-2.01-12.67-4.33-18.37-5.27-9.6-1.58-16.59.16-16.59.16V8.75Z" }),
            React.createElement("rect", { width: "43.4", height: "58.2", x: "14.18", y: "7.2", fill: fill, rx: "2", ry: "2", transform: "rotate(24.24 35.88 36.308)" }),
            React.createElement("circle", { cx: "36.42", cy: "36.19", r: "13.29", fill: fill }),
            React.createElement("circle", { cx: "36.42", cy: "36.19", r: "4.8", fill: fill }),
            React.createElement("path", { fill: "none", d: "m31.61 36.27-8.48.14M41.22 36.11l8.48-.14" }))));
};
const IconTPromotionalCards = React.memo(IconTPromotionalCardsComponent);

const IconVendingComponent = (props) => {
    const { fill = '#fff', stroke = '#000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 73.81 73.81" },
        React.createElement("circle", { cx: "36.91", cy: "36.91", r: "36.91" }),
        React.createElement("circle", { cx: "20.77", cy: "32.82", r: "8.97", fill: fill }),
        React.createElement("circle", { cx: "20.77", cy: "32.82", r: "5.65", fill: fill, stroke: stroke, strokeMiterlimit: "10" }),
        React.createElement("path", { fill: fill, d: "M18.54 22c-.5.28-1.01 0-1.45.36-.71.2-1.75.41-2.45 1-2.49 1.97-3.64 2.3-5.33-.79-2.48-7.83 10.67-16 17.04-18.51.14-.04.36.09.4-.19.09-.09.65.1.68-.2.14-.14.63.09.68-.24.16-.09.46-.04.66-.05.37-.18.48-.29.92-.23.29-.21.59-.25.95-.23.49-.39 1.11-.06 1.55-.45 3.15-.45 6.31-.51 9.58-.23 0 .03-.01.06-.02.09.44.23.93.13 1.41.14 0 .03-.01.06-.02.08.35.23.77.13 1.16.14q.09.21.91.23c12.5 2.86 23.18 14.26 25.22 26.97.52 3.99.72 8.45-.45 12.35-.02.21.02.47-.02.65-.42.33-.27 1.44-.59 1.91-.27.8-.29 1.92-1.29 2.2 0 .03.01.05.02.08-1.58-.28-3.47-.03-4.79-.62-.38-.27-1.16.22-1.39-.26-.29-.16-.72.17-.95-.24-.04-.08-.34-.02-.52-.03-.32.03-.52-.36-1.06-.23-.35-.31-.71-.22-1.21-.23-.14 0-.34.09-.37-.18-.26-.13-.66.08-.89-.18-.4-.21-.77.02-1.1-.33-3.12-.62-6.23-1.73-9.21-2.97-3.87-1.12-7.7-2.44-11.46-3.89-.79-.12-2.07-.39-2.25-1.24-.03-2.18.17-4.38-.46-6.26-1.62-5.92-7.95-9.3-13.91-8.51V22ZM52.75 47.17c.27.3.85-.08.98.28.2.16.58.05.84.08.22.47.64.1.95.27.07.38.62.11.92.19.11.49.94.12 1.34.23 0 .03-.02.05-.02.08 1.4.33 2.61.88 4.13.84 1.03.69 2.31.39 3.6.46-.53.88-1.49.83-2.24.46-.78-.06-1.62.18-2.23-.23-.69-.03-1.32.11-1.86-.23-.62-.12-1.61.24-2.04-.16-.37-.28-1.18.22-1.38-.26-.35-.07-.76-.01-1.07-.27-3.64-.7-7.11-1.83-10.57-3.43-4.44-1.23-8.65-3-13.06-4.41.06-.43.31-.78.6-1.18 1.92.98 4.35 1.48 6.46 2.37 1.29.42 2.58.73 3.79 1.32 1.16-.06 1.91 1.12 3.08.95l-.03.11c2.65.66 5.14 1.91 7.81 2.43v.1ZM9.58 28.65c-.13.12-.24.23-.33.31-1.25-.6-1.95-1.75-2.71-2.92 1.43-.1 1.9 1.92 3.04 2.61Z" })));
};
const IconVending = React.memo(IconVendingComponent);

const IconGBPromoComponent = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 93.19 61.98" },
        React.createElement("path", { fill: fill, d: "M1.62 22.13C7.1 5.52 19.64-.7 33.98.06c4.3.23 16 4.7 16.42 15.06H37.27c.77-3.83-1.81-5.71-6.23-5.71-6.53 0-12.86 3.89-17 12.71-4.14 8.82-1.42 12.71 5.95 12.71 4.56 0 10.67-2.27 12.54-6.94h-8.3l4.07-8.37h20.45L38.19 44.91H27.77l1.54-5.48c-3.51 2.61-7.56 6.09-16.55 5.38-9.34-.73-15.96-8.08-11.14-22.7ZM40.78 61.98l18.03-42.43 24.38.11c11.3 2.15 10.86 7.19 8.96 11.78-2.19 5.31-5.06 6.9-9.81 8.61 4.09 1.39 6.29 4.17 3.63 9.41-5.29 10.43-13.78 12.51-26.63 12.51H40.78Zm13.98-9.16h9.39c5.2 0 8.46-1.58 9.86-4.3 1.65-3.29-.06-4.68-5.33-4.68h-9.32l-4.6 8.97Zm8.26-16.18h9.6c3.4 0 6.54-1.45 8.07-4.36 1.51-2.84-.46-4.11-3.78-4.11H67.3l-4.29 8.47Z" })));
};
const IconGBPromo = React.memo(IconGBPromoComponent);

const IconSnapComponent = (props) => {
    const { fill = '#fff', fillAlt = '#000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 106.23 78.68" },
        React.createElement("path", { fill: fill, stroke: fillAlt, strokeMiterlimit: "10", strokeWidth: "2", d: "M86.23 77.68H2.5c-.83 0-1.5-.67-1.5-1.5V19.71c0-.83.67-1.5 1.5-1.5h64.15l-3.8-8.86 13.16 5.43 5.04-12.26 5.42 12.05 10.95-5.48-3.84 11.7 11.62 5.22c.83 0-11.66 5.31-11.66 5.31l6.13 13.63-11.94-6.02v37.24c0 .83-.67 1.5-1.5 1.5Z" }),
        React.createElement("path", { d: "M5.6 25.96v45.62c0 .83.67 1.5 1.5 1.5h74.54c.83 0 1.5-.67 1.5-1.5V23.65c0-.83-.67-1.5-1.5-1.5H27.19c-.55 0-1.05.3-1.31.78l-.42.78c-.26.48-.77.78-1.32.78l-17.03-.04c-.83 0-1.5.67-1.5 1.5Z" }),
        React.createElement("path", { fill: fill, d: "M76.63 26.35H29.22c-.51 0-.98.26-1.26.68l-3.58 5.53c-.28.43-.75.68-1.26.68H10.68l-.44.76c-.41.69-.44 1.54-.09 2.26l.44.92c.32.67 1.01 1.1 1.75 1.1h64.28c.41 0 .75-.34.75-.75V27.09c0-.41-.34-.75-.75-.75Z" }),
        React.createElement("path", { stroke: "#fff", strokeMiterlimit: "10", strokeWidth: "3", d: "M44.44 31.49c-8.85 0-16.04 7.18-16.04 16.04s7.18 16.04 16.04 16.04 16.03-7.18 16.03-16.04-7.17-16.04-16.03-16.04Zm0 25.29c-5.11 0-9.25-4.14-9.25-9.25s4.14-9.25 9.25-9.25 9.25 4.14 9.25 9.25-4.14 9.25-9.25 9.25Z" }),
        React.createElement("path", { fill: fill, d: "M66.81 34.81a2.5 2.5 0 0 1 0-5h5.81a2.5 2.5 0 0 1 0 5h-5.81Z" }),
        React.createElement("path", { d: "M72.62 30.82c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5.81c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h5.81m0-2h-5.81c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h5.81c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5Z" }),
        React.createElement("circle", { cx: "72.77", cy: "32.32", r: "1.5" })));
};
const IconSnap = React.memo(IconSnapComponent);

const IconE3Component = (props) => {
    const { fill } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72.65 67.24" },
        React.createElement("path", { fill: fill, d: "M58.19 16.45a8.48 8.48 0 0 0 2.69-.64c.83-.35 1.51-.86 2.05-1.52.54-.67.8-1.55.8-2.66 0-1.66-.55-2.94-1.66-3.82-1.11-.89-2.38-1.33-3.82-1.33-1.99 0-3.5.66-4.51 1.97-1.02 1.31-1.5 2.96-1.47 4.96h-7.48c.07-1.99.43-3.81 1.08-5.46.65-1.64 1.55-3.06 2.71-4.24 1.16-1.18 2.56-2.1 4.18-2.74C54.38.32 56.19 0 58.19 0c1.55 0 3.1.23 4.65.69 1.55.46 2.94 1.15 4.18 2.08 1.24.92 2.24 2.05 3.02 3.38.78 1.33 1.16 2.86 1.16 4.6 0 1.88-.45 3.54-1.36 4.98-.91 1.44-2.26 2.42-4.07 2.94v.11c2.14.48 3.82 1.51 5.04 3.1 1.22 1.59 1.83 3.49 1.83 5.71 0 2.03-.4 3.84-1.19 5.43-.79 1.59-1.86 2.92-3.19 3.99-1.33 1.07-2.86 1.88-4.6 2.44-1.74.55-3.54.83-5.43.83-2.18 0-4.16-.31-5.95-.94-1.79-.63-3.32-1.54-4.57-2.74-1.26-1.2-2.22-2.67-2.91-4.4-.68-1.74-1.01-3.73-.97-5.98h7.48c.04 1.03.2 2.02.5 2.96.29.94.72 1.75 1.27 2.44.55.68 1.25 1.23 2.08 1.63.83.41 1.82.61 2.96.61 1.77 0 3.27-.54 4.49-1.63 1.22-1.09 1.83-2.58 1.83-4.46 0-1.48-.29-2.6-.86-3.38s-1.3-1.34-2.19-1.69c-.89-.35-1.86-.55-2.91-.61-1.05-.06-2.06-.08-3.02-.08v-5.54c.85.07 1.75.07 2.71 0ZM0 67.24V14.53h39.08v8.92H10.64v11.68H37.1v8.88H10.64v14.34h29.44v8.88H0Z" })));
};
const IconE3 = React.memo(IconE3Component);

const CardSetSymbolComponent = (props) => {
    const { fill, fillAlt, isCardCreatorMode, setSymbol, stroke, strokeWidth } = props;
    const setSymbolClassNames = classNames({
        'set-symbol': true,
        [`set-symbol--${setSymbol}`]: setSymbol,
    });
    const getSetSymbol = () => {
        if (setSymbol) {
            switch (setSymbol) {
                case pokemonCardLibrary.CARD_SETS.AQUAPOLIS.value:
                    return (React.createElement(IconAquapolis, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.AQUAPOLIS_1.value:
                    return (React.createElement(IconTownOnNoMap, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.AQUAPOLIS_2.value:
                    return (React.createElement(IconWindFromTheSea, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.BASE.value:
                case pokemonCardLibrary.CARD_SETS_JPN.BASE.value:
                    return !isCardCreatorMode ? React.createElement(IconPokeBall, { fill: fill }) : undefined;
                case pokemonCardLibrary.CARD_SETS.BASE_2.value:
                    return (React.createElement(IconBase2, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.BEST_OF_GAME.value:
                    return (React.createElement(IconBestOfGame, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.BLACK_STAR_PROMO.value:
                case pokemonCardLibrary.CARD_SETS_JPN.P_PROMOTIONAL_CARDS.value:
                    return (React.createElement(IconBlackStarPromo, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.EXPEDITION.value:
                    return React.createElement(IconExpedition, { fill: fill });
                case pokemonCardLibrary.CARD_SETS_JPN.EXPEDITION.value:
                    return (React.createElement(IconBaseExpansion, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.FOSSIL.value:
                case pokemonCardLibrary.CARD_SETS_JPN.FOSSIL.value:
                    return React.createElement(IconFossil, { fill: fill });
                case 'gym-challenge':
                    return (React.createElement(IconGymChallenge, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.GYM_HEROES.value:
                    return React.createElement(IconGymHeroes, null);
                case pokemonCardLibrary.CARD_SETS_JPN.GYM_HEROES.value:
                case pokemonCardLibrary.CARD_SETS_JPN.GYM_CHALLENGE.value:
                    return React.createElement(IconGymLeaders, null);
                case pokemonCardLibrary.CARD_SETS.JUNGLE.value:
                case pokemonCardLibrary.CARD_SETS_JPN.JUNGLE.value:
                    return (React.createElement(IconJungle, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.LEGENDARY_COLLECTION.value:
                    return (React.createElement(IconLegendaryCollection, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.NEO_DESTINY.value:
                case pokemonCardLibrary.CARD_SETS_JPN.NEO_DESTINY.value:
                    return (React.createElement(IconNeoDestiny, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.NEO_DISCOVERY.value:
                case pokemonCardLibrary.CARD_SETS_JPN.NEO_DISCOVERY.value:
                case 'premium-file-2':
                    return React.createElement(IconNeoDiscovery, null);
                case pokemonCardLibrary.CARD_SETS.NEO_GENESIS.value:
                case pokemonCardLibrary.CARD_SETS_JPN.NEO_GENESIS.value:
                case 'premium-file':
                    return React.createElement(IconNeoGenesis, null);
                case pokemonCardLibrary.CARD_SETS.NEO_REVELATION.value:
                case pokemonCardLibrary.CARD_SETS_JPN.NEO_REVELATION.value:
                case 'premium-file-3':
                    return (React.createElement(IconNeoRevelation, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.SKYRIDGE.value:
                    return (React.createElement(IconSkyridge, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.SKYRIDGE_1.value:
                    return (React.createElement(IconSplitEarth, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.SKYRIDGE_2.value:
                    return (React.createElement(IconMysteriousMountains, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.SOUTHERN_ISLANDS.value:
                case pokemonCardLibrary.CARD_SETS_JPN.SOUTHERN_ISLANDS.value:
                    return (React.createElement(IconSouthernIslands, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS.TEAM_ROCKET.value:
                case pokemonCardLibrary.CARD_SETS_JPN.TEAM_ROCKET.value:
                    return (React.createElement(IconTeamRocket, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.VS.value:
                    return (React.createElement(VSLogo, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.WEB.value:
                    return (React.createElement(IconWeb, { fill: fill, fillAlt: fillAlt, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.T_PROMOTIONAL_CARDS.value:
                    return (React.createElement(IconTPromotionalCards, { fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                case pokemonCardLibrary.CARD_SETS_JPN.VENDING.value:
                    return React.createElement(IconVending, { fill: fill, stroke: stroke });
                case pokemonCardLibrary.CARD_SETS_JPN.GB_PROMO.value:
                    return React.createElement(IconGBPromo, { fill: fill });
                case 'mcdonalds':
                    return React.createElement(IconMcdonalds, { fill: fill, fillAlt: fillAlt });
                case 'snap':
                    return React.createElement(IconSnap, { fill: fill, fillAlt: fillAlt });
                case 'e3':
                    return React.createElement(IconE3, { fill: fill, fillAlt: fillAlt });
            }
        }
    };
    return React.createElement("div", { className: setSymbolClassNames }, getSetSymbol());
};
const CardSetSymbol = React.memo(CardSetSymbolComponent);

const CardStatsBarComponent = (props) => {
    const { eReaderId, hasShadow, lengthFeet, lengthLabel, lengthInches, measurementSystem, typeLabel, weight, weightLabel, } = props;
    const statsBarClassNames = classNames({
        'card-stats-bar': true,
        'card-stats-bar--shadowed': hasShadow,
    });
    const isStandardUnits = measurementSystem === 'standard';
    const weightUnit = isStandardUnits ? 'lbs.' : 'kg.';
    const getLengthLabel = () => {
        let lengthString = '';
        if (lengthFeet || lengthFeet === 0) {
            lengthString += `${lengthLabel}: `;
            if (isStandardUnits) {
                lengthString += `${lengthFeet}'`;
            }
            else {
                lengthString += `${lengthFeet},`;
            }
        }
        if (lengthInches || lengthInches === 0) {
            if (isStandardUnits) {
                lengthString += `${lengthInches}"`;
            }
            else {
                lengthString += `${lengthInches}m`;
            }
        }
        return lengthString;
    };
    const finalLengthLabel = getLengthLabel();
    return (React.createElement("div", { className: statsBarClassNames },
        React.createElement("span", { className: "card-stats-bar-text" },
            typeLabel,
            " ",
            finalLengthLabel,
            weight
                ? `, ${weightLabel}: ${weight.toLocaleString()} ${weightUnit}`
                : undefined,
            (finalLengthLabel || weight) && eReaderId ? ', ' : undefined,
            eReaderId ? `ID: ${eReaderId}` : undefined)));
};
const CardStatsBar = React.memo(CardStatsBarComponent);

const FirstEditionStampJpnComponent = (props) => {
    const { fill = '#000000', height = DEFAULT_FIRST_EDITION_ICON_SIZE, width = DEFAULT_FIRST_EDITION_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 85.37 71.53", height: height, width: width },
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("g", { "data-name": "Layer 1" },
                React.createElement("path", { fill: fill, d: "M10.25 62.32H0V48h10.25v2.8H3.63v2.46h6.14V56H3.63v3.53h6.62ZM26.91 55.19a7 7 0 0 1-.91 3.58 6.66 6.66 0 0 1-2.28 2.42 7.07 7.07 0 0 1-2.28.88 14.68 14.68 0 0 1-2.93.25h-5V48h5.14a13 13 0 0 1 3 .3 6.75 6.75 0 0 1 2.12.83 6.58 6.58 0 0 1 2.31 2.43 7.37 7.37 0 0 1 .83 3.63Zm-3.78 0a5.26 5.26 0 0 0-.51-2.41 3.57 3.57 0 0 0-1.62-1.6 4.37 4.37 0 0 0-1.14-.38 12.36 12.36 0 0 0-1.77-.1h-.92v8.94h.92a10.82 10.82 0 0 0 1.91-.12 4.05 4.05 0 0 0 1.19-.43 3.57 3.57 0 0 0 1.47-1.54 5.5 5.5 0 0 0 .47-2.39ZM47.33 50.8h-4.18v11.52h-3.46V50.8h-4.18V48h11.82ZM69.9 55.18a7.76 7.76 0 0 1-1.83 5.43 6.55 6.55 0 0 1-5.08 2 6.5 6.5 0 0 1-5.06-2 7.72 7.72 0 0 1-1.84-5.43 7.71 7.71 0 0 1 1.84-5.44 6.5 6.5 0 0 1 5.06-2 6.53 6.53 0 0 1 5.07 2 7.71 7.71 0 0 1 1.84 5.44Zm-4.58 3.62a4.34 4.34 0 0 0 .75-1.54 8.06 8.06 0 0 0 .24-2.09A7.42 7.42 0 0 0 66 53a4.18 4.18 0 0 0-.72-1.45 2.71 2.71 0 0 0-1.06-.84 3.18 3.18 0 0 0-1.22-.28 3.14 3.14 0 0 0-1.23.25 2.86 2.86 0 0 0-1.07.83A4 4 0 0 0 60 53a7.59 7.59 0 0 0-.29 2.19 7.19 7.19 0 0 0 .29 2.16 4.39 4.39 0 0 0 .72 1.47 2.77 2.77 0 0 0 1 .83 3.12 3.12 0 0 0 1.27.27 3 3 0 0 0 1.27-.27 2.82 2.82 0 0 0 1.06-.85ZM84.87 62.32h-3.33l-5.69-9.81v9.81h-3.17V48h4.13l4.89 8.19V48h3.17ZM29.53 48.03h3.83v14.28h-3.83zM49.72 48.03h3.83v14.28h-3.83zM0 66.09l1.69 5.44H83.3l2.06-5.44H0zM22.92 44.78l1.97-5.44H1.88L0 44.78h22.92zM61.61 44.78l-1.99-5.44h23.3l1.9 5.44H61.61zM26.13 3.1s8.63-.33 13.87-.9A89.43 89.43 0 0 0 51.41 0l-.33 35.6s.05 2.3 1.59 2.81a33.68 33.68 0 0 0 4.55.93l2.4 5.44H24.89l2.22-5.44s5 .06 6.33-1.35a8.17 8.17 0 0 0 1.78-3.14s1.25-26.73-1.34-28.09-8-1.74-8-1.74Z" })))));
};
const FirstEditionStampJpn = React.memo(FirstEditionStampJpnComponent);

const EnergyHeadingESeriesComponent = (props) => {
    const { fill = '#000000' } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 263.8 45.57" },
        React.createElement("g", { fill: "none", stroke: fill, strokeMiterlimit: "10", strokeWidth: "1" },
            React.createElement("path", { d: "M34.52 2.33v8.55H14.94c-3.6 0-4.72 1.18-4.72 4.78v2.59h24.29v8.61H10.23v3.07c0 3.6 1.12 4.72 4.72 4.72h19.57v8.61H14.29c-9.26 0-12.79-3.6-12.79-12.85V15.14c0-9.28 3.54-12.81 12.79-12.81h20.22ZM67.7 32.63c.48 1.89.91 2.83 2.3 2.83 1.28 0 1.98-.88 1.98-2.59V2.33h7.92v31.54c0 6.43-3.64 10.2-9.69 10.2s-8.46-2.95-10.12-9.43l-5.57-21.7c-.48-1.89-.91-2.83-2.3-2.83-1.28 0-1.98.82-1.98 2.54v30.6h-7.92V11.64c0-6.43 3.64-10.14 9.69-10.14s8.46 2.95 10.12 9.43l5.57 21.7ZM120.81 2.33v8.55h-19.57c-3.6 0-4.72 1.18-4.72 4.78v2.59h24.29v8.61H96.52v3.07c0 3.6 1.12 4.72 4.72 4.72h19.57v8.61h-20.22c-9.26 0-12.79-3.6-12.79-12.85V15.14c0-9.26 3.54-12.79 12.79-12.79h20.22ZM139.92 25.56l3.89-4.52c.8-.93 1.94-1.52 3.17-1.62l5.35-.46c2.97 0 4.52-1.12 4.52-2.95v-2.18c0-1.83-1.55-2.95-4.52-2.95h-14.79v32.37h-9.56V2.33h24.74c9.24 0 13.7 2.77 13.7 9.02v3.24c0 2.3-.22 8.05-3.53 10.16-3.49 2.22-10.13.76-12.18 1.34 2.46.88 7.38 7.39 7.38 7.39l8.72 9.77h-12.58M209.49 2.33v8.55h-21.32c-2.83 0-5.13 2.19-5.13 4.89v13.97c0 2.7 2.3 4.89 5.13 4.89h13.9v-6.78h-3.95V19.3h13.09v17.22c0 3.71-3.15 6.71-7.04 6.71H187.3c-7.4 0-13.41-5.73-13.41-12.79V15.11c0-9.44 3.43-12.79 13.41-12.79h22.18ZM232.54 42.97v-17.1L215.21 2.43h13.27l9.54 13.81 9.58-13.81h13.23L243.5 25.89v17.09h-10.95ZM138.39 24.82l17.06 18.89" }))));
};
const EnergyHeadingESeries = React.memo(EnergyHeadingESeriesComponent);

const CardHeaderESeriesEnergyComponent = (props) => {
    const { energyType } = props;
    return (React.createElement("div", { className: "card-header--e-series card-header--e-series--energy" },
        React.createElement("div", { className: "trainer-energy__heading" },
            React.createElement("div", { className: "trainer-energy-title" },
                React.createElement(EnergyHeadingESeries, null)),
            React.createElement("div", { className: "trainer-energy-pill" },
                React.createElement(EnergySymbol, { type: energyType })))));
};
const CardHeaderESeriesEnergy = React.memo(CardHeaderESeriesEnergyComponent);

const getLabel = (label, language = DEFAULT_LANGUAGE) => {
    return pokemonCardLibrary.CARD_LABELS[language][label];
};
const getStageLabel = (stage, language = DEFAULT_LANGUAGE) => {
    if (!stage)
        return '';
    const stageLabel = getLabel('stage', language);
    return stageLabel.replace('<STAGENUM>', stage.toString());
};
const getPutBabyLabel = (name, language = DEFAULT_LANGUAGE) => {
    if (!name)
        return '';
    const putBabyLabel = getLabel('putBaby', language);
    return putBabyLabel.replace('<PKMN>', name);
};
const getStagePokemonLabel = (stage, language = DEFAULT_LANGUAGE) => {
    if (!stage)
        return '';
    const stageLabel = getLabel('stagePokemon', language);
    return stageLabel.replace('<STAGENUM>', stage.toString());
};
const getEvolvesFromLabel = (evolvesFrom, language = DEFAULT_LANGUAGE) => {
    const evolvesFromLabel = getLabel('evolvesFrom', language);
    return `${evolvesFromLabel} ${evolvesFrom}`;
};
const getEvolvesToLabel = (evolvesTo, language = DEFAULT_LANGUAGE) => {
    const evolvesToLabel = getLabel('evolvesTo', language);
    return `${evolvesToLabel} ${evolvesTo}`;
};
const getPutLabel = (name, stage, language = DEFAULT_LANGUAGE) => {
    const basicLabel = getLabel('basic', language);
    const putLabel = getLabel('put', language);
    const stageCardLabel = getLabel('stageCard', language);
    const putLabelWithName = putLabel.replace('<PKMN>', name);
    if (!isBasic(stage)) {
        if (Number(stage) === 1) {
            return `${putLabelWithName} ${basicLabel}`;
        }
        else if (Number(stage) > 1) {
            const prevStage = Number(stage) - 1;
            const stageLabelWithStage = stageCardLabel.replace('<STAGENUM>', prevStage.toString());
            return `${putLabelWithName} ${stageLabelWithStage}`;
        }
    }
};
const getHitPointsLabel = (hitPoints, language = DEFAULT_LANGUAGE) => {
    if (!hitPoints)
        return '';
    const hitPointsLabel = getLabel('hp', language);
    return hitPointsLabel.replace('<HP>', hitPoints.toString());
};
const getShiningRuleLabel = (name, language = DEFAULT_LANGUAGE) => {
    if (!name)
        return '';
    const shiningRuleLabel = getLabel('shiningRule', language);
    return shiningRuleLabel.replace('<PKMN>', name);
};
const getTypeLabel = (type, language = DEFAULT_LANGUAGE) => {
    if (!type)
        return '';
    const typeLabel = getLabel('pokemonType', language);
    return typeLabel.replace('<TYPE>', type);
};

const CardComponent = React.forwardRef((props, ref) => {
    const { babyDescription, backgroundColor, backgroundImageBlendMode, backgroundImageOpacity = 1, backgroundImagePositionX, backgroundImagePositionY, backgroundImageUrl, cardTemplate = DEFAULT_CARD_TEMPLATE, cardTemplateSubtype, className, copyright, creatureImageBlendMode, description, dotMatrixVariant, energyResistance, energyRetreatCost, energyType = DEFAULT_CARD_ENERGY_TYPE, energyWeakness, eReaderId, evolutionBoxBackgroundImageSize, evolutionBoxBackgroundVariant, evolutionBoxImageUrl, evolvesFrom, evolvesTo, firstEdition, frameMode, hasStatsBarShadow, hitPoints, holo, holoBlendMode = DEFAULT_HOLO_BLEND_MODE, holoSheetType = DEFAULT_HOLO_SHEET_TYPE, holoStrength = DEFAULT_HOLO_STRENGTH, id, illustrator, isBoldName, isDoubleEnergyType, isEditable, isFlippable, isFlipped, isFullReverseHolo, isHoloAnimation, isLoading, language = 'en', lengthFeet, lengthInches, loadingLabel = 'Loading Card Data...', moves, name, nameCondenseLevel, onClick, onHpChange, onNameChange, pokemonImagePositionX = 50, pokemonImagePositionY = 50, pokemonImageRotation, pokemonImageShadowColor = '#000', pokemonImageShadowOffsetX, pokemonImageShadowOffsetY, pokemonImageShadowSize = DEFAULT_SHADOW_SIZE, pokemonImageSize = 50, pokemonImageUrl, pokemonLevel, pokemonNumber, pokemonType, randomizeHoloSheetPosition, rarity, reverseHoloSheetType = DEFAULT_REVERSE_HOLO_SHEET_TYPE, setNumber, setSymbol, setTotal, shadowless, size = CARD_SIZES.LARGE, specialTemplateType, stage, stamp, subtitle, trainerImageUrl, trainerRule, unownLetter, weight, } = props;
    const cardWrapperClassNames = classNames({
        'card-wrapper': true,
        'card-wrapper--small': size === CARD_SIZES.SMALL,
        [`${className}`]: className,
    });
    const baseClassName = 'pkmn-card';
    const cardClassNames = classNames({
        [`${baseClassName}`]: true,
        [`${baseClassName}--shadowless`]: shadowless,
        [`${baseClassName}--${frameMode}`]: frameMode,
        [`${baseClassName}--${cardTemplate}`]: cardTemplate,
        [`${baseClassName}--${pokemonCardLibrary.CARD_TEMPLATES.E_SERIES}`]: isESeriesTemplate(cardTemplate),
        [`${baseClassName}--energy-type-${energyType}`]: energyType && !isTrainerTemplate(cardTemplate),
        [`${baseClassName}--flippable`]: isFlippable,
        [`${baseClassName}--flipped`]: isFlipped,
        [`${baseClassName}--holo`]: !!holo,
        [`${baseClassName}--holo--reverse`]: holo && holo === 'reverse',
        [`${baseClassName}--holo--full`]: isFullReverseHolo,
        [`${baseClassName}--has-description`]: description,
        [`${baseClassName}--energy`]: isEnergyTemplate(cardTemplate),
        [`${baseClassName}--trainer`]: isTrainerTemplate(cardTemplate),
        [`${baseClassName}--trainer-e-series`]: isESeriesTrainerTemplate(cardTemplate),
        [`${baseClassName}--energy-e-series`]: isESeriesEnergyTemplate(cardTemplate),
        [`${baseClassName}--${cardTemplateSubtype}`]: cardTemplateSubtype,
        [`${baseClassName}--${specialTemplateType}`]: specialTemplateType,
    });
    const mainInfoClassNames = classNames({
        'card-header-name-bar': true,
        'card-header-name-bar--stage': !isShiningBabyUnownSubtype(cardTemplateSubtype) && !isBasic(stage),
    });
    const cardSetSymbolClassNames = classNames({
        'card-set-symbol': true,
        'card-set-symbol--first-edition': firstEdition,
        'small-frame': moves && moves.length > 2,
    });
    const cardBodyClassNames = classNames({
        'card-body': true,
    });
    const cardBodyInnerClassNames = classNames({
        'card-body__inner': true,
    });
    const firstEditionStampClassNames = classNames({
        'first-edition-stamp': true,
        'small-frame': moves && moves.length > 2,
    });
    const getCardFrameSize = () => {
        return moves && moves.length > 2 ? FRAME_SIZES.SMALL : undefined;
    };
    const getCardLogoIcon = () => {
        if (!cardTemplate)
            return;
        switch (cardTemplate) {
            case pokemonCardLibrary.CARD_TEMPLATES.VS:
            case pokemonCardLibrary.CARD_TEMPLATES.TRAINER_VS:
            case pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS:
                return React.createElement(VSLogo, null);
            case pokemonCardLibrary.CARD_TEMPLATES.WEB:
                return React.createElement(IconWeb, null);
        }
    };
    const getMoves = () => {
        if (moves && moves.length) {
            if (isBabySubtype(cardTemplateSubtype)) {
                return [moves[0]];
            }
            else {
                return moves;
            }
        }
        return [];
    };
    const showReverseHoloSheet = holo &&
        holo === 'reverse' &&
        !isReverseHoloEnergyTemplate(cardTemplate, holo);
    const stageText = getStageLabel(stage, language);
    const evolvesFromLabel = getEvolvesFromLabel(evolvesFrom, language);
    const evolvesToLabel = getEvolvesToLabel(evolvesTo, language);
    const putLabel = getPutLabel(name, stage, language);
    const hitPointsLabel = getHitPointsLabel(hitPoints, language);
    const lengthLabel = getLabel('length', language);
    const weightLabel = getLabel('weight', language);
    const weaknessLabel = getLabel('weakness', language);
    const resistanceLabel = getLabel('resistance', language);
    const retreatCostLabel = getLabel('retreatCost', language);
    const measurementSystem = getLabel('measurements', language);
    const pokemonLevelLabel = getLabel('level', language);
    const pokemonNumberLabel = getLabel('number', language);
    const basicLabel = getLabel('basic', language);
    const stagePokemonLabel = getStagePokemonLabel(stage, language);
    const babyLabel = getLabel('baby', language);
    const putBabyLabel = getPutBabyLabel(evolvesTo, language);
    const babyRuleLabel = getLabel('babyRule', language);
    const unownRuleLabel = getLabel('unownRule', language);
    const shiningRuleLabel = getShiningRuleLabel(name, language);
    const energyHeadingLabel = getLabel('energy', language);
    const trainerHeadingLabel = getLabel('trainer', language);
    const typeLabel = getTypeLabel(pokemonType, language);
    const getCardStageText = () => {
        const cardStageText = isBasic(stage) ? basicLabel : stagePokemonLabel;
        if (isBabySubtype(cardTemplateSubtype)) {
            return babyLabel;
        }
        return cardStageText;
    };
    return (React.createElement("div", { className: cardWrapperClassNames, onClick: onClick, ref: ref, id: id },
        React.createElement("div", { className: cardClassNames },
            React.createElement("div", { className: "card-surface card-surface--back", id: "card-surface-back" }),
            React.createElement("div", { className: "card-surface card-surface--front", id: "card-surface-front" },
                isLoading ? (React.createElement(RPCLoadingIndicator, { backdrop: true, full: true, label: loadingLabel })) : undefined,
                React.createElement(CardBodyImage, null,
                    React.createElement(CardBody, { className: cardBodyClassNames },
                        React.createElement("div", { className: cardBodyInnerClassNames },
                            showReverseHoloSheet ? (React.createElement(CardHoloSheet, { className: "card-body__holo-sheet", holoBlendMode: holoBlendMode || pokemonCardLibrary.BLEND_MODES.OVERLAY, holoStrength: holoStrength, isAnimated: isHoloAnimation, randomizeHoloSheetPosition: randomizeHoloSheetPosition, full: isFullReverseHolo, type: reverseHoloSheetType })) : undefined,
                            !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement("div", { className: mainInfoClassNames },
                                !isBasic(stage) &&
                                    !isShiningBabyUnownSubtype(cardTemplateSubtype) ? (React.createElement(CardEvolutionBox, { stageText: stageText, evolutionBoxBackgroundImageSize: evolutionBoxBackgroundImageSize, evolutionBoxImageUrl: evolutionBoxImageUrl, evolutionBoxBackgroundVariant: evolutionBoxBackgroundVariant })) : undefined,
                                React.createElement(CardHeader, { babyRuleLabel: babyRuleLabel, basicLabel: basicLabel, cardTemplate: cardTemplate, cardTemplateSubtype: cardTemplateSubtype, evolvesFromLabel: evolvesFromLabel, putLabel: putLabel, shiningRuleLabel: shiningRuleLabel, stage: stage, unownRuleLabel: unownRuleLabel }),
                                React.createElement(CardNameBar, { cardTemplate: cardTemplate, cardTemplateSubtype: cardTemplateSubtype, energyType: energyType === pokemonCardLibrary.SPECIAL_ENERGY_TYPES.CRYSTAL
                                        ? pokemonCardLibrary.ENERGY_TYPES.COLORLESS
                                        : energyType, hitPoints: hitPoints, hitPointsLabel: hitPointsLabel, isEditable: isEditable, name: name, nameCondenseLevel: nameCondenseLevel, onHpChange: onHpChange, onNameChange: onNameChange, stage: isShiningBabyUnownSubtype(cardTemplateSubtype)
                                        ? 0
                                        : stage, unownLetter: unownLetter }))) : undefined,
                            isTrainerTemplate(cardTemplate) ? (React.createElement(CardHeaderTrainer, { cardTemplate: cardTemplate, hitPoints: hitPoints, isBoldName: isBoldName, name: name, nameCondenseLevel: nameCondenseLevel, subtitle: subtitle, trainerHeadingLabel: trainerHeadingLabel })) : undefined,
                            isEnergyTemplate(cardTemplate) ? (React.createElement(React.Fragment, null, isESeriesEnergyTemplate(cardTemplate) ? (React.createElement(CardHeaderESeriesEnergy, { energyType: energyType })) : (React.createElement(CardMasthead, { energyHeadingLabel: energyHeadingLabel, energyType: energyType, firstEdition: firstEdition, isDoubleEnergyType: isDoubleEnergyType, type: MASTHEAD_TYPES.ENERGY })))) : undefined,
                            React.createElement(CardFrame, { backgroundColor: backgroundColor, backgroundImageBlendMode: backgroundImageBlendMode, backgroundImageOpacity: backgroundImageOpacity, backgroundImagePositionX: backgroundImagePositionX, backgroundImagePositionY: backgroundImagePositionY, backgroundImageUrl: backgroundImageUrl, cardTemplate: cardTemplate, creatureImageBlendMode: creatureImageBlendMode, energyType: energyType, frameBadgeText: getCardStageText(), holo: holo, holoBlendMode: holoBlendMode, holoSheetType: holoSheetType, holoStrength: holoStrength, isHoloAnimation: isHoloAnimation, pokemonImagePositionX: pokemonImagePositionX, pokemonImagePositionY: pokemonImagePositionY, pokemonImageRotation: pokemonImageRotation, pokemonImageShadowColor: pokemonImageShadowColor, pokemonImageShadowOffsetX: pokemonImageShadowOffsetX, pokemonImageShadowOffsetY: pokemonImageShadowOffsetY, pokemonImageShadowSize: pokemonImageShadowSize, pokemonImageSize: pokemonImageSize, pokemonImageUrl: pokemonImageUrl, randomizeHoloSheetPosition: randomizeHoloSheetPosition, reverseHoloSheetType: reverseHoloSheetType, shadowless: shadowless, size: getCardFrameSize(), stamp: stamp }),
                            firstEdition && !isEnergyTemplate(cardTemplate) ? (React.createElement("div", { className: firstEditionStampClassNames }, isESeriesTemplate(cardTemplate) ? (React.createElement(FirstEditionStampJpn, null)) : (React.createElement(FirstEditionStamp, null)))) : undefined,
                            setSymbol ? (React.createElement("div", { className: cardSetSymbolClassNames },
                                React.createElement(CardSetSymbol, { isCardCreatorMode: true, setSymbol: setSymbol }))) : undefined,
                            !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(React.Fragment, null,
                                React.createElement(CardStatsBar, { eReaderId: eReaderId, hasShadow: hasStatsBarShadow, lengthFeet: lengthFeet, lengthLabel: lengthLabel, lengthInches: lengthInches, measurementSystem: measurementSystem, typeLabel: typeLabel, weight: weight, weightLabel: weightLabel }),
                                isBabySubtype(cardTemplateSubtype) ? (React.createElement(CardEvolutionBoxBaby, { babyDescription: babyDescription, evolvesToLabel: evolvesToLabel, evolutionBoxBackgroundImageSize: evolutionBoxBackgroundImageSize, evolutionBoxImageUrl: evolutionBoxImageUrl, isESeriesTemplate: isESeriesTemplate(cardTemplate), putBabyLabel: putBabyLabel })) : undefined,
                                React.createElement(CardMovesList, { isESeriesTemplate: isESeriesTemplate(cardTemplate), isVsTemplate: isVsOrWebTemplate(cardTemplate), moves: getMoves() }),
                                isESeriesTemplate(cardTemplate) ? (React.createElement("hr", { className: "e-divider" })) : undefined,
                                React.createElement(CardCostGrid, { appendResistanceToTitle: isVsOrWebTemplate(cardTemplate), isFloatedGrid: isGymTemplate(cardTemplate), energyResistance: energyResistance, energyRetreatCost: energyRetreatCost, energyWeakness: energyWeakness, pokemonLevel: pokemonLevel, pokemonLevelLabel: pokemonLevelLabel, pokemonNumber: pokemonNumber, pokemonNumberLabel: pokemonNumberLabel, resistanceLabel: resistanceLabel, retreatCostLabel: retreatCostLabel, showSwooshes: isNeoOrESeriesTemplate(cardTemplate), trainerImageUrl: trainerImageUrl, weaknessLabel: weaknessLabel }),
                                !isESeriesTemplate(cardTemplate) &&
                                    !isGymTemplate(cardTemplate) ? (React.createElement(CardDescription, { description: description, pokemonLevel: pokemonLevel, pokemonLevelLabel: pokemonLevelLabel, pokemonNumber: pokemonNumber, pokemonNumberLabel: pokemonNumberLabel })) : undefined)) : (React.createElement(React.Fragment, null,
                                isTrainerTemplate(cardTemplate) ? (React.createElement(CardDescriptionTrainer, { description: description, rule: trainerRule, showScrews: cardTemplate === pokemonCardLibrary.CARD_TEMPLATES.TRAINER })) : undefined,
                                isEnergyTemplate(cardTemplate) &&
                                    (description || name) ? (React.createElement(CardDescriptionEnergy, { description: description, name: name, opacity: isReverseHoloEnergyTemplate(cardTemplate, holo)
                                        ? 0.7
                                        : undefined, subtitle: subtitle })) : undefined)),
                            React.createElement(CardFooter, { copyright: copyright, illustrator: illustrator, isESeriesTemplate: isESeriesTemplate(cardTemplate), rarity: rarity, setNumber: setNumber, setTotal: setTotal })))),
                isESeriesTemplate(cardTemplate) ? (React.createElement(CardFrameESeries, { cardTemplate: cardTemplate, dotMatrixVariant: dotMatrixVariant, holo: holo, logoIcon: getCardLogoIcon(), trainerImageUrl: trainerImageUrl })) : undefined))));
});
const Card = React.memo(CardComponent);

const RPCCheckboxComponent = (props) => {
    const { id, label, checked, onChange } = props;
    return (React.createElement(Form$1.Check, { id: id, label: label, checked: checked, onChange: onChange }));
};
const RPCCheckbox = React.memo(RPCCheckboxComponent);

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$a(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function useEvent(callback) {
  var fnRef = React__namespace.useRef();
  fnRef.current = callback;
  var memoFn = React__namespace.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect = process.env.NODE_ENV !== 'test' && canUseDom() ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var useLayoutEffect$1 = function useLayoutEffect(callback, deps) {
  var firstMountRef = React__namespace.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect$1(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};

/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = React__namespace.useRef(false);
  var _React$useState = React__namespace.useState(defaultValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React__namespace.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/** We only think `undefined` is empty */
function hasValue$1(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = useSafeState(function () {
      if (hasValue$1(value)) {
        return value;
      } else if (hasValue$1(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]),
    _useState4 = _slicedToArray(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  useLayoutUpdateEffect(function () {
    if (!hasValue$1(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = useEvent(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
    }, message);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
    }, message);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;

var isMobile = (function () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
});

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return  false};reactIs_production_min.isConcurrentMode=function(){return  false};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?true:false};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = React__namespace.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');

/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */
function isFragment(object) {
  return (
    // Base object type
    object && _typeof(object) === 'object' && (
    // React Element type
    object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) &&
    // React Fragment type
    object.type === REACT_FRAGMENT_TYPE
  );
}

var ReactMajorVersion = Number(React.version.split('.')[0]);
var fillRef = function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
};

/**
 * Merge refs into one ref function to support ref passing.
 */
var composeRef = function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
};
var useComposeRef = function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length !== next.length || prev.every(function (ref, i) {
      return ref !== next[i];
    });
  });
};
var supportRef = function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }

  // React 19 no need `forwardRef` anymore. So just pass if is a React element.
  if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) {
    return true;
  }
  var type = reactIsExports.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node) {
  return /*#__PURE__*/React.isValidElement(node) && !isFragment(node);
}

/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */
var getNodeRef = function getNodeRef(node) {
  if (node && isReactElement(node)) {
    var ele = node;

    // Source from:
    // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
    return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
  }
  return null;
};

var TransBtn = function TransBtn(props) {
  var className = props.className,
    customizeIcon = props.customizeIcon,
    customizeIconProps = props.customizeIconProps,
    children = props.children,
    _onMouseDown = props.onMouseDown,
    onClick = props.onClick;
  var icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: className,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
    },
    style: {
      userSelect: 'none',
      WebkitUserSelect: 'none'
    },
    unselectable: "on",
    onClick: onClick,
    "aria-hidden": true
  }, icon !== undefined ? icon : /*#__PURE__*/React__namespace.createElement("span", {
    className: classNames(className.split(/\s+/).map(function (cls) {
      return "".concat(cls, "-icon");
    }))
  }, children));
};

var useAllowClear = function useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
  var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
  var mode = arguments.length > 7 ? arguments[7] : undefined;
  var mergedClearIcon = React.useMemo(function () {
    if (_typeof(allowClear) === 'object') {
      return allowClear.clearIcon;
    }
    if (clearIcon) {
      return clearIcon;
    }
  }, [allowClear, clearIcon]);
  var mergedAllowClear = React.useMemo(function () {
    if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) {
      return true;
    }
    return false;
  }, [allowClear, disabled, displayValues.length, mergedSearchValue, mode]);
  return {
    allowClear: mergedAllowClear,
    clearIcon: /*#__PURE__*/React.createElement(TransBtn, {
      className: "".concat(prefixCls, "-clear"),
      onMouseDown: onClearMouseDown,
      customizeIcon: mergedClearIcon
    }, "\xD7")
  };
};

/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */

var BaseSelectContext = /*#__PURE__*/React__namespace.createContext(null);
function useBaseProps() {
  return React__namespace.useContext(BaseSelectContext);
}

/**
 * Similar with `useLock`, but this hook will always execute last value.
 * When set to `true`, it will keep `true` for a short time even if `false` is set.
 */
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    bool = _React$useState2[0],
    setBool = _React$useState2[1];
  var delayRef = React__namespace.useRef(null);
  var cancelLatest = function cancelLatest() {
    window.clearTimeout(delayRef.current);
  };
  React__namespace.useEffect(function () {
    return cancelLatest;
  }, []);
  var delaySetBool = function delaySetBool(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function () {
      setBool(value);
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}

/**
 * Locker return cached mark.
 * If set to `true`, will return `true` in a short time even if set `false`.
 * If set to `false` and then set to `true`, will change to `true`.
 * And after time duration, it will back to `null` automatically.
 */
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  var lockRef = React__namespace.useRef(null);
  var timeoutRef = React__namespace.useRef(null);

  // Clean up
  React__namespace.useEffect(function () {
    return function () {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function () {
      lockRef.current = null;
    }, duration);
  }
  return [function () {
    return lockRef.current;
  }, doLock];
}

function useSelectTriggerControl(elements, open, triggerOpen, customizedTrigger) {
  var propsRef = React__namespace.useRef(null);
  propsRef.current = {
    open: open,
    triggerOpen: triggerOpen,
    customizedTrigger: customizedTrigger
  };
  React__namespace.useEffect(function () {
    function onGlobalMouseDown(event) {
      var _propsRef$current;
      // If trigger is customized, Trigger will take control of popupVisible
      if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) {
        return;
      }
      var target = event.target;
      if (target.shadowRoot && event.composed) {
        target = event.composedPath()[0] || target;
      }
      if (propsRef.current.open && elements().filter(function (element) {
        return element;
      }).every(function (element) {
        return !element.contains(target) && element !== target;
      })) {
        // Should trigger close
        propsRef.current.triggerOpen(false);
      }
    }
    window.addEventListener('mousedown', onGlobalMouseDown);
    return function () {
      return window.removeEventListener('mousedown', onGlobalMouseDown);
    };
  }, []);
}

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224};

/** keyCode Judgment function */
function isValidateOpenKey(currentKeyCode) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode &&
    // Other keys
    ![
    // System function button
    KeyCode.ESC, KeyCode.SHIFT, KeyCode.BACKSPACE, KeyCode.TAB, KeyCode.WIN_KEY, KeyCode.ALT, KeyCode.META, KeyCode.WIN_KEY_RIGHT, KeyCode.CTRL, KeyCode.SEMICOLON, KeyCode.EQUALS, KeyCode.CAPS_LOCK, KeyCode.CONTEXT_MENU,
    // F1-F12
    KeyCode.F1, KeyCode.F2, KeyCode.F3, KeyCode.F4, KeyCode.F5, KeyCode.F6, KeyCode.F7, KeyCode.F8, KeyCode.F9, KeyCode.F10, KeyCode.F11, KeyCode.F12].includes(currentKeyCode)
  );
}

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread2({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

function toArray$2(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  React.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray$2(child));
    } else if (isFragment(child) && child.props) {
      ret = ret.concat(toArray$2(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

function isDOM(node) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element
  // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
  return node instanceof HTMLElement || node instanceof SVGElement;
}

/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */
function getDOM(node) {
  if (node && _typeof(node) === 'object' && isDOM(node.nativeElement)) {
    return node.nativeElement;
  }
  if (isDOM(node)) {
    return node;
  }
  return null;
}

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  var domNode = getDOM(node);
  if (domNode) {
    return domNode;
  }
  if (node instanceof React.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = ReactDOM.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(ReactDOM, node);
  }
  return null;
}

var CollectionContext = /*#__PURE__*/React__namespace.createContext(null);
/**
 * Collect all the resize event from children ResizeObserver
 */
function Collection(_ref) {
  var children = _ref.children,
    onBatchResize = _ref.onBatchResize;
  var resizeIdRef = React__namespace.useRef(0);
  var resizeInfosRef = React__namespace.useRef([]);
  var onCollectionResize = React__namespace.useContext(CollectionContext);
  var onResize = React__namespace.useCallback(function (size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size: size,
      element: element,
      data: data
    });
    Promise.resolve().then(function () {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });

    // Continue bubbling if parent exist
    onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /*#__PURE__*/React__namespace.createElement(CollectionContext.Provider, {
    value: onResize
  }, children);
}

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();

// =============================== Const ===============================
var elementListeners = new Map();
function onResize(entities) {
  entities.forEach(function (entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function (listener) {
      return listener(target);
    });
  });
}

// Note: ResizeObserver polyfill not support option to measure border-box resize
var resizeObserver = new index(onResize);

// Dev env only
process.env.NODE_ENV !== 'production' ? elementListeners : null; // eslint-disable-line
process.env.NODE_ENV !== 'production' ? onResize : null; // eslint-disable-line

// ============================== Observe ==============================
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */
var DomWrapper$1 = /*#__PURE__*/function (_React$Component) {
  _inherits(DomWrapper, _React$Component);
  var _super = _createSuper(DomWrapper);
  function DomWrapper() {
    _classCallCheck(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(React__namespace.Component);

function SingleObserver(props, ref) {
  var children = props.children,
    disabled = props.disabled;
  var elementRef = React__namespace.useRef(null);
  var wrapperRef = React__namespace.useRef(null);
  var onCollectionResize = React__namespace.useContext(CollectionContext);

  // =========================== Children ===========================
  var isRenderProps = typeof children === 'function';
  var mergedChildren = isRenderProps ? children(elementRef) : children;

  // ============================= Size =============================
  var sizeRef = React__namespace.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });

  // ============================= Ref ==============================
  var canRef = !isRenderProps && /*#__PURE__*/React__namespace.isValidElement(mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? getNodeRef(mergedChildren) : null;
  var mergedRef = useComposeRef(originRef, elementRef);
  var getDom = function getDom() {
    var _elementRef$current;
    return findDOMNode(elementRef.current) || (
    // Support `nativeElement` format
    elementRef.current && _typeof(elementRef.current) === 'object' ? findDOMNode((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || findDOMNode(wrapperRef.current);
  };
  React__namespace.useImperativeHandle(ref, function () {
    return getDom();
  });

  // =========================== Observe ============================
  var propsRef = React__namespace.useRef(props);
  propsRef.current = props;

  // Handler
  var onInternalResize = React__namespace.useCallback(function (target) {
    var _propsRef$current = propsRef.current,
      onResize = _propsRef$current.onResize,
      data = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(),
      width = _target$getBoundingCl.width,
      height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth,
      offsetHeight = target.offsetHeight;

    /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth: offsetWidth,
        offsetHeight: offsetHeight
      };
      sizeRef.current = size;

      // IE is strange, right?
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = _objectSpread2(_objectSpread2({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });

      // Let collection know what happened
      onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
      if (onResize) {
        // defer the callback but not defer to next frame
        Promise.resolve().then(function () {
          onResize(sizeInfo, target);
        });
      }
    }
  }, []);

  // Dynamic observe
  React__namespace.useEffect(function () {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function () {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);

  // ============================ Render ============================
  return /*#__PURE__*/React__namespace.createElement(DomWrapper$1, {
    ref: wrapperRef
  }, canRef ? /*#__PURE__*/React__namespace.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /*#__PURE__*/React__namespace.forwardRef(SingleObserver);
if (process.env.NODE_ENV !== 'production') {
  RefSingleObserver.displayName = 'SingleObserver';
}

var INTERNAL_PREFIX_KEY = 'rc-observer-key';
function ResizeObserver(props, ref) {
  var children = props.children;
  var childNodes = typeof children === 'function' ? [children] : toArray$2(children);
  if (process.env.NODE_ENV !== 'production') {
    if (childNodes.length > 1) {
      warning(false, 'Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.');
    } else if (childNodes.length === 0) {
      warning(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
    }
  }
  return childNodes.map(function (child, index) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index);
    return /*#__PURE__*/React__namespace.createElement(RefSingleObserver, _extends({}, props, {
      key: key,
      ref: index === 0 ? ref : undefined
    }), child);
  });
}
var RefResizeObserver = /*#__PURE__*/React__namespace.forwardRef(ResizeObserver);
if (process.env.NODE_ENV !== 'production') {
  RefResizeObserver.displayName = 'ResizeObserver';
}
RefResizeObserver.Collection = Collection;

var _excluded$a = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];
// Use shared variable to save bundle size
var UNDEFINED = undefined;
function InternalItem(props, ref) {
  var prefixCls = props.prefixCls,
    invalidate = props.invalidate,
    item = props.item,
    renderItem = props.renderItem,
    responsive = props.responsive,
    responsiveDisabled = props.responsiveDisabled,
    registerSize = props.registerSize,
    itemKey = props.itemKey,
    className = props.className,
    style = props.style,
    children = props.children,
    display = props.display,
    order = props.order,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    restProps = _objectWithoutProperties(props, _excluded$a);
  var mergedHidden = responsive && !display;

  // ================================ Effect ================================
  function internalRegisterSize(width) {
    registerSize(itemKey, width);
  }
  React__namespace.useEffect(function () {
    return function () {
      internalRegisterSize(null);
    };
  }, []);

  // ================================ Render ================================
  var childNode = renderItem && item !== UNDEFINED ? renderItem(item, {
    index: order
  }) : children;
  var overflowStyle;
  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? 'hidden' : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? 'none' : UNDEFINED,
      position: mergedHidden ? 'absolute' : UNDEFINED
    };
  }
  var overflowProps = {};
  if (mergedHidden) {
    overflowProps['aria-hidden'] = true;
  }
  var itemNode = /*#__PURE__*/React__namespace.createElement(Component, _extends({
    className: classNames(!invalidate && prefixCls, className),
    style: _objectSpread2(_objectSpread2({}, overflowStyle), style)
  }, overflowProps, restProps, {
    ref: ref
  }), childNode);
  if (responsive) {
    itemNode = /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
      onResize: function onResize(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }
  return itemNode;
}
var Item$1 = /*#__PURE__*/React__namespace.forwardRef(InternalItem);
Item$1.displayName = 'Item';

var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (process.env.NODE_ENV !== 'production') {
  wrapperRaf.ids = function () {
    return rafIds;
  };
}

function channelUpdate(callback) {
  if (typeof MessageChannel === 'undefined') {
    wrapperRaf(callback);
  } else {
    var channel = new MessageChannel();
    channel.port1.onmessage = function () {
      return callback();
    };
    channel.port2.postMessage(undefined);
  }
}

/**
 * Batcher for record any `useEffectState` need update.
 */
function useBatcher() {
  // Updater Trigger
  var updateFuncRef = React__namespace.useRef(null);

  // Notify update
  var notifyEffectUpdate = function notifyEffectUpdate(callback) {
    if (!updateFuncRef.current) {
      updateFuncRef.current = [];
      channelUpdate(function () {
        ReactDOM.unstable_batchedUpdates(function () {
          updateFuncRef.current.forEach(function (fn) {
            fn();
          });
          updateFuncRef.current = null;
        });
      });
    }
    updateFuncRef.current.push(callback);
  };
  return notifyEffectUpdate;
}

/**
 * Trigger state update by `useLayoutEffect` to save perf.
 */
function useEffectState(notifyEffectUpdate, defaultValue) {
  // Value
  var _React$useState = React__namespace.useState(defaultValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    stateValue = _React$useState2[0],
    setStateValue = _React$useState2[1];

  // Set State
  var setEffectVal = useEvent(function (nextValue) {
    notifyEffectUpdate(function () {
      setStateValue(nextValue);
    });
  });
  return [stateValue, setEffectVal];
}

var OverflowContext = /*#__PURE__*/React.createContext(null);

var _excluded$9 = ["component"],
  _excluded2$2 = ["className"],
  _excluded3 = ["className"];
var InternalRawItem = function InternalRawItem(props, ref) {
  var context = React__namespace.useContext(OverflowContext);

  // Render directly when context not provided
  if (!context) {
    var _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _restProps = _objectWithoutProperties(props, _excluded$9);
    return /*#__PURE__*/React__namespace.createElement(Component, _extends({}, _restProps, {
      ref: ref
    }));
  }
  var contextClassName = context.className,
    restContext = _objectWithoutProperties(context, _excluded2$2);
  var className = props.className,
    restProps = _objectWithoutProperties(props, _excluded3);

  // Do not pass context to sub item to avoid multiple measure
  return /*#__PURE__*/React__namespace.createElement(OverflowContext.Provider, {
    value: null
  }, /*#__PURE__*/React__namespace.createElement(Item$1, _extends({
    ref: ref,
    className: classNames(contextClassName, className)
  }, restContext, restProps)));
};
var RawItem = /*#__PURE__*/React__namespace.forwardRef(InternalRawItem);
RawItem.displayName = 'RawItem';

var _excluded$8 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];
var RESPONSIVE = 'responsive';
var INVALIDATE = 'invalidate';
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
function Overflow(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    renderItem = props.renderItem,
    renderRawItem = props.renderRawItem,
    itemKey = props.itemKey,
    _props$itemWidth = props.itemWidth,
    itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth,
    ssr = props.ssr,
    style = props.style,
    className = props.className,
    maxCount = props.maxCount,
    renderRest = props.renderRest,
    renderRawRest = props.renderRawRest,
    suffix = props.suffix,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    itemComponent = props.itemComponent,
    onVisibleChange = props.onVisibleChange,
    restProps = _objectWithoutProperties(props, _excluded$8);
  var fullySSR = ssr === 'full';
  var notifyEffectUpdate = useBatcher();
  var _useEffectState = useEffectState(notifyEffectUpdate, null),
    _useEffectState2 = _slicedToArray(_useEffectState, 2),
    containerWidth = _useEffectState2[0],
    setContainerWidth = _useEffectState2[1];
  var mergedContainerWidth = containerWidth || 0;
  var _useEffectState3 = useEffectState(notifyEffectUpdate, new Map()),
    _useEffectState4 = _slicedToArray(_useEffectState3, 2),
    itemWidths = _useEffectState4[0],
    setItemWidths = _useEffectState4[1];
  var _useEffectState5 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState6 = _slicedToArray(_useEffectState5, 2),
    prevRestWidth = _useEffectState6[0],
    setPrevRestWidth = _useEffectState6[1];
  var _useEffectState7 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState8 = _slicedToArray(_useEffectState7, 2),
    restWidth = _useEffectState8[0],
    setRestWidth = _useEffectState8[1];
  var _useEffectState9 = useEffectState(notifyEffectUpdate, 0),
    _useEffectState10 = _slicedToArray(_useEffectState9, 2),
    suffixWidth = _useEffectState10[0],
    setSuffixWidth = _useEffectState10[1];
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    suffixFixedStart = _useState2[0],
    setSuffixFixedStart = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    displayCount = _useState4[0],
    setDisplayCount = _useState4[1];
  var mergedDisplayCount = React__namespace.useMemo(function () {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }
    return displayCount || 0;
  }, [displayCount, containerWidth]);
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    restReady = _useState6[0],
    setRestReady = _useState6[1];
  var itemPrefixCls = "".concat(prefixCls, "-item");

  // Always use the max width to avoid blink
  var mergedRestWidth = Math.max(prevRestWidth, restWidth);

  // ================================= Data =================================
  var isResponsive = maxCount === RESPONSIVE;
  var shouldResponsive = data.length && isResponsive;
  var invalidate = maxCount === INVALIDATE;

  /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */
  var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
  var mergedData = React.useMemo(function () {
    var items = data;
    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data;
      } else {
        items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount === 'number') {
      items = data.slice(0, maxCount);
    }
    return items;
  }, [data, itemWidth, containerWidth, maxCount, shouldResponsive]);
  var omittedItems = React.useMemo(function () {
    if (shouldResponsive) {
      return data.slice(mergedDisplayCount + 1);
    }
    return data.slice(mergedData.length);
  }, [data, mergedData, shouldResponsive, mergedDisplayCount]);

  // ================================= Item =================================
  var getKey = React.useCallback(function (item, index) {
    var _ref;
    if (typeof itemKey === 'function') {
      return itemKey(item);
    }
    return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
  }, [itemKey]);
  var mergedRenderItem = React.useCallback(renderItem || function (item) {
    return item;
  }, [renderItem]);
  function updateDisplayCount(count, suffixFixedStartVal, notReady) {
    // React 18 will sync render even when the value is same in some case.
    // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
    // ref: https://github.com/ant-design/ant-design/issues/36559
    if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) {
      return;
    }
    setDisplayCount(count);
    if (!notReady) {
      setRestReady(count < data.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
    }
    if (suffixFixedStartVal !== undefined) {
      setSuffixFixedStart(suffixFixedStartVal);
    }
  }

  // ================================= Size =================================
  function onOverflowResize(_, element) {
    setContainerWidth(element.clientWidth);
  }
  function registerSize(key, width) {
    setItemWidths(function (origin) {
      var clone = new Map(origin);
      if (width === null) {
        clone.delete(key);
      } else {
        clone.set(key, width);
      }
      return clone;
    });
  }
  function registerOverflowSize(_, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }
  function registerSuffixSize(_, width) {
    setSuffixWidth(width);
  }

  // ================================ Effect ================================
  function getItemWidth(index) {
    return itemWidths.get(getKey(mergedData[index], index));
  }
  useLayoutEffect$1(function () {
    if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1;

      // When data count change to 0, reset this since not loop will reach
      if (!len) {
        updateDisplayCount(0, null);
        return;
      }
      for (var i = 0; i < len; i += 1) {
        var currentItemWidth = getItemWidth(i);

        // Fully will always render
        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        }

        // Break since data not ready
        if (currentItemWidth === undefined) {
          updateDisplayCount(i - 1, undefined, true);
          break;
        }

        // Find best match
        totalWidth += currentItemWidth;
        if (
        // Only one means `totalWidth` is the final width
        lastIndex === 0 && totalWidth <= mergedContainerWidth ||
        // Last two width will be the final width
        i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
          // Additional check if match the end
          updateDisplayCount(lastIndex, null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          // Can not hold all the content to show rest
          updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }
      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey, mergedData]);

  // ================================ Render ================================
  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};
  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: 'absolute',
      left: suffixFixedStart,
      top: 0
    };
  }
  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate: invalidate
  };

  // >>>>> Choice render fun by `renderRawItem`
  var internalRenderItemNode = renderRawItem ? function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/React__namespace.createElement(OverflowContext.Provider, {
      key: key,
      value: _objectSpread2(_objectSpread2({}, itemSharedProps), {}, {
        order: index,
        item: item,
        itemKey: key,
        registerSize: registerSize,
        display: index <= mergedDisplayCount
      })
    }, renderRawItem(item, index));
  } : function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/React__namespace.createElement(Item$1, _extends({}, itemSharedProps, {
      order: index,
      key: key,
      item: item,
      renderItem: mergedRenderItem,
      itemKey: key,
      registerSize: registerSize,
      display: index <= mergedDisplayCount
    }));
  };

  // >>>>> Rest node
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };
  var mergedRenderRest = renderRest || defaultRenderRest;
  var restNode = renderRawRest ? /*#__PURE__*/React__namespace.createElement(OverflowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, itemSharedProps), restContextProps)
  }, renderRawRest(omittedItems)) : /*#__PURE__*/React__namespace.createElement(Item$1, _extends({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
  var overflowNode = /*#__PURE__*/React__namespace.createElement(Component, _extends({
    className: classNames(!invalidate && prefixCls, className),
    style: style,
    ref: ref
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/React__namespace.createElement(Item$1, _extends({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));
  return isResponsive ? /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
    onResize: onOverflowResize,
    disabled: !shouldResponsive
  }, overflowNode) : overflowNode;
}
var ForwardOverflow = /*#__PURE__*/React__namespace.forwardRef(Overflow);
ForwardOverflow.displayName = 'Overflow';
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;

var Input = function Input(props, ref) {
  var _inputNode2;
  var prefixCls = props.prefixCls,
    id = props.id,
    inputElement = props.inputElement,
    disabled = props.disabled,
    tabIndex = props.tabIndex,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    editable = props.editable,
    activeDescendantId = props.activeDescendantId,
    value = props.value,
    maxLength = props.maxLength,
    _onKeyDown = props.onKeyDown,
    _onMouseDown = props.onMouseDown,
    _onChange = props.onChange,
    onPaste = props.onPaste,
    _onCompositionStart = props.onCompositionStart,
    _onCompositionEnd = props.onCompositionEnd,
    _onBlur = props.onBlur,
    open = props.open,
    attrs = props.attrs;
  var inputNode = inputElement || /*#__PURE__*/React__namespace.createElement("input", null);
  var _inputNode = inputNode,
    originRef = _inputNode.ref,
    originProps = _inputNode.props;
  var onOriginKeyDown = originProps.onKeyDown,
    onOriginChange = originProps.onChange,
    onOriginMouseDown = originProps.onMouseDown,
    onOriginCompositionStart = originProps.onCompositionStart,
    onOriginCompositionEnd = originProps.onCompositionEnd,
    onOriginBlur = originProps.onBlur,
    style = originProps.style;
  warning(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
  inputNode = /*#__PURE__*/React__namespace.cloneElement(inputNode, _objectSpread2(_objectSpread2(_objectSpread2({
    type: 'search'
  }, originProps), {}, {
    // Override over origin props
    id: id,
    ref: composeRef(ref, originRef),
    disabled: disabled,
    tabIndex: tabIndex,
    autoComplete: autoComplete || 'off',
    autoFocus: autoFocus,
    className: classNames("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
    role: 'combobox',
    'aria-expanded': open || false,
    'aria-haspopup': 'listbox',
    'aria-owns': "".concat(id, "_list"),
    'aria-autocomplete': 'list',
    'aria-controls': "".concat(id, "_list"),
    'aria-activedescendant': open ? activeDescendantId : undefined
  }, attrs), {}, {
    value: editable ? value : '',
    maxLength: maxLength,
    readOnly: !editable,
    unselectable: !editable ? 'on' : null,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      opacity: editable ? null : 0
    }),
    onKeyDown: function onKeyDown(event) {
      _onKeyDown(event);
      if (onOriginKeyDown) {
        onOriginKeyDown(event);
      }
    },
    onMouseDown: function onMouseDown(event) {
      _onMouseDown(event);
      if (onOriginMouseDown) {
        onOriginMouseDown(event);
      }
    },
    onChange: function onChange(event) {
      _onChange(event);
      if (onOriginChange) {
        onOriginChange(event);
      }
    },
    onCompositionStart: function onCompositionStart(event) {
      _onCompositionStart(event);
      if (onOriginCompositionStart) {
        onOriginCompositionStart(event);
      }
    },
    onCompositionEnd: function onCompositionEnd(event) {
      _onCompositionEnd(event);
      if (onOriginCompositionEnd) {
        onOriginCompositionEnd(event);
      }
    },
    onPaste: onPaste,
    onBlur: function onBlur(event) {
      _onBlur(event);
      if (onOriginBlur) {
        onOriginBlur(event);
      }
    }
  }));
  return inputNode;
};
var RefInput = /*#__PURE__*/React__namespace.forwardRef(Input);
if (process.env.NODE_ENV !== 'production') {
  RefInput.displayName = 'Input';
}

function toArray$1(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== undefined ? [value] : [];
}
var isClient = typeof window !== 'undefined' && window.document && window.document.documentElement;

/** Is client side and not jsdom */
var isBrowserClient$1 = process.env.NODE_ENV !== 'test' && isClient;
function hasValue(value) {
  return value !== undefined && value !== null;
}

/** combo mode no value judgment function */
function isComboNoValue(value) {
  return !value && value !== 0;
}
function isTitleType$1(title) {
  return ['string', 'number'].includes(_typeof(title));
}
function getTitle(item) {
  var title = undefined;
  if (item) {
    if (isTitleType$1(item.title)) {
      title = item.title.toString();
    } else if (isTitleType$1(item.label)) {
      title = item.label.toString();
    }
  }
  return title;
}

/* eslint-disable react-hooks/rules-of-hooks */

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
function useLayoutEffect(effect, deps) {
  // Never happen in test env
  if (isBrowserClient$1) {
    /* istanbul ignore next */
    React__namespace.useLayoutEffect(effect, deps);
  } else {
    React__namespace.useEffect(effect, deps);
  }
}
/* eslint-enable */

function itemKey(value) {
  var _value$key;
  return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var onPreventMouseDown = function onPreventMouseDown(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = function SelectSelector(props) {
  var id = props.id,
    prefixCls = props.prefixCls,
    values = props.values,
    open = props.open,
    searchValue = props.searchValue,
    autoClearSearchValue = props.autoClearSearchValue,
    inputRef = props.inputRef,
    placeholder = props.placeholder,
    disabled = props.disabled,
    mode = props.mode,
    showSearch = props.showSearch,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    activeDescendantId = props.activeDescendantId,
    tabIndex = props.tabIndex,
    removeIcon = props.removeIcon,
    maxTagCount = props.maxTagCount,
    maxTagTextLength = props.maxTagTextLength,
    _props$maxTagPlacehol = props.maxTagPlaceholder,
    maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function (omittedValues) {
      return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol,
    tagRender = props.tagRender,
    onToggleOpen = props.onToggleOpen,
    onRemove = props.onRemove,
    onInputChange = props.onInputChange,
    onInputPaste = props.onInputPaste,
    onInputKeyDown = props.onInputKeyDown,
    onInputMouseDown = props.onInputMouseDown,
    onInputCompositionStart = props.onInputCompositionStart,
    onInputCompositionEnd = props.onInputCompositionEnd,
    onInputBlur = props.onInputBlur;
  var measureRef = React__namespace.useRef(null);
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    inputWidth = _useState2[0],
    setInputWidth = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var selectionPrefixCls = "".concat(prefixCls, "-selection");

  // ===================== Search ======================
  var inputValue = open || mode === 'multiple' && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
  var inputEditable = mode === 'tags' || mode === 'multiple' && autoClearSearchValue === false || showSearch && (open || focused);

  // We measure width and set to the input immediately
  useLayoutEffect(function () {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]);

  // ===================== Render ======================
  // >>> Render Selector Node. Includes Item & Rest
  var defaultRenderSelector = function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
    return /*#__PURE__*/React__namespace.createElement("span", {
      title: getTitle(item),
      className: classNames("".concat(selectionPrefixCls, "-item"), _defineProperty({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /*#__PURE__*/React__namespace.createElement("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /*#__PURE__*/React__namespace.createElement(TransBtn, {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose,
      customizeIcon: removeIcon
    }, "\xD7"));
  };
  var customizeRenderSelector = function customizeRenderSelector(value, content, itemDisabled, closable, onClose, isMaxTag) {
    var onMouseDown = function onMouseDown(e) {
      onPreventMouseDown(e);
      onToggleOpen(!open);
    };
    return /*#__PURE__*/React__namespace.createElement("span", {
      onMouseDown: onMouseDown
    }, tagRender({
      label: content,
      value: value,
      disabled: itemDisabled,
      closable: closable,
      onClose: onClose,
      isMaxTag: !!isMaxTag
    }));
  };
  var renderItem = function renderItem(valueItem) {
    var itemDisabled = valueItem.disabled,
      label = valueItem.label,
      value = valueItem.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;
    if (typeof maxTagTextLength === 'number') {
      if (typeof label === 'string' || typeof label === 'number') {
        var strLabel = String(displayLabel);
        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }
    var onClose = function onClose(event) {
      if (event) {
        event.stopPropagation();
      }
      onRemove(valueItem);
    };
    return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
  };
  var renderRest = function renderRest(omittedValues) {
    // https://github.com/ant-design/ant-design/issues/48930
    if (!values.length) {
      return null;
    }
    var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
      title: content
    }, content, false);
  };

  // >>> Input Node
  var inputNode = /*#__PURE__*/React__namespace.createElement("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /*#__PURE__*/React__namespace.createElement(RefInput, {
    ref: inputRef,
    open: open,
    prefixCls: prefixCls,
    id: id,
    inputElement: null,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    activeDescendantId: activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex: tabIndex,
    attrs: pickAttrs(props, true)
  }), /*#__PURE__*/React__namespace.createElement("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0"));

  // >>> Selections
  var selectionNode = /*#__PURE__*/React__namespace.createElement(ForwardOverflow, {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem: renderItem,
    renderRest: renderRest,
    suffix: inputNode,
    itemKey: itemKey,
    maxCount: maxTagCount
  });
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: "".concat(selectionPrefixCls, "-wrap")
  }, selectionNode, !values.length && !inputValue && /*#__PURE__*/React__namespace.createElement("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};

var SingleSelector = function SingleSelector(props) {
  var inputElement = props.inputElement,
    prefixCls = props.prefixCls,
    id = props.id,
    inputRef = props.inputRef,
    disabled = props.disabled,
    autoFocus = props.autoFocus,
    autoComplete = props.autoComplete,
    activeDescendantId = props.activeDescendantId,
    mode = props.mode,
    open = props.open,
    values = props.values,
    placeholder = props.placeholder,
    tabIndex = props.tabIndex,
    showSearch = props.showSearch,
    searchValue = props.searchValue,
    activeValue = props.activeValue,
    maxLength = props.maxLength,
    onInputKeyDown = props.onInputKeyDown,
    onInputMouseDown = props.onInputMouseDown,
    onInputChange = props.onInputChange,
    onInputPaste = props.onInputPaste,
    onInputCompositionStart = props.onInputCompositionStart,
    onInputCompositionEnd = props.onInputCompositionEnd,
    onInputBlur = props.onInputBlur,
    title = props.title;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputChanged = _React$useState2[0],
    setInputChanged = _React$useState2[1];
  var combobox = mode === 'combobox';
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || '';
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  React__namespace.useEffect(function () {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);

  // Not show text when closed expect combobox mode
  var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;

  // Get title of selection item
  var selectionTitle = title === undefined ? getTitle(item) : title;
  var placeholderNode = React__namespace.useMemo(function () {
    if (item) {
      return null;
    }
    return /*#__PURE__*/React__namespace.createElement("span", {
      className: "".concat(prefixCls, "-selection-placeholder"),
      style: hasTextInput ? {
        visibility: 'hidden'
      } : undefined
    }, placeholder);
  }, [item, hasTextInput, placeholder, prefixCls]);
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: "".concat(prefixCls, "-selection-wrap")
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /*#__PURE__*/React__namespace.createElement(RefInput, {
    ref: inputRef,
    prefixCls: prefixCls,
    id: id,
    open: open,
    inputElement: inputElement,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    activeDescendantId: activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e) {
      setInputChanged(true);
      onInputChange(e);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    onBlur: onInputBlur,
    tabIndex: tabIndex,
    attrs: pickAttrs(props, true),
    maxLength: combobox ? maxLength : undefined
  })), !combobox && item ? /*#__PURE__*/React__namespace.createElement("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title: selectionTitle
    // 当 Select 已经选中选项时，还需 selection 隐藏但留在原地占位
    // https://github.com/ant-design/ant-design/issues/27688
    // https://github.com/ant-design/ant-design/issues/41530
    ,
    style: hasTextInput ? {
      visibility: 'hidden'
    } : undefined
  }, item.label) : null, placeholderNode);
};

var Selector = function Selector(props, ref) {
  var inputRef = React.useRef(null);
  var compositionStatusRef = React.useRef(false);
  var prefixCls = props.prefixCls,
    open = props.open,
    mode = props.mode,
    showSearch = props.showSearch,
    tokenWithEnter = props.tokenWithEnter,
    disabled = props.disabled,
    prefix = props.prefix,
    autoClearSearchValue = props.autoClearSearchValue,
    onSearch = props.onSearch,
    onSearchSubmit = props.onSearchSubmit,
    onToggleOpen = props.onToggleOpen,
    onInputKeyDown = props.onInputKeyDown,
    onInputBlur = props.onInputBlur,
    domRef = props.domRef;

  // ======================= Ref =======================
  React__namespace.useImperativeHandle(ref, function () {
    return {
      focus: function focus(options) {
        inputRef.current.focus(options);
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });

  // ====================== Input ======================
  var _useLock = useLock(0),
    _useLock2 = _slicedToArray(_useLock, 2),
    getInputMouseDown = _useLock2[0],
    setInputMouseDown = _useLock2[1];
  var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
    var which = event.which;

    // Compatible with multiple lines in TextArea
    var isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
    if (!isTextAreaElement && open && (which === KeyCode.UP || which === KeyCode.DOWN)) {
      event.preventDefault();
    }
    if (onInputKeyDown) {
      onInputKeyDown(event);
    }
    if (which === KeyCode.ENTER && mode === 'tags' && !compositionStatusRef.current && !open) {
      // When menu isn't open, OptionList won't trigger a value change
      // So when enter is pressed, the tag's input value should be emitted here to let selector know
      onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
    }
    // Move within the text box
    if (isTextAreaElement && !open && ~[KeyCode.UP, KeyCode.DOWN, KeyCode.LEFT, KeyCode.RIGHT].indexOf(which)) {
      return;
    }
    if (isValidateOpenKey(which)) {
      onToggleOpen(true);
    }
  };

  /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */
  var onInternalInputMouseDown = function onInternalInputMouseDown() {
    setInputMouseDown(true);
  };

  // When paste come, ignore next onChange
  var pastedTextRef = React.useRef(null);
  var triggerOnSearch = function triggerOnSearch(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };
  var onInputCompositionStart = function onInputCompositionStart() {
    compositionStatusRef.current = true;
  };
  var onInputCompositionEnd = function onInputCompositionEnd(e) {
    compositionStatusRef.current = false;

    // Trigger search again to support `tokenSeparators` with typewriting
    if (mode !== 'combobox') {
      triggerOnSearch(e.target.value);
    }
  };
  var onInputChange = function onInputChange(event) {
    var value = event.target.value;

    // Pasted text should replace back to origin content
    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      // CRLF will be treated as a single space for input element
      var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
      value = value.replace(replacedText, pastedTextRef.current);
    }
    pastedTextRef.current = null;
    triggerOnSearch(value);
  };
  var onInputPaste = function onInputPaste(e) {
    var clipboardData = e.clipboardData;
    var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text');
    pastedTextRef.current = value || '';
  };
  var onClick = function onClick(_ref) {
    var target = _ref.target;
    if (target !== inputRef.current) {
      // Should focus input if click the selector
      var isIE = document.body.style.msTouchAction !== undefined;
      if (isIE) {
        setTimeout(function () {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };
  var onMouseDown = function onMouseDown(event) {
    var inputMouseDown = getInputMouseDown();

    // when mode is combobox and it is disabled, don't prevent default behavior
    // https://github.com/ant-design/ant-design/issues/37320
    // https://github.com/ant-design/ant-design/issues/48281
    if (event.target !== inputRef.current && !inputMouseDown && !(mode === 'combobox' && disabled)) {
      event.preventDefault();
    }
    if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
      if (open && autoClearSearchValue !== false) {
        onSearch('', true, false);
      }
      onToggleOpen();
    }
  };

  // ================= Inner Selector ==================
  var sharedProps = {
    inputRef: inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange: onInputChange,
    onInputPaste: onInputPaste,
    onInputCompositionStart: onInputCompositionStart,
    onInputCompositionEnd: onInputCompositionEnd,
    onInputBlur: onInputBlur
  };
  var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/React__namespace.createElement(SelectSelector, _extends({}, props, sharedProps)) : /*#__PURE__*/React__namespace.createElement(SingleSelector, _extends({}, props, sharedProps));
  return /*#__PURE__*/React__namespace.createElement("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick: onClick,
    onMouseDown: onMouseDown
  }, prefix && /*#__PURE__*/React__namespace.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix), selectNode);
};
var ForwardSelector = /*#__PURE__*/React__namespace.forwardRef(Selector);
if (process.env.NODE_ENV !== 'production') {
  ForwardSelector.displayName = 'Selector';
}

var OrderContext = /*#__PURE__*/React__namespace.createContext(null);

var EMPTY_LIST = [];

/**
 * Will add `div` to document. Nest call will keep order
 * @param render Render DOM in document
 */
function useDom(render, debug) {
  var _React$useState = React__namespace.useState(function () {
      if (!canUseDom()) {
        return null;
      }
      var defaultEle = document.createElement('div');
      if (process.env.NODE_ENV !== 'production' && debug) {
        defaultEle.setAttribute('data-debug', debug);
      }
      return defaultEle;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    ele = _React$useState2[0];

  // ========================== Order ==========================
  var appendedRef = React__namespace.useRef(false);
  var queueCreate = React__namespace.useContext(OrderContext);
  var _React$useState3 = React__namespace.useState(EMPTY_LIST),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    queue = _React$useState4[0],
    setQueue = _React$useState4[1];
  var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function (appendFn) {
    setQueue(function (origin) {
      var newQueue = [appendFn].concat(_toConsumableArray(origin));
      return newQueue;
    });
  });

  // =========================== DOM ===========================
  function append() {
    if (!ele.parentElement) {
      document.body.appendChild(ele);
    }
    appendedRef.current = true;
  }
  function cleanup() {
    var _ele$parentElement;
    (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 ? void 0 : _ele$parentElement.removeChild(ele);
    appendedRef.current = false;
  }
  useLayoutEffect$1(function () {
    if (render) {
      if (queueCreate) {
        queueCreate(append);
      } else {
        append();
      }
    } else {
      cleanup();
    }
    return cleanup;
  }, [render]);
  useLayoutEffect$1(function () {
    if (queue.length) {
      queue.forEach(function (appendFn) {
        return appendFn();
      });
      setQueue(EMPTY_LIST);
    }
  }, [queue]);
  return [ele, mergedQueueCreate];
}

function contains(root, n) {
  if (!root) {
    return false;
  }

  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }

  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

var APPEND_ORDER = 'data-rc-order';
var APPEND_PRIORITY = 'data-rc-priority';
var MARK_KEY = "rc-util-key";
var containerCache = new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mark = _ref.mark;
  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector('head');
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === 'queue') {
    return 'prependQueue';
  }
  return prepend ? 'prepend' : 'append';
}

/**
 * Find style which inject by rc-util
 */
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function (node) {
    return node.tagName === 'STYLE';
  });
}
function injectCSS(css) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!canUseDom()) {
    return null;
  }
  var csp = option.csp,
    prepend = option.prepend,
    _option$priority = option.priority,
    priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === 'prependQueue';
  var styleNode = document.createElement('style');
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    // If is queue `prepend`, it will prepend first style and then append rest style
    if (isPrependQueue) {
      var existStyle = (option.styles || findStyles(container)).filter(function (node) {
        // Ignore style which not injected by rc-util with prepend
        if (!['prepend', 'prependQueue'].includes(node.getAttribute(APPEND_ORDER))) {
          return false;
        }

        // Ignore style which priority less then new style
        var nodePriority = Number(node.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }

    // Use `insertBefore` as `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return (option.styles || findStyles(container)).find(function (node) {
    return node.getAttribute(getMark(option)) === key;
  });
}
function removeCSS(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var existNode = findExistNode(key, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}

/**
 * qiankun will inject `appendChild` to insert into other
 */
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);

  // Find real container when not cached or cached container removed
  if (!cachedRealContainer || !contains(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css, key) {
  var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(originOption);
  var styles = findStyles(container);
  var option = _objectSpread2(_objectSpread2({}, originOption), {}, {
    styles: styles
  });

  // Sync real parent
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

/* eslint-disable no-param-reassign */
function measureScrollbarSize(ele) {
  var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
  var measureEle = document.createElement('div');
  measureEle.id = randomId;

  // Create Style
  var measureStyle = measureEle.style;
  measureStyle.position = 'absolute';
  measureStyle.left = '0';
  measureStyle.top = '0';
  measureStyle.width = '100px';
  measureStyle.height = '100px';
  measureStyle.overflow = 'scroll';

  // Clone Style if needed
  var fallbackWidth;
  var fallbackHeight;
  if (ele) {
    var targetStyle = getComputedStyle(ele);
    measureStyle.scrollbarColor = targetStyle.scrollbarColor;
    measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;

    // Set Webkit style
    var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
    var width = parseInt(webkitScrollbarStyle.width, 10);
    var height = parseInt(webkitScrollbarStyle.height, 10);

    // Try wrap to handle CSP case
    try {
      var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
      var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
      updateCSS("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
    } catch (e) {
      // Can't wrap, just log error
      console.error(e);

      // Get from style directly
      fallbackWidth = width;
      fallbackHeight = height;
    }
  }
  document.body.appendChild(measureEle);

  // Measure. Get fallback style if provided
  var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
  var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;

  // Clean up
  document.body.removeChild(measureEle);
  removeCSS(randomId);
  return {
    width: scrollWidth,
    height: scrollHeight
  };
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  return measureScrollbarSize(target);
}

/**
 * Test usage export. Do not use in your production
 */
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

var UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var uuid$2 = 0;
function useScrollLocker(lock) {
  var mergedLock = !!lock;
  var _React$useState = React__namespace.useState(function () {
      uuid$2 += 1;
      return "".concat(UNIQUE_ID, "_").concat(uuid$2);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    id = _React$useState2[0];
  useLayoutEffect$1(function () {
    if (mergedLock) {
      var scrollbarSize = getTargetScrollBarSize(document.body).width;
      var isOverflow = isBodyOverflowing();
      updateCSS("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
    } else {
      removeCSS(id);
    }
    return function () {
      removeCSS(id);
    };
  }, [mergedLock, id]);
}

var inline = false;
function inlineMock(nextInline) {
  return inline;
}

var getPortalContainer = function getPortalContainer(getContainer) {
  if (getContainer === false) {
    return false;
  }
  if (!canUseDom() || !getContainer) {
    return null;
  }
  if (typeof getContainer === 'string') {
    return document.querySelector(getContainer);
  }
  if (typeof getContainer === 'function') {
    return getContainer();
  }
  return getContainer;
};
var Portal = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var open = props.open,
    autoLock = props.autoLock,
    getContainer = props.getContainer,
    debug = props.debug,
    _props$autoDestroy = props.autoDestroy,
    autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy,
    children = props.children;
  var _React$useState = React__namespace.useState(open),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    shouldRender = _React$useState2[0],
    setShouldRender = _React$useState2[1];
  var mergedRender = shouldRender || open;

  // ========================= Warning =========================
  if (process.env.NODE_ENV !== 'production') {
    warningOnce(canUseDom() || !open, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR.");
  }

  // ====================== Should Render ======================
  React__namespace.useEffect(function () {
    if (autoDestroy || open) {
      setShouldRender(open);
    }
  }, [open, autoDestroy]);

  // ======================== Container ========================
  var _React$useState3 = React__namespace.useState(function () {
      return getPortalContainer(getContainer);
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    innerContainer = _React$useState4[0],
    setInnerContainer = _React$useState4[1];
  React__namespace.useEffect(function () {
    var customizeContainer = getPortalContainer(getContainer);

    // Tell component that we check this in effect which is safe to be `null`
    setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
  });
  var _useDom = useDom(mergedRender && !innerContainer, debug),
    _useDom2 = _slicedToArray(_useDom, 2),
    defaultContainer = _useDom2[0],
    queueCreate = _useDom2[1];
  var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;

  // ========================= Locker ==========================
  useScrollLocker(autoLock && open && canUseDom() && (mergedContainer === defaultContainer || mergedContainer === document.body));

  // =========================== Ref ===========================
  var childRef = null;
  if (children && supportRef(children) && ref) {
    var _ref = children;
    childRef = _ref.ref;
  }
  var mergedRef = useComposeRef(childRef, ref);

  // ========================= Render ==========================
  // Do not render when nothing need render
  // When innerContainer is `undefined`, it may not ready since user use ref in the same render
  if (!mergedRender || !canUseDom() || innerContainer === undefined) {
    return null;
  }

  // Render inline
  var renderInline = mergedContainer === false || inlineMock();
  var reffedChildren = children;
  if (ref) {
    reffedChildren = /*#__PURE__*/React__namespace.cloneElement(children, {
      ref: mergedRef
    });
  }
  return /*#__PURE__*/React__namespace.createElement(OrderContext.Provider, {
    value: queueCreate
  }, renderInline ? reffedChildren : /*#__PURE__*/ReactDOM.createPortal(reffedChildren, mergedContainer));
});
if (process.env.NODE_ENV !== 'production') {
  Portal.displayName = 'Portal';
}

function getRoot(ele) {
  var _ele$getRootNode;
  return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}

/**
 * Check if is in shadowRoot
 */
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}

/**
 * Return shadowRoot if possible
 */
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

function getUseId() {
  // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
  var fullClone = _objectSpread2({}, React__namespace);
  return fullClone.useId;
}
var uuid$1 = 0;
var useOriginId = getUseId();
var useId$1 = useOriginId ?
// Use React `useId`
function useId(id) {
  var reactId = useOriginId();

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (process.env.NODE_ENV === 'test') {
    return 'test-id';
  }
  return reactId;
} :
// Use compatible of `useId`
function useCompatId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = React__namespace.useState('ssr-id'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  React__namespace.useEffect(function () {
    var nextId = uuid$1;
    uuid$1 += 1;
    setInnerId("rc_unique_".concat(nextId));
  }, []);

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (process.env.NODE_ENV === 'test') {
    return 'test-id';
  }

  // Return react native id or inner id
  return innerId;
};

var Context = /*#__PURE__*/React__namespace.createContext({});

var DomWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(DomWrapper, _React$Component);
  var _super = _createSuper(DomWrapper);
  function DomWrapper() {
    _classCallCheck(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(React__namespace.Component);

function _toArray(r) {
  return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest();
}

/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */
function useSyncState(defaultValue) {
  var _React$useReducer = React__namespace.useReducer(function (x) {
      return x + 1;
    }, 0),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    forceUpdate = _React$useReducer2[1];
  var currentValueRef = React__namespace.useRef(defaultValue);
  var getValue = useEvent(function () {
    return currentValueRef.current;
  });
  var setValue = useEvent(function (updater) {
    currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue, setValue];
}

var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
/**
 * Used for disabled motion case.
 * Prepare stage will still work but start & active will be skipped.
 */
var STEP_PREPARED = 'prepared';

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };
  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }
    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== 'undefined' ? window : {});
var style = {};
if (canUseDom()) {
  var _document$createEleme = document.createElement('div');
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if (_typeof(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}

var useDomMotionEvents = (function (onInternalMotionEnd) {
  var cacheElementRef = React.useRef();

  // Remove events
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }

  // Patch events
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);

      // Save as cache in case dom removed trigger by `motionDeadline`
      cacheElementRef.current = element;
    }
  }

  // Clean up when removed
  React__namespace.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});

// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = canUseDom() ? React.useLayoutEffect : React.useEffect;

var useNextFrame = (function () {
  var nextFrameRef = React__namespace.useRef(null);
  function cancelNextFrame() {
    wrapperRaf.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = wrapperRaf(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React__namespace.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});

var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];

/** Skip current step */
var SkipStep = false;
/** Current step should be update in */
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var useStepQueue = (function (status, prepareOnly, callback) {
  var _useState = useSafeState(STEP_NONE),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useNextFrame = useNextFrame(),
    _useNextFrame2 = _slicedToArray(_useNextFrame, 2),
    nextFrame = _useNextFrame2[0],
    cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);
      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else if (nextStep) {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React__namespace.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});

function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
    _ref$motionAppear = _ref.motionAppear,
    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
    _ref$motionLeave = _ref.motionLeave,
    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
    motionDeadline = _ref.motionDeadline,
    motionLeaveImmediately = _ref.motionLeaveImmediately,
    onAppearPrepare = _ref.onAppearPrepare,
    onEnterPrepare = _ref.onEnterPrepare,
    onLeavePrepare = _ref.onLeavePrepare,
    onAppearStart = _ref.onAppearStart,
    onEnterStart = _ref.onEnterStart,
    onLeaveStart = _ref.onLeaveStart,
    onAppearActive = _ref.onAppearActive,
    onEnterActive = _ref.onEnterActive,
    onLeaveActive = _ref.onLeaveActive,
    onAppearEnd = _ref.onAppearEnd,
    onEnterEnd = _ref.onEnterEnd,
    onLeaveEnd = _ref.onLeaveEnd,
    onVisibleChanged = _ref.onVisibleChanged;
  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = useSafeState(),
    _useState2 = _slicedToArray(_useState, 2),
    asyncVisible = _useState2[0],
    setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE),
    _useSyncState2 = _slicedToArray(_useSyncState, 2),
    getStatus = _useSyncState2[0],
    setStatus = _useSyncState2[1];
  var _useState3 = useSafeState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = React.useRef(false);
  var deadlineRef = React.useRef(null);

  // =========================== Dom Node ===========================
  function getDomElement() {
    return getElement();
  }

  // ========================== Motion End ==========================
  var activeRef = React.useRef(false);

  /**
   * Clean up status & style
   */
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = useEvent(function (event) {
    var status = getStatus();
    // Do nothing since not in any transition status.
    // This may happen when `motionDeadline` trigger.
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }

    // Only update status when `canEnd` and not destroyed
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
    _useDomMotionEvents2 = _slicedToArray(_useDomMotionEvents, 1),
    patchMotionEvents = _useDomMotionEvents2[0];

  // ============================= Step =============================
  var getEventHandlers = function getEventHandlers(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = React__namespace.useMemo(function () {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function (newStep) {
      // Only prepare step can be skip
      if (newStep === STEP_PREPARE) {
        var onPrepare = eventHandlers[STEP_PREPARE];
        if (!onPrepare) {
          return SkipStep;
        }
        return onPrepare(getDomElement());
      }

      // Rest step is sync update
      if (step in eventHandlers) {
        var _eventHandlers$step;
        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
      }
      if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
        // Patch events when motion needed
        patchMotionEvents(getDomElement());
        if (motionDeadline > 0) {
          clearTimeout(deadlineRef.current);
          deadlineRef.current = setTimeout(function () {
            onInternalMotionEnd({
              deadline: true
            });
          }, motionDeadline);
        }
      }
      if (step === STEP_PREPARED) {
        updateMotionEndStatus();
      }
      return DoStep;
    }),
    _useStepQueue2 = _slicedToArray(_useStepQueue, 2),
    startStep = _useStepQueue2[0],
    step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;

  // ============================ Status ============================
  var visibleRef = React.useRef(null);

  // Update with new status
  useIsomorphicLayoutEffect(function () {
    // When use Suspense, the `visible` will repeat trigger,
    // But not real change of the `visible`, we need to skip it.
    // https://github.com/ant-design/ant-design/issues/44379
    if (mountedRef.current && visibleRef.current === visible) {
      return;
    }
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    // if (!supportMotion) {
    //   return;
    // }

    var nextStatus;

    // Appear
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }

    // Enter
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }

    // Leave
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);

    // Update to next status
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      // Set back in case no motion but prev status has prepare step
      setStatus(STATUS_NONE);
    }
    visibleRef.current = visible;
  }, [visible]);

  // ============================ Effect ============================
  // Reset when motion changed
  React.useEffect(function () {
    if (
    // Cancel appear
    currentStatus === STATUS_APPEAR && !motionAppear ||
    // Cancel enter
    currentStatus === STATUS_ENTER && !motionEnter ||
    // Cancel leave
    currentStatus === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  React.useEffect(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);

  // Trigger `onVisibleChanged`
  var firstMountChangeRef = React__namespace.useRef(false);
  React.useEffect(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== undefined && currentStatus === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);

  // ============================ Styles ============================
  var mergedStyle = style;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2({
      transition: 'none'
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  if (_typeof(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$removeOnLeave = props.removeOnLeave,
      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
      forceRender = props.forceRender,
      children = props.children,
      motionName = props.motionName,
      leavedClassName = props.leavedClassName,
      eventProps = props.eventProps;
    var _React$useContext = React__namespace.useContext(Context),
      contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);

    // Ref to the react node, it may be a HTMLElement
    var nodeRef = React.useRef();
    // Ref to the dom wrapper in case ref can not pass to HTMLElement
    var wrapperNodeRef = React.useRef();
    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
      _useStatus2 = _slicedToArray(_useStatus, 4),
      status = _useStatus2[0],
      statusStep = _useStatus2[1],
      statusStyle = _useStatus2[2],
      mergedVisible = _useStatus2[3];

    // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`
    var renderedRef = React__namespace.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }

    // ====================== Refs ======================
    var setNodeRef = React__namespace.useCallback(function (node) {
      nodeRef.current = node;
      fillRef(ref, node);
    }, [ref]);

    // ===================== Render =====================
    var motionChildren;
    var mergedProps = _objectSpread2(_objectSpread2({}, eventProps), {}, {
      visible: visible
    });
    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children(_objectSpread2({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      // In motion
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
        className: classNames(getTransitionName(motionName, status), _defineProperty(_defineProperty({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
        style: statusStyle
      }), setNodeRef);
    }

    // Auto inject ref if child node not have `ref` props
    if ( /*#__PURE__*/React__namespace.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var originNodeRef = getNodeRef(motionChildren);
      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/React__namespace.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /*#__PURE__*/React__namespace.createElement(DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
var CSSMotion = genCSSMotion(supportTransition);

var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;
  if (key && _typeof(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }
  return _objectSpread2(_objectSpread2({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);

  // Check prev keys to insert or keep
  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return _objectSpread2(_objectSpread2({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push(_objectSpread2(_objectSpread2({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }

    // If not hit, it means key is removed
    if (!hit) {
      list.push(_objectSpread2(_objectSpread2({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });

  // Add rest to the list
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }

  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */
  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
        status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });

    // Update `STATUS_ADD` to `STATUS_KEEP`
    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

var _excluded$7 = ["component", "children", "onVisibleChanged", "onAllRemoved"],
  _excluded2$1 = ["status"];
var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CSSMotion;
  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    _inherits(CSSMotionList, _React$Component);
    var _super = _createSuper(CSSMotionList);
    function CSSMotionList() {
      var _this;
      _classCallCheck(this, CSSMotionList);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        keyEntities: []
      });
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
      _defineProperty(_assertThisInitialized(_this), "removeKey", function (removeKey) {
        _this.setState(function (prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function (entity) {
            if (entity.key !== removeKey) return entity;
            return _objectSpread2(_objectSpread2({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function () {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function (_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    _createClass(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          _onVisibleChanged = _this$props.onVisibleChanged;
          _this$props.onAllRemoved;
          var restProps = _objectWithoutProperties(_this$props, _excluded$7);
        var Component = component || React__namespace.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/React__namespace.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
          var status = _ref2.status,
            eventProps = _objectWithoutProperties(_ref2, _excluded2$1);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/React__namespace.createElement(CSSMotion$1, _extends({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function (props, ref) {
            return children(_objectSpread2(_objectSpread2({}, props), {}, {
              index: index
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });

            // Remove if already mark as removed
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList;
  }(React__namespace.Component);
  _defineProperty(CSSMotionList, "defaultProps", {
    component: 'div'
  });
  return CSSMotionList;
}
genCSSMotionList(supportTransition);

function Arrow(props) {
  var prefixCls = props.prefixCls,
    align = props.align,
    arrow = props.arrow,
    arrowPos = props.arrowPos;
  var _ref = arrow || {},
    className = _ref.className,
    content = _ref.content;
  var _arrowPos$x = arrowPos.x,
    x = _arrowPos$x === void 0 ? 0 : _arrowPos$x,
    _arrowPos$y = arrowPos.y,
    y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
  var arrowRef = React__namespace.useRef();

  // Skip if no align
  if (!align || !align.points) {
    return null;
  }
  var alignStyle = {
    position: 'absolute'
  };

  // Skip if no need to align
  if (align.autoArrow !== false) {
    var popupPoints = align.points[0];
    var targetPoints = align.points[1];
    var popupTB = popupPoints[0];
    var popupLR = popupPoints[1];
    var targetTB = targetPoints[0];
    var targetLR = targetPoints[1];

    // Top & Bottom
    if (popupTB === targetTB || !['t', 'b'].includes(popupTB)) {
      alignStyle.top = y;
    } else if (popupTB === 't') {
      alignStyle.top = 0;
    } else {
      alignStyle.bottom = 0;
    }

    // Left & Right
    if (popupLR === targetLR || !['l', 'r'].includes(popupLR)) {
      alignStyle.left = x;
    } else if (popupLR === 'l') {
      alignStyle.left = 0;
    } else {
      alignStyle.right = 0;
    }
  }
  return /*#__PURE__*/React__namespace.createElement("div", {
    ref: arrowRef,
    className: classNames("".concat(prefixCls, "-arrow"), className),
    style: alignStyle
  }, content);
}

function Mask(props) {
  var prefixCls = props.prefixCls,
    open = props.open,
    zIndex = props.zIndex,
    mask = props.mask,
    motion = props.motion;
  if (!mask) {
    return null;
  }
  return /*#__PURE__*/React__namespace.createElement(CSSMotion, _extends({}, motion, {
    motionAppear: true,
    visible: open,
    removeOnLeave: true
  }), function (_ref) {
    var className = _ref.className;
    return /*#__PURE__*/React__namespace.createElement("div", {
      style: {
        zIndex: zIndex
      },
      className: classNames("".concat(prefixCls, "-mask"), className)
    });
  });
}

var PopupContent = /*#__PURE__*/React__namespace.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, next) {
  return next.cache;
});
if (process.env.NODE_ENV !== 'production') {
  PopupContent.displayName = 'PopupContent';
}

var Popup = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var popup = props.popup,
    className = props.className,
    prefixCls = props.prefixCls,
    style = props.style,
    target = props.target,
    _onVisibleChanged = props.onVisibleChanged,
    open = props.open,
    keepDom = props.keepDom,
    fresh = props.fresh,
    onClick = props.onClick,
    mask = props.mask,
    arrow = props.arrow,
    arrowPos = props.arrowPos,
    align = props.align,
    motion = props.motion,
    maskMotion = props.maskMotion,
    forceRender = props.forceRender,
    getPopupContainer = props.getPopupContainer,
    autoDestroy = props.autoDestroy,
    Portal = props.portal,
    zIndex = props.zIndex,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onPointerEnter = props.onPointerEnter,
    onPointerDownCapture = props.onPointerDownCapture,
    ready = props.ready,
    offsetX = props.offsetX,
    offsetY = props.offsetY,
    offsetR = props.offsetR,
    offsetB = props.offsetB,
    onAlign = props.onAlign,
    onPrepare = props.onPrepare,
    stretch = props.stretch,
    targetWidth = props.targetWidth,
    targetHeight = props.targetHeight;
  var childNode = typeof popup === 'function' ? popup() : popup;

  // We can not remove holder only when motion finished.
  var isNodeVisible = open || keepDom;

  // ======================= Container ========================
  var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
  var _React$useState = React__namespace.useState(!getPopupContainer || !getPopupContainerNeedParams),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];

  // Delay to show since `getPopupContainer` need target element
  useLayoutEffect$1(function () {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);

  // ========================= Render =========================
  if (!show) {
    return null;
  }

  // >>>>> Offset
  var AUTO = 'auto';
  var offsetStyle = {
    left: '-1000vw',
    top: '-1000vh',
    right: AUTO,
    bottom: AUTO
  };

  // Set align style
  if (ready || !open) {
    var _experimental;
    var points = align.points;
    var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
    var alignRight = dynamicInset && points[0][1] === 'r';
    var alignBottom = dynamicInset && points[0][0] === 'b';
    if (alignRight) {
      offsetStyle.right = offsetR;
      offsetStyle.left = AUTO;
    } else {
      offsetStyle.left = offsetX;
      offsetStyle.right = AUTO;
    }
    if (alignBottom) {
      offsetStyle.bottom = offsetB;
      offsetStyle.top = AUTO;
    } else {
      offsetStyle.top = offsetY;
      offsetStyle.bottom = AUTO;
    }
  }

  // >>>>> Misc
  var miscStyle = {};
  if (stretch) {
    if (stretch.includes('height') && targetHeight) {
      miscStyle.height = targetHeight;
    } else if (stretch.includes('minHeight') && targetHeight) {
      miscStyle.minHeight = targetHeight;
    }
    if (stretch.includes('width') && targetWidth) {
      miscStyle.width = targetWidth;
    } else if (stretch.includes('minWidth') && targetWidth) {
      miscStyle.minWidth = targetWidth;
    }
  }
  if (!open) {
    miscStyle.pointerEvents = 'none';
  }
  return /*#__PURE__*/React__namespace.createElement(Portal, {
    open: forceRender || isNodeVisible,
    getContainer: getPopupContainer && function () {
      return getPopupContainer(target);
    },
    autoDestroy: autoDestroy
  }, /*#__PURE__*/React__namespace.createElement(Mask, {
    prefixCls: prefixCls,
    open: open,
    zIndex: zIndex,
    mask: mask,
    motion: maskMotion
  }), /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
    onResize: onAlign,
    disabled: !open
  }, function (resizeObserverRef) {
    return /*#__PURE__*/React__namespace.createElement(CSSMotion, _extends({
      motionAppear: true,
      motionEnter: true,
      motionLeave: true,
      removeOnLeave: false,
      forceRender: forceRender,
      leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
      onAppearPrepare: onPrepare,
      onEnterPrepare: onPrepare,
      visible: open,
      onVisibleChanged: function onVisibleChanged(nextVisible) {
        var _motion$onVisibleChan;
        motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
        _onVisibleChanged(nextVisible);
      }
    }), function (_ref, motionRef) {
      var motionClassName = _ref.className,
        motionStyle = _ref.style;
      var cls = classNames(prefixCls, motionClassName, className);
      return /*#__PURE__*/React__namespace.createElement("div", {
        ref: composeRef(resizeObserverRef, ref, motionRef),
        className: cls,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          '--arrow-x': "".concat(arrowPos.x || 0, "px"),
          '--arrow-y': "".concat(arrowPos.y || 0, "px")
        }, offsetStyle), miscStyle), motionStyle), {}, {
          boxSizing: 'border-box',
          zIndex: zIndex
        }, style),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onClick: onClick,
        onPointerDownCapture: onPointerDownCapture
      }, arrow && /*#__PURE__*/React__namespace.createElement(Arrow, {
        prefixCls: prefixCls,
        arrow: arrow,
        arrowPos: arrowPos,
        align: align
      }), /*#__PURE__*/React__namespace.createElement(PopupContent, {
        cache: !open && !fresh
      }, childNode));
    });
  }));
});
if (process.env.NODE_ENV !== 'production') {
  Popup.displayName = 'Popup';
}

var TriggerWrapper = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var children = props.children,
    getTriggerDOMNode = props.getTriggerDOMNode;
  var canUseRef = supportRef(children);

  // When use `getTriggerDOMNode`, we should do additional work to get the real dom
  var setRef = React__namespace.useCallback(function (node) {
    fillRef(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
  }, [getTriggerDOMNode]);
  var mergedRef = useComposeRef(setRef, getNodeRef(children));
  return canUseRef ? /*#__PURE__*/React__namespace.cloneElement(children, {
    ref: mergedRef
  }) : children;
});
if (process.env.NODE_ENV !== 'production') {
  TriggerWrapper.displayName = 'TriggerWrapper';
}

var TriggerContext = /*#__PURE__*/React__namespace.createContext(null);

function toArray(val) {
  return val ? Array.isArray(val) ? val : [val] : [];
}
function useAction(mobile, action, showAction, hideAction) {
  return React__namespace.useMemo(function () {
    var mergedShowAction = toArray(showAction !== null && showAction !== void 0 ? showAction : action);
    var mergedHideAction = toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    var showActionSet = new Set(mergedShowAction);
    var hideActionSet = new Set(mergedHideAction);
    if (mobile) {
      if (showActionSet.has('hover')) {
        showActionSet.delete('hover');
        showActionSet.add('click');
      }
      if (hideActionSet.has('hover')) {
        hideActionSet.delete('hover');
        hideActionSet.add('click');
      }
    }
    return [showActionSet, hideActionSet];
  }, [mobile, action, showAction, hideAction]);
}

var isVisible = (function (element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(),
        width = _getBBox.width,
        height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(),
        _width = _element$getBoundingC.width,
        _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
});

function isPointsEq() {
  var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);
  for (var i = 0; i < placements.length; i += 1) {
    var _builtinPlacements$pl;
    var placement = placements[i];
    if (isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return '';
}

/** @deprecated We should not use this if we can refactor all deps */
function getMotion(prefixCls, motion, animation, transitionName) {
  if (motion) {
    return motion;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}
function getWin(ele) {
  return ele.ownerDocument.defaultView;
}

/**
 * Get all the scrollable parent elements of the element
 * @param ele       The element to be detected
 * @param areaOnly  Only return the parent which will cut visible area
 */
function collectScroller(ele) {
  var scrollerList = [];
  var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
  var scrollStyle = ['hidden', 'scroll', 'clip', 'auto'];
  while (current) {
    var _getWin$getComputedSt = getWin(current).getComputedStyle(current),
      overflowX = _getWin$getComputedSt.overflowX,
      overflowY = _getWin$getComputedSt.overflowY,
      overflow = _getWin$getComputedSt.overflow;
    if ([overflowX, overflowY, overflow].some(function (o) {
      return scrollStyle.includes(o);
    })) {
      scrollerList.push(current);
    }
    current = current.parentElement;
  }
  return scrollerList;
}
function toNum(num) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Number.isNaN(num) ? defaultValue : num;
}
function getPxValue(val) {
  return toNum(parseFloat(val), 0);
}
/**
 *
 *
 *  **************************************
 *  *              Border                *
 *  *     **************************     *
 *  *     *                  *     *     *
 *  *  B  *                  *  S  *  B  *
 *  *  o  *                  *  c  *  o  *
 *  *  r  *      Content     *  r  *  r  *
 *  *  d  *                  *  o  *  d  *
 *  *  e  *                  *  l  *  e  *
 *  *  r  ********************  l  *  r  *
 *  *     *        Scroll          *     *
 *  *     **************************     *
 *  *              Border                *
 *  **************************************
 *
 */
/**
 * Get visible area of element
 */
function getVisibleArea(initArea, scrollerList) {
  var visibleArea = _objectSpread2({}, initArea);
  (scrollerList || []).forEach(function (ele) {
    if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) {
      return;
    }

    // Skip if static position which will not affect visible area
    var _getWin$getComputedSt2 = getWin(ele).getComputedStyle(ele),
      overflow = _getWin$getComputedSt2.overflow,
      overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin,
      borderTopWidth = _getWin$getComputedSt2.borderTopWidth,
      borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth,
      borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth,
      borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
    var eleRect = ele.getBoundingClientRect();
    var eleOutHeight = ele.offsetHeight,
      eleInnerHeight = ele.clientHeight,
      eleOutWidth = ele.offsetWidth,
      eleInnerWidth = ele.clientWidth;
    var borderTopNum = getPxValue(borderTopWidth);
    var borderBottomNum = getPxValue(borderBottomWidth);
    var borderLeftNum = getPxValue(borderLeftWidth);
    var borderRightNum = getPxValue(borderRightWidth);
    var scaleX = toNum(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
    var scaleY = toNum(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);

    // Original visible area
    var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
    var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;

    // Cut border size
    var scaledBorderTopWidth = borderTopNum * scaleY;
    var scaledBorderBottomWidth = borderBottomNum * scaleY;
    var scaledBorderLeftWidth = borderLeftNum * scaleX;
    var scaledBorderRightWidth = borderRightNum * scaleX;

    // Clip margin
    var clipMarginWidth = 0;
    var clipMarginHeight = 0;
    if (overflow === 'clip') {
      var clipNum = getPxValue(overflowClipMargin);
      clipMarginWidth = clipNum * scaleX;
      clipMarginHeight = clipNum * scaleY;
    }

    // Region
    var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
    var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
    var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
    var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
    visibleArea.left = Math.max(visibleArea.left, eleLeft);
    visibleArea.top = Math.max(visibleArea.top, eleTop);
    visibleArea.right = Math.min(visibleArea.right, eleRight);
    visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
  });
  return visibleArea;
}

function getUnitOffset(size) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var offsetStr = "".concat(offset);
  var cells = offsetStr.match(/^(.*)\%$/);
  if (cells) {
    return size * (parseFloat(cells[1]) / 100);
  }
  return parseFloat(offsetStr);
}
function getNumberOffset(rect, offset) {
  var _ref = offset || [],
    _ref2 = _slicedToArray(_ref, 2),
    offsetX = _ref2[0],
    offsetY = _ref2[1];
  return [getUnitOffset(rect.width, offsetX), getUnitOffset(rect.height, offsetY)];
}
function splitPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [points[0], points[1]];
}
function getAlignPoint(rect, points) {
  var topBottom = points[0];
  var leftRight = points[1];
  var x;
  var y;

  // Top & Bottom
  if (topBottom === 't') {
    y = rect.y;
  } else if (topBottom === 'b') {
    y = rect.y + rect.height;
  } else {
    y = rect.y + rect.height / 2;
  }

  // Left & Right
  if (leftRight === 'l') {
    x = rect.x;
  } else if (leftRight === 'r') {
    x = rect.x + rect.width;
  } else {
    x = rect.x + rect.width / 2;
  }
  return {
    x: x,
    y: y
  };
}
function reversePoints(points, index) {
  var reverseMap = {
    t: 'b',
    b: 't',
    l: 'r',
    r: 'l'
  };
  return points.map(function (point, i) {
    if (i === index) {
      return reverseMap[point] || 'c';
    }
    return point;
  }).join('');
}
function useAlign(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
  var _React$useState = React__namespace.useState({
      ready: false,
      offsetX: 0,
      offsetY: 0,
      offsetR: 0,
      offsetB: 0,
      arrowX: 0,
      arrowY: 0,
      scaleX: 1,
      scaleY: 1,
      align: builtinPlacements[placement] || {}
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    offsetInfo = _React$useState2[0],
    setOffsetInfo = _React$useState2[1];
  var alignCountRef = React__namespace.useRef(0);
  var scrollerList = React__namespace.useMemo(function () {
    if (!popupEle) {
      return [];
    }
    return collectScroller(popupEle);
  }, [popupEle]);

  // ========================= Flip ==========================
  // We will memo flip info.
  // If size change to make flip, it will memo the flip info and use it in next align.
  var prevFlipRef = React__namespace.useRef({});
  var resetFlipCache = function resetFlipCache() {
    prevFlipRef.current = {};
  };
  if (!open) {
    resetFlipCache();
  }

  // ========================= Align =========================
  var onAlign = useEvent(function () {
    if (popupEle && target && open) {
      var _popupElement$parentE, _popupRect$x, _popupRect$y, _popupElement$parentE2;
      var popupElement = popupEle;
      var doc = popupElement.ownerDocument;
      var win = getWin(popupElement);
      var _win$getComputedStyle = win.getComputedStyle(popupElement),
        width = _win$getComputedStyle.width,
        height = _win$getComputedStyle.height,
        popupPosition = _win$getComputedStyle.position;
      var originLeft = popupElement.style.left;
      var originTop = popupElement.style.top;
      var originRight = popupElement.style.right;
      var originBottom = popupElement.style.bottom;
      var originOverflow = popupElement.style.overflow;

      // Placement
      var placementInfo = _objectSpread2(_objectSpread2({}, builtinPlacements[placement]), popupAlign);

      // placeholder element
      var placeholderElement = doc.createElement('div');
      (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
      placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
      placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
      placeholderElement.style.position = popupPosition;
      placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
      placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");

      // Reset first
      popupElement.style.left = '0';
      popupElement.style.top = '0';
      popupElement.style.right = 'auto';
      popupElement.style.bottom = 'auto';
      popupElement.style.overflow = 'hidden';

      // Calculate align style, we should consider `transform` case
      var targetRect;
      if (Array.isArray(target)) {
        targetRect = {
          x: target[0],
          y: target[1],
          width: 0,
          height: 0
        };
      } else {
        var _rect$x, _rect$y;
        var rect = target.getBoundingClientRect();
        rect.x = (_rect$x = rect.x) !== null && _rect$x !== void 0 ? _rect$x : rect.left;
        rect.y = (_rect$y = rect.y) !== null && _rect$y !== void 0 ? _rect$y : rect.top;
        targetRect = {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        };
      }
      var popupRect = popupElement.getBoundingClientRect();
      popupRect.x = (_popupRect$x = popupRect.x) !== null && _popupRect$x !== void 0 ? _popupRect$x : popupRect.left;
      popupRect.y = (_popupRect$y = popupRect.y) !== null && _popupRect$y !== void 0 ? _popupRect$y : popupRect.top;
      var _doc$documentElement = doc.documentElement,
        clientWidth = _doc$documentElement.clientWidth,
        clientHeight = _doc$documentElement.clientHeight,
        scrollWidth = _doc$documentElement.scrollWidth,
        scrollHeight = _doc$documentElement.scrollHeight,
        scrollTop = _doc$documentElement.scrollTop,
        scrollLeft = _doc$documentElement.scrollLeft;
      var popupHeight = popupRect.height;
      var popupWidth = popupRect.width;
      var targetHeight = targetRect.height;
      var targetWidth = targetRect.width;

      // Get bounding of visible area
      var visibleRegion = {
        left: 0,
        top: 0,
        right: clientWidth,
        bottom: clientHeight
      };
      var scrollRegion = {
        left: -scrollLeft,
        top: -scrollTop,
        right: scrollWidth - scrollLeft,
        bottom: scrollHeight - scrollTop
      };
      var htmlRegion = placementInfo.htmlRegion;
      var VISIBLE = 'visible';
      var VISIBLE_FIRST = 'visibleFirst';
      if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) {
        htmlRegion = VISIBLE;
      }
      var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
      var scrollRegionArea = getVisibleArea(scrollRegion, scrollerList);
      var visibleRegionArea = getVisibleArea(visibleRegion, scrollerList);
      var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;

      // When set to `visibleFirst`,
      // the check `adjust` logic will use `visibleRegion` for check first.
      var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;

      // Record right & bottom align data
      popupElement.style.left = 'auto';
      popupElement.style.top = 'auto';
      popupElement.style.right = '0';
      popupElement.style.bottom = '0';
      var popupMirrorRect = popupElement.getBoundingClientRect();

      // Reset back
      popupElement.style.left = originLeft;
      popupElement.style.top = originTop;
      popupElement.style.right = originRight;
      popupElement.style.bottom = originBottom;
      popupElement.style.overflow = originOverflow;
      (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);

      // Calculate scale
      var _scaleX = toNum(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
      var _scaleY = toNum(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);

      // No need to align since it's not visible in view
      if (_scaleX === 0 || _scaleY === 0 || isDOM(target) && !isVisible(target)) {
        return;
      }

      // Offset
      var offset = placementInfo.offset,
        targetOffset = placementInfo.targetOffset;
      var _getNumberOffset = getNumberOffset(popupRect, offset),
        _getNumberOffset2 = _slicedToArray(_getNumberOffset, 2),
        popupOffsetX = _getNumberOffset2[0],
        popupOffsetY = _getNumberOffset2[1];
      var _getNumberOffset3 = getNumberOffset(targetRect, targetOffset),
        _getNumberOffset4 = _slicedToArray(_getNumberOffset3, 2),
        targetOffsetX = _getNumberOffset4[0],
        targetOffsetY = _getNumberOffset4[1];
      targetRect.x -= targetOffsetX;
      targetRect.y -= targetOffsetY;

      // Points
      var _ref3 = placementInfo.points || [],
        _ref4 = _slicedToArray(_ref3, 2),
        popupPoint = _ref4[0],
        targetPoint = _ref4[1];
      var targetPoints = splitPoints(targetPoint);
      var popupPoints = splitPoints(popupPoint);
      var targetAlignPoint = getAlignPoint(targetRect, targetPoints);
      var popupAlignPoint = getAlignPoint(popupRect, popupPoints);

      // Real align info may not same as origin one
      var nextAlignInfo = _objectSpread2({}, placementInfo);

      // Next Offset
      var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
      var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;

      // ============== Intersection ===============
      // Get area by position. Used for check if flip area is better
      function getIntersectionVisibleArea(offsetX, offsetY) {
        var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
        var l = popupRect.x + offsetX;
        var t = popupRect.y + offsetY;
        var r = l + popupWidth;
        var b = t + popupHeight;
        var visibleL = Math.max(l, area.left);
        var visibleT = Math.max(t, area.top);
        var visibleR = Math.min(r, area.right);
        var visibleB = Math.min(b, area.bottom);
        return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
      }
      var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);

      // As `visibleFirst`, we prepare this for check
      var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);

      // ========================== Overflow ===========================
      var targetAlignPointTL = getAlignPoint(targetRect, ['t', 'l']);
      var popupAlignPointTL = getAlignPoint(popupRect, ['t', 'l']);
      var targetAlignPointBR = getAlignPoint(targetRect, ['b', 'r']);
      var popupAlignPointBR = getAlignPoint(popupRect, ['b', 'r']);
      var overflow = placementInfo.overflow || {};
      var adjustX = overflow.adjustX,
        adjustY = overflow.adjustY,
        shiftX = overflow.shiftX,
        shiftY = overflow.shiftY;
      var supportAdjust = function supportAdjust(val) {
        if (typeof val === 'boolean') {
          return val;
        }
        return val >= 0;
      };

      // Prepare position
      var nextPopupY;
      var nextPopupBottom;
      var nextPopupX;
      var nextPopupRight;
      function syncNextPopupPosition() {
        nextPopupY = popupRect.y + nextOffsetY;
        nextPopupBottom = nextPopupY + popupHeight;
        nextPopupX = popupRect.x + nextOffsetX;
        nextPopupRight = nextPopupX + popupWidth;
      }
      syncNextPopupPosition();

      // >>>>>>>>>> Top & Bottom
      var needAdjustY = supportAdjust(adjustY);
      var sameTB = popupPoints[0] === targetPoints[0];

      // Bottom to Top
      if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
        var tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          tmpNextOffsetY -= popupHeight - targetHeight;
        } else {
          tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
        }
        var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
        var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        newVisibleRecommendArea >= originIntersectionRecommendArea)) {
          prevFlipRef.current.bt = true;
          nextOffsetY = tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.bt = false;
        }
      }

      // Top to Bottom
      if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
        var _tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          _tmpNextOffsetY += popupHeight - targetHeight;
        } else {
          _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
        }
        var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
        var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
          prevFlipRef.current.tb = true;
          nextOffsetY = _tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.tb = false;
        }
      }

      // >>>>>>>>>> Left & Right
      var needAdjustX = supportAdjust(adjustX);

      // >>>>> Flip
      var sameLR = popupPoints[1] === targetPoints[1];

      // Right to Left
      if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
        var tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          tmpNextOffsetX -= popupWidth - targetWidth;
        } else {
          tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
        }
        var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
          prevFlipRef.current.rl = true;
          nextOffsetX = tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.rl = false;
        }
      }

      // Left to Right
      if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
        var _tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          _tmpNextOffsetX += popupWidth - targetWidth;
        } else {
          _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
        }
        var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
        // Of course use larger one
        _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst ||
        // Choose recommend one
        _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
          prevFlipRef.current.lr = true;
          nextOffsetX = _tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.lr = false;
        }
      }

      // ============================ Shift ============================
      syncNextPopupPosition();
      var numShiftX = shiftX === true ? 0 : shiftX;
      if (typeof numShiftX === 'number') {
        // Left
        if (nextPopupX < visibleRegionArea.left) {
          nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
          if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
          }
        }

        // Right
        if (nextPopupRight > visibleRegionArea.right) {
          nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
          if (targetRect.x > visibleRegionArea.right - numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
          }
        }
      }
      var numShiftY = shiftY === true ? 0 : shiftY;
      if (typeof numShiftY === 'number') {
        // Top
        if (nextPopupY < visibleRegionArea.top) {
          nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;

          // When target if far away from visible area
          // Stop shift
          if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
          }
        }

        // Bottom
        if (nextPopupBottom > visibleRegionArea.bottom) {
          nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
          if (targetRect.y > visibleRegionArea.bottom - numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
          }
        }
      }

      // ============================ Arrow ============================
      // Arrow center align
      var popupLeft = popupRect.x + nextOffsetX;
      var popupRight = popupLeft + popupWidth;
      var popupTop = popupRect.y + nextOffsetY;
      var popupBottom = popupTop + popupHeight;
      var targetLeft = targetRect.x;
      var targetRight = targetLeft + targetWidth;
      var targetTop = targetRect.y;
      var targetBottom = targetTop + targetHeight;
      var maxLeft = Math.max(popupLeft, targetLeft);
      var minRight = Math.min(popupRight, targetRight);
      var xCenter = (maxLeft + minRight) / 2;
      var nextArrowX = xCenter - popupLeft;
      var maxTop = Math.max(popupTop, targetTop);
      var minBottom = Math.min(popupBottom, targetBottom);
      var yCenter = (maxTop + minBottom) / 2;
      var nextArrowY = yCenter - popupTop;
      onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);

      // Additional calculate right & bottom position
      var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
      var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
      if (_scaleX === 1) {
        nextOffsetX = Math.round(nextOffsetX);
        offsetX4Right = Math.round(offsetX4Right);
      }
      if (_scaleY === 1) {
        nextOffsetY = Math.round(nextOffsetY);
        offsetY4Bottom = Math.round(offsetY4Bottom);
      }
      var nextOffsetInfo = {
        ready: true,
        offsetX: nextOffsetX / _scaleX,
        offsetY: nextOffsetY / _scaleY,
        offsetR: offsetX4Right / _scaleX,
        offsetB: offsetY4Bottom / _scaleY,
        arrowX: nextArrowX / _scaleX,
        arrowY: nextArrowY / _scaleY,
        scaleX: _scaleX,
        scaleY: _scaleY,
        align: nextAlignInfo
      };
      setOffsetInfo(nextOffsetInfo);
    }
  });
  var triggerAlign = function triggerAlign() {
    alignCountRef.current += 1;
    var id = alignCountRef.current;

    // Merge all align requirement into one frame
    Promise.resolve().then(function () {
      if (alignCountRef.current === id) {
        onAlign();
      }
    });
  };

  // Reset ready status when placement & open changed
  var resetReady = function resetReady() {
    setOffsetInfo(function (ori) {
      return _objectSpread2(_objectSpread2({}, ori), {}, {
        ready: false
      });
    });
  };
  useLayoutEffect$1(resetReady, [placement]);
  useLayoutEffect$1(function () {
    if (!open) {
      resetReady();
    }
  }, [open]);
  return [offsetInfo.ready, offsetInfo.offsetX, offsetInfo.offsetY, offsetInfo.offsetR, offsetInfo.offsetB, offsetInfo.arrowX, offsetInfo.arrowY, offsetInfo.scaleX, offsetInfo.scaleY, offsetInfo.align, triggerAlign];
}

function useWatch(open, target, popup, onAlign, onScroll) {
  useLayoutEffect$1(function () {
    if (open && target && popup) {
      var targetElement = target;
      var popupElement = popup;
      var targetScrollList = collectScroller(targetElement);
      var popupScrollList = collectScroller(popupElement);
      var win = getWin(popupElement);
      var mergedList = new Set([win].concat(_toConsumableArray(targetScrollList), _toConsumableArray(popupScrollList)));
      function notifyScroll() {
        onAlign();
        onScroll();
      }
      mergedList.forEach(function (scroller) {
        scroller.addEventListener('scroll', notifyScroll, {
          passive: true
        });
      });
      win.addEventListener('resize', notifyScroll, {
        passive: true
      });

      // First time always do align
      onAlign();
      return function () {
        mergedList.forEach(function (scroller) {
          scroller.removeEventListener('scroll', notifyScroll);
          win.removeEventListener('resize', notifyScroll);
        });
      };
    }
  }, [open, target, popup]);
}

function useWinClick(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
  var openRef = React__namespace.useRef(open);
  openRef.current = open;
  var popupPointerDownRef = React__namespace.useRef(false);

  // Click to hide is special action since click popup element should not hide
  React__namespace.useEffect(function () {
    if (clickToHide && popupEle && (!mask || maskClosable)) {
      var onPointerDown = function onPointerDown() {
        popupPointerDownRef.current = false;
      };
      var onTriggerClose = function onTriggerClose(e) {
        var _e$composedPath;
        if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target) && !popupPointerDownRef.current) {
          triggerOpen(false);
        }
      };
      var win = getWin(popupEle);
      win.addEventListener('pointerdown', onPointerDown, true);
      win.addEventListener('mousedown', onTriggerClose, true);
      win.addEventListener('contextmenu', onTriggerClose, true);

      // shadow root
      var targetShadowRoot = getShadowRoot(targetEle);
      if (targetShadowRoot) {
        targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
        targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
      }

      // Warning if target and popup not in same root
      if (process.env.NODE_ENV !== 'production') {
        var _targetEle$getRootNod, _popupEle$getRootNode;
        var targetRoot = targetEle === null || targetEle === void 0 || (_targetEle$getRootNod = targetEle.getRootNode) === null || _targetEle$getRootNod === void 0 ? void 0 : _targetEle$getRootNod.call(targetEle);
        var popupRoot = (_popupEle$getRootNode = popupEle.getRootNode) === null || _popupEle$getRootNode === void 0 ? void 0 : _popupEle$getRootNode.call(popupEle);
        warning(targetRoot === popupRoot, "trigger element and popup element should in same shadow root.");
      }
      return function () {
        win.removeEventListener('pointerdown', onPointerDown, true);
        win.removeEventListener('mousedown', onTriggerClose, true);
        win.removeEventListener('contextmenu', onTriggerClose, true);
        if (targetShadowRoot) {
          targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
          targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
        }
      };
    }
  }, [clickToHide, targetEle, popupEle, mask, maskClosable]);
  function onPopupPointerDown() {
    popupPointerDownRef.current = true;
  }
  return onPopupPointerDown;
}

var _excluded$6 = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];

// Removed Props List
// Seems this can be auto
// getDocument?: (element?: HTMLElement) => Document;

// New version will not wrap popup with `rc-trigger-popup-content` when multiple children

function generateTrigger() {
  var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Portal;
  var Trigger = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
    var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls,
      children = props.children,
      _props$action = props.action,
      action = _props$action === void 0 ? 'hover' : _props$action,
      showAction = props.showAction,
      hideAction = props.hideAction,
      popupVisible = props.popupVisible,
      defaultPopupVisible = props.defaultPopupVisible,
      onPopupVisibleChange = props.onPopupVisibleChange,
      afterPopupVisibleChange = props.afterPopupVisibleChange,
      mouseEnterDelay = props.mouseEnterDelay,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      focusDelay = props.focusDelay,
      blurDelay = props.blurDelay,
      mask = props.mask,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
      getPopupContainer = props.getPopupContainer,
      forceRender = props.forceRender,
      autoDestroy = props.autoDestroy,
      destroyPopupOnHide = props.destroyPopupOnHide,
      popup = props.popup,
      popupClassName = props.popupClassName,
      popupStyle = props.popupStyle,
      popupPlacement = props.popupPlacement,
      _props$builtinPlaceme = props.builtinPlacements,
      builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme,
      popupAlign = props.popupAlign,
      zIndex = props.zIndex,
      stretch = props.stretch,
      getPopupClassNameFromAlign = props.getPopupClassNameFromAlign,
      fresh = props.fresh,
      alignPoint = props.alignPoint,
      onPopupClick = props.onPopupClick,
      onPopupAlign = props.onPopupAlign,
      arrow = props.arrow,
      popupMotion = props.popupMotion,
      maskMotion = props.maskMotion,
      popupTransitionName = props.popupTransitionName,
      popupAnimation = props.popupAnimation,
      maskTransitionName = props.maskTransitionName,
      maskAnimation = props.maskAnimation,
      className = props.className,
      getTriggerDOMNode = props.getTriggerDOMNode,
      restProps = _objectWithoutProperties(props, _excluded$6);
    var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;

    // =========================== Mobile ===========================
    var _React$useState = React__namespace.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mobile = _React$useState2[0],
      setMobile = _React$useState2[1];
    useLayoutEffect$1(function () {
      setMobile(isMobile());
    }, []);

    // ========================== Context ===========================
    var subPopupElements = React__namespace.useRef({});
    var parentContext = React__namespace.useContext(TriggerContext);
    var context = React__namespace.useMemo(function () {
      return {
        registerSubPopup: function registerSubPopup(id, subPopupEle) {
          subPopupElements.current[id] = subPopupEle;
          parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
        }
      };
    }, [parentContext]);

    // =========================== Popup ============================
    var id = useId$1();
    var _React$useState3 = React__namespace.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      popupEle = _React$useState4[0],
      setPopupEle = _React$useState4[1];

    // Used for forwardRef popup. Not use internal
    var externalPopupRef = React__namespace.useRef(null);
    var setPopupRef = useEvent(function (node) {
      externalPopupRef.current = node;
      if (isDOM(node) && popupEle !== node) {
        setPopupEle(node);
      }
      parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
    });

    // =========================== Target ===========================
    // Use state to control here since `useRef` update not trigger render
    var _React$useState5 = React__namespace.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      targetEle = _React$useState6[0],
      setTargetEle = _React$useState6[1];

    // Used for forwardRef target. Not use internal
    var externalForwardRef = React__namespace.useRef(null);
    var setTargetRef = useEvent(function (node) {
      if (isDOM(node) && targetEle !== node) {
        setTargetEle(node);
        externalForwardRef.current = node;
      }
    });

    // ========================== Children ==========================
    var child = React__namespace.Children.only(children);
    var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var cloneProps = {};
    var inPopupOrChild = useEvent(function (ele) {
      var _getShadowRoot, _getShadowRoot2;
      var childDOM = targetEle;
      return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = getShadowRoot(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = getShadowRoot(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function (subPopupEle) {
        return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
      });
    });

    // =========================== Motion ===========================
    var mergePopupMotion = getMotion(prefixCls, popupMotion, popupAnimation, popupTransitionName);
    var mergeMaskMotion = getMotion(prefixCls, maskMotion, maskAnimation, maskTransitionName);

    // ============================ Open ============================
    var _React$useState7 = React__namespace.useState(defaultPopupVisible || false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      internalOpen = _React$useState8[0],
      setInternalOpen = _React$useState8[1];

    // Render still use props as first priority
    var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;

    // We use effect sync here in case `popupVisible` back to `undefined`
    var setMergedOpen = useEvent(function (nextOpen) {
      if (popupVisible === undefined) {
        setInternalOpen(nextOpen);
      }
    });
    useLayoutEffect$1(function () {
      setInternalOpen(popupVisible || false);
    }, [popupVisible]);
    var openRef = React__namespace.useRef(mergedOpen);
    openRef.current = mergedOpen;
    var lastTriggerRef = React__namespace.useRef([]);
    lastTriggerRef.current = [];
    var internalTriggerOpen = useEvent(function (nextOpen) {
      var _lastTriggerRef$curre;
      setMergedOpen(nextOpen);

      // Enter or Pointer will both trigger open state change
      // We only need take one to avoid duplicated change event trigger
      // Use `lastTriggerRef` to record last open type
      if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
        lastTriggerRef.current.push(nextOpen);
        onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
      }
    });

    // Trigger for delay
    var delayRef = React__namespace.useRef();
    var clearDelay = function clearDelay() {
      clearTimeout(delayRef.current);
    };
    var triggerOpen = function triggerOpen(nextOpen) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      clearDelay();
      if (delay === 0) {
        internalTriggerOpen(nextOpen);
      } else {
        delayRef.current = setTimeout(function () {
          internalTriggerOpen(nextOpen);
        }, delay * 1000);
      }
    };
    React__namespace.useEffect(function () {
      return clearDelay;
    }, []);

    // ========================== Motion ============================
    var _React$useState9 = React__namespace.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      inMotion = _React$useState10[0],
      setInMotion = _React$useState10[1];
    useLayoutEffect$1(function (firstMount) {
      if (!firstMount || mergedOpen) {
        setInMotion(true);
      }
    }, [mergedOpen]);
    var _React$useState11 = React__namespace.useState(null),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      motionPrepareResolve = _React$useState12[0],
      setMotionPrepareResolve = _React$useState12[1];

    // =========================== Align ============================
    var _React$useState13 = React__namespace.useState(null),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      mousePos = _React$useState14[0],
      setMousePos = _React$useState14[1];
    var setMousePosByEvent = function setMousePosByEvent(event) {
      setMousePos([event.clientX, event.clientY]);
    };
    var _useAlign = useAlign(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign),
      _useAlign2 = _slicedToArray(_useAlign, 11),
      ready = _useAlign2[0],
      offsetX = _useAlign2[1],
      offsetY = _useAlign2[2],
      offsetR = _useAlign2[3],
      offsetB = _useAlign2[4],
      arrowX = _useAlign2[5],
      arrowY = _useAlign2[6],
      scaleX = _useAlign2[7],
      scaleY = _useAlign2[8],
      alignInfo = _useAlign2[9],
      onAlign = _useAlign2[10];
    var _useAction = useAction(mobile, action, showAction, hideAction),
      _useAction2 = _slicedToArray(_useAction, 2),
      showActions = _useAction2[0],
      hideActions = _useAction2[1];
    var clickToShow = showActions.has('click');
    var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
    var triggerAlign = useEvent(function () {
      if (!inMotion) {
        onAlign();
      }
    });
    var onScroll = function onScroll() {
      if (openRef.current && alignPoint && clickToHide) {
        triggerOpen(false);
      }
    };
    useWatch(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
    useLayoutEffect$1(function () {
      triggerAlign();
    }, [mousePos, popupPlacement]);

    // When no builtinPlacements and popupAlign changed
    useLayoutEffect$1(function () {
      if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) {
        triggerAlign();
      }
    }, [JSON.stringify(popupAlign)]);
    var alignedClassName = React__namespace.useMemo(function () {
      var baseClassName = getAlignPopupClassName(builtinPlacements, prefixCls, alignInfo, alignPoint);
      return classNames(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
    }, [alignInfo, getPopupClassNameFromAlign, builtinPlacements, prefixCls, alignPoint]);

    // ============================ Refs ============================
    React__namespace.useImperativeHandle(ref, function () {
      return {
        nativeElement: externalForwardRef.current,
        popupElement: externalPopupRef.current,
        forceAlign: triggerAlign
      };
    });

    // ========================== Stretch ===========================
    var _React$useState15 = React__namespace.useState(0),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      targetWidth = _React$useState16[0],
      setTargetWidth = _React$useState16[1];
    var _React$useState17 = React__namespace.useState(0),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      targetHeight = _React$useState18[0],
      setTargetHeight = _React$useState18[1];
    var syncTargetSize = function syncTargetSize() {
      if (stretch && targetEle) {
        var rect = targetEle.getBoundingClientRect();
        setTargetWidth(rect.width);
        setTargetHeight(rect.height);
      }
    };
    var onTargetResize = function onTargetResize() {
      syncTargetSize();
      triggerAlign();
    };

    // ========================== Motion ============================
    var onVisibleChanged = function onVisibleChanged(visible) {
      setInMotion(false);
      onAlign();
      afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
    };

    // We will trigger align when motion is in prepare
    var onPrepare = function onPrepare() {
      return new Promise(function (resolve) {
        syncTargetSize();
        setMotionPrepareResolve(function () {
          return resolve;
        });
      });
    };
    useLayoutEffect$1(function () {
      if (motionPrepareResolve) {
        onAlign();
        motionPrepareResolve();
        setMotionPrepareResolve(null);
      }
    }, [motionPrepareResolve]);

    // =========================== Action ===========================
    /**
     * Util wrapper for trigger action
     */
    function wrapperAction(eventName, nextOpen, delay, preEvent) {
      cloneProps[eventName] = function (event) {
        var _originChildProps$eve;
        preEvent === null || preEvent === void 0 || preEvent(event);
        triggerOpen(nextOpen, delay);

        // Pass to origin
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [originChildProps, event].concat(args));
      };
    }

    // ======================= Action: Click ========================
    if (clickToShow || clickToHide) {
      cloneProps.onClick = function (event) {
        var _originChildProps$onC;
        if (openRef.current && clickToHide) {
          triggerOpen(false);
        } else if (!openRef.current && clickToShow) {
          setMousePosByEvent(event);
          triggerOpen(true);
        }

        // Pass to origin
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [originChildProps, event].concat(args));
      };
    }

    // Click to hide is special action since click popup element should not hide
    var onPopupPointerDown = useWinClick(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);

    // ======================= Action: Hover ========================
    var hoverToShow = showActions.has('hover');
    var hoverToHide = hideActions.has('hover');
    var onPopupMouseEnter;
    var onPopupMouseLeave;
    if (hoverToShow) {
      // Compatible with old browser which not support pointer event
      wrapperAction('onMouseEnter', true, mouseEnterDelay, function (event) {
        setMousePosByEvent(event);
      });
      wrapperAction('onPointerEnter', true, mouseEnterDelay, function (event) {
        setMousePosByEvent(event);
      });
      onPopupMouseEnter = function onPopupMouseEnter(event) {
        // Only trigger re-open when popup is visible
        if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) {
          triggerOpen(true, mouseEnterDelay);
        }
      };

      // Align Point
      if (alignPoint) {
        cloneProps.onMouseMove = function (event) {
          var _originChildProps$onM;
          // setMousePosByEvent(event);
          (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
        };
      }
    }
    if (hoverToHide) {
      wrapperAction('onMouseLeave', false, mouseLeaveDelay);
      wrapperAction('onPointerLeave', false, mouseLeaveDelay);
      onPopupMouseLeave = function onPopupMouseLeave() {
        triggerOpen(false, mouseLeaveDelay);
      };
    }

    // ======================= Action: Focus ========================
    if (showActions.has('focus')) {
      wrapperAction('onFocus', true, focusDelay);
    }
    if (hideActions.has('focus')) {
      wrapperAction('onBlur', false, blurDelay);
    }

    // ==================== Action: ContextMenu =====================
    if (showActions.has('contextMenu')) {
      cloneProps.onContextMenu = function (event) {
        var _originChildProps$onC2;
        if (openRef.current && hideActions.has('contextMenu')) {
          triggerOpen(false);
        } else {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        event.preventDefault();

        // Pass to origin
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [originChildProps, event].concat(args));
      };
    }

    // ========================= ClassName ==========================
    if (className) {
      cloneProps.className = classNames(originChildProps.className, className);
    }

    // =========================== Render ===========================
    var mergedChildrenProps = _objectSpread2(_objectSpread2({}, originChildProps), cloneProps);

    // Pass props into cloneProps for nest usage
    var passedProps = {};
    var passedEventList = ['onContextMenu', 'onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
    passedEventList.forEach(function (eventName) {
      if (restProps[eventName]) {
        passedProps[eventName] = function () {
          var _mergedChildrenProps$;
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [mergedChildrenProps].concat(args));
          restProps[eventName].apply(restProps, args);
        };
      }
    });

    // Child Node
    var triggerNode = /*#__PURE__*/React__namespace.cloneElement(child, _objectSpread2(_objectSpread2({}, mergedChildrenProps), passedProps));
    var arrowPos = {
      x: arrowX,
      y: arrowY
    };
    var innerArrow = arrow ? _objectSpread2({}, arrow !== true ? arrow : {}) : null;

    // Render
    return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
      disabled: !mergedOpen,
      ref: setTargetRef,
      onResize: onTargetResize
    }, /*#__PURE__*/React__namespace.createElement(TriggerWrapper, {
      getTriggerDOMNode: getTriggerDOMNode
    }, triggerNode)), /*#__PURE__*/React__namespace.createElement(TriggerContext.Provider, {
      value: context
    }, /*#__PURE__*/React__namespace.createElement(Popup, {
      portal: PortalComponent,
      ref: setPopupRef,
      prefixCls: prefixCls,
      popup: popup,
      className: classNames(popupClassName, alignedClassName),
      style: popupStyle,
      target: targetEle,
      onMouseEnter: onPopupMouseEnter,
      onMouseLeave: onPopupMouseLeave
      // https://github.com/ant-design/ant-design/issues/43924
      ,
      onPointerEnter: onPopupMouseEnter,
      zIndex: zIndex
      // Open
      ,
      open: mergedOpen,
      keepDom: inMotion,
      fresh: fresh
      // Click
      ,
      onClick: onPopupClick,
      onPointerDownCapture: onPopupPointerDown
      // Mask
      ,
      mask: mask
      // Motion
      ,
      motion: mergePopupMotion,
      maskMotion: mergeMaskMotion,
      onVisibleChanged: onVisibleChanged,
      onPrepare: onPrepare
      // Portal
      ,
      forceRender: forceRender,
      autoDestroy: mergedAutoDestroy,
      getPopupContainer: getPopupContainer
      // Arrow
      ,
      align: alignInfo,
      arrow: innerArrow,
      arrowPos: arrowPos
      // Align
      ,
      ready: ready,
      offsetX: offsetX,
      offsetY: offsetY,
      offsetR: offsetR,
      offsetB: offsetB,
      onAlign: triggerAlign
      // Stretch
      ,
      stretch: stretch,
      targetWidth: targetWidth / scaleX,
      targetHeight: targetHeight / scaleY
    })));
  });
  if (process.env.NODE_ENV !== 'production') {
    Trigger.displayName = 'Trigger';
  }
  return Trigger;
}
var Trigger = generateTrigger(Portal);

var _excluded$5 = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"];
var getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
  // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ['tl', 'bl'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    bottomRight: {
      points: ['tr', 'br'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    topLeft: {
      points: ['bl', 'tl'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    },
    topRight: {
      points: ['br', 'tr'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      },
      htmlRegion: 'scroll'
    }
  };
};
var SelectTrigger = function SelectTrigger(props, ref) {
  var prefixCls = props.prefixCls;
    props.disabled;
    var visible = props.visible,
    children = props.children,
    popupElement = props.popupElement,
    animation = props.animation,
    transitionName = props.transitionName,
    dropdownStyle = props.dropdownStyle,
    dropdownClassName = props.dropdownClassName,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'ltr' : _props$direction,
    placement = props.placement,
    builtinPlacements = props.builtinPlacements,
    dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
    dropdownRender = props.dropdownRender,
    dropdownAlign = props.dropdownAlign,
    getPopupContainer = props.getPopupContainer,
    empty = props.empty,
    getTriggerDOMNode = props.getTriggerDOMNode,
    onPopupVisibleChange = props.onPopupVisibleChange,
    onPopupMouseEnter = props.onPopupMouseEnter,
    restProps = _objectWithoutProperties(props, _excluded$5);
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  var mergedBuiltinPlacements = React__namespace.useMemo(function () {
    return builtinPlacements || getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [builtinPlacements, dropdownMatchSelectWidth]);

  // ===================== Motion ======================
  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;

  // =================== Popup Width ===================
  var isNumberPopupWidth = typeof dropdownMatchSelectWidth === 'number';
  var stretch = React__namespace.useMemo(function () {
    if (isNumberPopupWidth) {
      return null;
    }
    return dropdownMatchSelectWidth === false ? 'minWidth' : 'width';
  }, [dropdownMatchSelectWidth, isNumberPopupWidth]);
  var popupStyle = dropdownStyle;
  if (isNumberPopupWidth) {
    popupStyle = _objectSpread2(_objectSpread2({}, popupStyle), {}, {
      width: dropdownMatchSelectWidth
    });
  }

  // ======================= Ref =======================
  var triggerPopupRef = React__namespace.useRef(null);
  React__namespace.useImperativeHandle(ref, function () {
    return {
      getPopupElement: function getPopupElement() {
        var _triggerPopupRef$curr;
        return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
      }
    };
  });
  return /*#__PURE__*/React__namespace.createElement(Trigger, _extends({}, restProps, {
    showAction: onPopupVisibleChange ? ['click'] : [],
    hideAction: onPopupVisibleChange ? ['click'] : [],
    popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
    builtinPlacements: mergedBuiltinPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /*#__PURE__*/React__namespace.createElement("div", {
      onMouseEnter: onPopupMouseEnter
    }, popupNode),
    ref: triggerPopupRef,
    stretch: stretch,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer: getPopupContainer,
    popupClassName: classNames(dropdownClassName, _defineProperty({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
    popupStyle: popupStyle,
    getTriggerDOMNode: getTriggerDOMNode,
    onPopupVisibleChange: onPopupVisibleChange
  }), children);
};
var RefSelectTrigger = /*#__PURE__*/React__namespace.forwardRef(SelectTrigger);
if (process.env.NODE_ENV !== 'production') {
  RefSelectTrigger.displayName = 'SelectTrigger';
}

function getKey(data, index) {
  var key = data.key;
  var value;
  if ('value' in data) {
    value = data.value;
  }
  if (key !== null && key !== undefined) {
    return key;
  }
  if (value !== undefined) {
    return value;
  }
  return "rc-index-key-".concat(index);
}
function isValidCount(value) {
  return typeof value !== 'undefined' && !Number.isNaN(value);
}
function fillFieldNames(fieldNames, childrenAsData) {
  var _ref = fieldNames || {},
    label = _ref.label,
    value = _ref.value,
    options = _ref.options,
    groupLabel = _ref.groupLabel;
  var mergedLabel = label || (childrenAsData ? 'children' : 'label');
  return {
    label: mergedLabel,
    value: value || 'value',
    options: options || 'options',
    groupLabel: groupLabel || mergedLabel
  };
}

/**
 * Flat options into flatten list.
 * We use `optionOnly` here is aim to avoid user use nested option group.
 * Here is simply set `key` to the index if not provided.
 */
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    fieldNames = _ref2.fieldNames,
    childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames(fieldNames, false),
    fieldLabel = _fillFieldNames.label,
    fieldValue = _fillFieldNames.value,
    fieldOptions = _fillFieldNames.options,
    groupLabel = _fillFieldNames.groupLabel;
  function dig(list, isGroupOption) {
    if (!Array.isArray(list)) {
      return;
    }
    list.forEach(function (data) {
      if (isGroupOption || !(fieldOptions in data)) {
        var value = data[fieldValue];

        // Option
        flattenList.push({
          key: getKey(data, flattenList.length),
          groupOption: isGroupOption,
          data: data,
          label: data[fieldLabel],
          value: value
        });
      } else {
        var grpLabel = data[groupLabel];
        if (grpLabel === undefined && childrenAsData) {
          grpLabel = data.label;
        }

        // Option Group
        flattenList.push({
          key: getKey(data, flattenList.length),
          group: true,
          data: data,
          label: grpLabel
        });
        dig(data[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}

/**
 * Inject `props` into `option` for legacy usage
 */
function injectPropsWithOption(option) {
  var newOption = _objectSpread2({}, option);
  if (!('props' in newOption)) {
    Object.defineProperty(newOption, 'props', {
      get: function get() {
        warningOnce(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
        return newOption;
      }
    });
  }
  return newOption;
}
var getSeparatedContent = function getSeparatedContent(text, tokens, end) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match = false;
  var separate = function separate(str, _ref3) {
    var _ref4 = _toArray(_ref3),
      token = _ref4[0],
      restTokens = _ref4.slice(1);
    if (!token) {
      return [str];
    }
    var list = str.split(token);
    match = match || list.length > 1;
    return list.reduce(function (prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate(unitStr, restTokens)));
    }, []).filter(Boolean);
  };
  var list = separate(text, tokens);
  if (match) {
    return typeof end !== 'undefined' ? list.slice(0, end) : list;
  } else {
    return null;
  }
};

// Use any here since we do not get the type during compilation

var SelectContext = /*#__PURE__*/React__namespace.createContext(null);

function Polite(props) {
  var visible = props.visible,
    values = props.values;
  if (!visible) {
    return null;
  }

  // Only cut part of values since it's a screen reader
  var MAX_COUNT = 50;
  return /*#__PURE__*/React__namespace.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: 'absolute',
      overflow: 'hidden',
      opacity: 0
    }
  }, "".concat(values.slice(0, MAX_COUNT).map(function (_ref) {
    var label = _ref.label,
      value = _ref.value;
    return ['number', 'string'].includes(_typeof(label)) ? label : value;
  }).join(', ')), values.length > MAX_COUNT ? ', ...' : null);
}

var _excluded$4 = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"];
var DEFAULT_OMIT_PROPS = ['value', 'onChange', 'removeIcon', 'placeholder', 'autoFocus', 'maxTagCount', 'maxTagTextLength', 'maxTagPlaceholder', 'choiceTransitionName', 'onInputKeyDown', 'onPopupScroll', 'tabIndex'];
var isMultiple = function isMultiple(mode) {
  return mode === 'tags' || mode === 'multiple';
};
var BaseSelect = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var _customizeRawInputEle;
  var id = props.id,
    prefixCls = props.prefixCls,
    className = props.className,
    showSearch = props.showSearch,
    tagRender = props.tagRender,
    direction = props.direction,
    omitDomProps = props.omitDomProps,
    displayValues = props.displayValues,
    onDisplayValuesChange = props.onDisplayValuesChange,
    emptyOptions = props.emptyOptions,
    _props$notFoundConten = props.notFoundContent,
    notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten,
    onClear = props.onClear,
    mode = props.mode,
    disabled = props.disabled,
    loading = props.loading,
    getInputElement = props.getInputElement,
    getRawInputElement = props.getRawInputElement,
    open = props.open,
    defaultOpen = props.defaultOpen,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    activeValue = props.activeValue,
    onActiveValueChange = props.onActiveValueChange,
    activeDescendantId = props.activeDescendantId,
    searchValue = props.searchValue,
    autoClearSearchValue = props.autoClearSearchValue,
    onSearch = props.onSearch,
    onSearchSplit = props.onSearchSplit,
    tokenSeparators = props.tokenSeparators,
    allowClear = props.allowClear,
    prefix = props.prefix,
    suffixIcon = props.suffixIcon,
    clearIcon = props.clearIcon,
    OptionList = props.OptionList,
    animation = props.animation,
    transitionName = props.transitionName,
    dropdownStyle = props.dropdownStyle,
    dropdownClassName = props.dropdownClassName,
    dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
    dropdownRender = props.dropdownRender,
    dropdownAlign = props.dropdownAlign,
    placement = props.placement,
    builtinPlacements = props.builtinPlacements,
    getPopupContainer = props.getPopupContainer,
    _props$showAction = props.showAction,
    showAction = _props$showAction === void 0 ? [] : _props$showAction,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyUp = props.onKeyUp,
    onKeyDown = props.onKeyDown,
    onMouseDown = props.onMouseDown,
    restProps = _objectWithoutProperties(props, _excluded$4);

  // ============================== MISC ==============================
  var multiple = isMultiple(mode);
  var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
  var domProps = _objectSpread2({}, restProps);
  DEFAULT_OMIT_PROPS.forEach(function (propName) {
    delete domProps[propName];
  });
  omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function (propName) {
    delete domProps[propName];
  });

  // ============================= Mobile =============================
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mobile = _React$useState2[0],
    setMobile = _React$useState2[1];
  React__namespace.useEffect(function () {
    // Only update on the client side
    setMobile(isMobile());
  }, []);

  // ============================== Refs ==============================
  var containerRef = React__namespace.useRef(null);
  var selectorDomRef = React__namespace.useRef(null);
  var triggerRef = React__namespace.useRef(null);
  var selectorRef = React__namespace.useRef(null);
  var listRef = React__namespace.useRef(null);
  var blurRef = React__namespace.useRef(false);

  /** Used for component focused management */
  var _useDelayReset = useDelayReset(),
    _useDelayReset2 = _slicedToArray(_useDelayReset, 3),
    mockFocused = _useDelayReset2[0],
    setMockFocused = _useDelayReset2[1],
    cancelSetMockFocused = _useDelayReset2[2];

  // =========================== Imperative ===========================
  React__namespace.useImperativeHandle(ref, function () {
    var _selectorRef$current, _selectorRef$current2;
    return {
      focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
      blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
      scrollTo: function scrollTo(arg) {
        var _listRef$current;
        return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
      },
      nativeElement: containerRef.current || selectorDomRef.current
    };
  });

  // ========================== Search Value ==========================
  var mergedSearchValue = React__namespace.useMemo(function () {
    var _displayValues$;
    if (mode !== 'combobox') {
      return searchValue;
    }
    var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
    return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
  }, [searchValue, mode, displayValues]);

  // ========================== Custom Input ==========================
  // Only works in `combobox`
  var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;

  // Used for customize replacement for `rc-cascader`
  var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
  var customizeRawInputRef = useComposeRef(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);

  // ============================== Open ==============================
  // SSR not support Portal which means we need delay `open` for the first time render
  var _React$useState3 = React__namespace.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    rendered = _React$useState4[0],
    setRendered = _React$useState4[1];
  useLayoutEffect$1(function () {
    setRendered(true);
  }, []);
  var _useMergedState = useMergedState(false, {
      defaultValue: defaultOpen,
      value: open
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    innerOpen = _useMergedState2[0],
    setInnerOpen = _useMergedState2[1];
  var mergedOpen = rendered ? innerOpen : false;

  // Not trigger `open` in `combobox` when `notFoundContent` is empty
  var emptyListContent = !notFoundContent && emptyOptions;
  if (disabled || emptyListContent && mergedOpen && mode === 'combobox') {
    mergedOpen = false;
  }
  var triggerOpen = emptyListContent ? false : mergedOpen;
  var onToggleOpen = React__namespace.useCallback(function (newOpen) {
    var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
    if (!disabled) {
      setInnerOpen(nextOpen);
      if (mergedOpen !== nextOpen) {
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
      }
    }
  }, [disabled, mergedOpen, setInnerOpen, onDropdownVisibleChange]);

  // ============================= Search =============================
  var tokenWithEnter = React__namespace.useMemo(function () {
    return (tokenSeparators || []).some(function (tokenSeparator) {
      return ['\n', '\r\n'].includes(tokenSeparator);
    });
  }, [tokenSeparators]);
  var _ref = React__namespace.useContext(SelectContext) || {},
    maxCount = _ref.maxCount,
    rawValues = _ref.rawValues;
  var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
    if (multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) {
      return;
    }
    var ret = true;
    var newSearchText = searchText;
    onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
    var separatedList = getSeparatedContent(searchText, tokenSeparators, isValidCount(maxCount) ? maxCount - rawValues.size : undefined);

    // Check if match the `tokenSeparators`
    var patchLabels = isCompositing ? null : separatedList;

    // Ignore combobox since it's not split-able
    if (mode !== 'combobox' && patchLabels) {
      newSearchText = '';
      onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);

      // Should close when paste finish
      onToggleOpen(false);

      // Tell Selector that break next actions
      ret = false;
    }
    if (onSearch && mergedSearchValue !== newSearchText) {
      onSearch(newSearchText, {
        source: fromTyping ? 'typing' : 'effect'
      });
    }
    return ret;
  };

  // Only triggered when menu is closed & mode is tags
  // If menu is open, OptionList will take charge
  // If mode isn't tags, press enter is not meaningful when you can't see any option
  var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
    // prevent empty tags from appearing when you click the Enter button
    if (!searchText || !searchText.trim()) {
      return;
    }
    onSearch(searchText, {
      source: 'submit'
    });
  };

  // Close will clean up single mode search text
  React__namespace.useEffect(function () {
    if (!mergedOpen && !multiple && mode !== 'combobox') {
      onInternalSearch('', false, false);
    }
  }, [mergedOpen]);

  // ============================ Disabled ============================
  // Close dropdown & remove focus state when disabled change
  React__namespace.useEffect(function () {
    if (innerOpen && disabled) {
      setInnerOpen(false);
    }

    // After onBlur is triggered, the focused does not need to be reset
    if (disabled && !blurRef.current) {
      setMockFocused(false);
    }
  }, [disabled]);

  // ============================ Keyboard ============================
  /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */
  var _useLock = useLock(),
    _useLock2 = _slicedToArray(_useLock, 2),
    getClearLock = _useLock2[0],
    setClearLock = _useLock2[1];
  var keyLockRef = React__namespace.useRef(false);

  // KeyDown
  var onInternalKeyDown = function onInternalKeyDown(event) {
    var clearLock = getClearLock();
    var key = event.key;
    var isEnterKey = key === 'Enter';
    if (isEnterKey) {
      // Do not submit form when type in the input
      if (mode !== 'combobox') {
        event.preventDefault();
      }

      // We only manage open state here, close logic should handle by list component
      if (!mergedOpen) {
        onToggleOpen(true);
      }
    }
    setClearLock(!!mergedSearchValue);

    // Remove value by `backspace`
    if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
      var cloneDisplayValues = _toConsumableArray(displayValues);
      var removedDisplayValue = null;
      for (var i = cloneDisplayValues.length - 1; i >= 0; i -= 1) {
        var current = cloneDisplayValues[i];
        if (!current.disabled) {
          cloneDisplayValues.splice(i, 1);
          removedDisplayValue = current;
          break;
        }
      }
      if (removedDisplayValue) {
        onDisplayValuesChange(cloneDisplayValues, {
          type: 'remove',
          values: [removedDisplayValue]
        });
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
      var _listRef$current2;
      // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
      if (isEnterKey) {
        keyLockRef.current = true;
      }
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [event].concat(rest));
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [event].concat(rest));
  };

  // KeyUp
  var onInternalKeyUp = function onInternalKeyUp(event) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    if (mergedOpen) {
      var _listRef$current3;
      (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [event].concat(rest));
    }
    if (event.key === 'Enter') {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [event].concat(rest));
  };

  // ============================ Selector ============================
  var onSelectorRemove = function onSelectorRemove(val) {
    var newValues = displayValues.filter(function (i) {
      return i !== val;
    });
    onDisplayValuesChange(newValues, {
      type: 'remove',
      values: [val]
    });
  };
  var onInputBlur = function onInputBlur() {
    // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
    keyLockRef.current = false;
  };

  // ========================== Focus / Blur ==========================
  /** Record real focus status */
  var focusRef = React__namespace.useRef(false);
  var onContainerFocus = function onContainerFocus() {
    setMockFocused(true);
    if (!disabled) {
      if (onFocus && !focusRef.current) {
        onFocus.apply(void 0, arguments);
      }

      // `showAction` should handle `focus` if set
      if (showAction.includes('focus')) {
        onToggleOpen(true);
      }
    }
    focusRef.current = true;
  };
  var onContainerBlur = function onContainerBlur() {
    blurRef.current = true;
    setMockFocused(false, function () {
      focusRef.current = false;
      blurRef.current = false;
      onToggleOpen(false);
    });
    if (disabled) {
      return;
    }
    if (mergedSearchValue) {
      // `tags` mode should move `searchValue` into values
      if (mode === 'tags') {
        onSearch(mergedSearchValue, {
          source: 'submit'
        });
      } else if (mode === 'multiple') {
        // `multiple` mode only clean the search value but not trigger event
        onSearch('', {
          source: 'blur'
        });
      }
    }
    if (onBlur) {
      onBlur.apply(void 0, arguments);
    }
  };

  // Give focus back of Select
  var activeTimeoutIds = [];
  React__namespace.useEffect(function () {
    return function () {
      activeTimeoutIds.forEach(function (timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    };
  }, []);
  var onInternalMouseDown = function onInternalMouseDown(event) {
    var _triggerRef$current;
    var target = event.target;
    var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();

    // We should give focus back to selector if clicked item is not focusable
    if (popupElement && popupElement.contains(target)) {
      var timeoutId = setTimeout(function () {
        var index = activeTimeoutIds.indexOf(timeoutId);
        if (index !== -1) {
          activeTimeoutIds.splice(index, 1);
        }
        cancelSetMockFocused();
        if (!mobile && !popupElement.contains(document.activeElement)) {
          var _selectorRef$current3;
          (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
        }
      });
      activeTimeoutIds.push(timeoutId);
    }
    for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      restArgs[_key3 - 1] = arguments[_key3];
    }
    onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [event].concat(restArgs));
  };

  // ============================ Dropdown ============================
  var _React$useState5 = React__namespace.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    forceUpdate = _React$useState6[1];
  // We need force update here since popup dom is render async
  function onPopupMouseEnter() {
    forceUpdate({});
  }

  // Used for raw custom input trigger
  var onTriggerVisibleChange;
  if (customizeRawInputElement) {
    onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
      onToggleOpen(newOpen);
    };
  }

  // Close when click on non-select element
  useSelectTriggerControl(function () {
    var _triggerRef$current2;
    return [containerRef.current, (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()];
  }, triggerOpen, onToggleOpen, !!customizeRawInputElement);

  // ============================ Context =============================
  var baseSelectContext = React__namespace.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, props), {}, {
      notFoundContent: notFoundContent,
      open: mergedOpen,
      triggerOpen: triggerOpen,
      id: id,
      showSearch: mergedShowSearch,
      multiple: multiple,
      toggleOpen: onToggleOpen
    });
  }, [props, notFoundContent, triggerOpen, mergedOpen, id, mergedShowSearch, multiple, onToggleOpen]);

  // ==================================================================
  // ==                            Render                            ==
  // ==================================================================

  // ============================= Arrow ==============================
  var showSuffixIcon = !!suffixIcon || loading;
  var arrowNode;
  if (showSuffixIcon) {
    arrowNode = /*#__PURE__*/React__namespace.createElement(TransBtn, {
      className: classNames("".concat(prefixCls, "-arrow"), _defineProperty({}, "".concat(prefixCls, "-arrow-loading"), loading)),
      customizeIcon: suffixIcon,
      customizeIconProps: {
        loading: loading,
        searchValue: mergedSearchValue,
        open: mergedOpen,
        focused: mockFocused,
        showSearch: mergedShowSearch
      }
    });
  }

  // ============================= Clear ==============================
  var onClearMouseDown = function onClearMouseDown() {
    var _selectorRef$current4;
    onClear === null || onClear === void 0 || onClear();
    (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
    onDisplayValuesChange([], {
      type: 'clear',
      values: displayValues
    });
    onInternalSearch('', false, false);
  };
  var _useAllowClear = useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode),
    mergedAllowClear = _useAllowClear.allowClear,
    clearNode = _useAllowClear.clearIcon;

  // =========================== OptionList ===========================
  var optionList = /*#__PURE__*/React__namespace.createElement(OptionList, {
    ref: listRef
  });

  // ============================= Select =============================
  var mergedClassName = classNames(prefixCls, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));

  // >>> Selector
  var selectorNode = /*#__PURE__*/React__namespace.createElement(RefSelectTrigger, {
    ref: triggerRef,
    disabled: disabled,
    prefixCls: prefixCls,
    visible: triggerOpen,
    popupElement: optionList,
    animation: animation,
    transitionName: transitionName,
    dropdownStyle: dropdownStyle,
    dropdownClassName: dropdownClassName,
    direction: direction,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    dropdownRender: dropdownRender,
    dropdownAlign: dropdownAlign,
    placement: placement,
    builtinPlacements: builtinPlacements,
    getPopupContainer: getPopupContainer,
    empty: emptyOptions,
    getTriggerDOMNode: function getTriggerDOMNode(node) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        selectorDomRef.current || node
      );
    },
    onPopupVisibleChange: onTriggerVisibleChange,
    onPopupMouseEnter: onPopupMouseEnter
  }, customizeRawInputElement ? ( /*#__PURE__*/React__namespace.cloneElement(customizeRawInputElement, {
    ref: customizeRawInputRef
  })) : /*#__PURE__*/React__namespace.createElement(ForwardSelector, _extends({}, props, {
    domRef: selectorDomRef,
    prefixCls: prefixCls,
    inputElement: customizeInputElement,
    ref: selectorRef,
    id: id,
    prefix: prefix,
    showSearch: mergedShowSearch,
    autoClearSearchValue: autoClearSearchValue,
    mode: mode,
    activeDescendantId: activeDescendantId,
    tagRender: tagRender,
    values: displayValues,
    open: mergedOpen,
    onToggleOpen: onToggleOpen,
    activeValue: activeValue,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    onSearchSubmit: onInternalSearchSubmit,
    onRemove: onSelectorRemove,
    tokenWithEnter: tokenWithEnter,
    onInputBlur: onInputBlur
  })));

  // >>> Render
  var renderNode;

  // Render raw
  if (customizeRawInputElement) {
    renderNode = selectorNode;
  } else {
    renderNode = /*#__PURE__*/React__namespace.createElement("div", _extends({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), /*#__PURE__*/React__namespace.createElement(Polite, {
      visible: mockFocused && !mergedOpen,
      values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
  }
  return /*#__PURE__*/React__namespace.createElement(BaseSelectContext.Provider, {
    value: baseSelectContext
  }, renderNode);
});

// Set display name for dev
if (process.env.NODE_ENV !== 'production') {
  BaseSelect.displayName = 'BaseSelect';
}

/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
var OptGroup = function OptGroup() {
  return null;
};
OptGroup.isSelectOptGroup = true;

/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
var Option = function Option() {
  return null;
};
Option.isSelectOption = true;

function omit(obj, fields) {
  var clone = Object.assign({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}

/**
 * Fill component to provided the scroll content real height.
 */
var Filler = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var height = _ref.height,
    offsetY = _ref.offsetY,
    offsetX = _ref.offsetX,
    children = _ref.children,
    prefixCls = _ref.prefixCls,
    onInnerResize = _ref.onInnerResize,
    innerProps = _ref.innerProps,
    rtl = _ref.rtl,
    extra = _ref.extra;
  var outerStyle = {};
  var innerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };
  if (offsetY !== undefined) {
    // Not set `width` since this will break `sticky: right`
    outerStyle = {
      height: height,
      position: 'relative',
      overflow: 'hidden'
    };
    innerStyle = _objectSpread2(_objectSpread2({}, innerStyle), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      transform: "translateY(".concat(offsetY, "px)")
    }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
  }
  return /*#__PURE__*/React__namespace.createElement("div", {
    style: outerStyle
  }, /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
    onResize: function onResize(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /*#__PURE__*/React__namespace.createElement("div", _extends({
    style: innerStyle,
    className: classNames(_defineProperty({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref: ref
  }, innerProps), children, extra)));
});
Filler.displayName = 'Filler';

function Item(_ref) {
  var children = _ref.children,
    setRef = _ref.setRef;
  var refFunc = React__namespace.useCallback(function (node) {
    setRef(node);
  }, []);
  return /*#__PURE__*/React__namespace.cloneElement(children, {
    ref: refFunc
  });
}

function useChildren(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
  var getKey = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function (item, index) {
    var eleIndex = startIndex + index;
    var node = renderFunc(item, eleIndex, {
      style: {
        width: scrollWidth
      },
      offsetX: offsetX
    });
    var key = getKey(item);
    return /*#__PURE__*/React__namespace.createElement(Item, {
      key: key,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node);
  });
}

/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */

/**
 * We assume that 2 list has only 1 item diff and others keeping the order.
 * So we can use dichotomy algorithm to find changed one.
 */
function findListDiffIndex(originList, targetList, getKey) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== undefined) {
      return getKey(item);
    }
    return notExistKey;
  }

  // Loop to find diff one
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i = 0; i < longList.length; i += 1) {
    var shortKey = getItemKey(shortList[i]);
    var longKey = getItemKey(longList[i]);
    if (shortKey !== longKey) {
      diffIndex = i;
      multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple: multiple
  };
}

function useDiffItem(data, getKey, onDiff) {
  var _React$useState = React__namespace.useState(data),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    prevData = _React$useState2[0],
    setPrevData = _React$useState2[1];
  var _React$useState3 = React__namespace.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    diffItem = _React$useState4[0],
    setDiffItem = _React$useState4[1];
  React__namespace.useEffect(function () {
    var diff = findListDiffIndex(prevData || [], data || [], getKey);
    if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
      setDiffItem(data[diff.index]);
    }
    setPrevData(data);
  }, [data]);
  return [diffItem];
}

var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);

var useOriginScroll = (function (isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
  // Do lock for a wheel when scrolling
  var lockRef = React.useRef(false);
  var lockTimeoutRef = React.useRef(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function () {
      lockRef.current = false;
    }, 50);
  }

  // Pass to ref since global add is in closure
  var scrollPingRef = React.useRef({
    top: isScrollAtTop,
    bottom: isScrollAtBottom,
    left: isScrollAtLeft,
    right: isScrollAtRight
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  scrollPingRef.current.left = isScrollAtLeft;
  scrollPingRef.current.right = isScrollAtRight;
  return function (isHorizontal, delta) {
    var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var originScroll = isHorizontal ?
    // Pass origin wheel when on the left
    delta < 0 && scrollPingRef.current.left ||
    // Pass origin wheel when on the right
    delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
    : delta < 0 && scrollPingRef.current.top ||
    // Pass origin wheel when on the bottom
    delta > 0 && scrollPingRef.current.bottom;
    if (smoothOffset && originScroll) {
      // No need lock anymore when it's smooth offset from touchMove interval
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
});

function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll,
/***
 * Return `true` when you need to prevent default event
 */
onWheelDelta) {
  var offsetRef = React.useRef(0);
  var nextFrameRef = React.useRef(null);

  // Firefox patch
  var wheelValueRef = React.useRef(null);
  var isMouseScrollRef = React.useRef(false);

  // Scroll status sync
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
  function onWheelY(e, deltaY) {
    wrapperRaf.cancel(nextFrameRef.current);

    // Do nothing when scroll at the edge, Skip check when is in scroll
    if (originScroll(false, deltaY)) return;

    // Skip if nest List has handled this event
    var event = e;
    if (!event._virtualHandled) {
      event._virtualHandled = true;
    } else {
      return;
    }
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;

    // Proxy of scroll events
    if (!isFF) {
      event.preventDefault();
    }
    nextFrameRef.current = wrapperRaf(function () {
      // Patch a multiple for Firefox to fix wheel number too small
      // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple, false);
      offsetRef.current = 0;
    });
  }
  function onWheelX(event, deltaX) {
    onWheelDelta(deltaX, true);
    if (!isFF) {
      event.preventDefault();
    }
  }

  // Check for which direction does wheel do. `sx` means `shift + wheel`
  var wheelDirectionRef = React.useRef(null);
  var wheelDirectionCleanRef = React.useRef(null);
  function onWheel(event) {
    if (!inVirtual) return;

    // Wait for 2 frame to clean direction
    wrapperRaf.cancel(wheelDirectionCleanRef.current);
    wheelDirectionCleanRef.current = wrapperRaf(function () {
      wheelDirectionRef.current = null;
    }, 2);
    var deltaX = event.deltaX,
      deltaY = event.deltaY,
      shiftKey = event.shiftKey;
    var mergedDeltaX = deltaX;
    var mergedDeltaY = deltaY;
    if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
      mergedDeltaX = deltaY;
      mergedDeltaY = 0;
      wheelDirectionRef.current = 'sx';
    }
    var absX = Math.abs(mergedDeltaX);
    var absY = Math.abs(mergedDeltaY);
    if (wheelDirectionRef.current === null) {
      wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
    }
    if (wheelDirectionRef.current === 'y') {
      onWheelY(event, mergedDeltaY);
    } else {
      onWheelX(event, mergedDeltaX);
    }
  }

  // A patch for firefox
  function onFireFoxScroll(event) {
    if (!inVirtual) return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}

/**
 * Size info need loop query for the `heights` which will has the perf issue.
 * Let cache result for each render phase.
 */
function useGetSize(mergedData, getKey, heights, itemHeight) {
  var _React$useMemo = React__namespace.useMemo(function () {
      return [new Map(), []];
    }, [mergedData, heights.id, itemHeight]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    key2Index = _React$useMemo2[0],
    bottomList = _React$useMemo2[1];
  var getSize = function getSize(startKey) {
    var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
    // Get from cache first
    var startIndex = key2Index.get(startKey);
    var endIndex = key2Index.get(endKey);

    // Loop to fill the cache
    if (startIndex === undefined || endIndex === undefined) {
      var dataLen = mergedData.length;
      for (var i = bottomList.length; i < dataLen; i += 1) {
        var _heights$get;
        var item = mergedData[i];
        var key = getKey(item);
        key2Index.set(key, i);
        var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
        bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
        if (key === startKey) {
          startIndex = i;
        }
        if (key === endKey) {
          endIndex = i;
        }
        if (startIndex !== undefined && endIndex !== undefined) {
          break;
        }
      }
    }
    return {
      top: bottomList[startIndex - 1] || 0,
      bottom: bottomList[endIndex]
    };
  };
  return getSize;
}

// Firefox has low performance of map.
var CacheMap = /*#__PURE__*/function () {
  function CacheMap() {
    _classCallCheck(this, CacheMap);
    _defineProperty(this, "maps", void 0);
    // Used for cache key
    // `useMemo` no need to update if `id` not change
    _defineProperty(this, "id", 0);
    _defineProperty(this, "diffKeys", new Set());
    this.maps = Object.create(null);
  }
  _createClass(CacheMap, [{
    key: "set",
    value: function set(key, value) {
      this.maps[key] = value;
      this.id += 1;
      this.diffKeys.add(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.maps[key];
    }

    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function resetRecord() {
      this.diffKeys.clear();
    }
  }, {
    key: "getRecord",
    value: function getRecord() {
      return this.diffKeys;
    }
  }]);
  return CacheMap;
}();

function parseNumber(value) {
  var num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}
function useHeights(getKey, onItemAdd, onItemRemove) {
  var _React$useState = React__namespace.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    updatedMark = _React$useState2[0],
    setUpdatedMark = _React$useState2[1];
  var instanceRef = React.useRef(new Map());
  var heightsRef = React.useRef(new CacheMap());
  var promiseIdRef = React.useRef(0);
  function cancelRaf() {
    promiseIdRef.current += 1;
  }
  function collectHeight() {
    var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    cancelRaf();
    var doCollect = function doCollect() {
      var changed = false;
      instanceRef.current.forEach(function (element, key) {
        if (element && element.offsetParent) {
          var htmlElement = findDOMNode(element);
          var offsetHeight = htmlElement.offsetHeight;
          var _getComputedStyle = getComputedStyle(htmlElement),
            marginTop = _getComputedStyle.marginTop,
            marginBottom = _getComputedStyle.marginBottom;
          var marginTopNum = parseNumber(marginTop);
          var marginBottomNum = parseNumber(marginBottom);
          var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
          if (heightsRef.current.get(key) !== totalHeight) {
            heightsRef.current.set(key, totalHeight);
            changed = true;
          }
        }
      });

      // Always trigger update mark to tell parent that should re-calculate heights when resized
      if (changed) {
        setUpdatedMark(function (c) {
          return c + 1;
        });
      }
    };
    if (sync) {
      doCollect();
    } else {
      promiseIdRef.current += 1;
      var id = promiseIdRef.current;
      Promise.resolve().then(function () {
        if (id === promiseIdRef.current) {
          doCollect();
        }
      });
    }
  }
  function setInstanceRef(item, instance) {
    var key = getKey(item);
    instanceRef.current.get(key);
    if (instance) {
      instanceRef.current.set(key, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key);
    }
  }
  React.useEffect(function () {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}

var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = React.useRef(false);
  var touchXRef = React.useRef(0);
  var touchYRef = React.useRef(0);
  var elementRef = React.useRef(null);

  // Smooth scroll
  var intervalRef = React.useRef(null);

  /* eslint-disable prefer-const */
  var cleanUpEvents;
  var onTouchMove = function onTouchMove(e) {
    if (touchedRef.current) {
      var currentX = Math.ceil(e.touches[0].pageX);
      var currentY = Math.ceil(e.touches[0].pageY);
      var offsetX = touchXRef.current - currentX;
      var offsetY = touchYRef.current - currentY;
      var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
      if (_isHorizontal) {
        touchXRef.current = currentX;
      } else {
        touchYRef.current = currentY;
      }
      var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
      if (scrollHandled) {
        e.preventDefault();
      }

      // Smooth interval
      clearInterval(intervalRef.current);
      if (scrollHandled) {
        intervalRef.current = setInterval(function () {
          if (_isHorizontal) {
            offsetX *= SMOOTH_PTG;
          } else {
            offsetY *= SMOOTH_PTG;
          }
          var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
          if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) {
            clearInterval(intervalRef.current);
          }
        }, 16);
      }
    }
  };
  var onTouchEnd = function onTouchEnd() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart(e) {
    cleanUpEvents();
    if (e.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchXRef.current = Math.ceil(e.touches[0].pageX);
      touchYRef.current = Math.ceil(e.touches[0].pageY);
      elementRef.current = e.target;
      elementRef.current.addEventListener('touchmove', onTouchMove, {
        passive: false
      });
      elementRef.current.addEventListener('touchend', onTouchEnd, {
        passive: true
      });
    }
  };
  cleanUpEvents = function cleanUpEvents() {
    if (elementRef.current) {
      elementRef.current.removeEventListener('touchmove', onTouchMove);
      elementRef.current.removeEventListener('touchend', onTouchEnd);
    }
  };
  useLayoutEffect$1(function () {
    if (inVirtual) {
      listRef.current.addEventListener('touchstart', onTouchStart, {
        passive: true
      });
    }
    return function () {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}

function smoothScrollOffset(offset) {
  return Math.floor(Math.pow(offset, 0.5));
}
function getPageXY(e, horizontal) {
  var obj = 'touches' in e ? e.touches[0] : e;
  return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function useScrollDrag(inVirtual, componentRef, onScrollOffset) {
  React__namespace.useEffect(function () {
    var ele = componentRef.current;
    if (inVirtual && ele) {
      var mouseDownLock = false;
      var rafId;
      var _offset;
      var stopScroll = function stopScroll() {
        wrapperRaf.cancel(rafId);
      };
      var continueScroll = function continueScroll() {
        stopScroll();
        rafId = wrapperRaf(function () {
          onScrollOffset(_offset);
          continueScroll();
        });
      };
      var onMouseDown = function onMouseDown(e) {
        // Skip if element set draggable
        if (e.target.draggable) {
          return;
        }
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) {
          event._virtualHandled = true;
          mouseDownLock = true;
        }
      };
      var onMouseUp = function onMouseUp() {
        mouseDownLock = false;
        stopScroll();
      };
      var onMouseMove = function onMouseMove(e) {
        if (mouseDownLock) {
          var mouseY = getPageXY(e, false);
          var _ele$getBoundingClien = ele.getBoundingClientRect(),
            top = _ele$getBoundingClien.top,
            bottom = _ele$getBoundingClien.bottom;
          if (mouseY <= top) {
            var diff = top - mouseY;
            _offset = -smoothScrollOffset(diff);
            continueScroll();
          } else if (mouseY >= bottom) {
            var _diff = mouseY - bottom;
            _offset = smoothScrollOffset(_diff);
            continueScroll();
          } else {
            stopScroll();
          }
        }
      };
      ele.addEventListener('mousedown', onMouseDown);
      ele.ownerDocument.addEventListener('mouseup', onMouseUp);
      ele.ownerDocument.addEventListener('mousemove', onMouseMove);
      return function () {
        ele.removeEventListener('mousedown', onMouseDown);
        ele.ownerDocument.removeEventListener('mouseup', onMouseUp);
        ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
        stopScroll();
      };
    }
  }, [inVirtual]);
}

var MAX_TIMES = 10;
function useScrollTo(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = React__namespace.useRef();
  var _React$useState = React__namespace.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    syncState = _React$useState2[0],
    setSyncState = _React$useState2[1];

  // ========================== Sync Scroll ==========================
  useLayoutEffect$1(function () {
    if (syncState && syncState.times < MAX_TIMES) {
      // Never reach
      if (!containerRef.current) {
        setSyncState(function (ori) {
          return _objectSpread2({}, ori);
        });
        return;
      }
      collectHeight();
      var targetAlign = syncState.targetAlign,
        originAlign = syncState.originAlign,
        index = syncState.index,
        offset = syncState.offset;
      var height = containerRef.current.clientHeight;
      var needCollectHeight = false;
      var newTargetAlign = targetAlign;
      var targetTop = null;

      // Go to next frame if height not exist
      if (height) {
        var mergedAlign = targetAlign || originAlign;

        // Get top & bottom
        var stackTop = 0;
        var itemTop = 0;
        var itemBottom = 0;
        var maxLen = Math.min(data.length - 1, index);
        for (var i = 0; i <= maxLen; i += 1) {
          var key = getKey(data[i]);
          itemTop = stackTop;
          var cacheHeight = heights.get(key);
          itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
          stackTop = itemBottom;
        }

        // Check if need sync height (visible range has item not record height)
        var leftHeight = mergedAlign === 'top' ? offset : height - offset;
        for (var _i = maxLen; _i >= 0; _i -= 1) {
          var _key = getKey(data[_i]);
          var _cacheHeight = heights.get(_key);
          if (_cacheHeight === undefined) {
            needCollectHeight = true;
            break;
          }
          leftHeight -= _cacheHeight;
          if (leftHeight <= 0) {
            break;
          }
        }

        // Scroll to
        switch (mergedAlign) {
          case 'top':
            targetTop = itemTop - offset;
            break;
          case 'bottom':
            targetTop = itemBottom - height + offset;
            break;
          default:
            {
              var scrollTop = containerRef.current.scrollTop;
              var scrollBottom = scrollTop + height;
              if (itemTop < scrollTop) {
                newTargetAlign = 'top';
              } else if (itemBottom > scrollBottom) {
                newTargetAlign = 'bottom';
              }
            }
        }
        if (targetTop !== null) {
          syncScrollTop(targetTop);
        }

        // One more time for sync
        if (targetTop !== syncState.lastTop) {
          needCollectHeight = true;
        }
      }

      // Trigger next effect
      if (needCollectHeight) {
        setSyncState(_objectSpread2(_objectSpread2({}, syncState), {}, {
          times: syncState.times + 1,
          targetAlign: newTargetAlign,
          lastTop: targetTop
        }));
      }
    } else if (process.env.NODE_ENV !== 'production' && (syncState === null || syncState === void 0 ? void 0 : syncState.times) === MAX_TIMES) {
      warningOnce(false, 'Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.');
    }
  }, [syncState, containerRef.current]);

  // =========================== Scroll To ===========================
  return function (arg) {
    // When not argument provided, we think dev may want to show the scrollbar
    if (arg === null || arg === undefined) {
      triggerFlash();
      return;
    }

    // Normal scroll logic
    wrapperRaf.cancel(scrollRef.current);
    if (typeof arg === 'number') {
      syncScrollTop(arg);
    } else if (arg && _typeof(arg) === 'object') {
      var index;
      var align = arg.align;
      if ('index' in arg) {
        index = arg.index;
      } else {
        index = data.findIndex(function (item) {
          return getKey(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset,
        offset = _arg$offset === void 0 ? 0 : _arg$offset;
      setSyncState({
        times: 0,
        index: index,
        offset: offset,
        originAlign: align
      });
    }
  };
}

var ScrollBar = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    rtl = props.rtl,
    scrollOffset = props.scrollOffset,
    scrollRange = props.scrollRange,
    onStartMove = props.onStartMove,
    onStopMove = props.onStopMove,
    onScroll = props.onScroll,
    horizontal = props.horizontal,
    spinSize = props.spinSize,
    containerSize = props.containerSize,
    style = props.style,
    propsThumbStyle = props.thumbStyle,
    showScrollBar = props.showScrollBar;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dragging = _React$useState2[0],
    setDragging = _React$useState2[1];
  var _React$useState3 = React__namespace.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    pageXY = _React$useState4[0],
    setPageXY = _React$useState4[1];
  var _React$useState5 = React__namespace.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    startTop = _React$useState6[0],
    setStartTop = _React$useState6[1];
  var isLTR = !rtl;

  // ========================= Refs =========================
  var scrollbarRef = React__namespace.useRef();
  var thumbRef = React__namespace.useRef();

  // ======================= Visible ========================
  var _React$useState7 = React__namespace.useState(showScrollBar),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    visible = _React$useState8[0],
    setVisible = _React$useState8[1];
  var visibleTimeoutRef = React__namespace.useRef();
  var delayHidden = function delayHidden() {
    if (showScrollBar === true || showScrollBar === false) return;
    clearTimeout(visibleTimeoutRef.current);
    setVisible(true);
    visibleTimeoutRef.current = setTimeout(function () {
      setVisible(false);
    }, 3000);
  };

  // ======================== Range =========================
  var enableScrollRange = scrollRange - containerSize || 0;
  var enableOffsetRange = containerSize - spinSize || 0;

  // ========================= Top ==========================
  var top = React__namespace.useMemo(function () {
    if (scrollOffset === 0 || enableScrollRange === 0) {
      return 0;
    }
    var ptg = scrollOffset / enableScrollRange;
    return ptg * enableOffsetRange;
  }, [scrollOffset, enableScrollRange, enableOffsetRange]);

  // ====================== Container =======================
  var onContainerMouseDown = function onContainerMouseDown(e) {
    e.stopPropagation();
    e.preventDefault();
  };

  // ======================== Thumb =========================
  var stateRef = React__namespace.useRef({
    top: top,
    dragging: dragging,
    pageY: pageXY,
    startTop: startTop
  });
  stateRef.current = {
    top: top,
    dragging: dragging,
    pageY: pageXY,
    startTop: startTop
  };
  var onThumbMouseDown = function onThumbMouseDown(e) {
    setDragging(true);
    setPageXY(getPageXY(e, horizontal));
    setStartTop(stateRef.current.top);
    onStartMove();
    e.stopPropagation();
    e.preventDefault();
  };

  // ======================== Effect ========================

  // React make event as passive, but we need to preventDefault
  // Add event on dom directly instead.
  // ref: https://github.com/facebook/react/issues/9809
  React__namespace.useEffect(function () {
    var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
      e.preventDefault();
    };
    var scrollbarEle = scrollbarRef.current;
    var thumbEle = thumbRef.current;
    scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
      passive: false
    });
    thumbEle.addEventListener('touchstart', onThumbMouseDown, {
      passive: false
    });
    return function () {
      scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
      thumbEle.removeEventListener('touchstart', onThumbMouseDown);
    };
  }, []);

  // Pass to effect
  var enableScrollRangeRef = React__namespace.useRef();
  enableScrollRangeRef.current = enableScrollRange;
  var enableOffsetRangeRef = React__namespace.useRef();
  enableOffsetRangeRef.current = enableOffsetRange;
  React__namespace.useEffect(function () {
    if (dragging) {
      var moveRafId;
      var onMouseMove = function onMouseMove(e) {
        var _stateRef$current = stateRef.current,
          stateDragging = _stateRef$current.dragging,
          statePageY = _stateRef$current.pageY,
          stateStartTop = _stateRef$current.startTop;
        wrapperRaf.cancel(moveRafId);
        var rect = scrollbarRef.current.getBoundingClientRect();
        var scale = containerSize / (horizontal ? rect.width : rect.height);
        if (stateDragging) {
          var offset = (getPageXY(e, horizontal) - statePageY) * scale;
          var newTop = stateStartTop;
          if (!isLTR && horizontal) {
            newTop -= offset;
          } else {
            newTop += offset;
          }
          var tmpEnableScrollRange = enableScrollRangeRef.current;
          var tmpEnableOffsetRange = enableOffsetRangeRef.current;
          var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
          var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
          newScrollTop = Math.max(newScrollTop, 0);
          newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
          moveRafId = wrapperRaf(function () {
            onScroll(newScrollTop, horizontal);
          });
        }
      };
      var onMouseUp = function onMouseUp() {
        setDragging(false);
        onStopMove();
      };
      window.addEventListener('mousemove', onMouseMove, {
        passive: true
      });
      window.addEventListener('touchmove', onMouseMove, {
        passive: true
      });
      window.addEventListener('mouseup', onMouseUp, {
        passive: true
      });
      window.addEventListener('touchend', onMouseUp, {
        passive: true
      });
      return function () {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('touchmove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('touchend', onMouseUp);
        wrapperRaf.cancel(moveRafId);
      };
    }
  }, [dragging]);
  React__namespace.useEffect(function () {
    delayHidden();
    return function () {
      clearTimeout(visibleTimeoutRef.current);
    };
  }, [scrollOffset]);

  // ====================== Imperative ======================
  React__namespace.useImperativeHandle(ref, function () {
    return {
      delayHidden: delayHidden
    };
  });

  // ======================== Render ========================
  var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
  var containerStyle = {
    position: 'absolute',
    visibility: visible ? null : 'hidden'
  };
  var thumbStyle = {
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.5)',
    borderRadius: 99,
    cursor: 'pointer',
    userSelect: 'none'
  };
  if (horizontal) {
    // Container
    containerStyle.height = 8;
    containerStyle.left = 0;
    containerStyle.right = 0;
    containerStyle.bottom = 0;

    // Thumb
    thumbStyle.height = '100%';
    thumbStyle.width = spinSize;
    if (isLTR) {
      thumbStyle.left = top;
    } else {
      thumbStyle.right = top;
    }
  } else {
    // Container
    containerStyle.width = 8;
    containerStyle.top = 0;
    containerStyle.bottom = 0;
    if (isLTR) {
      containerStyle.right = 0;
    } else {
      containerStyle.left = 0;
    }

    // Thumb
    thumbStyle.width = '100%';
    thumbStyle.height = spinSize;
    thumbStyle.top = top;
  }
  return /*#__PURE__*/React__namespace.createElement("div", {
    ref: scrollbarRef,
    className: classNames(scrollbarPrefixCls, _defineProperty(_defineProperty(_defineProperty({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
    style: _objectSpread2(_objectSpread2({}, containerStyle), style),
    onMouseDown: onContainerMouseDown,
    onMouseMove: delayHidden
  }, /*#__PURE__*/React__namespace.createElement("div", {
    ref: thumbRef,
    className: classNames("".concat(scrollbarPrefixCls, "-thumb"), _defineProperty({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
    style: _objectSpread2(_objectSpread2({}, thumbStyle), propsThumbStyle),
    onMouseDown: onThumbMouseDown
  }));
});
if (process.env.NODE_ENV !== 'production') {
  ScrollBar.displayName = 'ScrollBar';
}

var MIN_SIZE = 20;
function getSpinSize() {
  var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var baseSize = containerSize / scrollRange * containerSize;
  if (isNaN(baseSize)) {
    baseSize = 0;
  }
  baseSize = Math.max(baseSize, MIN_SIZE);
  return Math.floor(baseSize);
}

var _excluded$3 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"];
var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: 'auto',
  overflowAnchor: 'none'
};
function RawList(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls,
    className = props.className,
    height = props.height,
    itemHeight = props.itemHeight,
    _props$fullHeight = props.fullHeight,
    fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight,
    style = props.style,
    data = props.data,
    children = props.children,
    itemKey = props.itemKey,
    virtual = props.virtual,
    direction = props.direction,
    scrollWidth = props.scrollWidth,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    onScroll = props.onScroll,
    onVirtualScroll = props.onVirtualScroll,
    onVisibleChange = props.onVisibleChange,
    innerProps = props.innerProps,
    extraRender = props.extraRender,
    styles = props.styles,
    _props$showScrollBar = props.showScrollBar,
    showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar,
    restProps = _objectWithoutProperties(props, _excluded$3);

  // =============================== Item Key ===============================
  var getKey = React__namespace.useCallback(function (item) {
    if (typeof itemKey === 'function') {
      return itemKey(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey];
  }, [itemKey]);

  // ================================ Height ================================
  var _useHeights = useHeights(getKey),
    _useHeights2 = _slicedToArray(_useHeights, 4),
    setInstanceRef = _useHeights2[0],
    collectHeight = _useHeights2[1],
    heights = _useHeights2[2],
    heightUpdatedMark = _useHeights2[3];

  // ================================= MISC =================================
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var containerHeight = React__namespace.useMemo(function () {
    return Object.values(heights.maps).reduce(function (total, curr) {
      return total + curr;
    }, 0);
  }, [heights.id, heights.maps]);
  var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
  var isRTL = direction === 'rtl';
  var mergedClassName = classNames(prefixCls, _defineProperty({}, "".concat(prefixCls, "-rtl"), isRTL), className);
  var mergedData = data || EMPTY_DATA;
  var componentRef = React.useRef();
  var fillerInnerRef = React.useRef();
  var containerRef = React.useRef();

  // =============================== Item Key ===============================

  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offsetTop = _useState2[0],
    setOffsetTop = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    offsetLeft = _useState4[0],
    setOffsetLeft = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollMoving = _useState6[0],
    setScrollMoving = _useState6[1];
  var onScrollbarStartMove = function onScrollbarStartMove() {
    setScrollMoving(true);
  };
  var onScrollbarStopMove = function onScrollbarStopMove() {
    setScrollMoving(false);
  };
  var sharedConfig = {
    getKey: getKey
  };

  // ================================ Scroll ================================
  function syncScrollTop(newTop) {
    setOffsetTop(function (origin) {
      var value;
      if (typeof newTop === 'function') {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }

  // ================================ Legacy ================================
  // Put ref here since the range is generate by follow
  var rangeRef = React.useRef({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = React.useRef();
  var _useDiffItem = useDiffItem(mergedData, getKey),
    _useDiffItem2 = _slicedToArray(_useDiffItem, 1),
    diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;

  // ========================== Visible Calculation =========================
  var _React$useMemo = React__namespace.useMemo(function () {
      if (!useVirtual) {
        return {
          scrollHeight: undefined,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }

      // Always use virtual scroll bar in avoid shaking
      if (!inVirtual) {
        var _fillerInnerRef$curre;
        return {
          scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }
      var itemTop = 0;
      var startIndex;
      var startOffset;
      var endIndex;
      var dataLen = mergedData.length;
      for (var i = 0; i < dataLen; i += 1) {
        var _item = mergedData[i];
        var key = getKey(_item);
        var cacheHeight = heights.get(key);
        var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);

        // Check item top in the range
        if (currentItemBottom >= offsetTop && startIndex === undefined) {
          startIndex = i;
          startOffset = itemTop;
        }

        // Check item bottom in the range. We will render additional one item for motion usage
        if (currentItemBottom > offsetTop + height && endIndex === undefined) {
          endIndex = i;
        }
        itemTop = currentItemBottom;
      }

      // When scrollTop at the end but data cut to small count will reach this
      if (startIndex === undefined) {
        startIndex = 0;
        startOffset = 0;
        endIndex = Math.ceil(height / itemHeight);
      }
      if (endIndex === undefined) {
        endIndex = mergedData.length - 1;
      }

      // Give cache to improve scroll experience
      endIndex = Math.min(endIndex + 1, mergedData.length - 1);
      return {
        scrollHeight: itemTop,
        start: startIndex,
        end: endIndex,
        offset: startOffset
      };
    }, [inVirtual, useVirtual, offsetTop, mergedData, heightUpdatedMark, height]),
    scrollHeight = _React$useMemo.scrollHeight,
    start = _React$useMemo.start,
    end = _React$useMemo.end,
    fillerOffset = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;

  // When scroll up, first visible item get real height may not same as `itemHeight`,
  // Which will make scroll jump.
  // Let's sync scroll top to avoid jump
  React__namespace.useLayoutEffect(function () {
    var changedRecord = heights.getRecord();
    if (changedRecord.size === 1) {
      var recordKey = Array.from(changedRecord)[0];
      var startIndexKey = getKey(mergedData[start]);
      if (startIndexKey === recordKey) {
        var realStartHeight = heights.get(recordKey);
        var diffHeight = realStartHeight - itemHeight;
        syncScrollTop(function (ori) {
          return ori + diffHeight;
        });
      }
    }
    heights.resetRecord();
  }, [scrollHeight]);

  // ================================= Size =================================
  var _React$useState = React__namespace.useState({
      width: 0,
      height: height
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    size = _React$useState2[0],
    setSize = _React$useState2[1];
  var onHolderResize = function onHolderResize(sizeInfo) {
    setSize({
      width: sizeInfo.offsetWidth,
      height: sizeInfo.offsetHeight
    });
  };

  // Hack on scrollbar to enable flash call
  var verticalScrollBarRef = React.useRef();
  var horizontalScrollBarRef = React.useRef();
  var horizontalScrollBarSpinSize = React__namespace.useMemo(function () {
    return getSpinSize(size.width, scrollWidth);
  }, [size.width, scrollWidth]);
  var verticalScrollBarSpinSize = React__namespace.useMemo(function () {
    return getSpinSize(size.height, scrollHeight);
  }, [size.height, scrollHeight]);

  // =============================== In Range ===============================
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = React.useRef(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = offsetTop <= 0;
  var isScrollAtBottom = offsetTop >= maxScrollHeight;
  var isScrollAtLeft = offsetLeft <= 0;
  var isScrollAtRight = offsetLeft >= scrollWidth;
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);

  // ================================ Scroll ================================
  var getVirtualScrollInfo = function getVirtualScrollInfo() {
    return {
      x: isRTL ? -offsetLeft : offsetLeft,
      y: offsetTop
    };
  };
  var lastVirtualScrollInfoRef = React.useRef(getVirtualScrollInfo());
  var triggerScroll = useEvent(function (params) {
    if (onVirtualScroll) {
      var nextInfo = _objectSpread2(_objectSpread2({}, getVirtualScrollInfo()), params);

      // Trigger when offset changed
      if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
        onVirtualScroll(nextInfo);
        lastVirtualScrollInfoRef.current = nextInfo;
      }
    }
  });
  function onScrollBar(newScrollOffset, horizontal) {
    var newOffset = newScrollOffset;
    if (horizontal) {
      ReactDOM.flushSync(function () {
        setOffsetLeft(newOffset);
      });
      triggerScroll();
    } else {
      syncScrollTop(newOffset);
    }
  }

  // When data size reduce. It may trigger native scroll event back to fit scroll position
  function onFallbackScroll(e) {
    var newScrollTop = e.currentTarget.scrollTop;
    if (newScrollTop !== offsetTop) {
      syncScrollTop(newScrollTop);
    }

    // Trigger origin onScroll
    onScroll === null || onScroll === void 0 || onScroll(e);
    triggerScroll();
  }
  var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
    var tmpOffsetLeft = nextOffsetLeft;
    var max = !!scrollWidth ? scrollWidth - size.width : 0;
    tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
    tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
    return tmpOffsetLeft;
  };
  var onWheelDelta = useEvent(function (offsetXY, fromHorizontal) {
    if (fromHorizontal) {
      ReactDOM.flushSync(function () {
        setOffsetLeft(function (left) {
          var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
          return keepInHorizontalRange(nextOffsetLeft);
        });
      });
      triggerScroll();
    } else {
      syncScrollTop(function (top) {
        var newTop = top + offsetXY;
        return newTop;
      });
    }
  });

  // Since this added in global,should use ref to keep update
  var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta),
    _useFrameWheel2 = _slicedToArray(_useFrameWheel, 2),
    onRawWheel = _useFrameWheel2[0],
    onFireFoxScroll = _useFrameWheel2[1];

  // Mobile touch move
  useMobileTouchMove(useVirtual, componentRef, function (isHorizontal, delta, smoothOffset, e) {
    var event = e;
    if (originScroll(isHorizontal, delta, smoothOffset)) {
      return false;
    }

    // Fix nest List trigger TouchMove event
    if (!event || !event._virtualHandled) {
      if (event) {
        event._virtualHandled = true;
      }
      onRawWheel({
        preventDefault: function preventDefault() {},
        deltaX: isHorizontal ? delta : 0,
        deltaY: isHorizontal ? 0 : delta
      });
      return true;
    }
    return false;
  });

  // MouseDown drag for scroll
  useScrollDrag(inVirtual, componentRef, function (offset) {
    syncScrollTop(function (top) {
      return top + offset;
    });
  });
  useLayoutEffect$1(function () {
    // Firefox only
    function onMozMousePixelScroll(e) {
      // scrolling at top/bottom limit
      var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
      var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
      if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) {
        e.preventDefault();
      }
    }
    var componentEle = componentRef.current;
    componentEle.addEventListener('wheel', onRawWheel, {
      passive: false
    });
    componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
      passive: true
    });
    componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
      passive: false
    });
    return function () {
      componentEle.removeEventListener('wheel', onRawWheel);
      componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
      componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
    };
  }, [useVirtual, isScrollAtTop, isScrollAtBottom]);

  // Sync scroll left
  useLayoutEffect$1(function () {
    if (scrollWidth) {
      var newOffsetLeft = keepInHorizontalRange(offsetLeft);
      setOffsetLeft(newOffsetLeft);
      triggerScroll({
        x: newOffsetLeft
      });
    }
  }, [size.width, scrollWidth]);

  // ================================= Ref ==================================
  var delayHideScrollBar = function delayHideScrollBar() {
    var _verticalScrollBarRef, _horizontalScrollBarR;
    (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
    (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
  };
  var _scrollTo = useScrollTo(componentRef, mergedData, heights, itemHeight, getKey, function () {
    return collectHeight(true);
  }, syncScrollTop, delayHideScrollBar);
  React__namespace.useImperativeHandle(ref, function () {
    return {
      nativeElement: containerRef.current,
      getScrollInfo: getVirtualScrollInfo,
      scrollTo: function scrollTo(config) {
        function isPosScroll(arg) {
          return arg && _typeof(arg) === 'object' && ('left' in arg || 'top' in arg);
        }
        if (isPosScroll(config)) {
          // Scroll X
          if (config.left !== undefined) {
            setOffsetLeft(keepInHorizontalRange(config.left));
          }

          // Scroll Y
          _scrollTo(config.top);
        } else {
          _scrollTo(config);
        }
      }
    };
  });

  // ================================ Effect ================================
  /** We need told outside that some list not rendered */
  useLayoutEffect$1(function () {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);

  // ================================ Extra =================================
  var getSize = useGetSize(mergedData, getKey, heights, itemHeight);
  var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
    start: start,
    end: end,
    virtual: inVirtual,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    rtl: isRTL,
    getSize: getSize
  });

  // ================================ Render ================================
  var listChildren = useChildren(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = _objectSpread2(_defineProperty({}, fullHeight ? 'height' : 'maxHeight', height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = 'hidden';
      if (scrollWidth) {
        componentStyle.overflowX = 'hidden';
      }
      if (scrollMoving) {
        componentStyle.pointerEvents = 'none';
      }
    }
  }
  var containerProps = {};
  if (isRTL) {
    containerProps.dir = 'rtl';
  }
  return /*#__PURE__*/React__namespace.createElement("div", _extends({
    ref: containerRef,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      position: 'relative'
    }),
    className: mergedClassName
  }, containerProps, restProps), /*#__PURE__*/React__namespace.createElement(RefResizeObserver, {
    onResize: onHolderResize
  }, /*#__PURE__*/React__namespace.createElement(Component, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll,
    onMouseEnter: delayHideScrollBar
  }, /*#__PURE__*/React__namespace.createElement(Filler, {
    prefixCls: prefixCls,
    height: scrollHeight,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    scrollWidth: scrollWidth,
    onInnerResize: collectHeight,
    ref: fillerInnerRef,
    innerProps: innerProps,
    rtl: isRTL,
    extra: extraContent
  }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/React__namespace.createElement(ScrollBar, {
    ref: verticalScrollBarRef,
    prefixCls: prefixCls,
    scrollOffset: offsetTop,
    scrollRange: scrollHeight,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: verticalScrollBarSpinSize,
    containerSize: size.height,
    style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
    showScrollBar: showScrollBar
  }), inVirtual && scrollWidth > size.width && /*#__PURE__*/React__namespace.createElement(ScrollBar, {
    ref: horizontalScrollBarRef,
    prefixCls: prefixCls,
    scrollOffset: offsetLeft,
    scrollRange: scrollWidth,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: horizontalScrollBarSpinSize,
    containerSize: size.width,
    horizontal: true,
    style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
    showScrollBar: showScrollBar
  }));
}
var List = /*#__PURE__*/React__namespace.forwardRef(RawList);
List.displayName = 'List';

/* istanbul ignore file */
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}

var _excluded$2 = ["disabled", "title", "children", "style", "className"];

// export interface OptionListProps<OptionsType extends object[]> {

function isTitleType(content) {
  return typeof content === 'string' || typeof content === 'number';
}

/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */
var OptionList = function OptionList(_, ref) {
  var _useBaseProps = useBaseProps(),
    prefixCls = _useBaseProps.prefixCls,
    id = _useBaseProps.id,
    open = _useBaseProps.open,
    multiple = _useBaseProps.multiple,
    mode = _useBaseProps.mode,
    searchValue = _useBaseProps.searchValue,
    toggleOpen = _useBaseProps.toggleOpen,
    notFoundContent = _useBaseProps.notFoundContent,
    onPopupScroll = _useBaseProps.onPopupScroll;
  var _React$useContext = React__namespace.useContext(SelectContext),
    maxCount = _React$useContext.maxCount,
    flattenOptions = _React$useContext.flattenOptions,
    onActiveValue = _React$useContext.onActiveValue,
    defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption,
    onSelect = _React$useContext.onSelect,
    menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon,
    rawValues = _React$useContext.rawValues,
    fieldNames = _React$useContext.fieldNames,
    virtual = _React$useContext.virtual,
    direction = _React$useContext.direction,
    listHeight = _React$useContext.listHeight,
    listItemHeight = _React$useContext.listItemHeight,
    optionRender = _React$useContext.optionRender;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = useMemo(function () {
    return flattenOptions;
  }, [open, flattenOptions], function (prev, next) {
    return next[0] && prev[1] !== next[1];
  });

  // =========================== List ===========================
  var listRef = React__namespace.useRef(null);
  var overMaxCount = React__namespace.useMemo(function () {
    return multiple && isValidCount(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
  }, [multiple, maxCount, rawValues === null || rawValues === void 0 ? void 0 : rawValues.size]);
  var onListMouseDown = function onListMouseDown(event) {
    event.preventDefault();
  };
  var scrollIntoView = function scrollIntoView(args) {
    var _listRef$current;
    (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === 'number' ? {
      index: args
    } : args);
  };

  // https://github.com/ant-design/ant-design/issues/34975
  var isSelected = React__namespace.useCallback(function (value) {
    if (mode === 'combobox') {
      return false;
    }
    return rawValues.has(value);
  }, [mode, _toConsumableArray(rawValues).toString(), rawValues.size]);

  // ========================== Active ==========================
  var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var len = memoFlattenOptions.length;
    for (var i = 0; i < len; i += 1) {
      var current = (index + i * offset + len) % len;
      var _ref = memoFlattenOptions[current] || {},
        group = _ref.group,
        data = _ref.data;
      if (!group && !(data !== null && data !== void 0 && data.disabled) && (isSelected(data.value) || !overMaxCount)) {
        return current;
      }
    }
    return -1;
  };
  var _React$useState = React__namespace.useState(function () {
      return getEnabledActiveIndex(0);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  var setActive = function setActive(index) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setActiveIndex(index);
    var info = {
      source: fromKeyboard ? 'keyboard' : 'mouse'
    };

    // Trigger active event
    var flattenItem = memoFlattenOptions[index];
    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }
    onActiveValue(flattenItem.value, index, info);
  };

  // Auto active first item when list length or searchValue changed
  React.useEffect(function () {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]);

  // https://github.com/ant-design/ant-design/issues/48036
  var isAriaSelected = React__namespace.useCallback(function (value) {
    if (mode === 'combobox') {
      return String(value).toLowerCase() === searchValue.toLowerCase();
    }
    return rawValues.has(value);
  }, [mode, searchValue, _toConsumableArray(rawValues).toString(), rawValues.size]);

  // Auto scroll to item position in single mode
  React.useEffect(function () {
    /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */
    var timeoutId = setTimeout(function () {
      if (!multiple && open && rawValues.size === 1) {
        var value = Array.from(rawValues)[0];
        var index = memoFlattenOptions.findIndex(function (_ref2) {
          var data = _ref2.data;
          return data.value === value;
        });
        if (index !== -1) {
          setActive(index);
          scrollIntoView(index);
        }
      }
    });

    // Force trigger scrollbar visible when open
    if (open) {
      var _listRef$current2;
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(undefined);
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [open, searchValue]);

  // ========================== Values ==========================
  var onSelectValue = function onSelectValue(value) {
    if (value !== undefined) {
      onSelect(value, {
        selected: !rawValues.has(value)
      });
    }

    // Single mode should always close by select
    if (!multiple) {
      toggleOpen(false);
    }
  };

  // ========================= Keyboard =========================
  React__namespace.useImperativeHandle(ref, function () {
    return {
      onKeyDown: function onKeyDown(event) {
        var which = event.which,
          ctrlKey = event.ctrlKey;
        switch (which) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN:
            {
              var offset = 0;
              if (which === KeyCode.UP) {
                offset = -1;
              } else if (which === KeyCode.DOWN) {
                offset = 1;
              } else if (isPlatformMac() && ctrlKey) {
                if (which === KeyCode.N) {
                  offset = 1;
                } else if (which === KeyCode.P) {
                  offset = -1;
                }
              }
              if (offset !== 0) {
                var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                scrollIntoView(nextActiveIndex);
                setActive(nextActiveIndex, true);
              }
              break;
            }

          // >>> Select (Tab / Enter)
          case KeyCode.TAB:
          case KeyCode.ENTER:
            {
              var _item$data;
              // value
              var item = memoFlattenOptions[activeIndex];
              if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) {
                onSelectValue(item.value);
              } else {
                onSelectValue(undefined);
              }
              if (open) {
                event.preventDefault();
              }
              break;
            }

          // >>> Close
          case KeyCode.ESC:
            {
              toggleOpen(false);
              if (open) {
                event.stopPropagation();
              }
            }
        }
      },
      onKeyUp: function onKeyUp() {},
      scrollTo: function scrollTo(index) {
        scrollIntoView(index);
      }
    };
  });

  // ========================== Render ==========================
  if (memoFlattenOptions.length === 0) {
    return /*#__PURE__*/React__namespace.createElement("div", {
      role: "listbox",
      id: "".concat(id, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var omitFieldNameList = Object.keys(fieldNames).map(function (key) {
    return fieldNames[key];
  });
  var getLabel = function getLabel(item) {
    return item.label;
  };
  function getItemAriaProps(item, index) {
    var group = item.group;
    return {
      role: group ? 'presentation' : 'option',
      id: "".concat(id, "_list_").concat(index)
    };
  }
  var renderItem = function renderItem(index) {
    var item = memoFlattenOptions[index];
    if (!item) {
      return null;
    }
    var itemData = item.data || {};
    var value = itemData.value;
    var group = item.group;
    var attrs = pickAttrs(itemData, true);
    var mergedLabel = getLabel(item);
    return item ? /*#__PURE__*/React__namespace.createElement("div", _extends({
      "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
    }, attrs, {
      key: index
    }, getItemAriaProps(item, index), {
      "aria-selected": isAriaSelected(value)
    }), value) : null;
  };
  var a11yProps = {
    role: 'listbox',
    id: "".concat(id, "_list")
  };
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, virtual && /*#__PURE__*/React__namespace.createElement("div", _extends({}, a11yProps, {
    style: {
      height: 0,
      width: 0,
      overflow: 'hidden'
    }
  }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/React__namespace.createElement(List, {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height: listHeight,
    itemHeight: listItemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll: onPopupScroll,
    virtual: virtual,
    direction: direction,
    innerProps: virtual ? null : a11yProps
  }, function (item, itemIndex) {
    var group = item.group,
      groupOption = item.groupOption,
      data = item.data,
      label = item.label,
      value = item.value;
    var key = data.key;

    // Group
    if (group) {
      var _data$title;
      var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : isTitleType(label) ? label.toString() : undefined;
      return /*#__PURE__*/React__namespace.createElement("div", {
        className: classNames(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data.className),
        title: groupTitle
      }, label !== undefined ? label : key);
    }
    var disabled = data.disabled,
      title = data.title;
      data.children;
      var style = data.style,
      className = data.className,
      otherProps = _objectWithoutProperties(data, _excluded$2);
    var passedProps = omit(otherProps, omitFieldNameList);

    // Option
    var selected = isSelected(value);
    var mergedDisabled = disabled || !selected && overMaxCount;
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = classNames(itemPrefixCls, optionPrefixCls, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
    var mergedLabel = getLabel(item);
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;

    // https://github.com/ant-design/ant-design/issues/34145
    var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
    // https://github.com/ant-design/ant-design/issues/26717
    var optionTitle = isTitleType(content) ? content.toString() : undefined;
    if (title !== undefined) {
      optionTitle = title;
    }
    return /*#__PURE__*/React__namespace.createElement("div", _extends({}, pickAttrs(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
      "aria-selected": isAriaSelected(value),
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || mergedDisabled) {
          return;
        }
        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!mergedDisabled) {
          onSelectValue(value);
        }
      },
      style: style
    }), /*#__PURE__*/React__namespace.createElement("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, typeof optionRender === 'function' ? optionRender(item, {
      index: itemIndex
    }) : content), /*#__PURE__*/React__namespace.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/React__namespace.createElement(TransBtn, {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        value: value,
        disabled: mergedDisabled,
        isSelected: selected
      }
    }, selected ? '✓' : null));
  }));
};
var RefOptionList = /*#__PURE__*/React__namespace.forwardRef(OptionList);
if (process.env.NODE_ENV !== 'production') {
  RefOptionList.displayName = 'OptionList';
}

/**
 * Cache `value` related LabeledValue & options.
 */
var useCache = (function (labeledValues, valueOptions) {
  var cacheRef = React__namespace.useRef({
    values: new Map(),
    options: new Map()
  });
  var filledLabeledValues = React__namespace.useMemo(function () {
    var _cacheRef$current = cacheRef.current,
      prevValueCache = _cacheRef$current.values,
      prevOptionCache = _cacheRef$current.options;

    // Fill label by cache
    var patchedValues = labeledValues.map(function (item) {
      if (item.label === undefined) {
        var _prevValueCache$get;
        return _objectSpread2(_objectSpread2({}, item), {}, {
          label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
        });
      }
      return item;
    });

    // Refresh cache
    var valueCache = new Map();
    var optionCache = new Map();
    patchedValues.forEach(function (item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.current.values = valueCache;
    cacheRef.current.options = optionCache;
    return patchedValues;
  }, [labeledValues, valueOptions]);
  var getOption = React__namespace.useCallback(function (val) {
    return valueOptions.get(val) || cacheRef.current.options.get(val);
  }, [valueOptions]);
  return [filledLabeledValues, getOption];
});

function includes(test, search) {
  return toArray$1(test).join('').toUpperCase().includes(search);
}
var useFilterOptions = (function (options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return React__namespace.useMemo(function () {
    if (!searchValue || filterOption === false) {
      return options;
    }
    var fieldOptions = fieldNames.options,
      fieldLabel = fieldNames.label,
      fieldValue = fieldNames.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOption === 'function';
    var upperSearch = searchValue.toUpperCase();
    var filterFunc = customizeFilter ? filterOption : function (_, option) {
      // Use provided `optionFilterProp`
      if (optionFilterProp) {
        return includes(option[optionFilterProp], upperSearch);
      }

      // Auto select `label` or `value` by option type
      if (option[fieldOptions]) {
        // hack `fieldLabel` since `OptionGroup` children is not `label`
        return includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
      }
      return includes(option[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function (opt) {
      return injectPropsWithOption(opt);
    } : function (opt) {
      return opt;
    };
    options.forEach(function (item) {
      // Group should check child options
      if (item[fieldOptions]) {
        // Check group first
        var matchGroup = filterFunc(searchValue, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          // Check option
          var subOptions = item[fieldOptions].filter(function (subItem) {
            return filterFunc(searchValue, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push(_objectSpread2(_objectSpread2({}, item), {}, _defineProperty({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValue, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  }, [options, filterOption, optionFilterProp, searchValue, fieldNames]);
});

var uuid = 0;

/** Is client side and not jsdom */
var isBrowserClient = process.env.NODE_ENV !== 'test' && canUseDom();

/** Get unique id for accessibility usage */
function getUUID() {
  var retId;

  // Test never reach
  /* istanbul ignore if */
  if (isBrowserClient) {
    retId = uuid;
    uuid += 1;
  } else {
    retId = 'TEST_OR_SSR';
  }
  return retId;
}
function useId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = React__namespace.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  React__namespace.useEffect(function () {
    setInnerId("rc_select_".concat(getUUID()));
  }, []);
  return id || innerId;
}

var _excluded$1 = ["children", "value"],
  _excluded2 = ["children"];
function convertNodeToOption(node) {
  var _ref = node,
    key = _ref.key,
    _ref$props = _ref.props,
    children = _ref$props.children,
    value = _ref$props.value,
    restProps = _objectWithoutProperties(_ref$props, _excluded$1);
  return _objectSpread2({
    key: key,
    value: value !== undefined ? value : key,
    children: children
  }, restProps);
}
function convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return toArray$2(nodes).map(function (node, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(node) || !node.type) {
      return null;
    }
    var _ref2 = node,
      isSelectOptGroup = _ref2.type.isSelectOptGroup,
      key = _ref2.key,
      _ref2$props = _ref2.props,
      children = _ref2$props.children,
      restProps = _objectWithoutProperties(_ref2$props, _excluded2);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    return _objectSpread2(_objectSpread2({
      key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
      label: key
    }, restProps), {}, {
      options: convertChildrenToData(children)
    });
  }).filter(function (data) {
    return data;
  });
}

/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */
var useOptions = function useOptions(options, children, fieldNames, optionFilterProp, optionLabelProp) {
  return React__namespace.useMemo(function () {
    var mergedOptions = options;
    var childrenAsData = !options;
    if (childrenAsData) {
      mergedOptions = convertChildrenToData(children);
    }
    var valueOptions = new Map();
    var labelOptions = new Map();
    var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
      if (key && typeof key === 'string') {
        labelOptionsMap.set(option[key], option);
      }
    };
    var dig = function dig(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // for loop to speed up collection speed
      for (var i = 0; i < optionList.length; i += 1) {
        var option = optionList[i];
        if (!option[fieldNames.options] || isChildren) {
          valueOptions.set(option[fieldNames.value], option);
          setLabelOptions(labelOptions, option, fieldNames.label);
          // https://github.com/ant-design/ant-design/issues/35304
          setLabelOptions(labelOptions, option, optionFilterProp);
          setLabelOptions(labelOptions, option, optionLabelProp);
        } else {
          dig(option[fieldNames.options], true);
        }
      }
    };
    dig(mergedOptions);
    return {
      options: mergedOptions,
      valueOptions: valueOptions,
      labelOptions: labelOptions
    };
  }, [options, children, fieldNames, optionFilterProp, optionLabelProp]);
};

/**
 * Same as `React.useCallback` but always return a memoized function
 * but redirect to real function.
 */
function useRefFunc(callback) {
  var funcRef = React__namespace.useRef();
  funcRef.current = callback;
  var cacheFn = React__namespace.useCallback(function () {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}

function warningProps(props) {
  var mode = props.mode,
    options = props.options,
    children = props.children,
    backfill = props.backfill,
    allowClear = props.allowClear,
    placeholder = props.placeholder,
    getInputElement = props.getInputElement,
    showSearch = props.showSearch,
    onSearch = props.onSearch,
    defaultOpen = props.defaultOpen,
    autoFocus = props.autoFocus,
    labelInValue = props.labelInValue,
    value = props.value,
    inputValue = props.inputValue,
    optionLabelProp = props.optionLabelProp;
  var multiple = isMultiple(mode);
  var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
  var mergedOptions = options || convertChildrenToData(children);

  // `tags` should not set option as disabled
  warningOnce(mode !== 'tags' || mergedOptions.every(function (opt) {
    return !opt.disabled;
  }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');

  // `combobox` & `tags` should option be `string` type
  if (mode === 'tags' || mode === 'combobox') {
    var hasNumberValue = mergedOptions.some(function (item) {
      if (item.options) {
        return item.options.some(function (opt) {
          return typeof ('value' in opt ? opt.value : opt.key) === 'number';
        });
      }
      return typeof ('value' in item ? item.value : item.key) === 'number';
    });
    warningOnce(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
  }

  // `combobox` should not use `optionLabelProp`
  warningOnce(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');

  // Only `combobox` support `backfill`
  warningOnce(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');

  // Only `combobox` support `getInputElement`
  warningOnce(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');

  // Customize `getInputElement` should not use `allowClear` & `placeholder`
  noteOnce(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');

  // `onSearch` should use in `combobox` or `showSearch`
  if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') {
    warningOnce(false, '`onSearch` should work with `showSearch` instead of use alone.');
  }
  noteOnce(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
  if (value !== undefined && value !== null) {
    var values = toArray$1(value);
    warningOnce(!labelInValue || values.every(function (val) {
      return _typeof(val) === 'object' && ('key' in val || 'value' in val);
    }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
    warningOnce(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
  }

  // Syntactic sugar should use correct children type
  if (children) {
    var invalidateChildType = null;
    toArray$2(children).some(function (node) {
      if (! /*#__PURE__*/React__namespace.isValidElement(node) || !node.type) {
        return false;
      }
      var _ref = node,
        type = _ref.type;
      if (type.isSelectOption) {
        return false;
      }
      if (type.isSelectOptGroup) {
        var allChildrenValid = toArray$2(node.props.children).every(function (subNode) {
          if (! /*#__PURE__*/React__namespace.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) {
            return true;
          }
          invalidateChildType = subNode.type;
          return false;
        });
        if (allChildrenValid) {
          return false;
        }
        return true;
      }
      invalidateChildType = type;
      return true;
    });
    if (invalidateChildType) {
      warningOnce(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }
    warningOnce(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
  }
}

// value in Select option should not be null
// note: OptGroup has options too
function warningNullOptions(options, fieldNames) {
  if (options) {
    var recursiveOptions = function recursiveOptions(optionsList) {
      var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var i = 0; i < optionsList.length; i++) {
        var option = optionsList[i];
        if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
          warningOnce(false, '`value` in Select options should not be `null`.');
          return true;
        }
        if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) {
          break;
        }
      }
    };
    recursiveOptions(options);
  }
}

var _excluded = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"];
var OMIT_DOM_PROPS = ['inputValue'];
function isRawValue(value) {
  return !value || _typeof(value) !== 'object';
}
var Select = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var id = props.id,
    mode = props.mode,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls,
    backfill = props.backfill,
    fieldNames = props.fieldNames,
    inputValue = props.inputValue,
    searchValue = props.searchValue,
    onSearch = props.onSearch,
    _props$autoClearSearc = props.autoClearSearchValue,
    autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
    onSelect = props.onSelect,
    onDeselect = props.onDeselect,
    _props$dropdownMatchS = props.dropdownMatchSelectWidth,
    dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS,
    filterOption = props.filterOption,
    filterSort = props.filterSort,
    optionFilterProp = props.optionFilterProp,
    optionLabelProp = props.optionLabelProp,
    options = props.options,
    optionRender = props.optionRender,
    children = props.children,
    defaultActiveFirstOption = props.defaultActiveFirstOption,
    menuItemSelectedIcon = props.menuItemSelectedIcon,
    virtual = props.virtual,
    direction = props.direction,
    _props$listHeight = props.listHeight,
    listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight,
    _props$listItemHeight = props.listItemHeight,
    listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight,
    labelRender = props.labelRender,
    value = props.value,
    defaultValue = props.defaultValue,
    labelInValue = props.labelInValue,
    onChange = props.onChange,
    maxCount = props.maxCount,
    restProps = _objectWithoutProperties(props, _excluded);
  var mergedId = useId(id);
  var multiple = isMultiple(mode);
  var childrenAsData = !!(!options && children);
  var mergedFilterOption = React__namespace.useMemo(function () {
    if (filterOption === undefined && mode === 'combobox') {
      return false;
    }
    return filterOption;
  }, [filterOption, mode]);

  // ========================= FieldNames =========================
  var mergedFieldNames = React__namespace.useMemo(function () {
    return fillFieldNames(fieldNames, childrenAsData);
  }, /* eslint-disable react-hooks/exhaustive-deps */
  [
  // We stringify fieldNames to avoid unnecessary re-renders.
  JSON.stringify(fieldNames), childrenAsData]
  /* eslint-enable react-hooks/exhaustive-deps */);

  // =========================== Search ===========================
  var _useMergedState = useMergedState('', {
      value: searchValue !== undefined ? searchValue : inputValue,
      postState: function postState(search) {
        return search || '';
      }
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    mergedSearchValue = _useMergedState2[0],
    setSearchValue = _useMergedState2[1];

  // =========================== Option ===========================
  var parsedOptions = useOptions(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
  var valueOptions = parsedOptions.valueOptions,
    labelOptions = parsedOptions.labelOptions,
    mergedOptions = parsedOptions.options;

  // ========================= Wrap Value =========================
  var convert2LabelValues = React__namespace.useCallback(function (draftValues) {
    // Convert to array
    var valueList = toArray$1(draftValues);

    // Convert to labelInValue type
    return valueList.map(function (val) {
      var rawValue;
      var rawLabel;
      var rawKey;
      var rawDisabled;
      var rawTitle;

      // Fill label & value
      if (isRawValue(val)) {
        rawValue = val;
      } else {
        var _val$value;
        rawKey = val.key;
        rawLabel = val.label;
        rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
      }
      var option = valueOptions.get(rawValue);
      if (option) {
        var _option$key;
        // Fill missing props
        if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
        if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
        rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
        rawTitle = option === null || option === void 0 ? void 0 : option.title;

        // Warning if label not same as provided
        if (process.env.NODE_ENV !== 'production' && !optionLabelProp) {
          var optionLabel = option === null || option === void 0 ? void 0 : option[mergedFieldNames.label];
          if (optionLabel !== undefined && ! /*#__PURE__*/React__namespace.isValidElement(optionLabel) && ! /*#__PURE__*/React__namespace.isValidElement(rawLabel) && optionLabel !== rawLabel) {
            warningOnce(false, '`label` of `value` is not same as `label` in Select options.');
          }
        }
      }
      return {
        label: rawLabel,
        value: rawValue,
        key: rawKey,
        disabled: rawDisabled,
        title: rawTitle
      };
    });
  }, [mergedFieldNames, optionLabelProp, valueOptions]);

  // =========================== Values ===========================
  var _useMergedState3 = useMergedState(defaultValue, {
      value: value
    }),
    _useMergedState4 = _slicedToArray(_useMergedState3, 2),
    internalValue = _useMergedState4[0],
    setInternalValue = _useMergedState4[1];

  // Merged value with LabelValueType
  var rawLabeledValues = React__namespace.useMemo(function () {
    var _values$;
    var newInternalValue = multiple && internalValue === null ? [] : internalValue;
    var values = convert2LabelValues(newInternalValue);

    // combobox no need save value when it's no value (exclude value equal 0)
    if (mode === 'combobox' && isComboNoValue((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) {
      return [];
    }
    return values;
  }, [internalValue, convert2LabelValues, mode, multiple]);

  // Fill label with cache to avoid option remove
  var _useCache = useCache(rawLabeledValues, valueOptions),
    _useCache2 = _slicedToArray(_useCache, 2),
    mergedValues = _useCache2[0],
    getMixedOption = _useCache2[1];
  var displayValues = React__namespace.useMemo(function () {
    // `null` need show as placeholder instead
    // https://github.com/ant-design/ant-design/issues/25057
    if (!mode && mergedValues.length === 1) {
      var firstValue = mergedValues[0];
      if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) {
        return [];
      }
    }
    return mergedValues.map(function (item) {
      var _ref;
      return _objectSpread2(_objectSpread2({}, item), {}, {
        label: (_ref = typeof labelRender === 'function' ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
      });
    });
  }, [mode, mergedValues, labelRender]);

  /** Convert `displayValues` to raw value type set */
  var rawValues = React__namespace.useMemo(function () {
    return new Set(mergedValues.map(function (val) {
      return val.value;
    }));
  }, [mergedValues]);
  React__namespace.useEffect(function () {
    if (mode === 'combobox') {
      var _mergedValues$;
      var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
      setSearchValue(hasValue(strValue) ? String(strValue) : '');
    }
  }, [mergedValues]);

  // ======================= Display Option =======================
  // Create a placeholder item if not exist in `options`
  var createTagOption = useRefFunc(function (val, label) {
    var mergedLabel = label !== null && label !== void 0 ? label : val;
    return _defineProperty(_defineProperty({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
  });

  // Fill tag as option if mode is `tags`
  var filledTagOptions = React__namespace.useMemo(function () {
    if (mode !== 'tags') {
      return mergedOptions;
    }

    // >>> Tag mode
    var cloneOptions = _toConsumableArray(mergedOptions);

    // Check if value exist in options (include new patch item)
    var existOptions = function existOptions(val) {
      return valueOptions.has(val);
    };

    // Fill current value as option
    _toConsumableArray(mergedValues).sort(function (a, b) {
      return a.value < b.value ? -1 : 1;
    }).forEach(function (item) {
      var val = item.value;
      if (!existOptions(val)) {
        cloneOptions.push(createTagOption(val, item.label));
      }
    });
    return cloneOptions;
  }, [createTagOption, mergedOptions, valueOptions, mergedValues, mode]);
  var filteredOptions = useFilterOptions(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);

  // Fill options with search value if needed
  var filledSearchOptions = React__namespace.useMemo(function () {
    if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function (item) {
      return item[optionFilterProp || 'value'] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    // ignore when search value equal select input value
    if (filteredOptions.some(function (item) {
      return item[mergedFieldNames.value] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    // Fill search value as option
    return [createTagOption(mergedSearchValue)].concat(_toConsumableArray(filteredOptions));
  }, [createTagOption, optionFilterProp, mode, filteredOptions, mergedSearchValue, mergedFieldNames]);
  var sorter = function sorter(inputOptions) {
    var sortedOptions = _toConsumableArray(inputOptions).sort(function (a, b) {
      return filterSort(a, b, {
        searchValue: mergedSearchValue
      });
    });
    return sortedOptions.map(function (item) {
      if (Array.isArray(item.options)) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          options: item.options.length > 0 ? sorter(item.options) : item.options
        });
      }
      return item;
    });
  };
  var orderedFilteredOptions = React__namespace.useMemo(function () {
    if (!filterSort) {
      return filledSearchOptions;
    }
    return sorter(filledSearchOptions);
  }, [filledSearchOptions, filterSort, mergedSearchValue]);
  var displayOptions = React__namespace.useMemo(function () {
    return flattenOptions(orderedFilteredOptions, {
      fieldNames: mergedFieldNames,
      childrenAsData: childrenAsData
    });
  }, [orderedFilteredOptions, mergedFieldNames, childrenAsData]);

  // =========================== Change ===========================
  var triggerChange = function triggerChange(values) {
    var labeledValues = convert2LabelValues(values);
    setInternalValue(labeledValues);
    if (onChange && (
    // Trigger event only when value changed
    labeledValues.length !== mergedValues.length || labeledValues.some(function (newVal, index) {
      var _mergedValues$index;
      return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
    }))) {
      var returnValues = labelInValue ? labeledValues : labeledValues.map(function (v) {
        return v.value;
      });
      var returnOptions = labeledValues.map(function (v) {
        return injectPropsWithOption(getMixedOption(v.value));
      });
      onChange(
      // Value
      multiple ? returnValues : returnValues[0],
      // Option
      multiple ? returnOptions : returnOptions[0]);
    }
  };

  // ======================= Accessibility ========================
  var _React$useState = React__namespace.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeValue = _React$useState2[0],
    setActiveValue = _React$useState2[1];
  var _React$useState3 = React__namespace.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    accessibilityIndex = _React$useState4[0],
    setAccessibilityIndex = _React$useState4[1];
  var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
  var onActiveValue = React__namespace.useCallback(function (active, index) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$source = _ref3.source,
      source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;
    setAccessibilityIndex(index);
    if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') {
      setActiveValue(String(active));
    }
  }, [backfill, mode]);

  // ========================= OptionList =========================
  var triggerSelect = function triggerSelect(val, selected, type) {
    var getSelectEnt = function getSelectEnt() {
      var _option$key2;
      var option = getMixedOption(val);
      return [labelInValue ? {
        label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
        value: val,
        key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
      } : val, injectPropsWithOption(option)];
    };
    if (selected && onSelect) {
      var _getSelectEnt = getSelectEnt(),
        _getSelectEnt2 = _slicedToArray(_getSelectEnt, 2),
        wrappedValue = _getSelectEnt2[0],
        _option = _getSelectEnt2[1];
      onSelect(wrappedValue, _option);
    } else if (!selected && onDeselect && type !== 'clear') {
      var _getSelectEnt3 = getSelectEnt(),
        _getSelectEnt4 = _slicedToArray(_getSelectEnt3, 2),
        _wrappedValue = _getSelectEnt4[0],
        _option2 = _getSelectEnt4[1];
      onDeselect(_wrappedValue, _option2);
    }
  };

  // Used for OptionList selection
  var onInternalSelect = useRefFunc(function (val, info) {
    var cloneValues;

    // Single mode always trigger select only with option list
    var mergedSelect = multiple ? info.selected : true;
    if (mergedSelect) {
      cloneValues = multiple ? [].concat(_toConsumableArray(mergedValues), [val]) : [val];
    } else {
      cloneValues = mergedValues.filter(function (v) {
        return v.value !== val;
      });
    }
    triggerChange(cloneValues);
    triggerSelect(val, mergedSelect);

    // Clean search value if single or configured
    if (mode === 'combobox') {
      // setSearchValue(String(val));
      setActiveValue('');
    } else if (!isMultiple || autoClearSearchValue) {
      setSearchValue('');
      setActiveValue('');
    }
  });

  // ======================= Display Change =======================
  // BaseSelect display values change
  var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
    triggerChange(nextValues);
    var type = info.type,
      values = info.values;
    if (type === 'remove' || type === 'clear') {
      values.forEach(function (item) {
        triggerSelect(item.value, false, type);
      });
    }
  };

  // =========================== Search ===========================
  var onInternalSearch = function onInternalSearch(searchText, info) {
    setSearchValue(searchText);
    setActiveValue(null);

    // [Submit] Tag mode should flush input
    if (info.source === 'submit') {
      var formatted = (searchText || '').trim();
      // prevent empty tags from appearing when you click the Enter button
      if (formatted) {
        var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), [formatted])));
        triggerChange(newRawValues);
        triggerSelect(formatted, true);
        setSearchValue('');
      }
      return;
    }
    if (info.source !== 'blur') {
      if (mode === 'combobox') {
        triggerChange(searchText);
      }
      onSearch === null || onSearch === void 0 || onSearch(searchText);
    }
  };
  var onInternalSearchSplit = function onInternalSearchSplit(words) {
    var patchValues = words;
    if (mode !== 'tags') {
      patchValues = words.map(function (word) {
        var opt = labelOptions.get(word);
        return opt === null || opt === void 0 ? void 0 : opt.value;
      }).filter(function (val) {
        return val !== undefined;
      });
    }
    var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), _toConsumableArray(patchValues))));
    triggerChange(newRawValues);
    newRawValues.forEach(function (newRawValue) {
      triggerSelect(newRawValue, true);
    });
  };

  // ========================== Context ===========================
  var selectContext = React__namespace.useMemo(function () {
    var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
    return _objectSpread2(_objectSpread2({}, parsedOptions), {}, {
      flattenOptions: displayOptions,
      onActiveValue: onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon: menuItemSelectedIcon,
      rawValues: rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      direction: direction,
      listHeight: listHeight,
      listItemHeight: listItemHeight,
      childrenAsData: childrenAsData,
      maxCount: maxCount,
      optionRender: optionRender
    });
  }, [maxCount, parsedOptions, displayOptions, onActiveValue, mergedDefaultActiveFirstOption, onInternalSelect, menuItemSelectedIcon, rawValues, mergedFieldNames, virtual, dropdownMatchSelectWidth, direction, listHeight, listItemHeight, childrenAsData, optionRender]);

  // ========================== Warning ===========================
  if (process.env.NODE_ENV !== 'production') {
    warningProps(props);
    warningNullOptions(mergedOptions, mergedFieldNames);
  }

  // ==============================================================
  // ==                          Render                          ==
  // ==============================================================
  return /*#__PURE__*/React__namespace.createElement(SelectContext.Provider, {
    value: selectContext
  }, /*#__PURE__*/React__namespace.createElement(BaseSelect, _extends({}, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls: prefixCls,
    ref: ref,
    omitDomProps: OMIT_DOM_PROPS,
    mode: mode
    // >>> Values
    ,
    displayValues: displayValues,
    onDisplayValuesChange: onDisplayValuesChange
    // >>> Trigger
    ,
    direction: direction
    // >>> Search
    ,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    autoClearSearchValue: autoClearSearchValue,
    onSearchSplit: onInternalSearchSplit,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
    // >>> OptionList
    ,
    OptionList: RefOptionList,
    emptyOptions: !displayOptions.length
    // >>> Accessibility
    ,
    activeValue: activeValue,
    activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Select.displayName = 'Select';
}
var TypedSelect = Select;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;

const IconRemoveComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "-3.5 0 19 19" },
        React.createElement("path", { fill: fill, d: "M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z" })));
};
const IconRemove = React.memo(IconRemoveComponent);

const IconCaretUpComponent = (props) => {
    const { fill = '#000000', width = DEFAULT_ICON_SIZE, height = DEFAULT_ICON_SIZE, } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
        React.createElement("path", { stroke: fill, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "m8 14 4-4 4 4", fill: "none" })));
};
const IconCaretUp = React.memo(IconCaretUpComponent);

const RPCDropdownMenuComponent = (props) => {
    const { active, allowClear, autoFocus, className, disabled, defaultOpen, defaultValue, id, inline, label, mode, notFoundContent, onChange, onClear, onSearch, onSelect, open, options, placeholder, renderOption, showSearch, value, variant = 'white', } = props;
    const dropdownMenuClassNames = classNames({
        'rpc-dropdown-menu': true,
        'rpc-dropdown-menu--inline': inline,
        'rpc-dropdown-menu--disabled': disabled,
        [`bg-${variant} bg-gradient`]: variant && !disabled,
        [`text-light`]: variant && isLightText(variant),
        active: active,
        'has-value': !!value,
        [`${className}`]: className,
    });
    const dropdownMenuDropdownClassNames = classNames({
        'rpc-dropdown-menu__dropdown': true,
        [`bg-${variant}`]: variant,
        [`text-light`]: variant && isLightText(variant),
    });
    return (React.createElement("div", { className: dropdownMenuClassNames },
        React.createElement("div", { className: "form-floating" },
            label && React.createElement("label", { htmlFor: id }, label),
            React.createElement(TypedSelect, { allowClear: allowClear ? { clearIcon: React.createElement(IconRemove, { fill: "#cc0000" }) } : false, autoFocus: autoFocus, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, dropdownClassName: dropdownMenuDropdownClassNames, id: id, menuItemSelectedIcon: React.createElement(IconPokeBall, { width: 16 }), mode: mode, notFoundContent: notFoundContent, onChange: onChange, onClear: onClear, onSearch: onSearch, onSelect: onSelect, open: open, placeholder: placeholder, showSearch: showSearch, suffixIcon: React.createElement(IconCaretUp, null), value: value || null }, options && options.length ? (React.createElement(React.Fragment, null, options.map((option, index) => (React.createElement(Option, { value: option.value, key: `option_${index}_${id}` }, renderOption ? (React.createElement(React.Fragment, null, renderOption(option))) : (React.createElement(React.Fragment, null, option.label))))))) : undefined))));
};
const RPCDropdownMenu = React.memo(RPCDropdownMenuComponent);

const EnergySelectorComponent = (props) => {
    const { label, isMulti, onChange, nullable, value: defaultValue, variant = 'white', } = props;
    const [activeEnergy, setActiveEnergy] = React.useState(defaultValue || []);
    const getEnergyCount = (energyType) => {
        if (Array.isArray(activeEnergy))
            return activeEnergy.filter((activeEnergyType) => energyType === activeEnergyType).length;
    };
    const isActiveEnergyString = activeEnergy && typeof activeEnergy === 'string';
    const fieldLabel = isActiveEnergyString ? `${label}: ` : label;
    const energySelectorClassNames = classNames({
        'energy-selector form-control': true,
        [`bg-${variant} bg-gradient`]: variant,
        [`text-light`]: variant && isLightText(variant),
    });
    const energySelectorActiveEnergyTextClassNames = classNames({
        'text-black': variant === 'light' || variant === 'white',
    });
    const hasActiveEnergyOrEnergies = Array.isArray(activeEnergy)
        ? activeEnergy.length
        : activeEnergy && activeEnergy !== '';
    return (React.createElement("div", { className: energySelectorClassNames },
        React.createElement("label", null,
            fieldLabel,
            activeEnergy && typeof activeEnergy === 'string' ? (React.createElement("span", { className: energySelectorActiveEnergyTextClassNames }, capitalizeFirstLetter(activeEnergy))) : undefined),
        React.createElement("div", { className: "energy-selector__energies d-flex align-items-center" },
            Object.values(pokemonCardLibrary.ENERGY_TYPES).map((value, index) => (React.createElement(RPCButton, { className: "energy-selector__energy", key: `energy-selector-energy-${index}`, active: activeEnergy === value, title: `Select ${value} energy`, hasTooltip: true, disabled: activeEnergy === value ||
                    (isMulti &&
                        Array.isArray(activeEnergy) &&
                        activeEnergy.length === ENERGY_COST_MAX), onClick: () => {
                    if (isMulti) {
                        const updatedActiveEnergy = activeEnergy && Array.isArray(activeEnergy)
                            ? [...activeEnergy, value]
                            : [value];
                        setActiveEnergy(updatedActiveEnergy);
                        if (onChange)
                            onChange(updatedActiveEnergy);
                    }
                    else {
                        setActiveEnergy(value);
                        if (onChange)
                            onChange(value);
                    }
                }, tooltipContent: capitalizeFirstLetter(value), tooltipPlacement: "bottom", variant: "link" },
                isMulti && getEnergyCount(value) > 0 ? (React.createElement("span", { className: "energy-selector__energy-count d-flex justify-content-center align-items-center w-100 h-100" }, getEnergyCount(value))) : undefined,
                React.createElement(EnergySymbol, { type: value })))),
            nullable && hasActiveEnergyOrEnergies ? (React.createElement(RPCButton, { className: "energy-selector__clear p-1", hasTooltip: true, tooltipContent: "Reset", tooltipPlacement: "bottom", title: "Remove energy costs", onClick: () => {
                    if (isMulti) {
                        setActiveEnergy([]);
                        if (onChange)
                            onChange([]);
                    }
                    else {
                        setActiveEnergy(null);
                        if (onChange)
                            onChange(null);
                    }
                }, icon: React.createElement(IconRemove, null), variant: "link" })) : undefined)));
};
const EnergySelector = React.memo(EnergySelectorComponent);

const RPCInputGroupComponent = (props) => {
    const { children, icon } = props;
    return (React.createElement(InputGroup$1, null,
        icon && React.createElement(InputGroup$1.Text, null, icon),
        children));
};
const RPCInputGroup = React.memo(RPCInputGroupComponent);

const IconCaretDownComponent = (props) => {
    const { fill = '#000000', width = DEFAULT_ICON_SIZE, height = DEFAULT_ICON_SIZE, } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
        React.createElement("path", { stroke: fill, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "m16 10-4 4-4-4", fill: "none" })));
};
const IconCaretDown = React.memo(IconCaretDownComponent);

const RPCTextInputComponent = (props) => {
    const { as, autoFocus, className, disabled, helperText, id, inputMode, isArrowDownDisabled, isArrowUpDisabled, isClearable = true, isFocused, isInvalid, isValid, label, max, min, maxLength, name, onArrowDownClick, onArrowUpClick, onChange, onClear, placeholder, plaintext, required, rows, size, type, value, variant = 'white', } = props;
    const [cursor, setCursor] = React.useState(null);
    const ref = React.useRef(null);
    const textInputClassNames = classNames({
        'rpc-text-input': true,
        'rpc-text-input--disabled': disabled,
        'rpc-text-input--clearable': isClearable,
        'rpc-text-input--numeric': inputMode === 'numeric',
        [`${className}`]: className,
        [`label-light`]: variant && isLightText(variant),
        [`label-primary`]: variant && isPrimaryLabel(variant) && !disabled,
    });
    const textInputFormControlClassNames = classNames({
        [`bg-${variant} bg-gradient`]: variant && !disabled,
        [`text-light`]: variant && isLightText(variant),
    });
    const textInputClearClassNames = classNames({
        'input-clear position-absolute': true,
    });
    const handleChange = (e) => {
        setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };
    React.useEffect(() => {
        const input = ref.current;
        if (input && type !== 'email')
            input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);
    React.useEffect(() => {
        if (isFocused && ref && ref.current !== undefined)
            ref.current.focus();
    }, [isFocused]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FloatingLabel, { controlId: id, label: label, className: textInputClassNames },
            React.createElement(Form$1.Control, { as: as, autoFocus: autoFocus, className: textInputFormControlClassNames, disabled: disabled, inputMode: inputMode, isInvalid: isInvalid, isValid: isValid, max: max, maxLength: maxLength, min: min, name: name, onChange: handleChange, placeholder: placeholder, plaintext: plaintext, ref: ref, required: required, rows: rows, size: size, type: type, value: value }),
            inputMode === 'numeric' ? (React.createElement("div", { className: "input-arrows" },
                React.createElement(RPCButton, { className: "arrow up", disabled: isArrowUpDisabled || disabled, size: "sm", title: "Increment Value", variant: "link", onClick: onArrowUpClick },
                    React.createElement(IconCaretUp, null)),
                React.createElement(RPCButton, { className: "arrow down", disabled: isArrowDownDisabled || disabled, size: "sm", title: "Decrement value", variant: "link", onClick: onArrowDownClick },
                    React.createElement(IconCaretDown, null)))) : undefined,
            isClearable && value ? (React.createElement(RPCButton, { className: textInputClearClassNames, disabled: disabled, icon: React.createElement(IconRemove, { fill: "#cc0000" }), title: "Clear", type: "button", variant: "link", onClick: (e) => {
                    e.preventDefault();
                    if (onClear)
                        onClear();
                } })) : undefined),
        helperText ? (React.createElement("div", { className: "field-help" },
            React.createElement("small", null, helperText))) : undefined));
};
const RPCTextInput = React.memo(RPCTextInputComponent);

const IconFireComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 46.1 46.1" },
        React.createElement("path", { fill: fill, d: "M46.1 26.68c-.62 2.67-1.59 5.1-2.9 7.31a24.991 24.991 0 0 1-4.87 5.97c-2.01 1.78-4.2 3.17-6.55 4.18-2.4 1-4.99 1.64-7.77 1.91-.23 0-.48.02-.75.06h-1.45c-.35-.04-.72-.06-1.1-.06l-1.04-.12v-.58c.81.15 1.62.25 2.44.29.81 0 1.6-.06 2.38-.17.77-.16 1.55-.35 2.32-.58.81-.23 1.6-.48 2.38-.75.42-.15.79-.35 1.1-.58.31-.27.54-.56.7-.87.19-.31.29-.66.29-1.04.04-.39-.02-.79-.17-1.22a2.18 2.18 0 0 0-.29-.52c-.08-.15-.17-.31-.29-.46-.12-.15-.23-.29-.35-.41-.12-.15-.19-.33-.23-.52-.12-.19-.23-.41-.35-.64-.08-.19-.15-.41-.23-.64-.08-.23-.14-.46-.17-.7-.08-.23-.12-.46-.12-.7 0-.46.08-.89.23-1.28.12-.35.35-.7.7-1.04.35-.27.7-.54 1.04-.81.35-.27.7-.5 1.04-.7-.35 0-.7.02-1.04.06h-.99c-.31.08-.64.15-.98.23-.31.08-.64.19-.99.35-.35.08-.64.21-.87.4-.27.16-.5.35-.7.58l-.7.7c-.23.23-.44.48-.64.75.04-.54.02-1.06-.06-1.56s-.19-1.01-.35-1.51a3.28 3.28 0 0 0-.75-1.22c-.35-.35-.77-.66-1.28-.93a.493.493 0 0 0-.23-.06c-.04-.04-.08-.08-.12-.11h-.17s-.1-.06-.17-.06c-.15 0-.23-.1-.23-.29-.04-.15 0-.41.12-.75.04-.31.08-.56.12-.75.08-.19.12-.31.12-.35.12-.27.25-.52.41-.76.15-.23.33-.44.52-.64.15-.19.33-.39.52-.58.19-.19.41-.39.64-.58-.39.04-.77.1-1.16.17-.39.08-.77.18-1.16.29-.39.11-.75.25-1.1.41-.35.15-.7.33-1.04.52-.31.19-.62.4-.93.64-.31.19-.62.43-.93.7-.31.23-.56.5-.75.81-.19.31-.33.64-.4.98-.08.43-.08.81 0 1.16.08.39.25.7.52.93.31.27.58.54.81.81.23.27.44.56.64.87.27.31.41.64.41.99 0 .39-.12.75-.35 1.1-.19.39-.41.74-.64 1.04-.23.27-.46.52-.7.75.04-.39.04-.73 0-1.04-.04-.31-.12-.56-.23-.75-.12-.19-.31-.37-.58-.52-.23-.19-.54-.37-.93-.52a8.29 8.29 0 0 0-.93-.29c-.31-.08-.64-.13-.99-.17h-1.97c.35.19.72.39 1.1.58.35.2.7.41 1.04.64.35.19.58.46.7.81.15.35.21.75.17 1.22-.04.39-.17.75-.41 1.1-.19.35-.48.68-.87.99-.39.35-.64.72-.75 1.1-.08.35-.04.73.12 1.16.23.66.58 1.22 1.04 1.68.46.46 1.02.83 1.68 1.1.7.27 1.37.5 2.03.7.66.23 1.31.39 1.97.46v.58c-.97-.15-1.93-.39-2.9-.7-.93-.27-1.86-.6-2.78-.99-.93-.39-1.82-.79-2.67-1.22-.85-.43-1.66-.89-2.44-1.39-1.12-.73-2.15-1.53-3.07-2.38-.93-.85-1.76-1.76-2.49-2.73-.73-.96-1.37-2.01-1.91-3.13-.58-1.12-1.04-2.3-1.39-3.54a18.2 18.2 0 0 0 1.8 1.68c.7.5 1.47 1.03 2.32 1.57.81.5 1.54.89 2.2 1.16.62.27 1.16.41 1.62.41-.66-.85-1.3-1.76-1.91-2.73a99.94 99.94 0 0 1-1.86-3.02c-.62-1.08-1.04-2.16-1.28-3.25a9.655 9.655 0 0 1-.12-3.31c.08-.54.17-1.04.29-1.51.08-.5.19-.97.35-1.39.15-.46.33-.91.52-1.33.23-.42.52-.87.87-1.33.31-.42.64-.85.99-1.27.39-.42.77-.83 1.16-1.22.39-.39.79-.75 1.22-1.1.42-.35.85-.71 1.28-1.1a9.99 9.99 0 0 0-1.04 1.74c-.31.54-.56 1.1-.75 1.68-.19.54-.31 1.12-.35 1.74-.04.62.02 1.26.17 1.91.04.31.13.64.29.99.12.31.29.64.52.98.23.39.44.72.64.99.19.27.39.52.58.75.19.23.43.46.7.69.23.23.48.46.75.7.27.23.54.44.81.64.31.19.6.35.87.47-.12-.23-.23-.5-.35-.81-.12-.27-.21-.54-.29-.81-.12-.27-.21-.56-.29-.87-.12-.27-.21-.54-.29-.81-.19-.5-.31-1.02-.35-1.57-.04-.54-.02-1.08.06-1.62.08-.62.21-1.18.41-1.68.19-.5.44-.97.75-1.39.39-.46.77-.91 1.16-1.33.39-.39.81-.77 1.28-1.16l1.28-1.16c.46-.39.93-.77 1.39-1.16.35-.31.75-.64 1.22-.99s.97-.71 1.51-1.1c.54-.43.97-.87 1.28-1.33.35-.47.56-.95.64-1.45.08-.62.08-1.2 0-1.74a4.47 4.47 0 0 0-.64-1.51c-.27-.5-.58-1.01-.93-1.51-.31-.46-.64-.93-.99-1.39 1.2.39 2.28.85 3.25 1.39.97.58 1.84 1.24 2.61 1.97.73.77 1.39 1.62 1.97 2.55.58.89 1.08 1.86 1.51 2.9.39 1.12.73 2.24 1.04 3.36.27 1.12.48 2.26.64 3.42.15 1.12.19 2.28.12 3.48-.08 1.16-.25 2.36-.52 3.59.58-.04 1.18-.1 1.8-.17.62-.08 1.24-.17 1.86-.29.58-.15 1.14-.35 1.68-.58.58-.23 1.12-.5 1.62-.81.31-.15.58-.33.81-.52.27-.15.54-.31.81-.46.19-.19.41-.39.64-.58.23-.23.44-.46.64-.7.19-.23.35-.46.46-.7.15-.23.27-.46.35-.7.12-.27.19-.54.23-.81.08-.23.13-.48.17-.75.23.43.44.85.64 1.28.23.46.43.91.58 1.33.19.46.33.93.41 1.39.08.46.12.95.12 1.45-.04.43-.1.81-.17 1.16-.08.35-.19.7-.35 1.04-.12.31-.25.64-.41.99-.16.35-.31.69-.46 1.04-.39.77-.87 1.47-1.45 2.09-.58.66-1.24 1.24-1.97 1.74-.73.54-1.47 1.02-2.2 1.45-.73.46-1.49.87-2.26 1.22.31.12.62.21.93.29.35.04.72.04 1.1 0 .35 0 .71-.04 1.1-.12.39-.08.79-.17 1.22-.29.77-.23 1.55-.52 2.32-.87.77-.35 1.54-.76 2.32-1.22.77-.46 1.45-.93 2.03-1.39.58-.5 1.06-1.01 1.45-1.51Z" })));
};
const IconFire = React.memo(IconFireComponent);

const EnergySymbolCodesAlertComponent = () => {
    const [isCopied, setIsCopied] = React.useState(false);
    const handleCopyEnergyCode = (energyCode) => {
        navigator.clipboard.writeText(energyCode);
        setIsCopied(true);
    };
    const handleCopyHtmlCode = (htmlCode) => {
        navigator.clipboard.writeText(htmlCode);
        setIsCopied(true);
    };
    const buttonVariant = 'outline-secondary';
    return (React.createElement(RPCAlert, { className: "inline-energy-warning position-relative", variant: "light" },
        React.createElement("div", { className: "d-flex" },
            React.createElement("div", { className: "me-3" },
                React.createElement(IconFire, null)),
            React.createElement("p", null, "Click to copy the code to clipboard, then paste it into your move description wherever you want it. Move descriptions also support certain HTML elements.")),
        React.createElement("h6", { className: "font-family-gill-sans-condensed-bold" }, "Energy Symbol Codes"),
        React.createElement("div", { className: "mb-3" },
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(ColorlessEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{CO}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(DarknessEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{DK}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(FightingEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{FG}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(FireEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{FR}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(GrassEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{GR}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(LightningEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{LG}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(MetalEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{MT}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(PsychicEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{PS}') }),
            React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, icon: React.createElement(RainbowEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{RA}') }),
            React.createElement(RPCButton, { variant: buttonVariant, icon: React.createElement(WaterEnergy, { width: 20 }), onClick: () => handleCopyEnergyCode('{WA}') }),
            React.createElement(RPCToastMessage, { className: "position-absolute", variant: "dark-subtle", onClose: () => setIsCopied(false), show: isCopied },
                React.createElement("div", { className: "text-center" },
                    React.createElement("strong", { className: "text-light" }, "Copied!")))),
        React.createElement("h6", { className: "font-family-gill-sans-condensed-bold" }, "Other Useful Codes"),
        React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, label: "Italic", onClick: () => handleCopyHtmlCode('<em></em>') }),
        React.createElement(RPCButton, { className: "me-1", variant: buttonVariant, label: "Line Break", onClick: () => handleCopyHtmlCode('<br />') }),
        React.createElement(RPCButton, { variant: buttonVariant, label: "'Pok\u00E9mon'", onClick: () => handleCopyHtmlCode('Pokémon') })));
};
const EnergySymbolCodesAlert = React.memo(EnergySymbolCodesAlertComponent);

const RangeSliderValueSuffix = (props) => {
    const { type } = props;
    switch (type) {
        case 'degrees':
            return React.createElement(React.Fragment, null, "\u00B0");
        case 'percentage':
            return React.createElement(React.Fragment, null, "%");
        default:
            return React.createElement(React.Fragment, null);
    }
};
const RangeSliderInputComponent = (props) => {
    const { className, disabled, helperText, id, label, min, max, onChange, showText = true, step, type, value, variant = 'white', } = props;
    const numericVal = !!value ? Number(value) * 100 : 0;
    const fixedNum = numericVal.toFixed();
    const defaultValue = value || 0;
    const rangeSliderClassNames = classNames({
        'rpc-range-slider-input form-control': true,
        disabled: disabled,
        [`bg-${variant} bg-gradient`]: variant,
        [`text-light`]: variant && isLightText(variant),
        [`${className}`]: className,
    });
    const rangeSliderLabelClassNames = classNames({
        'mb-0': true,
        [`label-primary`]: variant && isPrimaryLabel(variant),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Form$1.Group, { controlId: id, className: rangeSliderClassNames, "aria-disabled": disabled },
            label && (React.createElement(Form$1.Label, { className: rangeSliderLabelClassNames }, label)),
            React.createElement("div", { className: "rpc-range-slider-input__input-container d-flex align-items-center lh-1" },
                React.createElement(Form$1.Range, { className: "rpc-range-slider-input__slider", disabled: disabled, onChange: onChange, min: min, max: max, step: step, value: defaultValue }),
                showText ? (React.createElement("div", { className: "rpc-range-slider-input__value" },
                    React.createElement("small", null,
                        step && step === 0.01 ? fixedNum : defaultValue,
                        React.createElement(RangeSliderValueSuffix, { type: type })))) : undefined)),
        helperText ? (React.createElement("div", { className: "field-help" },
            React.createElement("small", null, helperText))) : undefined));
};
const RPCRangeSliderInput = React.memo(RangeSliderInputComponent);

function getOptionsFromObject(inputObj) {
    const arrayValues = Object.values(inputObj);
    return arrayValues.map((item) => {
        return {
            label: item.label,
            value: item.value,
        };
    });
}
const getCardCreatorCardSetOptions = () => {
    const cardSetOptions = getOptionsFromObject(pokemonCardLibrary.CARD_SETS);
    const cardSetsWithoutBase = cardSetOptions.filter((cardSet) => {
        return cardSet.value !== pokemonCardLibrary.CARD_SETS.BASE.value;
    });
    return [...cardSetsWithoutBase, ...ADDITIONAL_CARD_CREATOR_SETS];
};

const TRAINER_OPTIONS = [
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.AGATHA.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.AGATHA[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.AGATHA[0].value,
    },
    {
        label: 'Alto Mare',
        value: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/alto-mare-vs-thumb.png',
        image: 'https://poketcgshop.s3.us-east-1.amazonaws.com/trainer-images/alto-mare-vs-thumb.png',
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.BLAINE.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BLAINE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BLAINE[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.BLAINE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BLAINE[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BLAINE[2].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.BROCK.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BROCK[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BROCK[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.BROCK.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BROCK[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BROCK[2].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.BRUNO.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BRUNO[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BRUNO[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.BUGSY.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BUGSY[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BUGSY[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.BUGSY.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.BUGSY[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.BUGSY[1].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.CHUCK.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.CHUCK[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.CHUCK[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.CHUCK.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.CHUCK[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.CHUCK[1].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.CLAIR.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.CLAIR[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.CLAIR[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.CLAIR.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.CLAIR[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.CLAIR[1].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.ERIKA.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ERIKA[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ERIKA[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.ERIKA.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ERIKA[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ERIKA[2].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.FALKNER.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.FALKNER[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.FALKNER[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.FALKNER.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.FALKNER[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.FALKNER[1].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.GIOVANNI.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.GIOVANNI[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.GIOVANNI[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.GIOVANNI.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.GIOVANNI[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.GIOVANNI[2].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.JANINE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.JANINE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.JANINE[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.JASMINE.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.JASMINE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.JASMINE[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.JASMINE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.JASMINE[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.JASMINE[1].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.KAREN.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.KAREN[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.KAREN[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.KOGA.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.KOGA[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.KOGA[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.KOGA.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.KOGA[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.KOGA[2].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.LANCE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.LANCE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.LANCE[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.LORELEI.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.LORELEI[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.LORELEI[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.LT_SURGE.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.LT_SURGE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.LT_SURGE[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.LT_SURGE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.LT_SURGE[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.LT_SURGE[2].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.MISTY.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.MISTY[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.MISTY[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.MISTY.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.MISTY[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.MISTY[2].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.MORTY.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.MORTY[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.MORTY[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.MORTY.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.MORTY[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.MORTY[1].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.OAKLEY.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.OAKLEY[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.OAKLEY[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.PRYCE.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.PRYCE[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.PRYCE[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.PRYCE.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.PRYCE[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.PRYCE[1].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.ROCKET.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.ROCKET.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[1].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.ROCKET.name} - VS (Marauder)`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ROCKET[2].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.ROSS.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.ROSS[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.ROSS[0].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.SABRINA.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.SABRINA[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.SABRINA[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.SABRINA.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.SABRINA[2].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.SABRINA[2].value,
    },
    {
        label: pokemonCardLibrary.GYM_LEADERS.WHITNEY.name,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.WHITNEY[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.WHITNEY[0].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.WHITNEY.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.WHITNEY[1].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.WHITNEY[1].value,
    },
    {
        label: `${pokemonCardLibrary.GYM_LEADERS.WILL.name} - VS`,
        value: pokemonCardLibrary.GYM_LEADER_IMAGES.WILL[0].value,
        image: pokemonCardLibrary.GYM_LEADER_IMAGES.WILL[0].value,
    },
];
const DAMAGE_MODIFIER_OPTIONS = [
    {
        label: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.PLUS,
        value: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.PLUS,
    },
    {
        label: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.MINUS,
        value: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.MINUS,
    },
    {
        label: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.TIMES,
        value: pokemonCardLibrary.DAMAGE_MODIFIER_VALUES.TIMES,
    },
];
const STAMP_OPTIONS = [
    {
        label: 'Prerelease',
        value: pokemonCardLibrary.STAMP_TYPES.PRERELEASE,
    },
    {
        label: 'Winner',
        value: pokemonCardLibrary.STAMP_TYPES.WINNER,
    },
    {
        label: 'Wizards',
        value: pokemonCardLibrary.STAMP_TYPES.WIZARDS,
    },
];
const POKE_SPECIAL_MOVE_OPTIONS = [
    {
        label: 'Poké Power',
        value: pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_POWER,
    },
    {
        label: 'Poké Body',
        value: pokemonCardLibrary.POKE_SPECIAL_MOVE_TYPES.POKE_BODY,
    },
];
const HOLO_SHEET_OPTIONS = [
    {
        label: 'Stars',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.STARS,
    },
    {
        label: 'Cosmos Dark',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS,
    },
    {
        label: 'Cosmos Dark 2',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS_4,
    },
    {
        label: 'Cosmos Saturated',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS_2,
    },
    {
        label: 'Cosmos Light',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.COSMOS_3,
    },
    {
        label: 'Fireworks',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.FIREWORKS,
    },
    {
        label: 'Swirl Crazy',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.SWIRL,
    },
    {
        label: 'Neo Shining',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.SHINING,
    },
    {
        label: 'Sparkle',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.SPARKLE,
    },
    {
        label: 'Disco Test Print',
        value: pokemonCardLibrary.CARD_HOLO_SHEETS.DISCO,
    },
    {
        label: 'Ripple',
        value: 'ripple',
    },
];
const BLEND_MODE_OPTIONS = [
    {
        label: 'Normal',
        value: pokemonCardLibrary.BLEND_MODES.NORMAL,
    },
    {
        label: 'Multiply',
        value: pokemonCardLibrary.BLEND_MODES.MULTIPLY,
    },
    {
        label: 'Screen',
        value: pokemonCardLibrary.BLEND_MODES.SCREEN,
    },
    {
        label: 'Overlay',
        value: pokemonCardLibrary.BLEND_MODES.OVERLAY,
    },
    {
        label: 'Darken',
        value: pokemonCardLibrary.BLEND_MODES.DARKEN,
    },
    {
        label: 'Lighten',
        value: pokemonCardLibrary.BLEND_MODES.LIGHTEN,
    },
    {
        label: 'Color Dodge',
        value: pokemonCardLibrary.BLEND_MODES.COLOR_DODGE,
    },
    {
        label: 'Color Burn',
        value: pokemonCardLibrary.BLEND_MODES.COLOR_BURN,
    },
    {
        label: 'Hard Light',
        value: pokemonCardLibrary.BLEND_MODES.HARD_LIGHT,
    },
    {
        label: 'Soft Light',
        value: pokemonCardLibrary.BLEND_MODES.SOFT_LIGHT,
    },
    {
        label: 'Difference',
        value: pokemonCardLibrary.BLEND_MODES.DIFFERENCE,
    },
    {
        label: 'Exclusion',
        value: pokemonCardLibrary.BLEND_MODES.EXCLUSION,
    },
    {
        label: 'Hue',
        value: pokemonCardLibrary.BLEND_MODES.HUE,
    },
    {
        label: 'Saturation',
        value: pokemonCardLibrary.BLEND_MODES.SATURATION,
    },
    {
        label: 'Color',
        value: pokemonCardLibrary.BLEND_MODES.COLOR,
    },
    {
        label: 'Luminosity',
        value: pokemonCardLibrary.BLEND_MODES.LUMINOSITY,
    },
];
const CARD_TEMPLATE_OPTIONS = [
    {
        label: 'Base',
        value: pokemonCardLibrary.CARD_TEMPLATES.BASE,
    },
    {
        label: 'Gym',
        value: pokemonCardLibrary.CARD_TEMPLATES.GYM,
    },
    {
        label: 'Neo',
        value: pokemonCardLibrary.CARD_TEMPLATES.NEO,
    },
    {
        label: 'Legendary Reverse',
        value: pokemonCardLibrary.CARD_TEMPLATES.LEGENDARY_REVERSE,
    },
    {
        label: 'E Series',
        value: pokemonCardLibrary.CARD_TEMPLATES.E_SERIES,
    },
    {
        label: 'Victory Stations (VS)',
        value: pokemonCardLibrary.CARD_TEMPLATES.VS,
    },
    {
        label: 'Web',
        value: pokemonCardLibrary.CARD_TEMPLATES.WEB,
    },
    {
        label: 'Trainer',
        value: pokemonCardLibrary.CARD_TEMPLATES.TRAINER,
    },
    {
        label: 'Trainer (E)',
        value: pokemonCardLibrary.CARD_TEMPLATES.TRAINER_E_SERIES,
    },
    {
        label: 'Trainer (VS)',
        value: pokemonCardLibrary.CARD_TEMPLATES.TRAINER_VS,
    },
    {
        label: 'Energy',
        value: pokemonCardLibrary.CARD_TEMPLATES.ENERGY,
    },
    {
        label: 'Energy (E)',
        value: pokemonCardLibrary.CARD_TEMPLATES.ENERGY_E_SERIES,
    },
    {
        label: 'Energy (VS)',
        value: pokemonCardLibrary.CARD_TEMPLATES.ENERGY_VS,
    },
];
const CARD_TEMPLATE_SUBTYPE_OPTIONS = [
    {
        label: 'Baby',
        value: pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.BABY,
    },
    {
        label: 'Shining',
        value: pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.SHINING,
    },
    {
        label: 'Unown',
        value: pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.UNOWN,
    },
];
const CARD_SPECIAL_TEMPLATE_OPTIONS = [
    {
        label: 'Crystal',
        value: pokemonCardLibrary.SPECIAL_CARD_TEMPLATES.CRYSTAL,
    },
    {
        label: 'Fossil',
        value: pokemonCardLibrary.SPECIAL_CARD_TEMPLATES.FOSSIL,
    },
];
const CARD_FRAME_STYLE_OPTIONS = [
    {
        label: 'Light',
        value: CARD_FRAME_STYLES.LIGHT,
    },
    {
        label: 'Dark',
        value: CARD_FRAME_STYLES.DARK,
    },
];
const UNOWN_LETTERS_OPTIONS = [
    {
        label: 'A',
        value: 'A',
    },
    {
        label: 'B',
        value: 'B',
    },
    {
        label: 'C',
        value: 'C',
    },
    {
        label: 'D',
        value: 'D',
    },
    {
        label: 'E',
        value: 'E',
    },
    {
        label: 'F',
        value: 'F',
    },
    {
        label: 'G',
        value: 'G',
    },
    {
        label: 'H',
        value: 'H',
    },
    {
        label: 'I',
        value: 'I',
    },
    {
        label: 'J',
        value: 'J',
    },
    {
        label: 'K',
        value: 'K',
    },
    {
        label: 'L',
        value: 'L',
    },
    {
        label: 'M',
        value: 'M',
    },
    {
        label: 'N',
        value: 'N',
    },
    {
        label: 'O',
        value: 'O',
    },
    {
        label: 'P',
        value: 'P',
    },
    {
        label: 'Q',
        value: 'Q',
    },
    {
        label: 'R',
        value: 'R',
    },
    {
        label: 'S',
        value: 'S',
    },
    {
        label: 'T',
        value: 'T',
    },
    {
        label: 'U',
        value: 'U',
    },
    {
        label: 'V',
        value: 'V',
    },
    {
        label: 'W',
        value: 'W',
    },
    {
        label: 'X',
        value: 'X',
    },
    {
        label: 'Y',
        value: 'Y',
    },
    {
        label: 'Z',
        value: 'Z',
    },
];
const CARD_SETS_OPTIONS = getCardCreatorCardSetOptions();
getOptionsFromObject(pokemonCardLibrary.CARD_SETS_JPN);
const CARD_LANGUAGE_OPTIONS = [
    {
        label: 'English',
        value: 'en',
    },
    {
        label: 'French',
        value: 'fr',
    },
    {
        label: 'German',
        value: 'gr',
    },
    {
        label: 'Italian',
        value: 'it',
    },
    {
        label: 'Japanese',
        value: 'jp',
    },
    {
        label: 'Spanish',
        value: 'sp',
    },
    {
        label: 'Korean',
        value: 'ko',
    },
    {
        label: 'Portuguese',
        value: 'pt',
    },
];
const FILE_SETTINGS_OPTIONS = [
    {
        label: 'JPEG (.jpg)',
        value: 'jpeg',
    },
    {
        label: 'PNG (.png)',
        value: 'png',
    },
    {
        label: 'SVG (.svg)',
        value: 'svg',
    },
];
const BACKGROUND_SIZE_OPTIONS = [
    {
        label: 'Cover',
        value: 'cover',
    },
    {
        label: 'Contain',
        value: 'contain',
    },
];
const ENERGY_TYPES_OPTIONS = Object.values(pokemonCardLibrary.ENERGY_TYPES).map((type) => {
    return {
        label: capitalizeFirstLetter(type),
        value: type,
    };
});
const DOT_MATRIX_POSITION_OPTIONS = [
    {
        label: 'None',
        value: '',
    },
    {
        label: 'Left And Bottom',
        value: pokemonCardLibrary.DOT_MATRIX_POSITIONS.LEFT_AND_BOTTOM,
    },
    {
        label: 'Bottom Only',
        value: pokemonCardLibrary.DOT_MATRIX_POSITIONS.BOTTOM_ONLY,
    },
];

const flattenMultiDimensionalArray = (arr) => {
    return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten)
            ? flattenMultiDimensionalArray(toFlatten)
            : toFlatten);
    }, []);
};
const moveArrayElementUp = (arr, currentIndex) => {
    if (currentIndex > 0) {
        const el = arr[currentIndex];
        arr[currentIndex] = arr[currentIndex - 1];
        arr[currentIndex - 1] = el;
    }
    return [...arr];
};
const moveArrayElementDown = (arr, currentIndex) => {
    if (currentIndex !== -1 && currentIndex < arr.length - 1) {
        const el = arr[currentIndex];
        arr[currentIndex] = arr[currentIndex + 1];
        arr[currentIndex + 1] = el;
    }
    return [...arr];
};

const DEFAULT_MOVE_DELETE_STATE = {
    moveIndex: null,
    moveName: '',
};
const MovesInputComponent = (props) => {
    const { movesMax = MOVES_MAX, onAdd, onChange, onRemove, onReorder, value, } = props;
    const [currentMoves, setCurrentMoves] = React.useState(value);
    const [moveToDelete, setMoveToDelete] = React.useState(DEFAULT_MOVE_DELETE_STATE);
    const [isDeleteMoveConfirmModalOpen, setIsDeleteMoveConfirmModalOpen] = React.useState(false);
    const resetMoveDeletion = () => {
        setMoveToDelete(DEFAULT_MOVE_DELETE_STATE);
        setIsDeleteMoveConfirmModalOpen(false);
    };
    React.useEffect(() => {
        if (value) {
            setCurrentMoves(value);
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EnergySymbolCodesAlert, null),
        currentMoves && currentMoves.length ? (React.createElement(React.Fragment, null, currentMoves.map((move, moveIndex) => (React.createElement("div", { className: "moves-input__move p-3 pb-1 mb-3", key: `moves-input-move-${moveIndex}` },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-8 col-sm-8 mb-3" },
                    React.createElement(RPCTextInput, { label: "Name", onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'name', e.target.value);
                        }, onClear: () => {
                            if (onChange)
                                onChange(moveIndex, 'name', '');
                        }, value: move.name })),
                React.createElement("div", { className: "col-4 col-sm-4 mb-3" },
                    React.createElement("div", { className: "d-flex justify-content-end moves-input__actions" },
                        moveIndex > 0 ? (React.createElement(RPCButton, { className: "me-1 arrow up", circular: true, disabled: moveIndex === 0, icon: React.createElement(IconCaretUp, { fill: "#fff" }), tooltipContent: "Move Up", hasTooltip: true, size: "sm", tooltipPlacement: "left", variant: "info", onClick: () => {
                                const updatedMovesOrder = moveArrayElementUp(value, moveIndex);
                                if (onReorder)
                                    onReorder(updatedMovesOrder);
                            } })) : undefined,
                        moveIndex < Number(value.length - 1) ? (React.createElement(RPCButton, { className: "me-1 arrow down", circular: true, icon: React.createElement(IconCaretDown, { fill: "#fff" }), tooltipContent: "Move Down", hasTooltip: true, size: "sm", tooltipPlacement: "left", variant: "info", onClick: () => {
                                const updatedMovesOrder = moveArrayElementDown(value, moveIndex);
                                if (onReorder)
                                    onReorder(updatedMovesOrder);
                            } })) : undefined,
                        React.createElement(RPCButton, { circular: true, icon: React.createElement(IconRemove, { fill: "#fff" }), tooltipContent: "Remove Move", hasTooltip: true, size: "sm", tooltipPlacement: "left", variant: "danger", onClick: () => {
                                setMoveToDelete({
                                    moveName: move.name,
                                    moveIndex,
                                });
                                setIsDeleteMoveConfirmModalOpen(true);
                            } })))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mb-3" },
                    React.createElement(RPCTextInput, { as: "textarea", label: "Description", onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'description', e.target.value);
                        }, onClear: () => {
                            if (onChange)
                                onChange(moveIndex, 'description', '');
                        }, rows: 4, value: move.description }))),
            !move.specialMoveType && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-6 mb-3" },
                    React.createElement(RPCTextInput, { maxLength: 3, isArrowDownDisabled: !move.damage || move.damage <= 0, label: "Damage", value: move.damage, onArrowDownClick: () => {
                            if (onChange) {
                                const newVal = (move.damage ? Number(move.damage) : 0) - 1;
                                onChange(moveIndex, 'damage', newVal);
                            }
                        }, onArrowUpClick: () => {
                            if (onChange) {
                                const newVal = (move.damage ? Number(move.damage) : 0) + 1;
                                onChange(moveIndex, 'damage', newVal);
                            }
                        }, onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'damage', e.target.value);
                        }, onClear: () => {
                            if (onChange)
                                onChange(moveIndex, 'damage', '');
                        }, inputMode: "numeric" })),
                React.createElement("div", { className: "col-6 mb-3" },
                    React.createElement(RPCDropdownMenu, { allowClear: true, id: `move-${moveIndex}-damageModifier`, inline: true, onChange: (selectedOption) => {
                            if (onChange) {
                                if (selectedOption) {
                                    onChange(moveIndex, 'damageModifier', selectedOption);
                                }
                                else {
                                    onChange(moveIndex, 'damageModifier', '');
                                }
                            }
                        }, onClear: () => {
                            if (onChange)
                                onChange(moveIndex, 'damageModifier', '');
                        }, options: DAMAGE_MODIFIER_OPTIONS, label: "Damage Modifier", placeholder: "+/-/x", showSearch: false, value: move.damageModifier })))),
            React.createElement("div", { className: "row align-items-center" },
                React.createElement("div", { className: "col-6 mb-3" },
                    React.createElement(RPCDropdownMenu, { allowClear: true, id: `move-${moveIndex}-specialMoveType`, inline: true, onChange: (selectedOption) => {
                            if (onChange) {
                                if (selectedOption) {
                                    onChange(moveIndex, 'specialMoveType', selectedOption);
                                }
                                else {
                                    onChange(moveIndex, 'specialMoveType', '');
                                }
                            }
                        }, onClear: () => {
                            if (onChange)
                                onChange(moveIndex, 'specialMoveType', '');
                        }, showSearch: false, options: POKE_SPECIAL_MOVE_OPTIONS, placeholder: "Power/Body", label: "Special Move Type", value: move.specialMoveType })),
                React.createElement("div", { className: "col-6 mb-3" },
                    React.createElement(RPCTextInput, { disabled: !move.specialMoveType, label: "Special Move Type Prefix", onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'specialMoveTypePrefix', e.target.value);
                        }, placeholder: "Replaces '___ Power/Body'", value: move.specialMoveTypePrefix }))),
            !move.specialMoveType && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mb-3" },
                    React.createElement(EnergySelector, { isMulti: true, label: "Energy Costs", nullable: true, onChange: (energyTypes) => {
                            if (onChange)
                                onChange(moveIndex, 'energyCost', energyTypes);
                        }, value: move.energyCost })))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col" },
                    React.createElement("h6", { className: "font-family-gill-sans-condensed-bold" },
                        "Advanced Settings",
                        ' ',
                        React.createElement("small", { className: "font-family-gill-sans-regular" }, "(Warning: Overrides default sizing)")))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mb-3" },
                    React.createElement(RPCRangeSliderInput, { label: "Name Size +/-", min: 0.03, max: 0.06, showText: false, step: 0.001, onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'nameSize', e.target.value);
                        }, value: move.nameSize })),
                React.createElement("div", { className: "col mb-3" },
                    React.createElement(RPCRangeSliderInput, { label: "Description Size +/-", min: 0.02, max: 0.05, showText: false, step: 0.001, onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'descriptionSize', e.target.value);
                        }, value: move.descriptionSize })),
                React.createElement("div", { className: "col mb-3" },
                    React.createElement(RPCRangeSliderInput, { label: "Line Height +/-", min: 0.02, max: 0.06, step: 0.001, showText: false, onChange: (e) => {
                            if (onChange)
                                onChange(moveIndex, 'lineHeight', e.target.value);
                        }, value: move.lineHeight })))))))) : undefined,
        React.createElement("div", { className: "moves-input__add-move" },
            React.createElement(RPCButton, { disabled: currentMoves && currentMoves.length >= movesMax, label: "Add Move", icon: React.createElement(IconPlusCircle, { fill: "#fff" }), title: "Add Move", variant: "info", onClick: () => {
                    if (onAdd)
                        onAdd();
                } })),
        React.createElement(RPCConfirmationModal, { onCancel: () => {
                resetMoveDeletion();
            }, onConfirm: () => {
                if (onRemove)
                    onRemove(moveToDelete.moveIndex);
                resetMoveDeletion();
            }, show: isDeleteMoveConfirmModalOpen, title: "Confirm Move Deletion" },
            "Are you sure you want to remove",
            ' ',
            moveToDelete.moveName ? `"${moveToDelete.moveName}"` : '',
            " move? This action cannot be undone.")));
};
const MovesInput = React.memo(MovesInputComponent);

const RaritySelectorComponent = (props) => {
    const { label, onChange, nullable, value: defaultValue } = props;
    const [activeRarity, setActiveRarity] = React.useState(defaultValue);
    const fieldLabel = activeRarity ? `${label}: ` : label;
    return (React.createElement("div", { className: "rarity-selector form-floating d-flex align-items-center" },
        React.createElement("label", null,
            fieldLabel,
            activeRarity ? (React.createElement("span", { className: "text-black" }, capitalizeFirstLetter(activeRarity))) : undefined),
        React.createElement("div", { className: "form-control d-flex align-items-center justify-content-end" },
            Object.values(pokemonCardLibrary.RARITY_TYPES).map((value, index) => (React.createElement(RPCButton, { className: "rarity-selector__rarity me-1", disabled: activeRarity === value, key: `rarity-${value}-${index}`, title: `Select ${value} rarity`, icon: React.createElement(RaritySymbol, { fill: "#fff", rarity: value }), onClick: () => {
                    setActiveRarity(value);
                    if (onChange)
                        onChange(value);
                }, hasTooltip: true, tooltipPlacement: "top", tooltipContent: capitalizeFirstLetter(value), variant: "info" }))),
            nullable && (React.createElement(RPCButton, { className: "rarity-selector__rarity rarity-selector__none", title: "Remove rarity", icon: React.createElement(IconRemove, { fill: "#fff" }), onClick: () => {
                    setActiveRarity(null);
                    if (onChange)
                        onChange(null);
                }, hasTooltip: true, tooltipPlacement: "top", tooltipContent: "Clear", variant: "danger" })))));
};
const RaritySelector = React.memo(RaritySelectorComponent);

const ToggleSwitchComponent = (props) => {
    const { checked, className, disabled, id = 'rpc-toggle-switch', label, name, onChange, optionLabels, small, stacked, variant = 'white', } = props;
    function handleKeyPress(e) {
        if (e.keyCode !== 32)
            return;
        e.preventDefault();
        onChange(!checked);
    }
    const toggleSwitchWrapperClassNames = classNames({
        'toggle-switch-wrapper form-control': true,
        stacked: stacked,
        [`${className}`]: className,
        [`bg-${variant} bg-gradient`]: variant,
        [`text-light`]: variant && isLightText(variant),
    });
    const toggleSwitchClassNames = classNames({
        'toggle-switch': true,
        small: small,
    });
    const toggleSwitchLabelClassNames = classNames({
        'toggle-switch-label-text': true,
        [`label-primary`]: variant && isPrimaryLabel(variant),
    });
    return (React.createElement("div", { className: toggleSwitchWrapperClassNames },
        React.createElement("div", { className: toggleSwitchLabelClassNames }, label),
        React.createElement("div", { className: toggleSwitchClassNames },
            React.createElement("input", { type: "checkbox", name: name, className: "toggle-switch-checkbox", id: id, checked: checked, onChange: e => onChange(e.target.checked), disabled: disabled }),
            React.createElement("label", { className: "toggle-switch-label", htmlFor: id, tabIndex: disabled ? -1 : 1, onKeyDown: e => {
                    handleKeyPress(e);
                } },
                React.createElement("span", { className: disabled
                        ? 'toggle-switch-inner toggle-switch-disabled'
                        : 'toggle-switch-inner', "data-yes": (optionLabels && optionLabels[0]) || 'On', "data-no": (optionLabels && optionLabels[1]) || 'Off', tabIndex: -1 }),
                React.createElement("span", { className: disabled
                        ? 'toggle-switch-switch toggle-switch-disabled'
                        : 'toggle-switch-switch', tabIndex: -1 })))));
};
const RPCToggleSwitch = React.memo(ToggleSwitchComponent);

const IconColorlessComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 37.02 42.75" },
        React.createElement("path", { fill: fill, d: "M35.38 30.61c-.07-.08-1.13-1.08-1.29-1.22a41.61 41.61 0 0 1-3.19-3.31 55.848 55.848 0 0 1-2.85-3.58c-.22-.36-.33-.74-.34-1.13 0-.39.12-.77.34-1.14.9-1.22 1.85-2.42 2.85-3.58a41.61 41.61 0 0 1 3.19-3.31c.16-.13 1.22-1.14 1.29-1.22.26-.22 1.23-1.09 1.64-1.44-.51.18-1.75.58-2.07.7-.1.02-1.51.44-1.7.51-1.46.45-2.95.82-4.46 1.11-1.51.29-3.02.51-4.53.68-.42.01-.81-.08-1.15-.27-.34-.2-.61-.49-.81-.86-.61-1.39-1.17-2.81-1.68-4.26-.51-1.46-.93-2.93-1.27-4.42-.03-.2-.37-1.63-.41-1.73-.06-.34-.33-1.61-.43-2.14-.1.54-.37 1.81-.43 2.14-.03.1-.37 1.52-.41 1.73-.34 1.49-.76 2.96-1.27 4.42a57.14 57.14 0 0 1-1.68 4.26c-.2.37-.47.66-.81.86-.09.05-.18.09-.27.12-.27.11-.57.15-.89.15-1.51-.17-3.02-.39-4.53-.68-1.51-.29-3-.66-4.46-1.11-.19-.07-1.59-.49-1.7-.51-.32-.11-1.56-.52-2.07-.7.41.35 1.38 1.22 1.64 1.44.07.08 1.13 1.08 1.29 1.22 1.12 1.04 2.19 2.14 3.19 3.31 1.01 1.17 1.96 2.36 2.86 3.58.22.36.33.74.34 1.13 0 .39-.12.77-.34 1.13-.9 1.22-1.85 2.42-2.86 3.58a41.61 41.61 0 0 1-3.19 3.31c-.16.13-1.22 1.14-1.29 1.22-.26.22-1.23 1.09-1.64 1.45.51-.18 1.75-.58 2.07-.7.1-.02 1.51-.44 1.7-.51 1.46-.45 2.95-.82 4.46-1.11 1.51-.29 3.02-.51 4.53-.68.42-.01.81.08 1.15.27.34.2.61.49.81.86.61 1.39 1.17 2.81 1.68 4.26.51 1.46.93 2.93 1.27 4.42.03.2.37 1.63.41 1.73.06.34.33 1.61.43 2.14.1-.54.37-1.81.43-2.14.03-.1.37-1.52.41-1.73.34-1.49.76-2.96 1.27-4.42a57.14 57.14 0 0 1 1.68-4.26c.12-.21.26-.4.42-.55.12-.12.25-.22.39-.31.34-.19.73-.28 1.15-.27 1.51.17 3.02.39 4.53.68s3 .66 4.46 1.11c.19.07 1.59.49 1.7.51.32.11 1.56.52 2.07.7-.41-.35-1.38-1.22-1.64-1.45Z" })));
};
const IconColorless = React.memo(IconColorlessComponent);

const IconDarknessComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 44.46 44.41" },
        React.createElement("path", { fill: fill, d: "M44.46 21.78c0 2.05-.25 4.01-.74 5.87-.49 1.86-1.24 3.63-2.22 5.3-.95 1.71-2.05 3.23-3.31 4.56a23.445 23.445 0 0 1-4.28 3.48c-.87.53-1.77 1.01-2.68 1.43-.91.42-1.86.78-2.85 1.08-.99.3-1.99.53-3.02.68-1.03.15-2.07.23-3.14.23s-2.13-.08-3.19-.23c-1.03-.15-2.01-.38-2.96-.68-1.03-.3-2-.66-2.91-1.08-.91-.42-1.81-.89-2.68-1.43C8.92 40 7.5 38.84 6.2 37.51a22.791 22.791 0 0 1-3.31-4.56c-.99-1.67-1.71-3.44-2.17-5.3-.49-1.86-.74-3.82-.74-5.87 0-2.62.4-5.09 1.2-7.41.8-2.32 2-4.5 3.59-6.56 1.6-1.97 3.38-3.63 5.36-4.96C12.11 1.56 14.29.61 16.69 0c-1.48.91-2.68 2.15-3.59 3.7-.91 1.6-1.37 3.33-1.37 5.19 0 2.93 1.03 5.42 3.08 7.47s4.52 3.08 7.41 3.08 5.36-1.03 7.41-3.08 3.08-4.54 3.08-7.47c0-1.86-.44-3.57-1.31-5.13C30.49 2.2 29.29.95 27.81 0c2.36.61 4.52 1.58 6.5 2.91 1.98 1.29 3.76 2.93 5.36 4.9 1.6 2.05 2.79 4.24 3.59 6.56.8 2.32 1.2 4.79 1.2 7.41Z" })));
};
const IconDarkness = React.memo(IconDarknessComponent);

const IconFightingComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { height: height, width: width, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 38.59 38.59" },
        React.createElement("path", { fill: fill, d: "M0 14.89V4.27c0-.59.21-1.09.63-1.51.42-.45.92-.68 1.51-.68h3.7c.59 0 1.09.23 1.51.68.42.42.62.92.62 1.51v10.62c0 .59-.21 1.09-.62 1.51-.42.42-.92.63-1.51.63h-3.7c-.59 0-1.09-.21-1.51-.63-.42-.42-.63-.92-.63-1.51Zm13.91 11.82c-.38.35-.96.87-1.72 1.56v4.22c-.38.35-.96.87-1.72 1.56H1.72c-.38-.35-.96-.87-1.72-1.56V20.88c.38-.31.95-.82 1.72-1.51h14.84c.38.35.95.85 1.72 1.51v4.27c-.38.35-.96.87-1.72 1.56H13.9Zm-3.59-11.82V2.13c0-.59.21-1.09.62-1.51.42-.42.92-.63 1.51-.63h3.54c.59 0 1.09.21 1.51.63.42.41.63.92.63 1.51v12.76c0 .59-.21 1.09-.63 1.51-.42.42-.92.63-1.51.63h-3.54c-.59 0-1.09-.21-1.51-.63-.42-.42-.62-.92-.62-1.51Zm26.56 4.48c.38.35.95.85 1.72 1.51v11.61c-.38.35-.96.87-1.72 1.56h-6.72c-.38.35-.96.87-1.72 1.56v1.41c-.38.35-.96.87-1.72 1.56H13.13v-2.81h1.56c.35-.35.87-.85 1.56-1.51v-2.34c.38-.35.95-.87 1.72-1.56h2.66c.38-.35.95-.85 1.72-1.51v-7.97c.38-.31.95-.82 1.72-1.51h12.81Zm-16.41-4.48V2.13c0-.59.21-1.09.63-1.51.42-.42.92-.63 1.51-.63h3.49c.59 0 1.09.21 1.51.63.42.41.63.92.63 1.51v12.76c0 .59-.21 1.09-.63 1.51-.42.42-.92.63-1.51.63h-3.49c-.59 0-1.09-.21-1.51-.63-.42-.42-.63-.92-.63-1.51ZM38.59 4.27v10.62c0 .59-.21 1.09-.62 1.51-.45.42-.97.63-1.56.63h-3.7c-.59 0-1.09-.21-1.51-.63-.42-.42-.62-.92-.62-1.51V4.27c0-.59.21-1.09.62-1.51.42-.45.92-.68 1.51-.68h3.7c.59 0 1.11.23 1.56.68.42.42.62.92.62 1.51Z" })));
};
const IconFighting = React.memo(IconFightingComponent);

const IconGrassComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41.35 49.17" },
        React.createElement("path", { fill: fill, d: "M41.35 28.78v.82c0 .93-.07 1.79-.21 2.59-.18.8-.42 1.56-.74 2.27-.32.72-.73 1.39-1.22 2.02-.5.67-1.08 1.28-1.75 1.83-.57.55-1.19 1.05-1.86 1.51-.64.42-1.29.8-1.96 1.14-.71.38-1.42.72-2.12 1.01-.71.29-1.41.55-2.12.76-.78.25-1.54.46-2.28.63l-2.23.63-2.23.51c-.78.13-1.56.21-2.34.25.07.8.16 1.56.27 2.27.07.76.16 1.47.27 2.15H14.3c-.21-.67-.39-1.41-.53-2.21-.18-.8-.3-1.66-.37-2.59-.92-.21-1.84-.46-2.76-.76-.96-.34-1.88-.72-2.76-1.14-.92-.42-1.77-.92-2.55-1.51-.78-.55-1.49-1.18-2.12-1.89-.85-.88-1.52-1.83-2.02-2.84-.5-1.05-.81-2.15-.96-3.28-.04-.34-.07-.65-.11-.95-.04-.29-.05-.59-.05-.88-.03-.46-.05-.93-.05-1.39 0-.42.02-.84.05-1.26.04-.88.12-1.77.27-2.65.25-1.64.71-3.2 1.38-4.67.67-1.51 1.56-2.95 2.65-4.29 1.06-1.35 2.16-2.59 3.29-3.72 1.17-1.14 2.34-2.17 3.5-3.09 1.24-1.01 2.49-1.98 3.77-2.9 1.31-.92 2.62-1.81 3.93-2.65 1.38-.84 2.76-1.62 4.14-2.33C24.38 1.41 25.78.7 27.19.02c.99 1.68 2.03 3.35 3.13 4.99 1.1 1.64 2.23 3.24 3.4 4.8 1.17 1.6 2.19 3.26 3.08 4.99.92 1.77 1.72 3.6 2.39 5.49.28.76.55 1.52.8 2.27.25.8.48 1.58.69 2.33.21.63.37 1.26.48 1.89.11.67.18 1.35.21 2.02Zm-7.43-5.11s.05.02.05.06h.11c-.21-.25-.46-.48-.74-.69-.32-.21-.66-.4-1.01-.57-.32-.17-.66-.32-1.01-.44-.32-.13-.64-.23-.96-.32-.32-.08-.64-.17-.96-.25-.32-.08-.64-.17-.96-.25-.32-.08-.65-.13-1.01-.13-.32-.04-.66-.04-1.01 0-.67.04-1.33.11-1.96.19-.64.13-1.26.25-1.86.38-.53.13-1.04.34-1.54.63-.5.25-.99.57-1.49.95-.04.04-.09.08-.16.13-.07 0-.12.02-.16.06.03-.21.07-.44.11-.69.07-.21.12-.44.16-.69.07-.21.12-.44.16-.69.04-.21.09-.42.16-.63.71-.92 1.49-1.7 2.34-2.33.88-.67 1.84-1.22 2.87-1.64.71-.29 1.45-.53 2.23-.69.74-.17 1.5-.25 2.28-.25h1.43c.11 0 .21.02.32.06-.04-.04-.07-.06-.11-.06l-.05-.06h.16c-.21-.13-.43-.23-.64-.32-.21-.13-.42-.23-.64-.32-.21-.08-.44-.17-.69-.25-.21-.04-.44-.08-.69-.13-.5-.08-.99-.13-1.49-.13s-1.01.02-1.54.06c-.46.04-.9.11-1.33.19-.46.13-.88.27-1.27.44-.32.13-.62.3-.9.51-.32.17-.6.38-.85.63-.07.04-.14.09-.21.13-.11.04-.19.1-.27.19.21-.8.44-1.58.69-2.34.21-.8.44-1.58.69-2.33.18-.55.35-1.09.53-1.64.18-.55.35-1.11.53-1.7.07-.21.16-.44.27-.69.07-.25.14-.48.21-.69a.18.18 0 0 0-.05.13c-.03.04-.07.09-.11.13.03-.04.05-.1.05-.19 0-.04.02-.08.05-.13-.5.76-.97 1.54-1.43 2.34-.43.76-.85 1.56-1.27 2.4-.35.72-.69 1.45-1.01 2.21-.32.71-.6 1.45-.85 2.21-.04.09-.07.17-.11.25-.03.08-.07.17-.11.25-.14-.13-.3-.25-.48-.38s-.37-.25-.58-.38c-.25-.17-.42-.29-.53-.38-.14-.09-.23-.13-.27-.13a5.56 5.56 0 0 0-1.33-.57c-.46-.17-.94-.27-1.43-.32-.42-.04-.87-.04-1.33 0-.42.04-.83.17-1.22.38a.42.42 0 0 1-.21.06c-.04 0-.09.02-.16.06h.11s-.02.06-.05.06h-.05c.35.08.69.17 1.01.25.32.04.65.13 1.01.25.32.08.62.21.9.38.28.21.57.44.85.69.25.21.5.42.74.63.25.25.48.51.69.76.21.25.41.55.58.88.21.34.37.67.48 1.01l-.05.19c-.04.13-.18.57-.42 1.33-.07.25-.12.48-.16.69-.07.25-.11.48-.11.69v.06s-.05.02-.05.06c-.21-.17-.42-.34-.64-.51-.18-.13-.37-.25-.58-.38-.21-.13-.42-.23-.64-.32-.25-.13-.5-.23-.74-.32-.25-.13-.51-.21-.8-.25a3.26 3.26 0 0 0-.9-.13c-.32-.04-.64-.06-.95-.06h-.8c-.35.04-.67.09-.95.13-.32.08-.62.17-.9.25-.18.04-.39.11-.64.19-.21.13-.46.27-.74.44-.04.04-.09.06-.16.06-.07.04-.14.08-.21.13h.16-.05s-.07.06-.11.06c.96-.04 1.86-.02 2.71.06.85.13 1.65.32 2.39.57.71.29 1.36.72 1.96 1.26.64.59 1.22 1.3 1.75 2.15-.11.42-.19.84-.27 1.26-.07.38-.14.78-.21 1.2-.04.34-.05.69-.05 1.07-.04.34-.04.67 0 1.01v.13s-.05.08-.05.13c-.35-.21-.71-.42-1.06-.63-.35-.21-.71-.42-1.06-.63-.39-.21-.78-.38-1.17-.5-.39-.13-.8-.23-1.22-.32-.42-.08-.85-.13-1.27-.13s-.88.04-1.38.13c-.39.04-.76.13-1.12.25-.39.13-.72.34-1.01.63-.04.04-.09.06-.16.06-.04.04-.09.08-.16.13h.11l-.05.06h-.05.26c.5 0 .96.02 1.38.06.46.04.88.1 1.27.19.42.09.87.23 1.33.44.42.17.85.38 1.27.63.35.21.72.46 1.11.76.35.3.71.59 1.06.88.32.38.64.74.96 1.07.28.38.58.74.9 1.07v.13l.05.76c.03.55.09 1.14.16 1.77.11.59.21 1.22.32 1.89.11.67.3 1.29.58 1.83.25.5.6.95 1.06 1.33h.05v.06s.05-.02.05-.06h.05v-.06c-.03-.55-.05-1.09-.05-1.64v-1.64c-.04-.55-.04-1.09 0-1.64v-1.51c.46-.63.96-1.2 1.49-1.7.53-.51 1.08-.95 1.65-1.33.53-.42 1.11-.8 1.75-1.14.64-.34 1.31-.63 2.02-.88a8.43 8.43 0 0 1 2.02-.51c.71-.13 1.43-.19 2.18-.19h1.96c.57.04 1.13.06 1.7.06.18 0 .37.02.58.06.21 0 .42.02.64.06-.04-.04-.07-.06-.11-.06s-.07-.02-.11-.06h.27c-.71-.38-1.43-.67-2.18-.89-.74-.25-1.49-.42-2.23-.51-.74-.08-1.49-.13-2.23-.13s-1.47.02-2.18.06c-.64.04-1.27.15-1.91.32-.6.13-1.22.29-1.86.51-.57.21-1.1.46-1.59.76-.46.34-.88.72-1.27 1.14-.03.04-.07.06-.11.06-.07.04-.12.08-.16.13.04-.42.07-.82.11-1.2.03-.42.09-.84.16-1.26.03-.42.09-.84.16-1.26.03-.42.09-.82.16-1.2.42-.55.9-1.03 1.43-1.45.5-.42 1.04-.8 1.65-1.14.57-.34 1.15-.63 1.75-.88.6-.25 1.2-.46 1.8-.63.78-.21 1.54-.36 2.28-.44a12.3 12.3 0 0 1 2.18-.06c.53.04 1.06.11 1.59.19a20.309 20.309 0 0 1 2.23.45c.21.04.41.11.58.19l-.05-.06s-.05-.02-.05-.06Zm-22.35-8.33h.27-.42.16Zm3.5 15.97c.07 0 .12.02.16.06.07.04.12.06.16.06v.06s-.09-.08-.16-.13a.211.211 0 0 0-.16-.06Zm1.59-8.08s.07.02.11.06h.05v.06s-.07-.06-.11-.06c0-.04-.02-.06-.05-.06Zm1.22 8.84v.51h-.05c0-.08.02-.17.05-.25v-.25Zm.9-15.09h.05v.06-.06h-.05Zm.37 6.38s.05-.08.05-.13v.25h-.05v-.13Zm1.64-6.63s-.05.02-.05.06h-.05c.03-.17.09-.34.16-.51.04-.17.09-.34.16-.5-.04.17-.09.34-.16.5-.03.13-.05.27-.05.44Zm2.87-9.47c-.14.25-.27.49-.37.69-.11.21-.23.44-.37.69.11-.17.21-.34.32-.51.07-.17.16-.34.27-.5.03-.04.05-.1.05-.19.03-.04.07-.1.11-.19Zm7.38 8.39h-.05s-.07-.02-.11-.06c.07.04.12.06.16.06s.07.02.11.06h-.05s-.05-.02-.05-.06Zm2.55 15.4c-.21-.08-.41-.15-.58-.19-.21-.08-.42-.15-.64-.19.14.04.3.11.48.19.14.04.28.11.42.19h.32Zm.42-7.39h-.16s-.09-.08-.16-.13c-.04-.04-.07-.08-.11-.13.07.04.14.08.21.13.07.04.14.09.21.13Z" })));
};
const IconGrass = React.memo(IconGrassComponent);

const IconLightningComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 35.36 44.02" },
        React.createElement("path", { fill: fill, d: "M22.94 0c-.71 1.91-1.63 4.29-2.75 7.14-1.12 2.85-2.42 6.18-3.88 10.01 2.1-.52 4.74-1.14 7.93-1.86 3.19-.75 6.9-1.61 11.13-2.59-2.4 3.49-5.42 7.83-9.05 13.04-3.6 5.21-7.81 11.3-12.65 18.27.79-2.47 1.78-5.55 2.98-9.22 1.2-3.67 2.59-7.98 4.16-12.93-2.32.68-5.21 1.48-8.66 2.42S4.65 26.32.01 27.6c2.55-3.07 5.73-6.92 9.56-11.53C13.38 11.51 17.84 6.15 22.94 0Z" })));
};
const IconLightning = React.memo(IconLightningComponent);

const IconMetalComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42.75 40.66" },
        React.createElement("path", { fill: fill, d: "M6.75 8.83c-.4.73-.75 1.39-1.04 1.98-.29.55-.53 1.01-.71 1.37.8 1.61 1.5 3.02 2.09 4.23.62 1.17 1.13 2.16 1.54 2.96-1.21 0-2.25-.02-3.13-.06H3.25c-.73-1.54-1.37-2.87-1.92-4-.51-1.17-.95-2.12-1.32-2.85C.7 11.14 1.31 9.99 1.82 9c.51-.99.95-1.81 1.32-2.47.04-.04.05-.07.05-.11l.06-.11c.69-1.32 1.3-2.47 1.81-3.46.51-.99.93-1.79 1.26-2.41C7.89.33 9.27.24 10.44.16 11.61.09 12.58.03 13.35 0c.62 1.13 1.17 2.14 1.65 3.02.44.84.8 1.56 1.1 2.14-1.65 0-3.09.02-4.34.05-1.24 0-2.27.02-3.07.06-.4.73-.75 1.37-1.04 1.92-.29.59-.55 1.06-.77 1.43l-.05.11s-.06.07-.06.11Zm24.64 2.2H11.03c2.27 4.13 5.67 10.34 10.21 18.6 2.27-4.13 5.65-10.33 10.15-18.6Zm-2.58 18.05c.62 1.1 1.15 2.09 1.59 2.96.44.84.81 1.56 1.1 2.14-.84 1.43-1.57 2.69-2.2 3.79-.62 1.06-1.15 1.96-1.59 2.69H15.04c-.84-1.43-1.57-2.69-2.2-3.79-.66-1.06-1.19-1.96-1.59-2.69.59-1.17 1.1-2.18 1.54-3.02.44-.84.82-1.54 1.15-2.09.8 1.54 1.54 2.89 2.19 4.06.62 1.17 1.15 2.14 1.59 2.91h7.3c.84-1.54 1.59-2.89 2.25-4.06.62-1.17 1.13-2.14 1.54-2.91Zm13.94-16.63c-.73 1.54-1.35 2.87-1.87 4.01-.55 1.13-.99 2.09-1.32 2.85-1.21.04-2.27.06-3.18.06h-2.25c.8-1.57 1.5-2.96 2.09-4.17.62-1.21 1.13-2.21 1.54-3.02-.4-.73-.73-1.37-.99-1.92-.29-.58-.53-1.06-.71-1.43l-.11-.11c-.04-.04-.05-.07-.05-.11-.4-.73-.75-1.39-1.04-1.98-.29-.55-.53-1.01-.71-1.37-1.65-.04-3.09-.06-4.33-.06-1.28-.03-2.32-.05-3.13-.05.59-1.17 1.12-2.18 1.59-3.02.44-.88.82-1.59 1.15-2.14 1.54.11 2.89.2 4.06.27 1.17.04 2.16.09 2.96.17.7 1.28 1.3 2.41 1.81 3.4.51.99.95 1.81 1.32 2.47 0 .04.02.07.05.11 0 .04.02.07.05.11.69 1.32 1.3 2.47 1.81 3.46.51.99.93 1.81 1.26 2.47Z" })));
};
const IconMetal = React.memo(IconMetalComponent);

const IconPsychicComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 43.12 30.1" },
        React.createElement("path", { fill: fill, d: "M21.47 30.1c-6.97-.27-12.75-3.11-17.37-8.37-1.65-1.88-2.96-3.97-4.01-6.23-.11-.24-.14-.63-.02-.86C3.84 6.85 9.76 1.72 18.45.28c6.33-1.04 11.98.85 17 4.69 3.33 2.54 5.79 5.81 7.55 9.6.11.23.17.59.07.8-3.13 6.57-7.95 11.31-14.96 13.64-2.13.71-4.34 1.02-6.64 1.1Zm6.55-24.31a10.787 10.787 0 0 1 1 16.08c-4.02 4.01-10.41 4.19-14.55.38-2.2-2.02-3.41-4.54-3.52-7.5-.14-3.64 1.33-6.61 4.17-8.96-.12 0-.17-.02-.2 0-4.19 1.84-7.61 4.55-9.78 8.68-.22.43-.22.76.01 1.17 1.91 3.46 4.61 6.15 8.14 7.92 3.79 1.91 7.72 2.97 12.03 1.75 5.49-1.55 9.76-4.62 12.59-9.61.26-.46.27-.83.01-1.3-2.17-4.07-5.54-6.76-9.69-8.59-.05-.02-.12-.01-.21-.02Zm-11.24 9.13c.21 2.12 1.76 3.8 3.91 4.26 2.08.45 4.25-.52 5.33-2.38 1.08-1.86.81-4.27-.61-5.86-1.14-1.29-3.39-2.1-5.16-1.35 1.86 1.77 2.2 3.24 1.11 4.73-1.04 1.42-2.63 1.64-4.59.6Z" })));
};
const IconPsychic = React.memo(IconPsychicComponent);

const IconWaterComponent = (props) => {
    const { fill = '#000000', width = 24, height = 24 } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32.59 39.44" },
        React.createElement("path", { fill: fill, d: "M25.68 1.77c-2.21.62-4.43 1.3-6.65 2.05-2.22.75-4.31 1.69-6.27 2.84a32.035 32.035 0 0 0-5.57 4.09c-.41.36-.81.73-1.18 1.12-.38.39-.75.79-1.12 1.2-.34.41-.66.83-.97 1.27-.34.41-.66.85-.96 1.32-.27.46-.52.94-.75 1.42-.27.46-.5.95-.69 1.46-.23.49-.43.98-.59 1.49-.13.5-.27 1-.4 1.5-.26 1.03-.43 2.06-.5 3.09-.07 1.03-.04 2.09.09 3.18l.07.37.07.37c.16.89.43 1.77.8 2.62.37.82.84 1.61 1.42 2.37.78.97 1.64 1.82 2.6 2.54.96.72 2.02 1.31 3.18 1.77 1.13.47 2.31.83 3.53 1.09 1.19.26 2.41.43 3.66.49.71.03 1.41.03 2.1 0 .7-.03 1.4-.09 2.11-.19.22 0 .46-.03.7-.08l.69-.12 1.34-.24c.39-.1.8-.22 1.22-.36.48-.15.95-.3 1.4-.44.45-.18.91-.35 1.38-.53.44-.21.86-.42 1.27-.66.43-.27.84-.55 1.23-.84.39-.29.75-.63 1.06-1 .35-.35.66-.74.94-1.17.31-.41.57-.83.77-1.28.21-.45.38-.91.52-1.38.13-.5.23-1 .31-1.49.07-.52.08-1.03.06-1.54a8.29 8.29 0 0 0-.23-1.53c-.15-.48-.33-.96-.54-1.43-.21-.44-.46-.86-.75-1.25-.26-.4-.58-.77-.96-1.12-.35-.35-.71-.68-1.09-1-.35-.35-.73-.68-1.13-.99-.41-.31-.81-.62-1.21-.93-.44-.3-.86-.63-1.27-.97-.41-.34-.81-.68-1.19-1.03-.35-.38-.7-.78-1.03-1.2-.3-.42-.58-.85-.85-1.28-.27-.46-.5-.94-.69-1.45a7.49 7.49 0 0 1-.6-3.09c0-1.21.26-2.3.75-3.28s1.23-1.86 2.2-2.63c.95-.74 1.91-1.42 2.88-2.04.97-.62 1.95-1.17 2.95-1.67.2-.1.41-.2.61-.3.2-.1.42-.2.66-.31.2-.1.41-.2.61-.3.23-.11.46-.21.66-.31-2.26.53-4.49 1.12-6.7 1.77Zm-4.22 34.86c-.07.33-.27.6-.62.82-.34.22-.84.39-1.48.5-.59.1-1.23.14-1.94.11-.71-.03-1.46-.14-2.25-.31-.79-.15-1.49-.35-2.11-.62-.65-.27-1.22-.58-1.69-.94-.53-.32-.91-.65-1.13-.99-.22-.34-.3-.68-.23-1.01.1-.31.33-.57.67-.79.34-.22.82-.38 1.44-.5s1.28-.15 1.98-.12c.71.03 1.44.12 2.2.28.79.18 1.52.4 2.17.66.65.26 1.23.56 1.73.88.51.36.86.71 1.05 1.05.22.34.29.66.22.96Z" })));
};
const IconWater = React.memo(IconWaterComponent);

const IconCaretLeftComponent = (props) => {
    const { fill = '#000000', width = DEFAULT_ICON_SIZE, height = DEFAULT_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: fill, width: width, height: height, viewBox: "0 0 256 256" },
        React.createElement("path", { d: "M160 220a11.963 11.963 0 0 1-8.485-3.515l-80-80a12 12 0 0 1 0-16.97l80-80a12 12 0 0 1 16.97 16.97L96.971 128l71.514 71.515A12 12 0 0 1 160 220Z" })));
};
const IconCaretLeft = React.memo(IconCaretLeftComponent);

const IconCaretRightComponent = (props) => {
    const { fill = '#000000', width = DEFAULT_ICON_SIZE, height = DEFAULT_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: fill, width: width, height: height, viewBox: "0 0 256 256" },
        React.createElement("path", { d: "M96 220a12 12 0 0 1-8.485-20.485L159.029 128 87.515 56.485a12 12 0 0 1 16.97-16.97l80 80a12 12 0 0 1 0 16.97l-80 80A11.963 11.963 0 0 1 96 220Z" })));
};
const IconCaretRight = React.memo(IconCaretRightComponent);

const IconHelpComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: width, height: height, version: "1.1", viewBox: "0 0 512 512" },
        React.createElement("path", { fill: fill, d: "M396.138 85.295c-13.172-25.037-33.795-45.898-59.342-61.03C311.26 9.2 280.435.001 246.98.001c-41.238-.102-75.5 10.642-101.359 25.521-25.962 14.826-37.156 32.088-37.156 32.088a19.471 19.471 0 0 0-6.721 15.056 19.425 19.425 0 0 0 7.273 14.784l35.933 28.78c7.324 5.864 17.806 5.644 24.875-.518 0 0 4.414-7.978 18.247-15.88 13.91-7.85 31.945-14.173 58.908-14.258 23.517-.051 44.022 8.725 58.016 20.717 6.952 5.941 12.145 12.594 15.328 18.68 3.208 6.136 4.379 11.5 4.363 15.574-.068 13.766-2.742 22.77-6.603 30.442-2.945 5.729-6.789 10.813-11.738 15.744-7.384 7.384-17.398 14.207-28.634 20.479-11.245 6.348-23.365 11.932-35.612 18.68-13.978 7.74-28.77 18.858-39.701 35.544-5.449 8.249-9.71 17.686-12.416 27.641-2.742 9.964-3.98 20.412-3.98 31.071v20.708c0 10.719 8.69 19.41 19.41 19.41h46.762c10.719 0 19.41-8.691 19.41-19.41v-20.708c0-4.107.467-6.755.917-8.436.773-2.512 1.206-3.14 2.47-4.668 1.29-1.452 3.895-3.674 8.698-6.331 7.019-3.946 18.298-9.276 31.07-16.176 19.121-10.456 42.367-24.646 61.972-48.062 9.752-11.686 18.374-25.758 24.323-41.968 6.001-16.21 9.242-34.431 9.226-53.96-.018-19.784-5.382-38.574-14.123-55.25zM228.809 406.44c-29.152 0-52.788 23.644-52.788 52.788 0 29.136 23.637 52.772 52.788 52.772 29.136 0 52.763-23.636 52.763-52.772 0-29.144-23.627-52.788-52.763-52.788z" })));
};
const IconHelp = React.memo(IconHelpComponent);

const IconPNGComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 330 330", xmlSpace: "preserve", width: width, height: height },
        React.createElement("path", { fill: fill, d: "M154.389 255.602c.351.351.719.683 1.103.998.169.138.347.258.52.388.218.164.432.333.659.484.212.142.432.265.649.395.202.121.4.248.608.359.223.12.453.221.681.328.215.102.427.21.648.301.223.092.45.167.676.247.236.085.468.175.709.248.226.068.456.119.684.176.246.062.489.131.739.181.263.052.529.083.794.121.219.031.435.073.658.095.492.048.986.075 1.48.075s.988-.026 1.479-.075c.226-.022.444-.064.667-.096.262-.037.524-.068.784-.12.255-.05.504-.121.754-.184.223-.057.448-.105.669-.172.246-.075.483-.167.724-.253.221-.08.444-.152.662-.242.225-.093.44-.202.659-.306.225-.106.452-.206.672-.324.21-.112.408-.239.611-.361.217-.13.437-.252.648-.394.222-.148.431-.314.644-.473.179-.134.362-.258.536-.4.365-.3.714-.617 1.049-.949.016-.016.034-.028.049-.044l70.002-69.998c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.858-21.213-.001l-44.396 44.393V25c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v183.785l-44.392-44.391c-5.857-5.858-15.355-5.858-21.213 0-5.858 5.858-5.858 15.355 0 21.213l69.997 69.995z" }),
        React.createElement("path", { fill: fill, d: "M315 160c-8.284 0-15 6.716-15 15v115H30V175c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v130c0 8.284 6.716 15 15 15h300c8.284 0 15-6.716 15-15V175c0-8.284-6.716-15-15-15z" })));
};
const IconPNG = React.memo(IconPNGComponent);

const IconPNGFileComponent = (props) => {
    const { fill = '#000000', width = DEFAULT_ICON_SIZE, height = DEFAULT_ICON_SIZE, } = props;
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", fill: fill, version: "1.1", viewBox: "0 0 550.801 550.801" },
        React.createElement("path", { d: "M146.747 276.708c0-13.998-9.711-22.352-26.887-22.352-6.99 0-11.726.675-14.204 1.355v44.927c2.932.676 6.539.896 11.52.896 18.273.012 29.571-9.254 29.571-24.826z" }),
        React.createElement("path", { d: "M488.426 197.019H475.2v-63.816c0-.398-.063-.799-.116-1.202-.021-2.534-.827-5.023-2.562-6.995L366.325 3.694c-.032-.031-.063-.042-.085-.076-.633-.707-1.371-1.295-2.151-1.804a9.495 9.495 0 0 0-.706-.419 11.131 11.131 0 0 0-2.131-.896c-.2-.056-.38-.138-.58-.19A10.774 10.774 0 0 0 358.193 0H97.2C85.282 0 75.6 9.693 75.6 21.601v175.413H62.377c-17.049 0-30.873 13.818-30.873 30.873v160.545c0 17.043 13.824 30.87 30.873 30.87h13.224V529.2c0 11.907 9.682 21.601 21.6 21.601h356.4c11.907 0 21.6-9.693 21.6-21.601V419.302h13.226c17.044 0 30.871-13.827 30.871-30.87v-160.54c-.001-17.054-13.828-30.873-30.872-30.873zM97.2 21.605h250.193v110.513c0 5.967 4.841 10.8 10.8 10.8H453.6v54.108H97.2V21.605zM234.344 335.86v45.831h-31.601V229.524h40.184l31.611 55.759c9.025 16.031 18.064 34.983 24.825 52.154h.675c-2.257-20.103-2.933-40.643-2.933-63.44v-44.473h31.614v152.167h-36.117l-32.516-58.703c-9.049-16.253-18.971-35.892-26.438-53.727l-.665.222c.923 20.097 1.361 41.544 1.361 66.377zM71.556 381.691V231.56c10.613-1.804 25.516-3.159 46.506-3.159 21.215 0 36.353 4.061 46.509 12.192 9.698 7.673 16.255 20.313 16.255 35.219 0 14.897-4.959 27.549-13.999 36.123-11.738 11.063-29.123 16.031-49.441 16.031-4.522 0-8.593-.231-11.736-.675v54.411H71.556v-.011zm382.045 141.662H97.2V419.302h356.4v104.051zm32.051-148.665c-10.61 3.607-30.713 8.585-50.805 8.585-27.759 0-47.872-7.003-61.857-20.545-13.995-13.1-21.684-32.97-21.452-55.318.222-50.569 37.03-79.463 86.917-79.463 19.644 0 34.783 3.829 42.219 7.446l-7.214 27.543c-8.369-3.617-18.752-6.55-35.458-6.55-28.656 0-50.341 16.256-50.341 49.22 0 31.382 19.649 49.892 47.872 49.892 7.895 0 14.218-.901 16.934-2.257v-31.835h-23.493v-26.869h56.679v80.151z" })));
};
const IconPNGFile = React.memo(IconPNGFileComponent);

const IconRemoveCircleComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { height: height, viewBox: "0 0 512 512", width: width, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fill: fill, d: "m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531 0 68.382812 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.636719 74.980469-181.019531 0-68.378906-26.628906-132.667969-74.980469-181.019531zm-70.292969 256.386719c9.761719 9.765624 9.761719 25.59375 0 35.355468-4.882812 4.882813-11.28125 7.324219-17.679687 7.324219s-12.796875-2.441406-17.679687-7.324219l-75.367188-75.367187-75.367188 75.371093c-4.882812 4.878907-11.28125 7.320313-17.679687 7.320313s-12.796875-2.441406-17.679687-7.320313c-9.761719-9.765624-9.761719-25.59375 0-35.355468l75.371093-75.371094-75.371093-75.367188c-9.761719-9.765624-9.761719-25.59375 0-35.355468 9.765624-9.765625 25.59375-9.765625 35.355468 0l75.371094 75.367187 75.367188-75.367187c9.765624-9.761719 25.59375-9.765625 35.355468 0 9.765625 9.761718 9.765625 25.589844 0 35.355468l-75.367187 75.367188zm0 0" })));
};
const IconRemoveCircle = React.memo(IconRemoveCircleComponent);

const AssetLibraryComponent = (props) => {
    const { assets, isBgImageCover, isInputFocused, libraryType = 'images', noResultsMessage = 'No results.', onImageClick, searchFilterPlaceholder = 'Search', searchFilterValue = '', searchIcon, searchMessage = 'Type in the input field above to search for assets.', showAllByDefault, } = props;
    const DEFAULT_ASSETS = showAllByDefault ? assets : [];
    const [searchFilter, setSearchFilter] = React.useState(searchFilterValue);
    const [filteredAssets, setFilteredAssets] = React.useState(DEFAULT_ASSETS);
    const assetLibraryClassNames = classNames({
        'asset-library': true,
        'asset-library--cover-bg': isBgImageCover,
        [`asset-library--${libraryType}`]: libraryType,
    });
    const searchContent = searchFilter === '' ? searchMessage : noResultsMessage;
    const handleSearchChange = (event) => {
        setSearchFilter(event.target.value);
        const updatedAssets = assets && assets.length
            ? assets.filter((asset) => {
                return (asset &&
                    ((asset.name &&
                        asset.name
                            .toLowerCase()
                            .includes(event.target.value.toLowerCase())) ||
                        (asset.label &&
                            asset.label
                                .toLowerCase()
                                .includes(event.target.value.toLowerCase()))));
            })
            : [];
        if (event.target.value === '') {
            if (showAllByDefault) {
                setFilteredAssets(assets);
            }
            else {
                setFilteredAssets([]);
            }
        }
        else {
            setFilteredAssets(updatedAssets);
        }
    };
    return (React.createElement("div", { className: assetLibraryClassNames },
        React.createElement("section", { className: "asset-library__search" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(RPCInputGroup, { icon: searchIcon },
                            React.createElement(RPCTextInput, { isFocused: isInputFocused, className: "asset-library__search__input", floatingLabel: false, label: searchFilterPlaceholder, onChange: handleSearchChange, placeholder: searchFilterPlaceholder, size: "lg", value: searchFilter })))))),
        React.createElement("div", { className: "container" }, filteredAssets && filteredAssets.length ? (React.createElement(React.Fragment, null, libraryType === 'rows' ? (React.createElement(React.Fragment, null, filteredAssets &&
            filteredAssets.map((asset, assetIndex) => (React.createElement(React.Fragment, { key: `card_art_row_${assetIndex}` }, asset &&
                asset.name &&
                asset.name
                    .toLowerCase()
                    .includes(searchFilter.toLowerCase()) ? (React.createElement("div", { className: "row asset" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("h4", { className: "asset__heading" },
                        asset.number && (React.createElement("span", { className: "asset__heading__number" }, asset.number)),
                        asset.name)),
                React.createElement("div", { className: "row" }, asset.images
                    ? asset.images.map((image, subImageAssetIndex) => (React.createElement("div", { className: "col-6 col-sm-4 col-md-4 col-lg-4 col-xl-2", key: `asset_${assetIndex}_image_${subImageAssetIndex}` }, image.value !== '' ? (React.createElement(React.Fragment, null,
                        React.createElement(RPCButton, { variant: "link", className: "asset__image", style: {
                                backgroundImage: `url("${image.value}")`,
                            }, onClick: () => {
                                if (onImageClick)
                                    onImageClick(image);
                            } }),
                        React.createElement("h6", { className: "asset__text text-center" }, image.label))) : (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "asset__image coming-soon text-center" },
                            React.createElement("h4", null, "Image Coming Soon")),
                        React.createElement("h6", { className: "asset__text text-center" }, image.label))))))
                    : undefined))) : undefined))))) : libraryType === 'moves' ? (React.createElement(React.Fragment, null, filteredAssets.map((move, moveIndex) => (React.createElement(React.Fragment, { key: `moves-library-row-${moveIndex}` }, searchFilter === '' ||
            move.name
                .toLowerCase()
                .includes(searchFilter.toLowerCase()) ? (React.createElement(CardMove, { damage: move.damage, damageModifier: move.damageModifier, description: move.description, dividerColor: "#000", energyCost: move.energyCost, id: `${move.name}-${moveIndex}`, name: move.name, specialMoveType: move.specialMoveType })) : undefined))))) : (React.createElement("div", { className: "row" }, filteredAssets.map((asset, assetIndex) => (React.createElement(React.Fragment, { key: `asset_${assetIndex}` }, typeof asset.label === 'string' &&
            asset.label
                .toLowerCase()
                .includes(searchFilter.toLowerCase()) ? (React.createElement("div", { className: "col-6 col-sm-4 col-md-4 col-lg-4 col-xl-2" },
            React.createElement(RPCButton, { variant: "link", className: "asset__image", style: {
                    backgroundImage: `url("${asset.value}")`,
                }, onClick: () => {
                    if (onImageClick)
                        onImageClick(asset);
                } }),
            React.createElement("h6", { className: "asset__text text-center" }, asset.label))) : undefined))))))) : (React.createElement("h4", null, searchContent)))));
};
const AssetLibrary = React.memo(AssetLibraryComponent);

const BoosterBoxComponent = (props) => {
    const { disabled, disabledMessage = 'Coming Soon!', firstEdition, onClick, orientation = 'top', setId, } = props;
    const [currentOrientation, setCurrentOrientation] = React.useState(orientation);
    const boosterBoxClassNames = classNames({
        'booster-box': true,
        'booster-box--e-series': pokemonCardLibrary.isESeriesSet(setId),
        [`booster-box--${setId}`]: true,
        [`booster-box--disabled`]: disabled,
        [`show-${currentOrientation}`]: currentOrientation,
        'first-edition': firstEdition,
    });
    const performBoosterBoxAnimation = () => {
        const newOrientation = currentOrientation === 'bottom' ? 'top' : 'bottom';
        setCurrentOrientation(newOrientation);
    };
    const resetBoosterBoxOrientation = () => {
        setCurrentOrientation('top');
    };
    return (React.createElement("div", { className: boosterBoxClassNames, onMouseEnter: () => {
            performBoosterBoxAnimation();
        }, onMouseLeave: () => resetBoosterBoxOrientation(), onClick: () => {
            if (onClick)
                onClick(setId, firstEdition);
        } },
        React.createElement("div", { className: "booster-box__box" },
            React.createElement("div", { className: "booster-box__face booster-box__face--front" }),
            React.createElement("div", { className: "booster-box__face booster-box__face--back" }),
            React.createElement("div", { className: "booster-box__face booster-box__face--right" }),
            React.createElement("div", { className: "booster-box__face booster-box__face--left" }),
            React.createElement("div", { className: "booster-box__face booster-box__face--top" }, disabled ? (React.createElement("div", { className: "text-light bg-dark-subtle d-flex fs-2 justify-content-center align-items-center h-100 w-100" }, disabledMessage)) : undefined),
            React.createElement("div", { className: "booster-box__face booster-box__face--bottom" }))));
};
const BoosterBox = React.memo(BoosterBoxComponent);

const getAvailableBoosterBoxes = () => {
    const cardSetsOptions = getOptionsFromObject(pokemonCardLibrary.CARD_SETS);
    return cardSetsOptions.filter((cardSetOption) => {
        return !pokemonCardLibrary.isEnglishPromoSet(cardSetOption.value.toString());
    });
};

const BoosterBoxGridComponent = (props) => {
    const { cardSets = getAvailableBoosterBoxes(), disabledSetIds, onBoxClick, } = props;
    const gridColClassName = 'col-xl-3 col-lg-4 col-md-6 col-6';
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "row" }, cardSets.map((option) => (React.createElement(React.Fragment, null,
            pokemonCardLibrary.isEnglishFirstEditionAvailable(option.value.toString()) ? (React.createElement("div", { className: gridColClassName },
                React.createElement(BoosterBox, { disabled: disabledSetIds &&
                        disabledSetIds.includes(option.value.toString()), firstEdition: true, setName: option.label, setId: option.value, onClick: (setId, firstEdition) => onBoxClick && onBoxClick(setId, firstEdition) }),
                option.label ? (React.createElement("h5", { className: "mb-0 text-light text-center p-3 pt-5" },
                    option.label,
                    " ",
                    React.createElement(FirstEditionStamp, { fill: "#fff" }))) : undefined)) : undefined,
            React.createElement("div", { className: gridColClassName },
                React.createElement(BoosterBox, { disabled: disabledSetIds &&
                        disabledSetIds.includes(option.value.toString()), setName: option.label, setId: option.value, onClick: (setId, firstEdition) => onBoxClick && onBoxClick(setId, firstEdition) }),
                option.label ? (React.createElement("h5", { className: "mb-0 text-light text-center p-3 pt-5" }, option.label)) : undefined)))))));
};
const BoosterBoxGrid = React.memo(BoosterBoxGridComponent);

const IconRotateComponent = (props) => {
    const { fill = '#000000', width = SMALL_ICON_SIZE, height = SMALL_ICON_SIZE, } = props;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 853.33 512.25", width: width, height: height },
        React.createElement("path", { fill: fill, d: "M426.67 0C183.47 0 0 91.73 0 213.33c0 104.54 136.11 186.88 329 208.22L311 439a42.67 42.67 0 0 0-.25 60.34l.25.25a42.66 42.66 0 0 0 60.34.24l.25-.24 85.41-85.3a44.1 44.1 0 0 0 0-60.58l-85.33-85.34A42.84 42.84 0 0 0 311 329l5.12 4.69C170.67 313.17 85.33 256 85.33 213.33c0-52.05 133.12-128 341.34-128s341.33 76 341.33 128c0 35.42-61.87 85.34-179.63 110.94a42.66 42.66 0 0 0-33.87 49.93c0 .28.11.56.17.84a42.66 42.66 0 0 0 50.58 32.89h.19c155.73-34.13 247.89-106.66 247.89-194.56C853.33 91.73 669.87 0 426.67 0Z" })));
};
const IconRotate = React.memo(IconRotateComponent);

const AVAILABLE_PKMN_IMAGES = [
    ...Object.values(pokemonCardLibrary.GEN_1_POKEMON),
    ...Object.values(pokemonCardLibrary.GEN_2_POKEMON),
];
const AVAILABLE_BG_IMAGES = Object.values(pokemonCardLibrary.CARD_FRAME_IMAGES);
const AssetLibraryModalComponent = (props) => {
    const { assetsType = 'pkmn', libraryType = 'rows', onHide, onImageClick, searchMessage, show, title, } = props;
    const LIBRARY_IMAGES = assetsType === 'bg' ? AVAILABLE_BG_IMAGES : AVAILABLE_PKMN_IMAGES;
    const DEFAULT_TITLE = assetsType === 'bg'
        ? 'Select Background Image'
        : 'Select Creature/Character Image';
    const DEFAULT_LIBRARY_TYPE = assetsType === 'bg' ? 'images' : 'rows';
    const DEFAULT_SEARCH_MESSAGE = assetsType === 'bg'
        ? 'Search by image name and then select your background image.'
        : 'Search using the input field above by Pokémon name, then select your image.';
    return (React.createElement(RPCModal, { className: "asset-library__modal", dismissible: true, scrollable: true, show: show, size: "xl", title: title || DEFAULT_TITLE, onHide: onHide },
        React.createElement(AssetLibrary, { assets: LIBRARY_IMAGES, isInputFocused: show, libraryType: libraryType || DEFAULT_LIBRARY_TYPE, onImageClick: onImageClick, searchMessage: searchMessage || DEFAULT_SEARCH_MESSAGE, showAllByDefault: assetsType === 'bg' })));
};
const AssetLibraryModal = React.memo(AssetLibraryModalComponent);

const ImageUploader = (props) => {
    const { btnClassName, id = 'rpcImageUploader', label = 'Upload Custom Image', onChange, } = props;
    const labelClassNames = classNames({
        'btn mb-0': true,
        [`${btnClassName}`]: btnClassName,
    });
    return (React.createElement("div", null,
        React.createElement(Form$1.Group, { className: "position-relative rpc-text-input" },
            React.createElement(Form$1.Label, { className: labelClassNames, htmlFor: id }, label),
            React.createElement("input", { accept: ALLOWED_IMAGE_UPLOAD_TYPES, className: "d-none", id: id, onChange: event => {
                    if (onChange)
                        onChange(event);
                }, type: "file" }))));
};

const RPCColorPickerComponent = (props) => {
    const { disabled, emptyValueLabel = 'None', id, label, onChange, value = '#000000', variant = 'white', } = props;
    const colorPickerClassNames = classNames({
        'rpc-color-picker form-control w-100 d-flex m-0': true,
        [`bg-${variant} bg-gradient`]: variant,
        [`text-light`]: variant && isLightText(variant),
    });
    const colorPickerLabelClassNames = classNames({
        'rpc-color-picker__label d-block': true,
        [`label-primary`]: variant && isPrimaryLabel(variant),
    });
    return (React.createElement(Form$1.Label, { htmlFor: id, className: colorPickerClassNames },
        React.createElement("div", { className: "lh-1" },
            React.createElement("span", { className: colorPickerLabelClassNames }, label),
            React.createElement("span", { className: "d-block rpc-color-picker__value" }, value ? value.toUpperCase() : emptyValueLabel)),
        React.createElement(Form$1.Control, { className: "ms-auto", disabled: disabled, id: id, onChange: onChange, title: "Choose your color", type: "color", value: value })));
};
const RPCColorPicker = React.memo(RPCColorPickerComponent);

const CardCreatorFormComponent = (props) => {
    const { cardState, cardSetState, defaultActiveKey, disabled, fluid = true, isHoloAnimation = true, isImageUploadEnabled, onBackgroundImageUpload, onCreatureImageUpload, onHoloAnimationChange, onCardValueChange, onCardSetValueChange, } = props;
    const marginBottomClassName = 'mb-3';
    const [isAssetLibraryModalOpen, setIsAssetLibraryModalOpen] = React.useState(false);
    const [currentAssetLibraryAssetsType, setCurrentAssetLibraryAssetsType] = React.useState('pkmn');
    const { babyDescription, backgroundColor, backgroundImageBlendMode, backgroundImageOpacity, backgroundImagePositionX, backgroundImagePositionY, backgroundImageUrl, cardTemplate, cardTemplateSubtype, creatureImageBlendMode, description, dotMatrixVariant, energyResistance, energyRetreatCost, energyType, energyWeakness, eReaderId, evolutionBoxBackgroundImageSize, evolutionBoxImageUrl, evolvesFrom, evolvesTo, frameMode, hasStatsBarShadow, hitPoints, holo, holoBlendMode, holoSheetType, holoStrength, illustrator, isBoldName, isFullReverseHolo, language, lengthFeet, lengthInches, moves, name, nameCondenseLevel, pokemonImagePositionX, pokemonImagePositionY, pokemonImageRotation, pokemonImageShadowColor, pokemonImageShadowOffsetX, pokemonImageShadowOffsetY, pokemonImageShadowSize, pokemonImageSize, pokemonImageUrl, pokemonLevel, pokemonNumber, pokemonType, rarity, reverseHoloSheetType, setNumber, specialTemplateType, stage, stamp, subtitle, trainerImageUrl, trainerRule, unownLetter, weight, } = cardState || null;
    const { copyright, firstEdition, holoSheetType: cardSetHoloSheetType, reverseHoloSheetType: cardSetReverseHoloSheetType, setSymbol, setTotal, shadowless, } = cardSetState;
    const isEvoBoxBgImageSizeDisabled = evolutionBoxBackgroundImageSize === 'cover' ||
        evolutionBoxBackgroundImageSize === 'contain';
    const cardFormClassNames = classNames({
        'card-creator-form': true,
    });
    const updateCardMoves = (moveIndex, field, value) => {
        const updatedMoves = [...moves];
        updatedMoves[moveIndex][field] = value;
        if (onCardValueChange)
            onCardValueChange('moves', updatedMoves);
    };
    const removeMove = (moveIndex) => {
        const updatedMoves = [...moves];
        if (moveIndex > -1) {
            updatedMoves.splice(moveIndex, 1);
        }
        if (onCardValueChange)
            onCardValueChange('moves', updatedMoves);
    };
    const openAssetLibraryModal = (assetsType) => {
        setCurrentAssetLibraryAssetsType(assetsType);
        setIsAssetLibraryModalOpen(true);
    };
    const cardNameColClassNames = classNames({
        'mb-3 col-sm-6': true,
    });
    const isTrainer = isTrainerTemplate(cardTemplate);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cardFormClassNames },
            React.createElement(RPCAccordion, { disabled: disabled, fluid: fluid, flush: true, defaultActiveKey: defaultActiveKey },
                React.createElement(RPCAccordionItem, { eventKey: "card_name_bar", header: "Name Bar", subheader: "(Energy Type, Name, Evolves from, Stage, HP)" },
                    !isTrainerTemplate(cardTemplate) ? (React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col mb-3" },
                            React.createElement(EnergySelector, { label: "Card Energy Type", onChange: (energyType) => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyType', energyType);
                                }, value: energyType })))) : undefined,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: cardNameColClassNames },
                            React.createElement(RPCTextInput, { label: "Card Name", helperText: `${name ? name.length : 0}/${getNameMaxLength(isTrainer)}`, maxLength: getNameMaxLength(isTrainer), placeholder: "Card Name", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('name', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('name', '');
                                }, value: name })),
                        !isTrainerOrEnergyTemplate(cardTemplate) &&
                            !isShiningBabyUnownSubtype(cardTemplateSubtype) ? (React.createElement("div", { className: cardNameColClassNames },
                            React.createElement(RPCTextInput, { disabled: isBasic(stage), label: "Evolves From", placeholder: "Evolves From", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('evolvesFrom', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('evolvesFrom', '');
                                }, value: evolvesFrom }))) : undefined,
                        isBabySubtype(cardTemplateSubtype) ? (React.createElement("div", { className: cardNameColClassNames },
                            React.createElement(RPCTextInput, { label: "Evolves To", placeholder: "Evolves To", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('evolvesTo', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('evolvesTo', '');
                                }, value: evolvesTo }))) : undefined,
                        !isEnergyTemplate(cardTemplate) ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "col-sm-3 mb-3" },
                                React.createElement(RPCTextInput, { isArrowUpDisabled: hitPoints >= HP_MAX, isArrowDownDisabled: !hitPoints || hitPoints <= HP_MIN, label: "HP", max: HP_MAX, min: 0, onArrowDownClick: () => {
                                        if (onCardValueChange) {
                                            const newVal = (hitPoints ? Number(hitPoints) : 0) - 1;
                                            onCardValueChange('hitPoints', newVal);
                                        }
                                    }, onArrowUpClick: () => {
                                        if (onCardValueChange) {
                                            const newVal = (hitPoints ? Number(hitPoints) : 0) + 1;
                                            onCardValueChange('hitPoints', newVal);
                                        }
                                    }, onChange: (event) => {
                                        if (Number(event.target.value) <= HP_MAX)
                                            if (onCardValueChange)
                                                onCardValueChange('hitPoints', event.target.value);
                                    }, onClear: () => {
                                        if (onCardValueChange)
                                            onCardValueChange('hitPoints', '');
                                    }, inputMode: "numeric", value: hitPoints })))) : undefined,
                        !isTrainerOrEnergyTemplate(cardTemplate) &&
                            !isShiningBabyUnownSubtype(cardTemplateSubtype) ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "col-sm-3 mb-3" },
                                React.createElement(RPCTextInput, { isArrowUpDisabled: stage >= STAGE_MAX, isArrowDownDisabled: !stage || stage === STAGE_MIN, label: "Stage", maxLength: 1, max: 2, min: 0, onArrowDownClick: () => {
                                        if (onCardValueChange) {
                                            const newVal = (stage ? Number(stage) : 0) - 1;
                                            onCardValueChange('stage', newVal);
                                        }
                                    }, onArrowUpClick: () => {
                                        if (onCardValueChange) {
                                            const newVal = (stage ? Number(stage) : 0) + 1;
                                            onCardValueChange('stage', newVal);
                                        }
                                    }, onChange: (event) => {
                                        if (onCardValueChange)
                                            onCardValueChange('stage', event.target.value);
                                    }, onClear: () => {
                                        if (onCardValueChange)
                                            onCardValueChange('stage', '');
                                    }, inputMode: "numeric", value: stage })))) : undefined,
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCRangeSliderInput, { helperText: "0 = Use Default, 5 = Hyper-condensed", label: "Name Condensing Level", min: 0, max: 5, onChange: (event) => {
                                    if (onCardValueChange) {
                                        const numericVal = Number(event.target.value);
                                        onCardValueChange('nameCondenseLevel', numericVal);
                                    }
                                }, step: 1, value: nameCondenseLevel || 0 })),
                        isUnownSubtype(cardTemplateSubtype) ? (React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "unownLetter", inline: true, label: "Unown Letter", options: UNOWN_LETTERS_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('unownLetter', value);
                                }, value: unownLetter || UNOWN_LETTERS_OPTIONS[0].value }))) : undefined,
                        isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCTextInput, { label: "Card Subtitle", helperText: `${subtitle ? subtitle.length : 0}/${30}`, maxLength: 30, placeholder: "Card Subtitle", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('subtitle', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('subtitle', '');
                                }, value: subtitle }))) : undefined,
                        isBaseTrainerTemplate(cardTemplate) ? (React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, id: "isBoldHeader", label: "Bold Name", checked: isBoldName, onChange: (checked) => {
                                    if (onCardValueChange)
                                        onCardValueChange('isBoldName', checked);
                                } }))) : undefined)),
                isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(RPCAccordionItem, { eventKey: "trainer_description", header: "Trainer/Energy Description", subheader: "(Description, Trainer Rule)" },
                    React.createElement(React.Fragment, null,
                        isTrainerTemplate(cardTemplate) ? (React.createElement("div", { className: "col mb-3" },
                            React.createElement(RPCTextInput, { as: "textarea", label: "Trainer Rule", placeholder: "Trainer Rule", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('trainerRule', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('trainerRule', '');
                                }, rows: 3, value: trainerRule }))) : undefined,
                        React.createElement("div", { className: "col mb-3" },
                            React.createElement(RPCTextInput, { as: "textarea", label: "Description", placeholder: "Description", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('description', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('description', '');
                                }, rows: 3, value: description }))))) : undefined,
                React.createElement(RPCAccordionItem, { eventKey: "template_options", header: "Template Settings", subheader: "(Card Template, Set Symbol, Frame Mode, Trainer Image, etc)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "cardTemplate", label: "Card Template", options: CARD_TEMPLATE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('cardTemplate', value);
                                }, showSearch: true, value: cardTemplate || CARD_TEMPLATE_OPTIONS[0].value }),
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, disabled: !cardTemplate || !isESeriesTemplate(cardTemplate), id: "dotMatrixVariant", label: "Show Dot Matrix", options: DOT_MATRIX_POSITION_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('dotMatrixVariant', value);
                                }, value: dotMatrixVariant || DOT_MATRIX_POSITION_OPTIONS[0].value }),
                            React.createElement(RPCDropdownMenu, { allowClear: true, className: marginBottomClassName, id: "cardTemplateSubtype", label: "Card Template Subtype", options: CARD_TEMPLATE_SUBTYPE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('cardTemplateSubtype', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('cardTemplateSubtype', '');
                                }, placeholder: "Baby, Shining, Unown", value: cardTemplateSubtype }),
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, id: "firstEdition", label: "First Edition", checked: firstEdition, onChange: (checked) => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('firstEdition', checked);
                                } }),
                            React.createElement(RPCDropdownMenu, { allowClear: true, className: marginBottomClassName, id: "setSymbol", label: "Set Symbol", options: CARD_SETS_OPTIONS, onChange: (value) => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('setSymbol', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('setSymbol', '');
                                }, placeholder: "Main and Promo Sets", renderOption: (option) => {
                                    return (React.createElement("div", { className: "d-flex align-items-center" },
                                        React.createElement("div", { className: "option-image me-3 d-flex justify-content-center align-items-center" },
                                            React.createElement(CardSetSymbol, { setSymbol: option.value?.toString() })),
                                        React.createElement("div", { className: "option-label" }, option.label)));
                                }, showSearch: true, value: setSymbol === 'base-set'
                                    ? 'Base Set (No Symbol)'
                                    : setSymbol }),
                            React.createElement(RPCDropdownMenu, { allowClear: true, className: marginBottomClassName, id: "frameMode", label: "Frame Mode", options: CARD_FRAME_STYLE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('frameMode', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('frameMode', '');
                                }, placeholder: "Light or Dark", value: frameMode })),
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCDropdownMenu, { allowClear: true, className: marginBottomClassName, disabled: isTrainerOrEnergyTemplate(cardTemplate), id: "specialTemplateType", label: "Special Template Type", options: CARD_SPECIAL_TEMPLATE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('specialTemplateType', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('specialTemplateType', '');
                                }, placeholder: "Crystal, Fossil", value: specialTemplateType }),
                            React.createElement(RPCDropdownMenu, { allowClear: true, showSearch: true, className: marginBottomClassName, id: "trainerImageUrl", disabled: isGymTrainerSettingsDisabled(cardTemplate), label: "Gym Trainer Image", options: TRAINER_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('trainerImageUrl', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('trainerImageUrl', '');
                                }, placeholder: "Kanto and Johto Trainers", renderOption: (option) => {
                                    return (React.createElement("div", { className: "d-flex align-items-center" },
                                        React.createElement("div", { className: "option-image me-3" },
                                            React.createElement("img", { src: option.image })),
                                        React.createElement("div", { className: "option-label" }, option.label)));
                                }, value: trainerImageUrl }),
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, id: "shadowless", label: "Shadowless", checked: shadowless, onChange: (checked) => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('shadowless', checked);
                                } }),
                            React.createElement(RPCDropdownMenu, { allowClear: true, className: marginBottomClassName, id: "stamp", label: "Frame Stamp", options: STAMP_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('stamp', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('stamp', '');
                                }, placeholder: "Prerelease, Winner, Wizards", value: stamp }),
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "language", label: "Template Language", options: CARD_LANGUAGE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('language', value);
                                }, value: language || 'en' })))),
                React.createElement(RPCAccordionItem, { eventKey: "card_images", header: "Images", subheader: "(Background, main creature and evolution box images)" },
                    !isBasic(stage) || isBabySubtype(cardTemplateSubtype) ? (React.createElement("div", { className: "images-section mb-3 shadow-sm" },
                        React.createElement("div", { className: "bg-secondary-subtle p-3" }, "Evolution Box Image"),
                        React.createElement("div", { className: "p-3 bg-white pb-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col text-center" },
                                    React.createElement(RPCButton, { size: "lg", variant: "primary", title: "Choose Evolves From Image", className: "card-images-row__btn", label: "Select From Gallery", onClick: () => openAssetLibraryModal('pkmn-evo') }))),
                            evolutionBoxImageUrl && (React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col text-center" },
                                    React.createElement("div", { className: "p-3 border border-secondary-subtle" },
                                        React.createElement(Image$1, { alt: "not found", src: evolutionBoxImageUrl, height: 200 }))))),
                            React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { disabled: isEvoBoxBgImageSizeDisabled, label: "Image Size %", min: 1, max: 100, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('evolutionBoxBackgroundImageSize', event.target.value);
                                        }, showText: !isEvoBoxBgImageSizeDisabled, step: 1, type: "percentage", value: evolutionBoxBackgroundImageSize })),
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCDropdownMenu, { allowClear: true, id: "evolutionBoxBackgroundImageSize", inline: true, label: "Image Size Preset", options: BACKGROUND_SIZE_OPTIONS, onChange: (value) => {
                                            if (onCardValueChange)
                                                onCardValueChange('evolutionBoxBackgroundImageSize', value);
                                        }, onClear: () => {
                                            if (onCardValueChange)
                                                onCardValueChange('evolutionBoxBackgroundImageSize', '');
                                        }, placeholder: "Cover, Contain", value: !isNumeric(evolutionBoxBackgroundImageSize)
                                            ? evolutionBoxBackgroundImageSize
                                            : '' }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col" },
                                    React.createElement(RPCTextInput, { className: "mb-3", disabled: isBasic(stage), label: "Evolution Box Image URL", placeholder: "Evolution Box Image URL", onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('evolutionBoxImageUrl', event.target.value);
                                        }, onClear: () => {
                                            if (onCardValueChange)
                                                onCardValueChange('evolutionBoxImageUrl', '');
                                        }, value: evolutionBoxImageUrl })))))) : undefined,
                    React.createElement("div", { className: "images-section mb-3 shadow-sm" },
                        React.createElement("div", { className: "bg-secondary-subtle p-3" },
                            "Creature/Character Image ",
                            React.createElement("small", null, "(Foreground Layer)")),
                        React.createElement("div", { className: "p-3 bg-white" },
                            isImageUploadEnabled ? (React.createElement(RPCAlert, { dismissible: true, className: "mb-3", variant: "warning", icon: React.createElement(IconPNGFile, null) }, "A .png image with a transparent background is recommended here, as holo patterns will not work without the foreground layer being transparent.")) : undefined,
                            React.createElement("div", { className: "row has-separator" },
                                React.createElement("div", { className: "col-6 mx-auto" },
                                    React.createElement(RPCButton, { size: "lg", variant: "primary", className: "d-block w-100", label: "Select From Gallery", title: "Choose Creature Image", onClick: () => openAssetLibraryModal('pkmn') })),
                                isImageUploadEnabled ? (React.createElement("div", { className: "col-6" },
                                    React.createElement(ImageUploader, { btnClassName: "btn-lg btn-info w-100", id: "creature-image-upload", onChange: (event) => {
                                            if (event &&
                                                event.target &&
                                                event.target.files &&
                                                event.target.files.length) {
                                                const imageUrl = URL.createObjectURL(event.target.files[0]);
                                                if (onCreatureImageUpload) {
                                                    onCreatureImageUpload(event.target.files[0]);
                                                }
                                                if (onCardValueChange) {
                                                    onCardValueChange('pokemonImageUrl', imageUrl);
                                                }
                                            }
                                        }, selectedImageUrl: pokemonImageUrl }))) : undefined),
                            pokemonImageUrl && (React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col text-center" },
                                    React.createElement("div", { className: "p-3 border border-secondary-subtle" },
                                        React.createElement(Image$1, { alt: "not found", src: pokemonImageUrl, height: 200 }))))),
                            React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { label: "Image Size", min: 1, max: 100, step: 1, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImageSize', event.target.value);
                                        }, type: "percentage", value: pokemonImageSize })),
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { type: "degrees", label: "Image Rotation", min: -360, max: 360, step: 1, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImageRotation', event.target.value);
                                        }, value: pokemonImageRotation }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { label: "Image X Position", min: -100, max: 200, step: 1, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImagePositionX', event.target.value);
                                        }, type: "percentage", value: pokemonImagePositionX })),
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { label: "Image Y Position", min: -100, max: 200, step: 1, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImagePositionY', event.target.value);
                                        }, type: "percentage", value: pokemonImagePositionY }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col" },
                                    React.createElement(RPCTextInput, { label: "Creature/Character Image URL", placeholder: "Creature/Character Image URL", onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImageUrl', event.target.value);
                                        }, onClear: () => {
                                            if (onCardValueChange)
                                                onCardValueChange('pokemonImageUrl', '');
                                        }, value: pokemonImageUrl }))))),
                    React.createElement("div", { className: "images-section mb-3 shadow-sm" },
                        React.createElement("div", { className: "bg-secondary-subtle p-3" },
                            "Background Image ",
                            React.createElement("small", null, "(Background Layer)")),
                        React.createElement("div", { className: "p-3 bg-white" },
                            React.createElement("div", { className: "row has-separator" },
                                React.createElement("div", { className: "col-6 mx-auto" },
                                    React.createElement(RPCButton, { size: "lg", variant: "primary", title: "Choose background image", className: "d-block w-100", label: "Select From Gallery", onClick: () => openAssetLibraryModal('bg') })),
                                isImageUploadEnabled ? (React.createElement("div", { className: "col-6" },
                                    React.createElement(ImageUploader, { btnClassName: "btn-lg btn-info w-100", id: "bg-image-upload", onChange: (event) => {
                                            if (event &&
                                                event.target &&
                                                event.target.files &&
                                                event.target.files.length) {
                                                const imageUrl = URL.createObjectURL(event.target.files[0]);
                                                if (onBackgroundImageUpload) {
                                                    onBackgroundImageUpload(event.target.files[0]);
                                                }
                                                if (onCardValueChange) {
                                                    onCardValueChange('backgroundImageUrl', imageUrl);
                                                }
                                            }
                                        }, selectedImageUrl: backgroundImageUrl }))) : undefined),
                            backgroundImageUrl && (React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col text-center" },
                                    React.createElement("div", { className: "p-3 border border-secondary-subtle" },
                                        React.createElement(Image$1, { alt: "not found", src: backgroundImageUrl, height: 200 }))))),
                            React.createElement("div", { className: "row mt-3" },
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { label: "BG X Position", min: -999, max: 999, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('backgroundImagePositionX', event.target.value);
                                        }, step: 1, type: "percentage", value: backgroundImagePositionX })),
                                React.createElement("div", { className: "col-sm-6 mb-3" },
                                    React.createElement(RPCRangeSliderInput, { label: "BG Y Position", min: -999, max: 999, onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('backgroundImagePositionY', event.target.value);
                                        }, step: 1, type: "percentage", value: backgroundImagePositionY }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col" },
                                    React.createElement(RPCTextInput, { label: "Background Image URL", placeholder: "Background Image URL", onChange: (event) => {
                                            if (onCardValueChange)
                                                onCardValueChange('backgroundImageUrl', event.target.value);
                                        }, onClear: () => {
                                            if (onCardValueChange)
                                                onCardValueChange('backgroundImageUrl', '');
                                        }, value: backgroundImageUrl })))))),
                React.createElement(RPCAccordionItem, { eventKey: "creature_image_options", header: "Foreground Layer Settings", subheader: "(Opacity, Blend Mode, Shadow) - Used for creature, trainer, etc." },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCRangeSliderInput, { label: "Shadow Offset X", min: -999, max: 999, step: 1, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonImageShadowOffsetX', event.target.value);
                                }, type: "percentage", value: pokemonImageShadowOffsetX || 0 })),
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCRangeSliderInput, { label: "Shadow Offset Y", min: -999, max: 999, step: 1, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonImageShadowOffsetY', event.target.value);
                                }, type: "percentage", value: pokemonImageShadowOffsetY || 0 }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCRangeSliderInput, { label: "Shadow Size", min: 0, max: 1, step: 0.01, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonImageShadowSize', event.target.value);
                                }, type: "percentage", value: pokemonImageShadowSize || DEFAULT_SHADOW_SIZE })),
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCColorPicker, { label: "Shadow Color", value: pokemonImageShadowColor, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonImageShadowColor', event.target.value);
                                } }))),
                    React.createElement("div", { className: "row align-items-center" },
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCDropdownMenu, { id: "creatureImageBlendMode", inline: true, label: "Image Blend Mode", options: BLEND_MODE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('creatureImageBlendMode', value);
                                }, value: creatureImageBlendMode || BLEND_MODE_OPTIONS[0].value })))),
                React.createElement(RPCAccordionItem, { eventKey: "background_image_options", header: React.createElement(React.Fragment, null, "Background Layer Settings "), subheader: "(Color, Opacity, Blend Mode, X/Y Position)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCRangeSliderInput, { className: marginBottomClassName, label: "BG Image Opacity", min: 0, max: 1, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('backgroundImageOpacity', event.target.value);
                                }, step: 0.01, type: "percentage", value: backgroundImageOpacity || 1 })),
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "backgroundImageBlendMode", inline: true, label: "BG Image Blend Mode", options: BLEND_MODE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('backgroundImageBlendMode', value);
                                }, value: backgroundImageBlendMode || BLEND_MODE_OPTIONS[0].value }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCColorPicker, { label: "BG Color", value: backgroundColor, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('backgroundColor', event.target.value);
                                } })))),
                React.createElement(RPCAccordionItem, { eventKey: "holo_options", header: "Holo Layer Settings", subheader: "(Holo/Reverse, Sheet Type, Blend Mode, Strength)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, stacked: true, id: "holographic", label: "Holographic", checked: !!holo, onChange: (checked) => {
                                    if (onCardValueChange)
                                        onCardValueChange('holo', checked);
                                } }),
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, stacked: true, checked: typeof holo === 'string' && holo === 'reverse', id: "rev_holo", label: "Reverse Holo", onChange: (checked) => {
                                    if (onCardValueChange) {
                                        if (checked) {
                                            onCardValueChange('holo', 'reverse');
                                        }
                                        else {
                                            if (holo) {
                                                onCardValueChange('holo', true);
                                            }
                                            else {
                                                onCardValueChange('holo', false);
                                            }
                                        }
                                    }
                                } }),
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, stacked: true, checked: isFullReverseHolo, disabled: typeof holo !== 'string' ||
                                    (typeof holo === 'string' && holo !== 'reverse'), id: "full_rev_holo", label: "Full Reverse", onChange: (checked) => {
                                    onCardValueChange('isFullReverseHolo', checked);
                                } }),
                            React.createElement(RPCRangeSliderInput, { className: marginBottomClassName, disabled: !holo, label: "Holo Strength", min: 0, max: 0.9, step: 0.01, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('holoStrength', event.target.value);
                                }, type: "percentage", value: holoStrength })),
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "holoSheetType", inline: true, label: "Holo Sheet Type", options: HOLO_SHEET_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('holoSheetType', value);
                                }, value: holoSheetType || cardSetHoloSheetType }),
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "reverseHoloSheetType", inline: true, label: "Reverse Holo Sheet Type", options: HOLO_SHEET_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('reverseHoloSheetType', value);
                                }, value: reverseHoloSheetType ||
                                    cardSetReverseHoloSheetType ||
                                    DEFAULT_REVERSE_HOLO_SHEET_TYPE }),
                            React.createElement(RPCDropdownMenu, { className: marginBottomClassName, id: "holoBlendMode", inline: true, label: "Holo Sheet Blend Mode", options: BLEND_MODE_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('holoBlendMode', value);
                                }, value: holoBlendMode || BLEND_MODE_OPTIONS[0].value }),
                            React.createElement(RPCToggleSwitch, { className: marginBottomClassName, stacked: true, checked: isHoloAnimation, disabled: !holo, id: "holoAnimation", label: "Holo Animation", onChange: (checked) => {
                                    if (onHoloAnimationChange)
                                        onHoloAnimationChange(checked);
                                } })))),
                !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(RPCAccordionItem, { eventKey: "creature_attributes", header: "Stats Bar", subheader: "(Type, Length, Weight)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { label: "Type", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonType', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonType', '');
                                }, value: pokemonType })),
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { isArrowDownDisabled: !lengthFeet || lengthFeet <= 0, label: "Length (ft)", max: 99, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (lengthFeet ? Number(lengthFeet) : 0) - 1;
                                        onCardValueChange('lengthFeet', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (lengthFeet ? Number(lengthFeet) : 0) + 1;
                                        onCardValueChange('lengthFeet', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('lengthFeet', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('lengthFeet', '');
                                }, inputMode: "numeric", value: lengthFeet })),
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { isArrowDownDisabled: !lengthInches || lengthInches <= 0, label: "Length (in)", max: 99, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (lengthInches ? Number(lengthInches) : 0) - 1;
                                        onCardValueChange('lengthInches', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (lengthInches ? Number(lengthInches) : 0) + 1;
                                        onCardValueChange('lengthInches', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('lengthInches', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('lengthInches', '');
                                }, inputMode: "numeric", value: lengthInches })),
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { isArrowUpDisabled: weight === WEIGHT_MAX, isArrowDownDisabled: !weight || weight <= 0, label: "Weight (lbs)", max: 99, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (weight ? Number(weight) : 0) - 1;
                                        onCardValueChange('weight', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (weight ? Number(weight) : 0) + 1;
                                        onCardValueChange('weight', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('weight', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('weight', '');
                                }, inputMode: "numeric", value: weight }))),
                    React.createElement("div", { className: "row align-items-center" },
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { disabled: !isESeriesTemplate(cardTemplate), label: "E Reader ID", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('eReaderId', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('eReaderId', '');
                                }, value: eReaderId })),
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCToggleSwitch, { id: "hasStatsBarShadow", label: "Stats Bar Shadow", checked: hasStatsBarShadow, onChange: (checked) => {
                                    if (onCardValueChange)
                                        onCardValueChange('hasStatsBarShadow', checked);
                                } }))))) : undefined,
                !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(RPCAccordionItem, { eventKey: "moves", header: "Moves", subheader: "(Add, Update, Remove & Reorder Moves)" },
                    React.createElement(MovesInput, { movesMax: isBabySubtype(cardTemplateSubtype) ? 1 : MOVES_MAX, onAdd: () => {
                            const newMoves = moves && moves.length
                                ? [...moves, { name: '' }]
                                : [{ name: '' }];
                            if (!moves || (moves && moves.length <= 2)) {
                                if (onCardValueChange)
                                    onCardValueChange('moves', newMoves);
                            }
                        }, onChange: (moveIndex, field, value) => {
                            if (typeof value === 'object' &&
                                (field === 'damageModifier' || field === 'specialMoveType')) {
                                updateCardMoves(moveIndex, field, value.value);
                            }
                            else {
                                updateCardMoves(moveIndex, field, value);
                            }
                        }, onRemove: (moveIndex) => {
                            removeMove(moveIndex);
                        }, onReorder: (updatedMoves) => {
                            if (onCardValueChange)
                                onCardValueChange('moves', updatedMoves);
                        }, value: moves }))) : undefined,
                !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(RPCAccordionItem, { eventKey: "card_energy_costs", header: "Energy Costs", subheader: "(Weakness, Resistance, Retreat)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-4 mb-3" },
                            React.createElement(RPCDropdownMenu, { allowClear: true, id: "weakness", label: "Weakness", options: ENERGY_TYPES_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyWeakness', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyWeakness', '');
                                }, placeholder: "Select Weakness", renderOption: (option) => {
                                    return (React.createElement("div", { className: "d-flex align-items-center" },
                                        React.createElement("div", { className: "option-image me-1 d-flex justify-content-center align-items-center" },
                                            React.createElement(EnergySymbol, { type: option.value })),
                                        React.createElement("div", { className: "option-label" }, option.label)));
                                }, showSearch: true, value: energyWeakness })),
                        React.createElement("div", { className: "col-4 mb-3" },
                            React.createElement(RPCDropdownMenu, { allowClear: true, id: "resistance", label: "Resistance", options: ENERGY_TYPES_OPTIONS, onChange: (value) => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyResistance', value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyResistance', '');
                                }, placeholder: "Select Resistance", renderOption: (option) => {
                                    return (React.createElement("div", { className: "d-flex align-items-center" },
                                        React.createElement("div", { className: "option-image me-1 d-flex justify-content-center align-items-center" },
                                            React.createElement(EnergySymbol, { type: option.value })),
                                        React.createElement("div", { className: "option-label" }, option.label)));
                                }, showSearch: true, value: energyResistance })),
                        React.createElement("div", { className: "col-4" },
                            React.createElement(RPCTextInput, { isArrowDownDisabled: !energyRetreatCost || energyRetreatCost <= 0, isArrowUpDisabled: energyRetreatCost >= RETREAT_COST_MAX, label: "Retreat Cost", max: RETREAT_COST_MAX, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (energyRetreatCost ? Number(energyRetreatCost) : 0) -
                                            1;
                                        onCardValueChange('energyRetreatCost', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (energyRetreatCost ? Number(energyRetreatCost) : 0) +
                                            1;
                                        onCardValueChange('energyRetreatCost', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (Number(event.target.value) <= RETREAT_COST_MAX &&
                                        onCardValueChange)
                                        onCardValueChange('energyRetreatCost', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('energyRetreatCost', '');
                                }, inputMode: "numeric", value: energyRetreatCost }))))) : undefined,
                !isTrainerOrEnergyTemplate(cardTemplate) ? (React.createElement(RPCAccordionItem, { eventKey: "creature_dex_entry", header: "'Dex Info", subheader: "(Description, Level, #)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col mb-3" },
                            React.createElement(RPCTextInput, { as: "textarea", helperText: `${(description && description.length) || 0}/138`, label: "Description", maxLength: 138, placeholder: "Description", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('description', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('description', '');
                                }, rows: 2, value: description })),
                        isBabySubtype(cardTemplateSubtype) ? (React.createElement("div", { className: "col mb-3" },
                            React.createElement(RPCTextInput, { as: "textarea", label: "'Baby Description' Text", placeholder: "'Baby Description' Text", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('babyDescription', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('babyDescription', '');
                                }, rows: 2, value: babyDescription }))) : undefined),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { isArrowDownDisabled: !pokemonLevel || pokemonLevel <= 0, isArrowUpDisabled: pokemonLevel === LEVEL_MAX, label: "Level", max: HP_MAX, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (pokemonLevel ? Number(pokemonLevel) : 0) - 1;
                                        onCardValueChange('pokemonLevel', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (pokemonLevel ? Number(pokemonLevel) : 0) + 1;
                                        onCardValueChange('pokemonLevel', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (Number(event.target.value) <= HP_MAX &&
                                        onCardValueChange)
                                        onCardValueChange('pokemonLevel', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonLevel', '');
                                }, inputMode: "numeric", value: pokemonLevel })),
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { isArrowDownDisabled: !pokemonNumber || pokemonNumber <= 0, label: "#", max: HP_MAX, min: 0, onArrowDownClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (pokemonNumber ? Number(pokemonNumber) : 0) - 1;
                                        onCardValueChange('pokemonNumber', newVal);
                                    }
                                }, onArrowUpClick: () => {
                                    if (onCardValueChange) {
                                        const newVal = (pokemonNumber ? Number(pokemonNumber) : 0) + 1;
                                        onCardValueChange('pokemonNumber', newVal);
                                    }
                                }, onChange: (event) => {
                                    if (Number(event.target.value) <= HP_MAX &&
                                        onCardValueChange)
                                        onCardValueChange('pokemonNumber', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('pokemonNumber', '');
                                }, inputMode: "numeric", value: pokemonNumber }))))) : undefined,
                React.createElement(RPCAccordionItem, { eventKey: "card_footer", header: "Footer", subheader: "(Illustrator, Copyright, Set Number, Set Total, Rarity)" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCTextInput, { label: "Illustrator", placeholder: "Illustrator", onChange: (event) => {
                                    if (onCardValueChange)
                                        onCardValueChange('illustrator', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('illustrator', '');
                                }, value: illustrator })),
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RPCTextInput, { label: "Copyright", placeholder: "Copyright", onChange: (event) => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('copyright', event.target.value);
                                }, onClear: () => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('copyright', '');
                                }, value: copyright }))),
                    React.createElement("div", { className: "row align-items-center" },
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { label: "Number", max: HP_MAX, min: 0, onChange: (event) => {
                                    if (Number(event.target.value) <= HP_MAX &&
                                        onCardValueChange)
                                        onCardValueChange('setNumber', event.target.value);
                                }, onClear: () => {
                                    if (onCardValueChange)
                                        onCardValueChange('setNumber', '');
                                }, value: setNumber })),
                        React.createElement("div", { className: "col-sm-3 mb-3" },
                            React.createElement(RPCTextInput, { max: HP_MAX, min: 0, onChange: (event) => {
                                    if (Number(event.target.value) <= HP_MAX &&
                                        onCardSetValueChange)
                                        onCardSetValueChange('setTotal', event.target.value);
                                }, onClear: () => {
                                    if (onCardSetValueChange)
                                        onCardSetValueChange('setTotal', '');
                                }, label: "Out Of", value: setTotal })),
                        React.createElement("div", { className: "col-sm-6 mb-3" },
                            React.createElement(RaritySelector, { label: "Rarity", nullable: true, value: rarity, onChange: (rarityType) => {
                                    if (onCardValueChange)
                                        onCardValueChange('rarity', rarityType);
                                } })))))),
        React.createElement(AssetLibraryModal, { assetsType: currentAssetLibraryAssetsType, libraryType: currentAssetLibraryAssetsType === 'bg' ? 'images' : 'rows', onHide: () => setIsAssetLibraryModalOpen(false), onImageClick: (image) => {
                const fieldNameToUpdate = currentAssetLibraryAssetsType === 'bg'
                    ? 'backgroundImageUrl'
                    : currentAssetLibraryAssetsType === 'pkmn-evo'
                        ? 'evolutionBoxImageUrl'
                        : 'pokemonImageUrl';
                if (onCardValueChange)
                    onCardValueChange(fieldNameToUpdate, image && image.value);
                setIsAssetLibraryModalOpen(false);
            }, show: isAssetLibraryModalOpen })));
};
const CardCreatorForm = React.memo(CardCreatorFormComponent);

const CardCreatorComponent = (props) => {
    const { adDelay = 5000, card, cardSet, defaultActiveKey = ['card_name_bar'], flipCardLabel = 'Flip Card', helpModalLabel = 'Help', hideFormSlideIn, isCardLoading, isImageUploadEnabled, isSaveFileEnabled, onBackgroundImageUpload, onCardFlip, onCardValueChange, onCardSetValueChange, onCreatureImageUpload, onHelpModalOpen, onSaveFile, onSlideInToggle, saveToFileLabel = 'Export to File', showAdOnSave, toggleSlideInLabel = 'Toggle Editor', } = props;
    const DEFAULT_FILE_TYPE_OPTION = FILE_SETTINGS_OPTIONS[1].value;
    const [cardSetState, setCardSetState] = React.useState(cardSet || DEFAULT_CARD_SET_STATE);
    const [cardState, setCardState] = React.useState(card || DEFAULT_CARD_STATE);
    const [isHoloAnimation, setIsHoloAnimation] = React.useState(true);
    const [selectedFileType, setSelectedFileType] = React.useState(DEFAULT_FILE_TYPE_OPTION);
    const cardImageNameDefault = `Custom Card - Untitled`;
    const cardImageName = cardState && cardState.name
        ? `Custom ${cardState.name}`
        : cardImageNameDefault;
    const [fileName, setFileName] = React.useState(cardImageName);
    const cardImageFileName = fileName || cardImageName;
    const cardImageFileExt = selectedFileType;
    const cardImageFile = `${cardImageFileName}.${cardImageFileExt}`;
    const [isFlipped, setIsFlipped] = React.useState(false);
    const [isSaveModalShowing, setIsSaveModalShowing] = React.useState(false);
    const [isImageSaving, setIsImageSaving] = React.useState(false);
    const { babyDescription, backgroundColor, backgroundImageBlendMode, backgroundImageOpacity, backgroundImagePositionX, backgroundImagePositionY, backgroundImageUrl, cardTemplate, cardTemplateSubtype, creatureImageBlendMode, description, dotMatrixVariant, energyResistance, energyRetreatCost, energyType, energyWeakness, eReaderId, evolutionBoxBackgroundImageSize, evolutionBoxBackgroundVariant, evolutionBoxImageUrl, evolvesFrom, evolvesTo, frameMode, hasStatsBarShadow, hitPoints, holo, holoBlendMode, holoSheetType, holoStrength, illustrator, isBoldName, isDoubleEnergyType, isFullReverseHolo, language, lengthFeet, lengthInches, moves, name, nameCondenseLevel, pokemonImagePositionX, pokemonImagePositionY, pokemonImageRotation, pokemonImageShadowColor, pokemonImageShadowSize, pokemonImageSize, pokemonImageUrl, pokemonLevel, pokemonNumber, pokemonType, rarity, reverseHoloSheetType, setNumber, setTotal, specialTemplateType, stage, stamp, subtitle, trainerImageUrl, trainerRule, unownLetter, weight, } = cardState || null;
    const { copyright, firstEdition, language: cardSetLanguage, reverseHoloSheetType: cardSetReverseHoloSheetType, setSymbol, setTotal: cardSetTotal, shadowless, } = cardSetState;
    const isDownloadFileDisabled = !isSaveFileEnabled || isImageSaving || isCardLoading;
    const cardCreatorCardId = isFlipped
        ? 'card-surface-back'
        : 'card-surface-front';
    const actionButtonVariant = 'info';
    const cardCreatorStageClassNames = classNames({
        'card-creator__stage d-flex align-items-center justify-content-center': true,
        'edit-mode': !hideFormSlideIn,
    });
    const onSaveModalHide = () => {
        setIsSaveModalShowing(false);
    };
    const handleCapture = async (id) => {
        setIsImageSaving(true);
        const buildImageOptions = {
            type: selectedFileType,
        };
        await buildImage(id, buildImageOptions).then((dataUrl) => {
            if (dataUrl) {
                saveImage(dataUrl, cardImageFile);
                setIsImageSaving(false);
            }
            setIsImageSaving(false);
        });
    };
    const handleResetSettings = () => {
        setSelectedFileType(DEFAULT_FILE_TYPE_OPTION);
        setFileName(cardImageName);
    };
    React.useEffect(() => {
        if (card)
            setCardState(card);
    }, [card]);
    React.useEffect(() => {
        if (cardSet)
            setCardSetState(cardSet);
    }, [cardSet]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card-creator__actions d-flex flex-column" },
            React.createElement("div", { className: "action-block mb-2" },
                React.createElement(RPCButton, { circular: true, variant: actionButtonVariant, onClick: onSlideInToggle, hasTooltip: true, icon: React.createElement(IconPsychic, { width: 30, fill: "#fff" }), tooltipContent: toggleSlideInLabel, tooltipPlacement: "right" })),
            React.createElement("div", { className: "action-block mb-2" },
                React.createElement(RPCButton, { circular: true, disabled: isCardLoading, variant: actionButtonVariant, onClick: () => {
                        setIsFlipped(!isFlipped);
                        if (onCardFlip) {
                            onCardFlip(isFlipped);
                        }
                    }, hasTooltip: true, icon: React.createElement(IconRotate, { width: 30, fill: "#fff" }), tooltipContent: flipCardLabel, tooltipPlacement: "right" })),
            React.createElement("div", { className: "action-block mb-2" },
                React.createElement(RPCModal, { dismissible: true, scrollable: true, headerVariant: "secondary", footer: React.createElement(React.Fragment, null,
                        React.createElement(RPCButton, { variant: "warning", label: "Reset Settings", icon: React.createElement(IconRemoveCircle, null), onClick: handleResetSettings }),
                        React.createElement(RPCButton, { label: isImageSaving ? 'Downloading...' : 'Download File', variant: "primary", disabled: isDownloadFileDisabled, onClick: async () => {
                                if (isSaveFileEnabled && onSaveFile) {
                                    if (showAdOnSave) {
                                        setIsImageSaving(true);
                                        await delay(adDelay);
                                        handleCapture(cardCreatorCardId);
                                    }
                                    else {
                                        handleCapture(cardCreatorCardId);
                                    }
                                }
                            }, icon: isImageSaving ? (React.createElement(RPCLoadingIndicator, null)) : (React.createElement(IconPNG, { fill: "#fff" })) })), show: isSaveModalShowing, size: "md", title: "Save Card To File", onHide: onSaveModalHide },
                    React.createElement("div", { className: "" },
                        React.createElement("h5", null, "File Settings"),
                        React.createElement(RPCTextInput, { className: "mb-3", label: "File Name", onClear: () => setFileName(''), onChange: (e) => setFileName(e.target.value), value: fileName }),
                        React.createElement(RPCDropdownMenu, { onChange: (value) => {
                                setSelectedFileType(value);
                            }, allowClear: false, options: FILE_SETTINGS_OPTIONS, label: "File Type", value: selectedFileType }))),
                React.createElement(RPCButton, { circular: true, variant: actionButtonVariant, hasTooltip: true, disabled: isDownloadFileDisabled, onClick: () => setIsSaveModalShowing(true), icon: isImageSaving ? React.createElement(RPCLoadingIndicator, null) : React.createElement(IconPNG, { fill: "#fff" }), tooltipContent: saveToFileLabel, tooltipPlacement: "right" })),
            React.createElement("div", { className: "action-block" },
                React.createElement(RPCButton, { circular: true, icon: React.createElement(IconHelp, { fill: "#fff" }), variant: actionButtonVariant, hasTooltip: true, onClick: onHelpModalOpen, tooltipContent: helpModalLabel, tooltipPlacement: "right" }))),
        React.createElement("div", { className: cardCreatorStageClassNames },
            React.createElement(Card, { babyDescription: babyDescription, backgroundColor: backgroundColor, backgroundImageBlendMode: backgroundImageBlendMode, backgroundImageOpacity: backgroundImageOpacity, backgroundImagePositionX: backgroundImagePositionX, backgroundImagePositionY: backgroundImagePositionY, backgroundImageUrl: backgroundImageUrl, cardTemplate: cardTemplate || DEFAULT_CARD_TEMPLATE, cardTemplateSubtype: cardTemplateSubtype, copyright: copyright, creatureImageBlendMode: creatureImageBlendMode, description: description, dotMatrixVariant: dotMatrixVariant, energyResistance: energyResistance, energyRetreatCost: energyRetreatCost, energyType: energyType, energyWeakness: energyWeakness, eReaderId: eReaderId, evolvesFrom: evolvesFrom, evolvesTo: evolvesTo, evolutionBoxBackgroundImageSize: evolutionBoxBackgroundImageSize, evolutionBoxBackgroundVariant: evolutionBoxBackgroundVariant, evolutionBoxImageUrl: evolutionBoxImageUrl, firstEdition: firstEdition, frameMode: frameMode, hasStatsBarShadow: hasStatsBarShadow, hitPoints: hitPoints, holo: holo, holoBlendMode: holoBlendMode || DEFAULT_HOLO_BLEND_MODE, holoSheetType: holoSheetType || cardSet.holoSheetType, holoStrength: holoStrength || DEFAULT_HOLO_STRENGTH, illustrator: illustrator, isBoldName: isBoldName, isDoubleEnergyType: isDoubleEnergyType, isEditable: true, isFlipped: isFlipped, isFullReverseHolo: isFullReverseHolo, isHoloAnimation: isHoloAnimation, isLoading: isCardLoading, language: language || cardSetLanguage, lengthFeet: lengthFeet, lengthInches: lengthInches, moves: moves, name: name, nameCondenseLevel: nameCondenseLevel, onNameChange: (event) => {
                    if (onCardValueChange)
                        onCardValueChange('name', event.target.value);
                }, pokemonImagePositionX: pokemonImagePositionX, pokemonImagePositionY: pokemonImagePositionY, pokemonImageRotation: pokemonImageRotation, pokemonImageShadowColor: pokemonImageShadowColor, pokemonImageShadowSize: pokemonImageShadowSize, pokemonImageSize: pokemonImageSize, pokemonImageUrl: pokemonImageUrl, pokemonLevel: pokemonLevel, pokemonNumber: pokemonNumber, pokemonType: pokemonType, rarity: rarity, reverseHoloSheetType: reverseHoloSheetType || cardSetReverseHoloSheetType, setNumber: setNumber, setTotal: setTotal || cardSetTotal, setSymbol: setSymbol, shadowless: shadowless, specialTemplateType: specialTemplateType, stage: stage, stamp: stamp, subtitle: subtitle, trainerImageUrl: trainerImageUrl, trainerRule: trainerRule, unownLetter: unownLetter, weight: weight })),
        React.createElement(RPCOffCanvas, { fluidContent: true, show: !hideFormSlideIn, placement: "end", backdrop: false, scroll: false, className: "card-creator-form__canvas" },
            React.createElement(CardCreatorForm, { cardState: cardState, cardSetState: cardSetState, defaultActiveKey: defaultActiveKey, disabled: isCardLoading, isHoloAnimation: isHoloAnimation, isImageUploadEnabled: isImageUploadEnabled, onBackgroundImageUpload: onBackgroundImageUpload, onCreatureImageUpload: onCreatureImageUpload, onHoloAnimationChange: (checked) => {
                    setIsHoloAnimation(checked);
                }, onCardSetValueChange: onCardSetValueChange, onCardValueChange: onCardValueChange }))));
};
const CardCreator = React.memo(CardCreatorComponent);

const CardModalComponent = (props) => {
    const { card, cardSet, editCardBadgeLabel, editCardButtonIcon, hideCardDataAction = true, hideCardEditAction, isEditCardDisabled, isShowCardDataDisabled, onEditCardClick, onHide, onNextCardClick, onPrevCardClick, nextCard, prevCard, show, showCardDataBadgeLabel = 'ADMIN', showCardNavigation = true, } = props;
    const { copyright, firstEdition, language, name, reverseHoloSheetType, setSymbol: cardSetSymbol, setTotal, shadowless, } = cardSet;
    const [isCardDataShowing, setIsCardDataShowing] = React.useState(false);
    const handleOnHide = () => {
        setIsCardDataShowing(false);
        if (onHide)
            onHide();
    };
    return (React.createElement(RPCModal, { centered: false, size: "xl", show: show, onHide: handleOnHide, className: "card-modal" },
        React.createElement("div", { className: "container" },
            showCardNavigation ? (React.createElement("div", { className: "row mb-3" },
                React.createElement("div", { className: "col d-flex justify-content-between" },
                    prevCard ? (React.createElement(RPCButton, { onClick: () => {
                            if (onPrevCardClick)
                                onPrevCardClick(prevCard);
                        }, variant: "info", label: `#${prevCard.setNumber} - ${prevCard.name}`, icon: React.createElement(IconCaretLeft, { fill: "#fff" }) })) : undefined,
                    nextCard ? (React.createElement(RPCButton, { onClick: () => {
                            if (onNextCardClick)
                                onNextCardClick(nextCard);
                        }, className: "ms-auto", variant: "info", label: `#${nextCard.setNumber} - ${nextCard.name}`, iconPosition: "right", icon: React.createElement(IconCaretRight, { fill: "#fff" }) })) : undefined))) : undefined,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col" }, card ? (React.createElement("div", { className: "card-modal__image" },
                    React.createElement(Card, { ...card, copyright: card.copyright || copyright, firstEdition: card.firstEdition || firstEdition, holoSheetType: card.holoSheetType || cardSet.holoSheetType, isHoloAnimation: true, language: card.language || language, reverseHoloSheetType: card.reverseHoloSheetType || reverseHoloSheetType, setTotal: card.setTotal || setTotal, setSymbol: card.setSymbol || cardSetSymbol, shadowless: card.shadowless || shadowless }))) : undefined),
                React.createElement("div", { className: "col" }, card ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-flex align-items-center card-modal__name-bar" },
                        React.createElement("div", { className: "card-modal__energy" },
                            React.createElement(EnergySymbol, { type: card.energyType })),
                        React.createElement("h2", { className: "card-modal__name" }, card && card.name),
                        React.createElement("div", { className: "modal-close", onClick: handleOnHide },
                            React.createElement(IconRemoveCircle, { fill: "#fff", width: 24, height: 24 }))),
                    React.createElement("div", { className: "card-modal__details" },
                        React.createElement(RPCTable, { variant: "dark", responsive: true, striped: true },
                            React.createElement("tbody", null,
                                card.description ? (React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { className: "text-accent" }, "Card Text")),
                                    React.createElement("td", null, card.description))) : undefined,
                                name ? (React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { className: "text-accent" }, "Set:")),
                                    React.createElement("td", null,
                                        React.createElement("div", { className: "d-flex align-items-center" },
                                            React.createElement(CardSetSymbol, { fill: "#fff", setSymbol: card.setSymbol || cardSetSymbol }),
                                            name)))) : undefined,
                                card.setNumber || card.rarity ? (React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { className: "text-accent" }, "# / Rarity:")),
                                    React.createElement("td", null,
                                        React.createElement("div", { className: "d-flex align-items-center" },
                                            React.createElement("span", { className: "d-inline-flex me-1" },
                                                "#",
                                                card.setNumber || 'N/A',
                                                setTotal ? `/${setTotal}` : undefined),
                                            card.rarity ? (React.createElement(RaritySymbol, { fill: "#fff", width: 14, height: 14, rarity: card.rarity })) : undefined)))) : undefined,
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { className: "text-accent" }, "Illustrator:")),
                                    React.createElement("td", null, card.illustrator))))),
                    !hideCardDataAction || !hideCardEditAction ? (React.createElement("div", { className: "card-modal__actions" },
                        !hideCardEditAction && (React.createElement(RPCButton, { className: "btn-block w-100", badgeLabel: editCardBadgeLabel, disabled: isEditCardDisabled, icon: editCardButtonIcon, label: "Edit in Card Creator", onClick: () => {
                                if (card && card.id && onEditCardClick)
                                    onEditCardClick(card.id);
                            }, size: "lg" })),
                        !hideCardDataAction && (React.createElement("div", { className: "admin-actions my-2" },
                            React.createElement("h6", { className: "mb-2" }, "Admin Actions"),
                            React.createElement("div", { className: "d-flex mb-2" },
                                React.createElement(RPCButton, { variant: "secondary", badgeLabel: showCardDataBadgeLabel, disabled: isShowCardDataDisabled, label: `${isCardDataShowing ? 'Hide' : 'Show'} Card Data`, onClick: () => {
                                        setIsCardDataShowing(!isCardDataShowing);
                                    } })))))) : undefined,
                    isCardDataShowing && !isShowCardDataDisabled ? (React.createElement("div", { className: "card-modal__data" },
                        "Card Data",
                        React.createElement("pre", null,
                            React.createElement("code", null, JSON.stringify(card, undefined, 2))),
                        "Set Data",
                        React.createElement("pre", null,
                            React.createElement("code", null, JSON.stringify({
                                copyright,
                                name,
                                cardSetSymbol,
                                firstEdition,
                                nextCard: {
                                    name: nextCard && nextCard.name,
                                    id: nextCard && nextCard.id,
                                },
                                prevCard: {
                                    name: prevCard && prevCard.name,
                                    id: prevCard && prevCard.id,
                                },
                                setTotal,
                                shadowless,
                            }, undefined, 2))))) : undefined)) : undefined)))));
};
const CardModal = React.memo(CardModalComponent);

const CardSetComponent = (props) => {
    const { activeCardId, cardActionIcon = React.createElement(IconPlusCircle, { fill: "#fff" }), cardActionLabel, cardDeleteIcon = React.createElement(IconRemove, { fill: "#fff" }), cardDeleteLabel, cards, copyright = '', createdByLabel = 'Created By:', editCardBadgeLabel, editCardButtonIcon, firstEdition, hitCardId, holoSheetType, hideCardDataAction, hideCardEditAction, id, isCardModalOpen, isEditCardDisabled, isFluid, isNextPageDisabled, isPaginated, isPrevPageDisabled, isRevealable, isShowCardDataDisabled, language, noResultsIcon, noResultsMessage = 'No cards found for this set.', onCardClick, onCardActionClick, onCardDeleteClick, onCardModalHide, onEditCardClick, onNextCardClick, onNextPageClick, onPrevCardClick, onPrevPageClick, name, randomizeHoloSheetPosition, reverseHoloSheetType, setSymbol, setTotal, shadowless, showCardCountBadge, showCardDataBadgeLabel, showCardNavigation, showCreatedBy, } = props;
    const currentCardSet = {
        copyright,
        firstEdition,
        holoSheetType,
        id,
        language,
        name,
        reverseHoloSheetType,
        setSymbol,
        setTotal,
        shadowless,
    };
    const [currentCard, setCurrentCard] = React.useState(null);
    const [isModalShowing, setIsModalShowing] = React.useState(false);
    const cardSetClassNames = classNames({
        'card-set': true,
        'card-set--isPaginated': isPaginated,
        'card-set--isRevealable': isRevealable,
    });
    const cardWrapperClassNames = classNames({
        'bg-dark-subtle p-3 mb-3 overflow-hidden': onCardActionClick || onCardDeleteClick,
    });
    const cardSetRowClassNames = classNames({
        row: true,
        'position-relative': isRevealable,
    });
    const cardSetColClassNames = classNames({
        'col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 d-flex justify-content-center flex-column': true,
        'position-relative': !isRevealable,
        'reveal-card': isRevealable,
    });
    const cardSetContainerClassNames = classNames({
        container: !isFluid,
        'container-fluid': isFluid,
    });
    const getNextCard = () => {
        if (!cards || !cards.length || !currentCard) {
            return;
        }
        let nextItem = null;
        const currentCardIndex = cards.indexOf(currentCard);
        if (currentCardIndex >= 0 && currentCardIndex < cards.length - 1)
            nextItem = cards[currentCardIndex + 1];
        return nextItem;
    };
    const getPrevCard = () => {
        if (!cards || !cards.length || !currentCard) {
            return;
        }
        let prevItem = null;
        const currentCardIndex = cards.indexOf(currentCard);
        if (currentCardIndex >= 0 && currentCardIndex < cards.length - 1)
            prevItem = cards[currentCardIndex - 1];
        return prevItem;
    };
    React.useEffect(() => {
        if (activeCardId && cards && cards.length) {
            const activeCard = cards.find((card) => {
                return card.id === activeCardId;
            });
            if (activeCard) {
                setCurrentCard(activeCard);
                setIsModalShowing(true);
            }
        }
    }, [activeCardId]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cardSetClassNames },
            isPaginated ? (React.createElement("button", { className: "card-set__pagination__arrow", disabled: isPrevPageDisabled, onClick: onPrevPageClick },
                React.createElement(IconCaretLeft, { fill: "#fff" }))) : undefined,
            cards ? (React.createElement("div", { className: "card-set__cards" },
                React.createElement("div", { className: cardSetContainerClassNames },
                    React.createElement("div", { className: cardSetRowClassNames }, cards && cards.length ? (cards.map((card, index) => (React.createElement("div", { className: cardSetColClassNames, key: `card-${card && card.id}-${index}` },
                        showCardCountBadge ? (React.createElement(RPCBadge, { className: "card-count-badge" },
                            "x",
                            card.count)) : undefined,
                        React.createElement("div", { className: cardWrapperClassNames },
                            React.createElement(Card, { ...card, className: hitCardId && hitCardId === card.id
                                    ? ' hit-card'
                                    : undefined, copyright: (card && card.copyright) || copyright, firstEdition: (card && card.firstEdition) || firstEdition, holoSheetType: (card && card.holoSheetType) || holoSheetType, isFlipped: isRevealable, language: card.language || language, onClick: () => {
                                    if (onCardClick)
                                        onCardClick(card);
                                    setCurrentCard(card);
                                    setIsModalShowing(!isModalShowing);
                                }, randomizeHoloSheetPosition: randomizeHoloSheetPosition, reverseHoloSheetType: (card && card.reverseHoloSheetType) ||
                                    reverseHoloSheetType, setTotal: (card && card.setTotal) || setTotal, setSymbol: (card && card.setSymbol) || setSymbol, shadowless: (card && card.shadowless) || shadowless, size: CARD_SIZES.SMALL }),
                            card && card.createdByUsername && showCreatedBy ? (React.createElement("p", { className: "card-preview__author" },
                                createdByLabel,
                                ' ',
                                React.createElement("span", { className: "text-accent" }, card.createdByUsername))) : undefined,
                            onCardDeleteClick || onCardActionClick ? (React.createElement("div", { className: "card-preview__actions" },
                                React.createElement(Dropdown$1, { className: "d-block w-100" },
                                    React.createElement(Dropdown$1.Toggle, { className: "d-block w-100", variant: "dark", id: "dropdown-basic" }, "Card Actions"),
                                    React.createElement(Dropdown$1.Menu, { variant: "dark", className: "w-100" },
                                        onCardActionClick ? (React.createElement(Dropdown$1.Item, { className: "d-flex align-items-center", onClick: () => {
                                                if (onCardActionClick)
                                                    onCardActionClick(card);
                                            } },
                                            cardActionIcon ? (React.createElement("span", { className: "card-action__icon text-center me-2" }, cardActionIcon)) : undefined,
                                            React.createElement("span", null, cardActionLabel))) : undefined,
                                        onCardDeleteClick ? (React.createElement(Dropdown$1.Item, { className: "d-flex align-items-center", onClick: () => {
                                                if (onCardDeleteClick)
                                                    onCardDeleteClick(card && card.id);
                                            } },
                                            cardDeleteIcon ? (React.createElement("span", { className: "card-action__icon text-center me-2" }, cardDeleteIcon)) : undefined,
                                            React.createElement("span", null, cardDeleteLabel))) : undefined)))) : undefined))))) : (React.createElement(RPCAlert, { icon: noResultsIcon, variant: "danger" }, noResultsMessage)))),
                React.createElement(CardModal, { card: currentCard, cardSet: currentCardSet, editCardBadgeLabel: editCardBadgeLabel, editCardButtonIcon: editCardButtonIcon, hideCardDataAction: hideCardDataAction, hideCardEditAction: hideCardEditAction, isEditCardDisabled: isEditCardDisabled, isShowCardDataDisabled: isShowCardDataDisabled, nextCard: getNextCard(), onEditCardClick: onEditCardClick, onNextCardClick: onNextCardClick, onPrevCardClick: onPrevCardClick, onHide: () => {
                        if (onCardModalHide)
                            onCardModalHide();
                        setIsModalShowing(false);
                    }, prevCard: getPrevCard(), show: isCardModalOpen || isModalShowing, showCardDataBadgeLabel: showCardDataBadgeLabel, showCardNavigation: showCardNavigation }))) : undefined,
            isPaginated ? (React.createElement("button", { className: "card-set__pagination__arrow arrow-right", disabled: isNextPageDisabled, onClick: onNextPageClick },
                React.createElement(IconCaretRight, { fill: "#fff" }))) : undefined)));
};
const CardSet = React.memo(CardSetComponent);

const CardSetsGridComponent = (props) => {
    const { activeSetId, alternate, cardSets, gridColClassName, isWotcGrid = true, noDataErrorMessage = 'No card sets found.', noGutter, onCardSetClick, small, width, } = props;
    const cardSetsGridClassNames = classNames({
        'card-sets-grid': true,
        container: true,
        small,
        alternate,
        'no-gutter': noGutter,
    });
    const cardSetsGridStyles = width
        ? { width: `${width}px` }
        : undefined;
    const getCardSetsGridSetClassNames = (setId) => {
        return classNames({
            'card-sets-grid__set': true,
            'mb-0 p-0': small,
            active: activeSetId === setId,
        });
    };
    const defaultCardSetsGridColClassName = 'col-6 col-sm-6 col-md-4 col-lg-2 col-xl-2';
    const cardSetsGridColClassName = classNames({
        [`${gridColClassName || defaultCardSetsGridColClassName}`]: true,
    });
    return (React.createElement("div", { className: cardSetsGridClassNames, style: cardSetsGridStyles },
        React.createElement("div", { className: "row" }, cardSets && cardSets.length ? (cardSets.map((cardSet, index) => (React.createElement("div", { className: cardSetsGridColClassName, key: `card-set-${cardSet.value || index}` },
            React.createElement("div", { className: getCardSetsGridSetClassNames(cardSet.value.toString()) },
                React.createElement("button", { className: `card-sets-grid__set__symbol ${cardSet.value}`, onClick: () => {
                        if (onCardSetClick)
                            onCardSetClick(cardSet.value.toString());
                    } },
                    isWotcGrid ? (React.createElement(CardSetSymbol, { setSymbol: cardSet.value.toString(), fill: alternate ? '#fff' : '#000', fillAlt: alternate ? '#000' : '#fff' })) : (React.createElement(React.Fragment, null, cardSet.icon)),
                    React.createElement("span", { className: "card-sets-grid__set__symbol__label" }, cardSet.label))))))) : (React.createElement("h5", null, noDataErrorMessage)))));
};
const CardSetsGrid = React.memo(CardSetsGridComponent);

const getUniqueRandomCards = (availableCards, n) => {
    if (!availableCards || !availableCards.length)
        return [];
    let len = availableCards.length;
    const result = new Array(n), taken = new Array(len);
    if (n > len)
        throw new RangeError('getUniqueRandomCards: more elements taken than available');
    while (n--) {
        const x = Math.floor(Math.random() * len);
        result[n] = availableCards[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
};
const getPackContents = (availableCards, cardOrder) => {
    if (!availableCards ||
        !availableCards.length ||
        !cardOrder ||
        !cardOrder.length)
        return;
    const { COMMON, ENERGY, HOLO_OR_COMMON, HOLO_COMMON_OR_CRYSTAL, HOLO_OR_RARE, HOLO_RARE_OR_SHINING, UNCOMMON, RARE, REVERSE_HOLO, } = pokemonCardLibrary.PACK_CARD_KEYS;
    const crystalHolos = availableCards.filter((card) => {
        return (card.holo && card.specialTemplateType === pokemonCardLibrary.SPECIAL_CARD_TEMPLATES.CRYSTAL);
    });
    const shinings = availableCards.filter((card) => {
        return card.cardTemplateSubtype === pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.SHINING;
    });
    const rareHolos = availableCards.filter((card) => {
        return (card.rarity === pokemonCardLibrary.RARITY_TYPES.RARE &&
            card.holo &&
            card.holo !== 'reverse' &&
            card.cardTemplateSubtype !== pokemonCardLibrary.CARD_TEMPLATE_SUBTYPES.SHINING &&
            card.specialTemplateType !== pokemonCardLibrary.SPECIAL_CARD_TEMPLATES.CRYSTAL);
    });
    const nonHoloRares = availableCards.filter((card) => {
        return card.rarity === pokemonCardLibrary.RARITY_TYPES.RARE && !card.holo;
    });
    const uncommons = availableCards.filter((card) => {
        return card.rarity === pokemonCardLibrary.RARITY_TYPES.UNCOMMON && !card.holo;
    });
    const commons = availableCards.filter((card) => {
        return card.rarity === pokemonCardLibrary.RARITY_TYPES.COMMON && !card.holo;
    });
    const energies = availableCards.filter((card) => {
        return (card.rarity !== pokemonCardLibrary.RARITY_TYPES.RARE && isEnergyTemplate(card.cardTemplate));
    });
    const counts = {};
    const packContents = [];
    for (const item of cardOrder) {
        counts[item] = counts[item] ? counts[item] + 1 : 1;
    }
    const countsKeys = Object.keys(counts);
    countsKeys.map((countKey) => {
        const cardsChunk = [];
        const rarityCount = counts[countKey];
        const holoOdds = getBooleanWithOdds(WOTC_HOLO_ODDS);
        switch (countKey) {
            case COMMON:
                cardsChunk.push(getUniqueRandomCards(commons, rarityCount));
                break;
            case UNCOMMON:
                cardsChunk.push(getUniqueRandomCards(uncommons, rarityCount));
                break;
            case RARE:
                cardsChunk.push(getUniqueRandomCards(nonHoloRares, rarityCount));
                break;
            case HOLO_RARE_OR_SHINING:
            case HOLO_OR_RARE:
                if (holoOdds) {
                    if (shinings && shinings.length) {
                        const shiningOdds = getBooleanWithOdds(WOTC_SHINING_ODDS);
                        if (shiningOdds) {
                            cardsChunk.push(getUniqueRandomCards(shinings, rarityCount));
                        }
                        else {
                            cardsChunk.push(getUniqueRandomCards(rareHolos, rarityCount));
                        }
                    }
                    else {
                        cardsChunk.push(getUniqueRandomCards(rareHolos, rarityCount));
                    }
                }
                else {
                    cardsChunk.push(getUniqueRandomCards(nonHoloRares, rarityCount));
                }
                break;
            case HOLO_OR_COMMON:
                if (holoOdds) {
                    cardsChunk.push(getUniqueRandomCards(rareHolos, rarityCount));
                }
                else {
                    cardsChunk.push(getUniqueRandomCards(commons, rarityCount));
                }
                break;
            case HOLO_COMMON_OR_CRYSTAL:
                if (holoOdds) {
                    if (crystalHolos && crystalHolos.length) {
                        const crystalOdds = getBooleanWithOdds(WOTC_CRYSTAL_ODDS);
                        if (crystalOdds) {
                            cardsChunk.push(getUniqueRandomCards(crystalHolos, rarityCount));
                        }
                        else {
                            cardsChunk.push(getUniqueRandomCards(rareHolos, rarityCount));
                        }
                    }
                    else {
                        cardsChunk.push(getUniqueRandomCards(rareHolos, rarityCount));
                    }
                }
                else {
                    cardsChunk.push(getUniqueRandomCards(commons, rarityCount));
                }
                break;
            case ENERGY:
                cardsChunk.push(getUniqueRandomCards(energies, rarityCount));
                break;
            case REVERSE_HOLO:
                const reverseHolos = availableCards.filter((card) => {
                    return card.holo && card.holo === 'reverse';
                });
                cardsChunk.push(getUniqueRandomCards(reverseHolos, rarityCount));
        }
        packContents[countKey] = cardsChunk;
    });
    const flattenedCardsArray = flattenMultiDimensionalArray(Object.values(packContents));
    return flattenedCardsArray;
};
const sortPulledCardsArray = (pulledCards) => {
    const sortedCards = pulledCards.sort((itemA, itemB) => itemA.setNumber - itemB.setNumber);
    const uniqueSortedCards = sortedCards.reduce((acc, e) => acc.set(e, (acc.get(e) || 0) + 1), new Map());
    return Array.from(uniqueSortedCards).map(([key, value]) => ({ key, value }));
};
const getHolosFromPulledCards = (pulledCards) => {
    return pulledCards.filter((card) => {
        return card.holo && card.holo !== 'reverse';
    });
};
const getReverseHolosFromPulledCards = (pulledCards) => {
    return pulledCards.filter((card) => {
        return card.holo && card.holo === 'reverse';
    });
};

const BoosterPackComponent = (props) => {
    const { artNumber, disabled, onPackClick, packNumber, setId, } = props;
    const boosterPackClassNames = classNames({
        'booster-pack': true,
        [`booster-pack--${setId}`]: setId,
        [`art-${artNumber}`]: artNumber,
    });
    const packSet = pokemonCardLibrary.getTcgSetById(setId);
    const availableCards = (packSet && packSet.cards) || 0;
    const cardOrder = (packSet && packSet.packInfo && packSet.packInfo.cardOrder) ||
        DEFAULT_CARD_ORDER;
    const handlePackClick = () => {
        if (availableCards && cardOrder) {
            const packContents = {
                cards: getPackContents(availableCards, cardOrder),
            };
            if (onPackClick)
                onPackClick(packContents);
        }
    };
    return (React.createElement("button", { className: boosterPackClassNames, onClick: handlePackClick, disabled: disabled }, disabled ? (React.createElement("div", { className: "cursor-not-allowed d-flex flex-column justify-content-center align-items-center top-0 left-0 bg-dark-subtle h-100 w-100 position-absolute text-white text-center" },
        packNumber ? (React.createElement("h6", { className: "text-accent" }, `Pack ${packNumber}`)) : undefined,
        "Opened")) : undefined));
};
const BoosterPack = React.memo(BoosterPackComponent);

const BoosterPacksGridComponent = (props) => {
    const { availableArts = 3, disabledPacks, firstEdition, onPackClick, setId, shadowless, totalAvailablePacks, } = props;
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "row" }, totalAvailablePacks > 0
            ? Array.from(Array(totalAvailablePacks).keys(), (packNumber) => (React.createElement("div", { className: "col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-3 col-3 text-center mb-2", key: `booster-pack_${packNumber}` },
                React.createElement(BoosterPack, { artNumber: randomNumberWithinRange(1, availableArts), disabled: disabledPacks && disabledPacks.includes(packNumber), firstEdition: firstEdition, onPackClick: (packResult) => {
                        {
                            if (onPackClick)
                                onPackClick(packNumber, packResult);
                        }
                    }, packNumber: packNumber + 1, shadowless: (shadowless && setId === 'base-set') || false, setId: setId }))))
            : undefined)));
};
const BoosterPacksGrid = React.memo(BoosterPacksGridComponent);

const defaultPullGameState = {
    cards: null,
};
const PullGameComponent = (props) => {
    const { endOfGameModalHeaderVariant = 'primary', endOfGameModalTitle = 'Box Opening Complete!', firstEdition, newGameConfirmModalHeaderVariant = 'warning', resetGameConfirmMessage = 'Are you sure you want to reset the game state? You will lose your progress without completing the game.', setId, shadowless, totalAvailablePacks = 36, } = props;
    const packSet = pokemonCardLibrary.getTcgSetById(setId);
    const setTotal = packSet && packSet.setTotal;
    const copyright = packSet && packSet.copyright;
    const setSymbol = packSet && packSet.setSymbol;
    const holoSheetType = packSet && packSet.holoSheetType;
    const reverseHoloSheetType = packSet && packSet.reverseHoloSheetType;
    const setName = packSet && packSet.name;
    const availableCards = packSet && packSet.cards;
    const availableArts = packSet && packSet.packInfo && packSet.packInfo.packArts;
    const [pullGameState, setPullGameState] = React.useState(defaultPullGameState);
    const [packsOpenedTotal, setPacksOpenedTotal] = React.useState(0);
    const [pulledCards, setPulledCards] = React.useState([]);
    const [disabledPacks, setDisabledPacks] = React.useState([]);
    const [isConfirmNewGameModalOpen, setIsConfirmNewGameModalOpen] = React.useState(false);
    const [isPullHolosRevealed, setIsPullHolosRevealed] = React.useState(true);
    const [isEndOfGameModalOpen, setIsEndOfGameModalOpen] = React.useState(false);
    const [isHoloBackdrop, setIsHoloBackdrop] = React.useState(false);
    const pullGameStageClassNames = classNames({
        'pull-game__stage': true,
        'pull-game__stage--packs': !pullGameState.cards,
    });
    const handleOnPackClick = (packNumber, packResult) => {
        const cards = packResult && packResult.cards;
        const foundHolo = cards && cards.length
            ? cards.find((card) => {
                return card.holo && card.holo !== 'reverse';
            })
            : undefined;
        if (foundHolo) {
            setIsHoloBackdrop(true);
        }
        setIsPullHolosRevealed(false);
        setDisabledPacks(prevState => [...prevState, packNumber]);
        setPacksOpenedTotal(packsOpenedTotal + 1);
        setPulledCards(prevState => [...prevState, ...cards]);
        setPullGameState({
            cards,
        });
    };
    const handleNextPackClick = () => {
        setIsPullHolosRevealed(true);
        setPullGameState(defaultPullGameState);
    };
    const handleEndGameClick = () => {
        setPullGameState(defaultPullGameState);
        setIsEndOfGameModalOpen(false);
    };
    const resetGameState = () => {
        setPullGameState(defaultPullGameState);
        setPacksOpenedTotal(0);
        setPulledCards([]);
        setDisabledPacks([]);
        setIsConfirmNewGameModalOpen(false);
    };
    const onStartNewGameClick = () => {
        setIsConfirmNewGameModalOpen(true);
    };
    const getHitCardId = () => {
        const foundCard = pullGameState.cards.find((card) => {
            return (card.rarity === pokemonCardLibrary.RARITY_TYPES.SHINING ||
                (card.rarity === pokemonCardLibrary.RARITY_TYPES.RARE && card.holo));
        });
        if (foundCard && foundCard.id)
            return foundCard.id;
    };
    const cardResultMap = sortPulledCardsArray(pulledCards);
    const actionLabel = packsOpenedTotal === totalAvailablePacks - 1
        ? 'Open Last Pack'
        : 'Open Next Pack';
    const getTotalCards = () => {
        if (!packSet)
            return 0;
        return ((packSet.packInfo &&
            packSet.packInfo.cardOrder &&
            packSet.packInfo.cardOrder.length * totalAvailablePacks) ||
            0);
    };
    const isEndOfGame = packsOpenedTotal > 0 && packsOpenedTotal === totalAvailablePacks;
    const pulledHolos = pulledCards && pulledCards.length
        ? getHolosFromPulledCards(pulledCards)
        : [];
    const pulledReverseHolos = pulledCards && pulledCards.length
        ? getReverseHolosFromPulledCards(pulledCards)
        : [];
    return (React.createElement("div", { className: "pull-game__wrapper" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row py-3 align-items-start" },
                React.createElement("div", { className: "col-md-3 text-center" },
                    React.createElement("h4", { className: "text-accent" }, "Packs Opened"),
                    React.createElement("h5", { className: "text-light" },
                        packsOpenedTotal,
                        "/",
                        totalAvailablePacks)),
                React.createElement("div", { className: "col-md-3 text-center" },
                    React.createElement("h4", { className: "text-accent" }, "Cards Seen"),
                    React.createElement("h5", { className: "text-light" },
                        pulledCards.length,
                        "/",
                        getTotalCards())),
                React.createElement("div", { className: "col-md-3 text-center mb-3 mb-md-0" },
                    isPullHolosRevealed ? (React.createElement(React.Fragment, null,
                        React.createElement("h4", { className: "text-accent" }, "Holos Pulled"),
                        React.createElement("h5", { className: "text-light" }, pulledHolos.length > 0 ? (React.createElement("a", { className: "btn btn-link p-0 text-light text-decoration-none", href: "#pulled-holos" },
                            "View (",
                            pulledHolos.length,
                            ")")) : (React.createElement(React.Fragment, null, pulledHolos.length))))) : undefined,
                    pullGameState.cards ? (React.createElement(React.Fragment, null, !isEndOfGame ? (React.createElement(RPCButton, { className: "d-block w-100", onClick: handleNextPackClick, size: "lg", label: actionLabel })) : (React.createElement(React.Fragment, null,
                        React.createElement(RPCButton, { className: "d-block w-100", onClick: () => setIsEndOfGameModalOpen(true), size: "lg", label: "View Results", variant: "info" }),
                        React.createElement(RPCModal, { show: isEndOfGameModalOpen, size: "md", title: endOfGameModalTitle, headerVariant: endOfGameModalHeaderVariant, footer: React.createElement(React.Fragment, null,
                                React.createElement(RPCButton, { variant: "success", onClick: handleEndGameClick }, "View Pull Results!"),
                                React.createElement(RPCButton, { onClick: () => setIsEndOfGameModalOpen(false) }, "Cancel")) },
                            React.createElement("p", null,
                                "Congratulations, you opened all ",
                                totalAvailablePacks,
                                ' ',
                                "packs! Let's check out those pull results!")))))) : undefined),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement(RPCButton, { className: "d-block w-100", disabled: packsOpenedTotal === 0, onClick: onStartNewGameClick, size: "lg", label: "Start New Game", variant: "success" }),
                    React.createElement(RPCModal, { onHide: () => setIsConfirmNewGameModalOpen(false), show: isConfirmNewGameModalOpen, size: "md", title: "Start New Game", headerVariant: newGameConfirmModalHeaderVariant, footer: React.createElement(React.Fragment, null,
                            React.createElement(RPCButton, { variant: "danger", onClick: resetGameState }, "OK"),
                            React.createElement(RPCButton, { onClick: () => setIsConfirmNewGameModalOpen(false) }, "Cancel")) },
                        React.createElement("p", null, resetGameConfirmMessage))))),
        React.createElement("div", { className: pullGameStageClassNames },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "row" }, !pullGameState.cards ? (React.createElement(React.Fragment, null,
                    React.createElement(BoosterPacksGrid, { availableArts: availableArts, availableCards: availableCards, disabledPacks: disabledPacks, onPackClick: handleOnPackClick, setId: setId, totalAvailablePacks: totalAvailablePacks }),
                    React.createElement("div", { className: "col pull-game__results" },
                        pulledHolos && pulledHolos.length ? (React.createElement("section", { id: "pulled-holos", className: "mb-3" },
                            React.createElement("h3", { className: "p-3 bg-dark-subtle text-light mb-3" }, "Holos Pulled"),
                            React.createElement(CardSet, { basic: true, cards: pulledHolos, copyright: copyright, firstEdition: firstEdition, hideCardDataAction: true, hideCardEditAction: true, holoSheetType: holoSheetType, id: setId, name: setName, reverseHoloSheetType: reverseHoloSheetType, setSymbol: setSymbol, setTotal: setTotal, shadowless: shadowless, showCardNavigation: false }))) : undefined,
                        pulledReverseHolos && pulledReverseHolos.length ? (React.createElement("section", { id: "pulled-holos", className: "mb-3" },
                            React.createElement("h3", { className: "p-3 bg-dark-subtle text-light mb-3" }, "Reverse Holos Pulled"),
                            React.createElement(CardSet, { basic: true, cards: pulledReverseHolos, copyright: copyright, firstEdition: firstEdition, hideCardDataAction: true, hideCardEditAction: true, holoSheetType: holoSheetType, id: setId, name: setName, reverseHoloSheetType: reverseHoloSheetType, setSymbol: setSymbol, setTotal: setTotal, shadowless: shadowless, showCardNavigation: false }))) : undefined,
                        cardResultMap && cardResultMap.length ? (React.createElement("section", { id: "pull-results" },
                            React.createElement("h3", { className: "p-3 bg-dark-subtle text-light mb-0" }, "Pull Results"),
                            React.createElement("div", { className: "pull-game__results__table" },
                                React.createElement(RPCTable, { variant: "dark" },
                                    React.createElement("thead", null,
                                        React.createElement("tr", null,
                                            React.createElement("th", { className: "sticky" }, "Pulled"),
                                            React.createElement("th", { className: "sticky" }, "Rarity"),
                                            React.createElement("th", { className: "sticky" }, "#"),
                                            React.createElement("th", { className: "sticky" }, "Name"))),
                                    React.createElement("tbody", null, cardResultMap.map((cardResult) => (React.createElement("tr", { className: `card-result-row card-result-row--${cardResult.key.rarity}`, key: `card-result-${cardResult.key.id}` },
                                        React.createElement("td", null,
                                            "x",
                                            cardResult.value),
                                        React.createElement("td", null, cardResult.key.rarity && (React.createElement("span", { className: "d-flex align-items-center justify-content-center" },
                                            cardResult.key.holo ? 'H' : undefined,
                                            React.createElement(RaritySymbol, { fill: "#fff", rarity: cardResult.key.rarity })))),
                                        React.createElement("td", null,
                                            "#",
                                            cardResult.key.setNumber,
                                            setTotal ? `/${setTotal}` : ''),
                                        React.createElement("td", null, cardResult.key.cardTemplate &&
                                            isEnergyTemplate(cardResult.key.cardTemplate) ? (React.createElement(EnergySymbol, { size: ENERGY_SIZES.TINY, type: cardResult.key.energyType })) : (cardResult.key.name)))))))))) : undefined))) : (React.createElement(React.Fragment, null,
                    React.createElement(RPCToastMessage, { isFixedTop: true, variant: "dark-subtle", onClose: () => setIsHoloBackdrop(false), show: isHoloBackdrop },
                        React.createElement("div", { className: "text-center" },
                            React.createElement("strong", { className: "text-light" }, "Holo Hit!"))),
                    pullGameState.cards.length ? (React.createElement("div", { className: "col" },
                        React.createElement(CardSet, { basic: true, cards: pullGameState.cards, copyright: copyright, firstEdition: firstEdition, hideCardDataAction: true, hideCardEditAction: true, hitCardId: getHitCardId(), holoSheetType: holoSheetType, id: setId, isRevealable: true, name: setName, reverseHoloSheetType: reverseHoloSheetType, setSymbol: setSymbol, setTotal: setTotal, shadowless: shadowless, showCardNavigation: false }))) : undefined)))))));
};
const PullGame = React.memo(PullGameComponent);

const ThemeDeckComponent = (props) => {
    const { disabled, disabledMessage = 'Coming Soon!', energyTypes, id, name, onClick, orientation = 'front', setId, shadowless, } = props;
    const [currentOrientation, setCurrentOrientation] = React.useState(orientation);
    const ThemeDeckClassNames = classNames({
        'theme-deck': true,
        'theme-deck--e-series': pokemonCardLibrary.isESeriesSet(setId),
        [`theme-deck--${id}`]: true,
        'theme-deck--disabled': disabled,
        [`show-${currentOrientation}`]: currentOrientation,
        'theme-deck--shadowless': shadowless,
    });
    const performThemeDeckAnimation = () => {
        const newOrientation = currentOrientation === 'front' ? 'back' : 'front';
        setCurrentOrientation(newOrientation);
    };
    const resetThemeDeckOrientation = () => {
        setCurrentOrientation('front');
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "theme-deck__info mb-5 py-5 text-light text-center" },
            React.createElement("h3", null, name),
            energyTypes && energyTypes.length ? (React.createElement("div", { className: "d-flex justify-content-center" }, energyTypes.map((energyType, index) => (React.createElement("div", { key: `theme-deck-${id}-${energyType}-${index}`, className: index !== energyTypes.length - 1 ? `me-2` : '' },
                React.createElement(EnergySymbol, { type: energyType })))))) : undefined),
        React.createElement("div", { className: ThemeDeckClassNames, onMouseEnter: () => {
                performThemeDeckAnimation();
            }, onMouseLeave: () => resetThemeDeckOrientation(), onClick: () => {
                if (onClick)
                    onClick(setId, shadowless);
            } },
            React.createElement("div", { className: "theme-deck__box" },
                React.createElement("div", { className: "theme-deck__face theme-deck__face--front" }),
                React.createElement("div", { className: "theme-deck__face theme-deck__face--back" }),
                React.createElement("div", { className: "theme-deck__face theme-deck__face--right" }),
                React.createElement("div", { className: "theme-deck__face theme-deck__face--left" }),
                React.createElement("div", { className: "theme-deck__face theme-deck__face--top" }, disabled ? (React.createElement("div", { className: "text-light bg-dark-subtle d-flex fs-2 justify-content-center align-items-center h-100 w-100" }, disabledMessage)) : undefined),
                React.createElement("div", { className: "theme-deck__face theme-deck__face--bottom" })))));
};
const ThemeDeck = React.memo(ThemeDeckComponent);

const ThemeDeckDisplayComponent = (props) => {
    const { cards, copyright, energyTypes, id, name, onPrevCardClick, onNextCardClick, setId, setSymbol, setTotal, } = props;
    return (React.createElement("div", { className: "container theme-deck-display" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-lg-4 col-xl-3" },
                React.createElement("div", { className: "mb-5 mb-lg-0 theme-deck-display__deck" },
                    React.createElement(ThemeDeck, { energyTypes: energyTypes, id: id, name: name, setId: setId }))),
            React.createElement("div", { className: "col-lg-8 col-xl-9" },
                React.createElement("div", { className: "mt-5 mt-lg-0 theme-deck-display__set" },
                    React.createElement(CardSet, { basic: true, cards: pokemonCardLibrary.getThemeDeckCards(setId, cards), copyright: copyright, id: setId, name: name, onNextCardClick: onNextCardClick, onPrevCardClick: onPrevCardClick, showCardCountBadge: true, setTotal: setTotal, setSymbol: setSymbol }))))));
};
const ThemeDeckDisplay = React.memo(ThemeDeckDisplayComponent);

exports.ADDITIONAL_CARD_CREATOR_SETS = ADDITIONAL_CARD_CREATOR_SETS;
exports.ALLOWED_IMAGE_UPLOAD_TYPES = ALLOWED_IMAGE_UPLOAD_TYPES;
exports.AssetLibrary = AssetLibrary;
exports.BOOSTER_BOX_ORIENTATIONS = BOOSTER_BOX_ORIENTATIONS;
exports.BoosterBox = BoosterBox;
exports.BoosterBoxGrid = BoosterBoxGrid;
exports.CARD_FRAME_STYLES = CARD_FRAME_STYLES;
exports.CARD_SIZES = CARD_SIZES;
exports.COMPONENT_VARIANTS = COMPONENT_VARIANTS;
exports.Card = Card;
exports.CardCreator = CardCreator;
exports.CardModal = CardModal;
exports.CardSet = CardSet;
exports.CardSetSymbol = CardSetSymbol;
exports.CardSetsGrid = CardSetsGrid;
exports.ColorlessEnergy = ColorlessEnergy;
exports.Common = Common;
exports.DEFAULT_CARD_ENERGY_TYPE = DEFAULT_CARD_ENERGY_TYPE;
exports.DEFAULT_CARD_ORDER = DEFAULT_CARD_ORDER;
exports.DEFAULT_CARD_SET_STATE = DEFAULT_CARD_SET_STATE;
exports.DEFAULT_CARD_STATE = DEFAULT_CARD_STATE;
exports.DEFAULT_CARD_TEMPLATE = DEFAULT_CARD_TEMPLATE;
exports.DEFAULT_ENERGY_HEADING = DEFAULT_ENERGY_HEADING;
exports.DEFAULT_ENERGY_ICON_SIZE = DEFAULT_ENERGY_ICON_SIZE;
exports.DEFAULT_ENERGY_ICON_SIZE_SMALL = DEFAULT_ENERGY_ICON_SIZE_SMALL;
exports.DEFAULT_ENERGY_ICON_SIZE_TINY = DEFAULT_ENERGY_ICON_SIZE_TINY;
exports.DEFAULT_FIRST_EDITION_ICON_SIZE = DEFAULT_FIRST_EDITION_ICON_SIZE;
exports.DEFAULT_HOLO_BLEND_MODE = DEFAULT_HOLO_BLEND_MODE;
exports.DEFAULT_HOLO_SHEET_TYPE = DEFAULT_HOLO_SHEET_TYPE;
exports.DEFAULT_HOLO_STRENGTH = DEFAULT_HOLO_STRENGTH;
exports.DEFAULT_ICON_SIZE = DEFAULT_ICON_SIZE;
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
exports.DEFAULT_REVERSE_HOLO_SHEET_TYPE = DEFAULT_REVERSE_HOLO_SHEET_TYPE;
exports.DEFAULT_SHADOW_SIZE = DEFAULT_SHADOW_SIZE;
exports.DEFAULT_TRAINER_HEADING = DEFAULT_TRAINER_HEADING;
exports.DarknessEnergy = DarknessEnergy;
exports.ENERGY_COST_MAX = ENERGY_COST_MAX;
exports.ENERGY_SIZES = ENERGY_SIZES;
exports.ENERGY_SYMBOL_CODES = ENERGY_SYMBOL_CODES;
exports.EnergySelector = EnergySelector;
exports.EnergySymbol = EnergySymbol;
exports.FRAME_SIZES = FRAME_SIZES;
exports.FightingEnergy = FightingEnergy;
exports.FireEnergy = FireEnergy;
exports.FirstEditionStamp = FirstEditionStamp;
exports.FirstEditionStampJpn = FirstEditionStampJpn;
exports.GrassEnergy = GrassEnergy;
exports.HP_MAX = HP_MAX;
exports.HP_MIN = HP_MIN;
exports.IconAquapolis = IconAquapolis;
exports.IconBase2 = IconBase2;
exports.IconBaseExpansion = IconBaseExpansion;
exports.IconBestOfGame = IconBestOfGame;
exports.IconBlackStarPromo = IconBlackStarPromo;
exports.IconCaretDown = IconCaretDown;
exports.IconCaretLeft = IconCaretLeft;
exports.IconCaretRight = IconCaretRight;
exports.IconCaretUp = IconCaretUp;
exports.IconColorless = IconColorless;
exports.IconDarkness = IconDarkness;
exports.IconE3 = IconE3;
exports.IconExpedition = IconExpedition;
exports.IconFighting = IconFighting;
exports.IconFire = IconFire;
exports.IconFossil = IconFossil;
exports.IconGBPromo = IconGBPromo;
exports.IconGrass = IconGrass;
exports.IconGymChallenge = IconGymChallenge;
exports.IconGymHeroes = IconGymHeroes;
exports.IconGymLeaders = IconGymLeaders;
exports.IconHelp = IconHelp;
exports.IconJungle = IconJungle;
exports.IconLegendaryCollection = IconLegendaryCollection;
exports.IconLightning = IconLightning;
exports.IconMcdonalds = IconMcdonalds;
exports.IconMetal = IconMetal;
exports.IconMinusCircle = IconMinusCircle;
exports.IconMysteriousMountains = IconMysteriousMountains;
exports.IconNeoDestiny = IconNeoDestiny;
exports.IconNeoDiscovery = IconNeoDiscovery;
exports.IconNeoGenesis = IconNeoGenesis;
exports.IconNeoRevelation = IconNeoRevelation;
exports.IconPNG = IconPNG;
exports.IconPNGFile = IconPNGFile;
exports.IconPlusCircle = IconPlusCircle;
exports.IconPokeBall = IconPokeBall;
exports.IconPsychic = IconPsychic;
exports.IconRemove = IconRemove;
exports.IconRemoveCircle = IconRemoveCircle;
exports.IconSkyridge = IconSkyridge;
exports.IconSnap = IconSnap;
exports.IconSouthernIslands = IconSouthernIslands;
exports.IconSplitEarth = IconSplitEarth;
exports.IconTPromotionalCards = IconTPromotionalCards;
exports.IconTeamRocket = IconTeamRocket;
exports.IconTownOnNoMap = IconTownOnNoMap;
exports.IconVending = IconVending;
exports.IconWater = IconWater;
exports.IconWeb = IconWeb;
exports.IconWindFromTheSea = IconWindFromTheSea;
exports.LEVEL_MAX = LEVEL_MAX;
exports.LightningEnergy = LightningEnergy;
exports.MASTHEAD_TYPES = MASTHEAD_TYPES;
exports.MOVES_MAX = MOVES_MAX;
exports.MetalEnergy = MetalEnergy;
exports.MovesInput = MovesInput;
exports.NAME_MAX_LENGTH = NAME_MAX_LENGTH;
exports.NAME_MAX_LENGTH_TRAINER = NAME_MAX_LENGTH_TRAINER;
exports.NEO_SWOOSH_BG = NEO_SWOOSH_BG;
exports.PreReleaseStamp = PreReleaseStamp;
exports.PsychicEnergy = PsychicEnergy;
exports.PullGame = PullGame;
exports.RETREAT_COST_MAX = RETREAT_COST_MAX;
exports.RPCAccordion = RPCAccordion;
exports.RPCAccordionItem = RPCAccordionItem;
exports.RPCAlert = RPCAlert;
exports.RPCBadge = RPCBadge;
exports.RPCBreadcrumbs = RPCBreadcrumbs;
exports.RPCButton = RPCButton;
exports.RPCButtonGroup = RPCButtonGroup;
exports.RPCCarousel = RPCCarousel;
exports.RPCCheckbox = RPCCheckbox;
exports.RPCConfirmationModal = RPCConfirmationModal;
exports.RPCDropdownMenu = RPCDropdownMenu;
exports.RPCInputGroup = RPCInputGroup;
exports.RPCLoadingIndicator = RPCLoadingIndicator;
exports.RPCModal = RPCModal;
exports.RPCNavbar = RPCNavbar;
exports.RPCNavbarDropdown = RPCNavbarDropdown;
exports.RPCNavbarLink = RPCNavbarLink;
exports.RPCOffCanvas = RPCOffCanvas;
exports.RPCRangeSliderInput = RPCRangeSliderInput;
exports.RPCTable = RPCTable;
exports.RPCTextInput = RPCTextInput;
exports.RPCToastMessage = RPCToastMessage;
exports.RPCToggleSwitch = RPCToggleSwitch;
exports.RainbowEnergy = RainbowEnergy;
exports.RaritySelector = RaritySelector;
exports.RaritySymbol = RaritySymbol;
exports.SMALL_ICON_SIZE = SMALL_ICON_SIZE;
exports.STAGE_MAX = STAGE_MAX;
exports.STAGE_MIN = STAGE_MIN;
exports.SingleStar = SingleStar;
exports.TINY_ICON_SIZE = TINY_ICON_SIZE;
exports.ThemeDeck = ThemeDeck;
exports.ThemeDeckDisplay = ThemeDeckDisplay;
exports.TripleStar = TripleStar;
exports.Uncommon = Uncommon;
exports.WEIGHT_MAX = WEIGHT_MAX;
exports.WOTC_CRYSTAL_ODDS = WOTC_CRYSTAL_ODDS;
exports.WOTC_HOLO_ODDS = WOTC_HOLO_ODDS;
exports.WOTC_SHINING_ODDS = WOTC_SHINING_ODDS;
exports.WaterEnergy = WaterEnergy;
exports.WinnerStamp = WinnerStamp;
exports.WizardsStamp = WizardsStamp;
exports.buildImage = buildImage;
exports.saveImage = saveImage;
//# sourceMappingURL=index.js.map
